export default [
  {
    zip_code: '01001',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01002',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01003',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01004',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01005',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01007',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01008',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01009',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01010',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01011',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01012',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01013',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01014',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01020',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01021',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01022',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01026',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01027',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01028',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01029',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01030',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01031',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01032',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01033',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01034',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01035',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01036',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01037',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01038',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01039',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01040',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01041',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01050',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01053',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01054',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01056',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01057',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01059',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01060',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01061',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01062',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01063',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01066',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01068',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01069',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01070',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01071',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01072',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01073',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01074',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01075',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01077',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01079',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01080',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01081',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01082',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01083',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01084',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01085',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01086',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01088',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01089',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01090',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01092',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01093',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01094',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01095',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01096',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01097',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01098',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01101',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01102',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01103',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01104',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01105',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01106',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01107',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01108',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01109',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01111',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01115',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01116',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01118',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01119',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01128',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01129',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01133',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01138',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01139',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01144',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01151',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01152',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01195',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01199',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01201',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01202',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01203',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01220',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01222',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01223',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01224',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01225',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01226',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01227',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01229',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01230',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01235',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01236',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01237',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01238',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01240',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01242',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01243',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01244',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01245',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01247',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01252',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01253',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01254',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01255',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01256',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01257',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01258',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01259',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01260',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01262',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01263',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01264',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01266',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01267',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01270',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01301',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01302',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01330',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01331',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01337',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01338',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01339',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01340',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01341',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01342',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01343',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '01344',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01346',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01347',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01349',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01350',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01351',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01354',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01355',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01360',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01364',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01366',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01367',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01368',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01370',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01373',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01375',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01376',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01378',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01379',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01380',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01420',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01430',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01431',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01432',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01434',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01436',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01438',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01440',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01441',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01450',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01451',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01452',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01453',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01460',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01462',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01463',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01464',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01467',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01468',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01469',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01470',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01471',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01472',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01473',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01474',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01475',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01477',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01501',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01503',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01504',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01505',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01506',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01507',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01508',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01509',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01510',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01515',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01516',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01517',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01518',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01519',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01520',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01521',
    dma_code: '543',
    dma_description: 'SPRINGFIELD - HOLYOKE',
  },
  {
    zip_code: '01522',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01523',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01524',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01525',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01526',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01527',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01529',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01531',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01532',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01534',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01535',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01536',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01537',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01538',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01540',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01541',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01542',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01543',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01545',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01546',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01550',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01560',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01561',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01562',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01564',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01566',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01568',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01569',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01570',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01571',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01580',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01581',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01582',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01583',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01585',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01586',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01588',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01590',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01601',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01602',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01603',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01604',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01605',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01606',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01607',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01608',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01609',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01610',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01611',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01612',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01613',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01614',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01615',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01653',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01654',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01655',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01701',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01702',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01703',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01704',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01705',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01718',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01719',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01720',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01721',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01730',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01731',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01740',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01741',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01742',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01745',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01746',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01747',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01748',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01749',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01752',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01754',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01756',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01757',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01760',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01770',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01772',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01773',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01775',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01776',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01778',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01784',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01801',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01803',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01805',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01806',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01807',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01808',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01810',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01812',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01813',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01815',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01821',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01822',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01824',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01826',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01827',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01830',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01831',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01832',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01833',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01834',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01835',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01840',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01841',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01842',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01843',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01844',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01845',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01850',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01851',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01852',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01853',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01854',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01860',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01862',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01863',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01864',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01865',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01866',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01867',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01876',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01879',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01880',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01885',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01886',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01887',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01888',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01889',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01890',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01899',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01901',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01902',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01903',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01904',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01905',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01906',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01907',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01908',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01910',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01913',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01915',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01921',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01922',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01923',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01929',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01930',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01931',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01936',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01937',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01938',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01940',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01944',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01945',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01949',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01950',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01951',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01952',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01960',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01961',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01965',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01966',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01969',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01970',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01971',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01982',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01983',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01984',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '01985',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02018',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02019',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02020',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02021',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02025',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02026',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02027',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02030',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02031',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02032',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02035',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02038',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02040',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02041',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02043',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02044',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02045',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02047',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02048',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02050',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02051',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02052',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02053',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02054',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02055',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02056',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02059',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02060',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02061',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02062',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02065',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02066',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02067',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02070',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02071',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02072',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02081',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02090',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02093',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02108',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02109',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02110',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02111',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02112',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02113',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02114',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02115',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02116',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02117',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02118',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02119',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02120',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02121',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02122',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02123',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02124',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02125',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02126',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02127',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02128',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02129',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02130',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02131',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02132',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02133',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02134',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02135',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02136',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02137',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02138',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02139',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02140',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02141',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02142',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02143',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02144',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02145',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02148',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02149',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02150',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02151',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02152',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02153',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02155',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02156',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02163',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02169',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02170',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02171',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02176',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02180',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02184',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02185',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02186',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02187',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02188',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02189',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02190',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02191',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02196',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02199',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02201',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02203',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02204',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02205',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02206',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02207',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02210',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02211',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02212',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02215',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02216',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02217',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02222',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02228',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02238',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02239',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02266',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02269',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02284',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02295',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02297',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02298',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02301',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02302',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02303',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02304',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02305',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02322',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02324',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02325',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02327',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02330',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02331',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02332',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02333',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02334',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02337',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02338',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02339',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02340',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02341',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02343',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02344',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02345',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02346',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02347',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02348',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02349',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02350',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02351',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02355',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02356',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02357',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02358',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02359',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02360',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02361',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02362',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02364',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02366',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02367',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02368',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02370',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02375',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02379',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02381',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02382',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02420',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02421',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02445',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02446',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02447',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02451',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02452',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02453',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02454',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02455',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02456',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02457',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02458',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02459',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02460',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02461',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02462',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02464',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02465',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02466',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02467',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02468',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02471',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02472',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02474',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02475',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02476',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02477',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02478',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02479',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02481',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02482',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02492',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02493',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02494',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02495',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02532',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02534',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02535',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02536',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02537',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02538',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02539',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02540',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02541',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02542',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02543',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02552',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02553',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02554',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02556',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02557',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02558',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02559',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02561',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02562',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02563',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02564',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02565',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02568',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02571',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02573',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02574',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02575',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02576',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02584',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02601',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02630',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02631',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02632',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02633',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02634',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02635',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02636',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02637',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02638',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02639',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02641',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02642',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02643',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02644',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02645',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02646',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02647',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02648',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02649',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02650',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02651',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02652',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02653',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02655',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02657',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02659',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02660',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02661',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02662',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02663',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02664',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02666',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02667',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02668',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02669',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02670',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02671',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02672',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02673',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02675',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02702',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02703',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02712',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02713',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02714',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02715',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02717',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02718',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02719',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02720',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02721',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02722',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02723',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02724',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02725',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02726',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02738',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02739',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02740',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02741',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02742',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02743',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02744',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02745',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02746',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02747',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02748',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02760',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02761',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02762',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02763',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02764',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02766',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02767',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02768',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02769',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02770',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '02771',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02777',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02779',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02780',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02783',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02790',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02791',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02801',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02802',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02804',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02806',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02807',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02808',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02809',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02812',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02813',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02814',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02815',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02816',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02817',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02818',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02822',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02823',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02824',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02825',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02826',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02827',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02828',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02829',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02830',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02831',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02832',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02833',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02835',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02836',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02837',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02838',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02839',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02840',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02841',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02842',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02852',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02857',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02858',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02859',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02860',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02861',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02862',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02863',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02864',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02865',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02871',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02872',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02873',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02874',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02875',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02876',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02877',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02878',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02879',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02880',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02881',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02882',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02883',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02885',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02886',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02887',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02888',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02889',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02891',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02892',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02893',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02894',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02895',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02896',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02898',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02901',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02902',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02903',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02904',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02905',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02906',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02907',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02908',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02909',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02910',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02911',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02912',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02914',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02915',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02916',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02917',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02918',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02919',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02920',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02921',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '02940',
    dma_code: '521',
    dma_description: 'PROVIDENCE - NEW BEDFORD',
  },
  {
    zip_code: '03031',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03032',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03033',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03034',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03036',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03037',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03038',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03040',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03041',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03042',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03043',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03044',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03045',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03046',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03047',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03048',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03049',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03051',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03052',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03053',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03054',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03055',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03057',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03060',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03061',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03062',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03063',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03064',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03070',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03071',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03073',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03076',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03077',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03079',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03082',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03084',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03086',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03087',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03101',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03102',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03103',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03104',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03105',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03106',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03107',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03108',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03109',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03110',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03111',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03215',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03216',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03217',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03218',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03220',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03221',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03222',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03223',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03224',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03225',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03226',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03227',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03229',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03230',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03231',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03233',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03234',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03235',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03237',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03238',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03240',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03241',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03242',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03243',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03244',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03245',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03246',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03247',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03249',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03251',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03252',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03253',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03254',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03255',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03256',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03257',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03258',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03259',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03260',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03261',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03262',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03263',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03264',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03266',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03268',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03269',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03272',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03273',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03274',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03275',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03276',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03278',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03279',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03280',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03281',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03282',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03284',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03285',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03287',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03289',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03290',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03291',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03293',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03298',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03299',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03301',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03302',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03303',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03304',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03305',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03307',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03431',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03435',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03440',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03441',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03442',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03443',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03444',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03445',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03446',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03447',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03448',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03449',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03450',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03451',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03452',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03455',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03456',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03457',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03458',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03461',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03462',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03464',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03465',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03466',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03467',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03468',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03469',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03470',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03561',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03570',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03574',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03575',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03576',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03579',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03580',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03581',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03582',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03583',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03584',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03585',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03586',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03588',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03589',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03590',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03592',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03593',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03595',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03597',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03598',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03601',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03602',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03603',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03604',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03605',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03607',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03608',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03609',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03740',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03741',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03743',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03745',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03746',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03748',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03749',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03750',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03751',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03752',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03753',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03754',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03755',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03756',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03765',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03766',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03768',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03769',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03770',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03771',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03773',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03774',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03777',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03779',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03780',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03781',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03782',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03784',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03785',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '03801',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03802',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03803',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03804',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03805',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03809',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03810',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03811',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03812',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03813',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03814',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03815',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03816',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03817',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03818',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03819',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03820',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03821',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03822',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03823',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03824',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03825',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03826',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03827',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03830',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03832',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03833',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03835',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03836',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03837',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03838',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03839',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03840',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03841',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03842',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03843',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03844',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03845',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03846',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03847',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03848',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03849',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03850',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03851',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03852',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03853',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03854',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03855',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03856',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03857',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03858',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03859',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03860',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03861',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03862',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03864',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03865',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03866',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03867',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03868',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03869',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03870',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03871',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03872',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03873',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03874',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03875',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03878',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03882',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03883',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03884',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03885',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '03886',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03887',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03890',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03894',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03896',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03897',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03901',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03902',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03903',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03904',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03905',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03906',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03907',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03908',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03909',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03910',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '03911',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04001',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04002',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04003',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04004',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04005',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04006',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04007',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04008',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04009',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04010',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04011',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04013',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04014',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04015',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04016',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04017',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04019',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04020',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04021',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04022',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04024',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04027',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04028',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04029',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04030',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04032',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04033',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04034',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04037',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04038',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04039',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04040',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04041',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04042',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04043',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04046',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04047',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04048',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04049',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04050',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04051',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04054',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04055',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04056',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04057',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04061',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04062',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04063',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04064',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04066',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04068',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04069',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04070',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04071',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04072',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04073',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04074',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04075',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04076',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04077',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04078',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04079',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04082',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04083',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04084',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04085',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04086',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04087',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04088',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04090',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04091',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04092',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04093',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04094',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04095',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04096',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04097',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04098',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04101',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04102',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04103',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04104',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04105',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04106',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04107',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04108',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04109',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04110',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04112',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04116',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04122',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04123',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04124',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04210',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04211',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04212',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04216',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04217',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04219',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04220',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04221',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04222',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04223',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04224',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04225',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04226',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04227',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04228',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04230',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04231',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04234',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04236',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04237',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04238',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04239',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04240',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04241',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04243',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04250',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04252',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04253',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04254',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04255',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04256',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04257',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04258',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04259',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04260',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04261',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04262',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04263',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04265',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04266',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04267',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04268',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04270',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04271',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04274',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04275',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04276',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04278',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04280',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04281',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04282',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04284',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04285',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04286',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04287',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04288',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04289',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04290',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04291',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04292',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04294',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04330',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04332',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04333',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04336',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04338',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04341',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04342',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04343',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04344',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04345',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04346',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04347',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04348',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04349',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04350',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04351',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04352',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04353',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04354',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04355',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04357',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04358',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04359',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04360',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04363',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04364',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04401',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04402',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04406',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04408',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04410',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04411',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04412',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04413',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04414',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04415',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04416',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04417',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04418',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04419',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04420',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04421',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04422',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04424',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04426',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04427',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04428',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04429',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04430',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04431',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04434',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04435',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04438',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04441',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04442',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04443',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04444',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04448',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04449',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04450',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04451',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04453',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04454',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04455',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04456',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04457',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04459',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04460',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04461',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04462',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04463',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04464',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04467',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04468',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04469',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04471',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04472',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04473',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04474',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04475',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04476',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04478',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04479',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04481',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04485',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04487',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04488',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04489',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04490',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04491',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04492',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04493',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04495',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04496',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04497',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04530',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04535',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04537',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04538',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04539',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04541',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04543',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04544',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04547',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04548',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04549',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04551',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04553',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04554',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04555',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04556',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04558',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04562',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04563',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04564',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04565',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04568',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04570',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04571',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04572',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04573',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04574',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04575',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04576',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04578',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04579',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04605',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04606',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04607',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04609',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04611',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04612',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04613',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04614',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04616',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04617',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04619',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04622',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04623',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04624',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04625',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04626',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04627',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04628',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04629',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04630',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04631',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04634',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04635',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04637',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04640',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04642',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04643',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04644',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04645',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04646',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04648',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04649',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04650',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04652',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04653',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04654',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04655',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04657',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04658',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04660',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04662',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04664',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04666',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04667',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04668',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04669',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04671',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04672',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04673',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04674',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04675',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04676',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04677',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04679',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04680',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04681',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04683',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04684',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04685',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04686',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04691',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04693',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04694',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04730',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04732',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04733',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04734',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04735',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04736',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04737',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04738',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04739',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04740',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04741',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04742',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04743',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04744',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04745',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04746',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04747',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04750',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04751',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04756',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04757',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04758',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04760',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04761',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04762',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04763',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04764',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04765',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04766',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04768',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04769',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04772',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04773',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04774',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04775',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04776',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04777',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04779',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04780',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04781',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04783',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04785',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04786',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04787',
    dma_code: '552',
    dma_description: 'PRESQUE ISLE',
  },
  {
    zip_code: '04841',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04843',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04846',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04847',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04848',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04849',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04850',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04851',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04852',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04853',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04854',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04855',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04856',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04858',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04859',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04860',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04861',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04862',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04863',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04864',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04865',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04901',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04903',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04910',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04911',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04912',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04915',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04917',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04918',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04920',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04921',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04922',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04923',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04924',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04925',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04926',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04927',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04928',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04929',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04930',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04932',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04933',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04935',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04936',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04937',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04938',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04939',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04940',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04941',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04942',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04943',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04944',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04945',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04947',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04949',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04950',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04951',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04952',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04953',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04954',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04955',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04956',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04957',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04958',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04961',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04962',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04963',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04964',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04965',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04966',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04967',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04969',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04970',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04971',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04972',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04973',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04974',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04975',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04976',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04978',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04979',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04981',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04982',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04983',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04984',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04985',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04986',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04987',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04988',
    dma_code: '537',
    dma_description: 'BANGOR',
  },
  {
    zip_code: '04989',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '04992',
    dma_code: '500',
    dma_description: 'PORTLAND - AUBURN',
  },
  {
    zip_code: '05001',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05009',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05030',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05031',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05032',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05033',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05034',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05035',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05036',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05037',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05038',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05039',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05040',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05041',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05042',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05043',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05045',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05046',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05047',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05048',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05049',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05050',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05051',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05052',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05053',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05054',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05055',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05056',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05058',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05059',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05060',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05061',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05062',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05065',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05067',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05068',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05069',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05070',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05071',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05072',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05073',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05074',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05075',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05076',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05077',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05079',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05081',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05083',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05084',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05085',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05086',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05088',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05089',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05091',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05101',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05141',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05142',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05143',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05144',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05146',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05148',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05149',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05150',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05151',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05152',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05153',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05154',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05155',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05156',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05158',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05159',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05161',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05201',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05250',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05251',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05252',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05253',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05254',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05255',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05257',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05260',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05261',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05262',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05301',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05302',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05303',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05304',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05340',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05341',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05342',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05343',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05344',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05345',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05346',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05350',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05351',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05352',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05353',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05354',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05355',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05356',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05357',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05358',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05359',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05360',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05361',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05362',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05363',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05401',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05402',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05403',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05404',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05405',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05406',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05407',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05408',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05439',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05440',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05441',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05442',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05443',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05444',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05445',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05446',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05447',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05448',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05449',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05450',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05451',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05452',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05453',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05454',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05455',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05456',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05457',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05458',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05459',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05460',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05461',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05462',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05463',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05464',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05465',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05466',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05468',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05469',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05470',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05471',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05472',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05473',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05474',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05476',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05477',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05478',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05479',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05481',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05482',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05483',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05485',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05486',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05487',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05488',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05489',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05490',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05491',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05492',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05494',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05495',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05501',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05544',
    dma_code: '506',
    dma_description: 'BOSTON (MANCHESTER)',
  },
  {
    zip_code: '05601',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05602',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05603',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05604',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05609',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05620',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05633',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05640',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05641',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05647',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05648',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05649',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05650',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05651',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05652',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05653',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05654',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05655',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05656',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05657',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05658',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05660',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05661',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05662',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05663',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05664',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05665',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05666',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05667',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05669',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05670',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05671',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05672',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05673',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05674',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05675',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05676',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05677',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05678',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05679',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05680',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05681',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05682',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05701',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05702',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05730',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05731',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05732',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05733',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05734',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05735',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05736',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05737',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05738',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05739',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05740',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05741',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05742',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05743',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05744',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05745',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05746',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05747',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05748',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05750',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05751',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05753',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05757',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05758',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05759',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05760',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05761',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05762',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05763',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05764',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05765',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05766',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05767',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05768',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05769',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05770',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05772',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05773',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05774',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05775',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05776',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '05777',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05778',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05819',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05820',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05821',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05822',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05823',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05824',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05825',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05826',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05827',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05828',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05829',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05830',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05832',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05833',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05836',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05837',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05838',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05839',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05840',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05841',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05842',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05843',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05845',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05846',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05847',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05848',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05849',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05850',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05851',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05853',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05855',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05857',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05858',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05859',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05860',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05861',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05862',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05863',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05866',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05867',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05868',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05871',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05872',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05873',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05874',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05875',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05901',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05902',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05903',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05904',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05905',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05906',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '05907',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '06001',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06002',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06006',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06010',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06011',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06013',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06016',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06018',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06019',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06020',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06021',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06022',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06023',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06024',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06025',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06026',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06027',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06028',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06029',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06030',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06031',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06032',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06033',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06034',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06035',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06037',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06039',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06040',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06041',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06042',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06043',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06045',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06050',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06051',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06052',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06053',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06057',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06058',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06059',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06060',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06061',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06062',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06063',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06064',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06065',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06066',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06067',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06068',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06069',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06070',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06071',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06072',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06073',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06074',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06075',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06076',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06077',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06078',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06079',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06080',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06081',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06082',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06083',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06084',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06085',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06087',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06088',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06089',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06090',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06091',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06092',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06093',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06094',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06095',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06096',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06098',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06101',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06102',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06103',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06105',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06106',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06107',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06108',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06109',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06110',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06111',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06112',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06114',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06115',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06117',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06118',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06119',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06120',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06123',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06126',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06127',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06128',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06129',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06131',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06132',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06133',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06134',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06137',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06138',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06140',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06141',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06142',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06143',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06144',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06145',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06146',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06147',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06150',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06151',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06152',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06153',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06154',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06155',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06156',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06160',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06161',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06167',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06176',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06180',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06183',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06226',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06230',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06231',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06232',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06233',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06234',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06235',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06237',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06238',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06239',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06241',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06242',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06243',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06244',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06245',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06246',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06247',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06248',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06249',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06250',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06251',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06254',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06255',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06256',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06258',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06259',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06260',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06262',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06263',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06264',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06265',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06266',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06267',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06268',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06269',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06277',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06278',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06279',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06280',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06281',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06282',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06320',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06330',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06331',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06332',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06333',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06334',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06335',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06336',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06338',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06339',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06340',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06349',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06350',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06351',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06353',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06354',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06355',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06357',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06359',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06360',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06365',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06370',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06371',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06372',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06373',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06374',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06375',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06376',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06377',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06378',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06379',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06380',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06382',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06383',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06384',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06385',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06386',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06387',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06388',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06389',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06390',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06401',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06403',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06404',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06405',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06408',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06409',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06410',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06411',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06412',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06413',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06414',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06415',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06416',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06417',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06418',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06419',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06420',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06422',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06423',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06424',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06426',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06437',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06438',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06439',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06440',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06441',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06442',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06443',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06444',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06447',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06450',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06451',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06454',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06455',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06456',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06457',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06459',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06460',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06461',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06467',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06468',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06469',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06470',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06471',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06472',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06473',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06474',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06475',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06477',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06478',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06479',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06480',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06481',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06482',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06483',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06484',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06487',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06488',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06489',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06491',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06492',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06493',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06494',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06495',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06497',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06498',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06501',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06502',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06503',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06504',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06505',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06506',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06507',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06508',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06509',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06510',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06511',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06512',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06513',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06514',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06515',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06516',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06517',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06518',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06519',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06520',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06521',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06524',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06525',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06530',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06531',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06532',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06533',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06534',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06535',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06536',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06537',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06540',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06601',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06602',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06604',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06605',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06606',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06607',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06608',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06610',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06611',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06612',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06614',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06615',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06673',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06701',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06702',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06703',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06704',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06705',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06706',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06708',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06710',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06712',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06716',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06720',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06721',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06722',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06723',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06724',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06725',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06749',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06750',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06751',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06752',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06753',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06754',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06755',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06756',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06757',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06758',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06759',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06762',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06763',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06770',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06776',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06777',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06778',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06779',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06781',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06782',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06783',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06784',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06785',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06786',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06787',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06790',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06791',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06792',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06793',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06794',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06795',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06796',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06798',
    dma_code: '533',
    dma_description: 'HARTFORD & NEW HAVEN',
  },
  {
    zip_code: '06801',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06804',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06807',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06810',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06811',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06812',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06813',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06814',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06816',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06817',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06820',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06824',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06825',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06828',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06829',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06830',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06831',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06832',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06836',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06838',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06840',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06842',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06850',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06851',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06852',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06853',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06854',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06855',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06856',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06857',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06858',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06859',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06860',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06870',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06875',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06876',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06877',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06878',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06879',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06880',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06881',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06883',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06888',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06889',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06890',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06896',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06897',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06901',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06902',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06903',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06904',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06905',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06906',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06907',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06911',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06912',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06913',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06914',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06920',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06921',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06922',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06925',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06926',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06927',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '06928',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07001',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07002',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07003',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07004',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07005',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07006',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07007',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07008',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07009',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07010',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07011',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07012',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07013',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07014',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07015',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07016',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07017',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07018',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07019',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07020',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07021',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07022',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07023',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07024',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07026',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07027',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07028',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07029',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07030',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07031',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07032',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07033',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07034',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07035',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07036',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07039',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07040',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07041',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07042',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07043',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07044',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07045',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07046',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07047',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07050',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07051',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07052',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07054',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07055',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07057',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07058',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07059',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07060',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07061',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07062',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07063',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07064',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07065',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07066',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07067',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07068',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07069',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07070',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07071',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07072',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07073',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07074',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07075',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07076',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07077',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07078',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07079',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07080',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07081',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07082',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07083',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07086',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07087',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07088',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07090',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07091',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07092',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07093',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07094',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07095',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07096',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07097',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07099',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07101',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07102',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07103',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07104',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07105',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07106',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07107',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07108',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07109',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07110',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07111',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07112',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07114',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07175',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07182',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07184',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07188',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07189',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07192',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07193',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07194',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07195',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07198',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07199',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07201',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07202',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07203',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07204',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07205',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07206',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07207',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07208',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07302',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07303',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07304',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07305',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07306',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07307',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07308',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07309',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07310',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07311',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07395',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07399',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07401',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07403',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07405',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07407',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07410',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07416',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07417',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07418',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07419',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07420',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07421',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07422',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07423',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07424',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07428',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07430',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07432',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07435',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07436',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07438',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07439',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07440',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07442',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07444',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07446',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07450',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07451',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07452',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07456',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07457',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07458',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07460',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07461',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07462',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07463',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07465',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07470',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07474',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07477',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07480',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07481',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07495',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07501',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07502',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07503',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07504',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07505',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07506',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07507',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07508',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07509',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07510',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07511',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07512',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07513',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07514',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07522',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07524',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07533',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07538',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07543',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07544',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07601',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07602',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07603',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07604',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07605',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07606',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07607',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07608',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07620',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07621',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07624',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07626',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07627',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07628',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07630',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07631',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07632',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07640',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07641',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07642',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07643',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07644',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07645',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07646',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07647',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07648',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07649',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07650',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07652',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07653',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07656',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07657',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07660',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07661',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07662',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07663',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07666',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07670',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07675',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07676',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07677',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07699',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07701',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07702',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07703',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07704',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07709',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07710',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07711',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07712',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07715',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07716',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07717',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07718',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07719',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07720',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07721',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07722',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07723',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07724',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07726',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07727',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07728',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07730',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07731',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07732',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07733',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07734',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07735',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07737',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07738',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07739',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07740',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07746',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07747',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07748',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07750',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07751',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07752',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07753',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07754',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07755',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07756',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07757',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07758',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07760',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07762',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07763',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07764',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07765',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07777',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07799',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07801',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07802',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07803',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07806',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07820',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07821',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07822',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07823',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07825',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07826',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07827',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07828',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07829',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07830',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07831',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07832',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07833',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07834',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07836',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07837',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07838',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07839',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07840',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07842',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07843',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07844',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07845',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07846',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07847',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07848',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07849',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07850',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07851',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07852',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07853',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07855',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07856',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07857',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07860',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07863',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07865',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07866',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07869',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07870',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07871',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07874',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07875',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07876',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07877',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07878',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07879',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07880',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07881',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07882',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07885',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07890',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07901',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07902',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07920',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07921',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07922',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07924',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07926',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07927',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07928',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07930',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07931',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07932',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07933',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07934',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07935',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07936',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07938',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07939',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07940',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07945',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07946',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07950',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07960',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07961',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07962',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07963',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07970',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07974',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07976',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07977',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07978',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07979',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07980',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07981',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '07983',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08001',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08002',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08003',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08004',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08005',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08006',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08007',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08008',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08009',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08010',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08011',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08012',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08014',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08015',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08016',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08018',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08019',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08020',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08021',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08022',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08023',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08025',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08026',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08027',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08028',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08029',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08030',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08031',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08032',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08033',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08034',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08035',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08036',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08037',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08038',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08039',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08041',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08042',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08043',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08045',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08046',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08048',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08049',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08050',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08051',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08052',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08053',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08054',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08055',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08056',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08057',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08059',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08060',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08061',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08062',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08063',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08064',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08065',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08066',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08067',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08068',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08069',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08070',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08071',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08072',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08073',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08074',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08075',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08076',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08077',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08078',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08079',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08080',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08081',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08083',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08084',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08085',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08086',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08087',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08088',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08089',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08090',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08091',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08092',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08093',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08094',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08095',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08096',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08097',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08098',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08099',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08101',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08102',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08103',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08104',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08105',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08106',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08107',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08108',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08109',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08110',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08201',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08202',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08203',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08204',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08205',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08210',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08212',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08213',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08214',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08215',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08217',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08218',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08219',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08220',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08221',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08223',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08224',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08225',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08226',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08230',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08231',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08232',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08234',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08240',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08241',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08242',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08243',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08244',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08245',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08246',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08247',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08248',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08250',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08251',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08252',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08260',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08270',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08302',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08310',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08311',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08312',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08313',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08314',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08315',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08316',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08317',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08318',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08319',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08320',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08321',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08322',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08323',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08324',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08326',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08327',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08328',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08329',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08330',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08332',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08340',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08341',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08342',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08343',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08344',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08345',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08346',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08347',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08348',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08349',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08350',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08352',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08353',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08360',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08361',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08362',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08401',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08402',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08403',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08404',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08405',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08406',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08501',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08502',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08504',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08505',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08510',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08511',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08512',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08514',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08515',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08518',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08520',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08525',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08526',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08527',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08528',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08530',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08533',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08534',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08535',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08536',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08540',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08541',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08542',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08543',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08544',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08550',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08551',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08553',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08554',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08555',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08556',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08557',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08558',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08559',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08560',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08561',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08562',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08601',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08602',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08603',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08604',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08605',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08606',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08607',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08608',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08609',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08610',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08611',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08618',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08619',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08620',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08625',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08628',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08629',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08638',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08640',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08641',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08645',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08646',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08647',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08648',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08650',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08666',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08677',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08690',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08691',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08695',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '08701',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08720',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08721',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08722',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08723',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08724',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08730',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08731',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08732',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08733',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08734',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08735',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08736',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08738',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08739',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08740',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08741',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08742',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08750',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08751',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08752',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08753',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08754',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08755',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08756',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08757',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08758',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08759',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08801',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08802',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08803',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08804',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08805',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08807',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08808',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08809',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08810',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08812',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08816',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08817',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08818',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08820',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08821',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08822',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08823',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08824',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08825',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08826',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08827',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08828',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08829',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08830',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08831',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08832',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08833',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08834',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08835',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08836',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08837',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08840',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08844',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08846',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08848',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08850',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08852',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08853',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08854',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08855',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08857',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08858',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08859',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08861',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08862',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08863',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08865',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08867',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08868',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08869',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08870',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08871',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08872',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08873',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08875',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08876',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08879',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08880',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08882',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08884',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08885',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08886',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08887',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08888',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08889',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08890',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08896',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08899',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08901',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08902',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08903',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08904',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08905',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08906',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08922',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '08933',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10001',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10002',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10003',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10004',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10005',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10006',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10007',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10008',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10009',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10010',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10011',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10012',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10013',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10014',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10016',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10017',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10018',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10019',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10020',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10021',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10022',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10023',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10024',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10025',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10026',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10027',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10028',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10029',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10030',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10031',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10032',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10033',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10034',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10035',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10036',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10037',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10038',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10039',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10040',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10041',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10043',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10044',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10045',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10046',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10047',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10055',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10065',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10069',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10072',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10075',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10079',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10080',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10081',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10082',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10087',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10094',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10095',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10096',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10101',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10102',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10103',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10104',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10105',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10106',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10107',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10108',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10109',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10110',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10111',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10112',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10113',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10114',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10115',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10116',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10117',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10118',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10119',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10120',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10121',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10122',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10123',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10124',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10125',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10126',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10128',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10129',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10130',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10131',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10132',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10133',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10138',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10149',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10150',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10151',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10152',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10153',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10154',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10155',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10156',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10157',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10158',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10159',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10160',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10161',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10162',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10163',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10164',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10165',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10166',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10167',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10168',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10169',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10170',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10171',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10172',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10173',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10174',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10175',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10176',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10177',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10178',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10179',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10184',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10185',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10196',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10197',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10199',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10203',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10211',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10212',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10213',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10249',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10256',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10258',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10259',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10260',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10261',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10265',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10268',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10269',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10270',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10271',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10272',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10273',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10274',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10275',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10276',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10277',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10278',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10279',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10280',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10281',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10282',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10285',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10286',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10292',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10301',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10302',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10303',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10304',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10305',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10306',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10307',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10308',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10309',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10310',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10311',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10312',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10313',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10314',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10451',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10452',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10453',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10454',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10455',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10456',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10457',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10458',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10459',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10460',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10461',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10462',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10463',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10464',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10465',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10466',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10467',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10468',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10469',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10470',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10471',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10472',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10473',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10474',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10475',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10499',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10501',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10502',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10503',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10504',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10505',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10506',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10507',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10509',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10510',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10511',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10512',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10514',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10516',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10517',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10518',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10519',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10520',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10521',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10522',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10523',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10524',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10526',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10527',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10528',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10530',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10532',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10533',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10535',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10536',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10537',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10538',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10540',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10541',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10542',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10543',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10545',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10546',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10547',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10548',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10549',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10550',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10551',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10552',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10553',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10557',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10558',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10560',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10562',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10566',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10567',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10570',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10571',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10572',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10573',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10576',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10577',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10578',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10579',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10580',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10583',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10587',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10588',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10589',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10590',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10591',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10594',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10595',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10596',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10597',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10598',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10601',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10602',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10603',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10604',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10605',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10606',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10607',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10610',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10701',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10702',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10703',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10704',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10705',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10706',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10707',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10708',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10709',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10710',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10801',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10802',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10803',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10804',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10805',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10901',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10910',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10911',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10912',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10913',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10914',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10915',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10916',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10917',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10918',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10919',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10920',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10921',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10922',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10923',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10924',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10925',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10926',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10927',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10928',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10930',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10931',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10932',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10933',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10940',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10941',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10943',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10949',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10950',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10952',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10953',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10954',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10956',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10958',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10959',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10960',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10962',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10963',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10964',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10965',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10968',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10969',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10970',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10973',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10974',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10975',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10976',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10977',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10979',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10980',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10981',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10982',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10983',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10984',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10985',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10986',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10987',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10988',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10989',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10990',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10992',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10993',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10994',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10996',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10997',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '10998',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11001',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11002',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11003',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11004',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11005',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11010',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11020',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11021',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11022',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11023',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11024',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11025',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11027',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11030',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11040',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11041',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11042',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11043',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11044',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11050',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11051',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11052',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11053',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11054',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11055',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11096',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11101',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11102',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11103',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11104',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11105',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11106',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11109',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11120',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11201',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11202',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11203',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11204',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11205',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11206',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11207',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11208',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11209',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11210',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11211',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11212',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11213',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11214',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11215',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11216',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11217',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11218',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11219',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11220',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11221',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11222',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11223',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11224',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11225',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11226',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11228',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11229',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11230',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11231',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11232',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11233',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11234',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11235',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11236',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11237',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11238',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11239',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11240',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11241',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11242',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11243',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11244',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11245',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11247',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11248',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11251',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11252',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11254',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11255',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11256',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11351',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11352',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11354',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11355',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11356',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11357',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11358',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11359',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11360',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11361',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11362',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11363',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11364',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11365',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11366',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11367',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11368',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11369',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11370',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11371',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11372',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11373',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11374',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11375',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11377',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11378',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11379',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11380',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11381',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11385',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11386',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11390',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11405',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11411',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11412',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11413',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11414',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11415',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11416',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11417',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11418',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11419',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11420',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11421',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11422',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11423',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11424',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11425',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11426',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11427',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11428',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11429',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11430',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11431',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11432',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11433',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11434',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11435',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11436',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11439',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11451',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11499',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11501',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11507',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11509',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11510',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11514',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11516',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11518',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11520',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11530',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11531',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11535',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11536',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11542',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11545',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11547',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11548',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11549',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11550',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11551',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11552',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11553',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11554',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11555',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11556',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11557',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11558',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11559',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11560',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11561',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11563',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11565',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11566',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11568',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11569',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11570',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11571',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11572',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11575',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11576',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11577',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11579',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11580',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11581',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11582',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11590',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11592',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11594',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11595',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11596',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11597',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11598',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11690',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11691',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11692',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11693',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11694',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11695',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11697',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11701',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11702',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11703',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11704',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11705',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11706',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11707',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11708',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11709',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11710',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11713',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11714',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11715',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11716',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11717',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11718',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11719',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11720',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11721',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11722',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11724',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11725',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11726',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11727',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11729',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11730',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11731',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11732',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11733',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11735',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11736',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11737',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11738',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11739',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11740',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11741',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11742',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11743',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11746',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11747',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11749',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11750',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11751',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11752',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11753',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11754',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11755',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11756',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11757',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11758',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11760',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11762',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11763',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11764',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11765',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11766',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11767',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11768',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11769',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11770',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11771',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11772',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11773',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11774',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11775',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11776',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11777',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11778',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11779',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11780',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11782',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11783',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11784',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11786',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11787',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11788',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11789',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11790',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11791',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11792',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11793',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11794',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11795',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11796',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11797',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11798',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11801',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11802',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11803',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11804',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11815',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11853',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11854',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11855',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11901',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11930',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11931',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11932',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11933',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11934',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11935',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11937',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11939',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11940',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11941',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11942',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11944',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11946',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11947',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11948',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11949',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11950',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11951',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11952',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11953',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11954',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11955',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11956',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11957',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11958',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11959',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11960',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11961',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11962',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11963',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11964',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11965',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11967',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11968',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11969',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11970',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11971',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11972',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11973',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11975',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11976',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11977',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11978',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '11980',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12007',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12008',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12009',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12010',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12015',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12016',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12017',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12018',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12019',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12020',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12022',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12023',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12024',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12025',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12027',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12028',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12029',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12031',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12032',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12033',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12035',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12036',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12037',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12040',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12041',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12042',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12043',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12045',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12046',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12047',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12050',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12051',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12052',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12053',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12054',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12055',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12056',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12057',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12058',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12059',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12060',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12061',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12062',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12063',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12064',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '12065',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12066',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12067',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12068',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12069',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12070',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12071',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12072',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12073',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12074',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12075',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12076',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12077',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12078',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12082',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12083',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12084',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12085',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12086',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12087',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12089',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12090',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12092',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12093',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12094',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12095',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12106',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12107',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12108',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12110',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12115',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12116',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '12117',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12118',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12120',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12121',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12122',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12123',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12124',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12125',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12128',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12130',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12131',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12132',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12133',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12134',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12136',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12137',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12138',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12139',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12140',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12141',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12143',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12144',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12147',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12148',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12149',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12150',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12151',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12153',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12154',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12155',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '12156',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12157',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12158',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12159',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12160',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12161',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12164',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12165',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12166',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12167',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '12168',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12169',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12170',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12172',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12173',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12174',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12175',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12176',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12177',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12180',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12181',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12182',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12183',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12184',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12185',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12186',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12187',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12188',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12189',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12190',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12192',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12193',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12194',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12195',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12196',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12197',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '12198',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12201',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12202',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12203',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12204',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12205',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12206',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12207',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12208',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12209',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12210',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12211',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12212',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12214',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12220',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12222',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12223',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12224',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12225',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12226',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12227',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12228',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12229',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12230',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12231',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12232',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12233',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12234',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12235',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12236',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12237',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12239',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12240',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12241',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12242',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12243',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12244',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12245',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12246',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12248',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12249',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12250',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12252',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12255',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12256',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12257',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12260',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12261',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12288',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12301',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12302',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12303',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12304',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12305',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12306',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12307',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12308',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12309',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12325',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12345',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12401',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12402',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12404',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12405',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12406',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '12407',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12409',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12410',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12411',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12412',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12413',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12414',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12416',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12417',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12418',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12419',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12420',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12421',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '12422',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12423',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12424',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12427',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12428',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12429',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12430',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '12431',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12432',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12433',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12434',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '12435',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12436',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12438',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '12439',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12440',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12441',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12442',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12443',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12444',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12446',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12448',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12449',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12450',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12451',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12452',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12453',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12454',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12455',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '12456',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12457',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12458',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12459',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '12460',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12461',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12463',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12464',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12465',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12466',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12468',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12469',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12470',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12471',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12472',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12473',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12474',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '12475',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12477',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12480',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12481',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12482',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12483',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12484',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12485',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12486',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12487',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12489',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12490',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12491',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12492',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12493',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12494',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12495',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12496',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12498',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12501',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12502',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12503',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12504',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12506',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12507',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12508',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12510',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12511',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12512',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12513',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12514',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12515',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12516',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12517',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12518',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12520',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12521',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12522',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12523',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12524',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12525',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12526',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12527',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12528',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12529',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12530',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12531',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12533',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12534',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12537',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12538',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12540',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12541',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12542',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12543',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12544',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12545',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12546',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12547',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12548',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12549',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12550',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12551',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12552',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12553',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12555',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12561',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12563',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12564',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12565',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12566',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12567',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12568',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12569',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12570',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12571',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12572',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12574',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12575',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12577',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12578',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12580',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12581',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12582',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12583',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12584',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12585',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12586',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12588',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12589',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12590',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12592',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12593',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12594',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12601',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12602',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12603',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12604',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12701',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12719',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12720',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12721',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12722',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12723',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12724',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12725',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12726',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12727',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12729',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12732',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12733',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12734',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12736',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12737',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12738',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12740',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12741',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12742',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12743',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12745',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12746',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12747',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12748',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12749',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12750',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12751',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12752',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12754',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12758',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12759',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12760',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12762',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12763',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12764',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12765',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12766',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12767',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12768',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12769',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12770',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12771',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12775',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12776',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12777',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12778',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12779',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12780',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12781',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12783',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12784',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12785',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12786',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12787',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12788',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12789',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12790',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12791',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12792',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '12801',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12803',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12804',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12808',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12809',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12810',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12811',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12812',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12814',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12815',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12816',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12817',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12819',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12820',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12821',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12822',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12823',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12824',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12827',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12828',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12831',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12832',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12833',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12834',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12835',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12836',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12837',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12838',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12839',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12841',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12842',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12843',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12844',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12845',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12846',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12847',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12848',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12849',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12850',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12851',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12852',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12853',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12854',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12855',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12856',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12857',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12858',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12859',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12860',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12861',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12862',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12863',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12864',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12865',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12866',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12870',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12871',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12872',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12873',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12874',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12878',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12879',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12883',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12884',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12885',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12886',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12887',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '12901',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12903',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12910',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12911',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12912',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12913',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12914',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12915',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12916',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12917',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12918',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12919',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12920',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12921',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12922',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '12923',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12924',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12926',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12927',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '12928',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12929',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12930',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12932',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12933',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12934',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12935',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12936',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12937',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12939',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12941',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12942',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12943',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12944',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12945',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12946',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12949',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '12950',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12952',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12953',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12955',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12956',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12957',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12958',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12959',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12960',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12961',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12962',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12964',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12965',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '12966',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12967',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '12969',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12970',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12972',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12973',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '12974',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12975',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12976',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12977',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12978',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12979',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12980',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12981',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12983',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12985',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12986',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12987',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12989',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12992',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12993',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12995',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12996',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12997',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '12998',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '13020',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13021',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13022',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13024',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13026',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13027',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13028',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13029',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13030',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13031',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13032',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13033',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13034',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13035',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13036',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13037',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13039',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13040',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13041',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13042',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13043',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13044',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13045',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13051',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13052',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13053',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13054',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13056',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13057',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13060',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13061',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13062',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13063',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13064',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13065',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13066',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13068',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13069',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13071',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13072',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13073',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13074',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13076',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13077',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13078',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13080',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13081',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13082',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13083',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13084',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13087',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13088',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13089',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13090',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13092',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13093',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13101',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13102',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13103',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13104',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13107',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13108',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13110',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13111',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13112',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13113',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13114',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13115',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13116',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13117',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13118',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13119',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13120',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13121',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13122',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13123',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13124',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13126',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13131',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13132',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13134',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13135',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13136',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13137',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13138',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13139',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13140',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13141',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13142',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13143',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '13144',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13145',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13146',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '13147',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13148',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13152',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13153',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13154',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '13155',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13156',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13157',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13158',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13159',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13160',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13162',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13163',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13164',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13165',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13166',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13167',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13201',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13202',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13203',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13204',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13205',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13206',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13207',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13208',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13209',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13210',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13211',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13212',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13214',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13215',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13217',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13218',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13219',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13220',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13221',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13224',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13225',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13235',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13244',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13250',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13251',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13252',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13261',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13290',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13301',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13302',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13303',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13304',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13305',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13308',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13309',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13310',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13312',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13313',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13314',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13315',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13316',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13317',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '13318',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13319',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13320',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13321',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13322',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13323',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13324',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13325',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13326',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13327',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13328',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13329',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13331',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13332',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13333',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13334',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13335',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13337',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13338',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13339',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '13340',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13341',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13342',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13343',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13345',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13346',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13348',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13350',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13352',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13353',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '13354',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13355',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13357',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13360',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '13361',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13362',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13363',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13364',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13365',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13367',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13368',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13401',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13402',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13403',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13404',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13406',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13407',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13408',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13409',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13410',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '13411',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13413',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13415',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13416',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13417',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13418',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13420',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13421',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13424',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13425',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13426',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13428',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '13431',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13433',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13435',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13436',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '13437',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13438',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13439',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13440',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13441',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13442',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13449',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13450',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13452',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '13454',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13455',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13456',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13457',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13459',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '13460',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13461',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13464',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13465',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13468',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13469',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13470',
    dma_code: '532',
    dma_description: 'ALBANY - SCHENECTADY - TROY',
  },
  {
    zip_code: '13471',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13472',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13473',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13475',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13476',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13477',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13478',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13479',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13480',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13482',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13483',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13484',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13485',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13486',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13488',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13489',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13490',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13491',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13492',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13493',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13494',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13495',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13501',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13502',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13503',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13504',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13505',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13599',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13601',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13602',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13603',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13605',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13606',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13607',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13608',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13611',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13612',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13613',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13614',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13615',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13616',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13617',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13618',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13619',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13620',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13621',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13622',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13623',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13624',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13625',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13626',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13627',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13628',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13630',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13631',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13632',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13633',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13634',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13635',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13636',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13637',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13638',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13639',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13640',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13641',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13642',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13643',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13645',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13646',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13647',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13648',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13649',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13650',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13651',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13652',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13654',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13655',
    dma_code: '523',
    dma_description: 'BURLINGTON - PLATTSBURGH',
  },
  {
    zip_code: '13656',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13657',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13658',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13659',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13660',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13661',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13662',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13664',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13665',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13666',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13667',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13668',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13669',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13670',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13671',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13672',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13673',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13674',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13675',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13676',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13677',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13678',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13679',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13680',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13681',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13682',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13683',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13684',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13685',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13687',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13690',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13691',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13692',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13693',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13694',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13695',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13696',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13697',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13699',
    dma_code: '549',
    dma_description: 'WATERTOWN',
  },
  {
    zip_code: '13730',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13731',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13732',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13733',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13734',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13736',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13737',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13738',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13739',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13740',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13743',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13744',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13745',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13746',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13747',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13748',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13749',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13750',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13751',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13752',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13753',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13754',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13755',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13756',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13757',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13758',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13760',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13761',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13762',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13763',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13774',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13775',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13776',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13777',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13778',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13780',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13782',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13783',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13784',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13786',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13787',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13788',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13790',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13794',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13795',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13796',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13797',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13801',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13802',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13803',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13804',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13806',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13807',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13808',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13809',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13810',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13811',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13812',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13813',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13814',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13815',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13820',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13825',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13826',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13827',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13830',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13832',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13833',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13834',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13835',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13837',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13838',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13839',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13840',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13841',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13842',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13843',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13844',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13845',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13846',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13847',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13848',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13849',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13850',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13851',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13856',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13859',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13860',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13861',
    dma_code: '526',
    dma_description: 'UTICA',
  },
  {
    zip_code: '13862',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13863',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '13864',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13865',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13901',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13902',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13903',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13904',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '13905',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '14001',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14004',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14005',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14006',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14008',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14009',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14010',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14011',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14012',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14013',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14020',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14021',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14024',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14025',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14026',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14027',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14028',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14029',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14030',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14031',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14032',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14033',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14034',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14035',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14036',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14037',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14038',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14039',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14040',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14041',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14042',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14043',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14047',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14048',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14051',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14052',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14054',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14055',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14056',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14057',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14058',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14059',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14060',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14061',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14062',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14063',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14065',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14066',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14067',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14068',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14069',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14070',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14072',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14075',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14080',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14081',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14082',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14083',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14085',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14086',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14091',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14092',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14094',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14095',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14098',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14101',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14102',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14103',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14105',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14107',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14108',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14109',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14110',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14111',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14112',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14113',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14120',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14125',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14126',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14127',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14129',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14130',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14131',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14132',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14133',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14134',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14135',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14136',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14138',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14139',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14140',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14141',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14143',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14144',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14145',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14150',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14151',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14166',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14167',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14168',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14169',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14170',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14171',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14172',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14173',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14174',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14201',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14202',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14203',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14204',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14205',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14206',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14207',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14208',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14209',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14210',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14211',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14212',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14213',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14214',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14215',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14216',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14217',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14218',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14219',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14220',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14221',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14222',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14223',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14224',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14225',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14226',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14227',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14228',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14231',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14233',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14240',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14241',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14260',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14261',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14263',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14264',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14265',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14267',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14269',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14270',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14272',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14273',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14276',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14280',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14301',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14302',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14303',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14304',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14305',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14410',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14411',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14413',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14414',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14415',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14416',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14418',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14420',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14422',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14423',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14424',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14425',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14427',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14428',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14429',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14430',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14432',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14433',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14435',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14437',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14441',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14443',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14445',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14449',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14450',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14452',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14453',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14454',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14456',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14461',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14462',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14463',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14464',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14466',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14467',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14468',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14469',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14470',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14471',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14472',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14475',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14476',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14477',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14478',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14479',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14480',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14481',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14482',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14485',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14486',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14487',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14488',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14489',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14502',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14504',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14505',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14506',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14507',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14508',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14510',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14511',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14512',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14513',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14514',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14515',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14516',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14517',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14518',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14519',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14520',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14521',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14522',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14525',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14526',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14527',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14529',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14530',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14532',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14533',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14534',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14536',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14537',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14538',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14539',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14541',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14542',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14543',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14544',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14545',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14546',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14547',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14548',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14549',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14550',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14551',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14555',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14556',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14557',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14558',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14559',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14560',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14561',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14563',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14564',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14568',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14569',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14571',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14572',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14580',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14585',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14586',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14588',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14589',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14590',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14591',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14592',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14602',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14603',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14604',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14605',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14606',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14607',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14608',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14609',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14610',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14611',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14612',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14613',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14614',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14615',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14616',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14617',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14618',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14619',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14620',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14621',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14622',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14623',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14624',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14625',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14626',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14627',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14642',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14643',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14644',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14645',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14646',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14647',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14649',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14650',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14651',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14652',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14653',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14673',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14692',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14694',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14701',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14702',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14706',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14707',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14708',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14709',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14710',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14711',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14712',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14714',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14715',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14716',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14717',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14718',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14719',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14720',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14721',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14722',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14723',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14724',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14726',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14727',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14728',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14729',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14730',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14731',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14732',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14733',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14735',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14736',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14737',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14738',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14739',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14740',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14741',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14742',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14743',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14744',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14745',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14747',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14748',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14750',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14751',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14752',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14753',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14754',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14755',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14756',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14757',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14758',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14760',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14766',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14767',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14769',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14770',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14772',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14774',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14775',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14777',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14778',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14779',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14781',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14782',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14783',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14784',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14785',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14786',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14787',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14788',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14801',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14802',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14803',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14804',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14805',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14806',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14807',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14808',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14809',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14810',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14812',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14813',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14814',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14815',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14816',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14817',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14818',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14819',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14820',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14821',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14822',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14823',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14824',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14825',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14826',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14827',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14830',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14831',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14836',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14837',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14838',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14839',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14840',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14841',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14842',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14843',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14845',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14846',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14847',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14850',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14851',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14852',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14853',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14854',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14855',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14856',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14857',
    dma_code: '538',
    dma_description: 'ROCHESTER, NY',
  },
  {
    zip_code: '14858',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14859',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '14860',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14861',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14863',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14864',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14865',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14867',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14869',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14870',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14871',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14872',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14873',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14874',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14876',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14877',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14878',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14879',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14880',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14881',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14882',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14883',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '14884',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14885',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14886',
    dma_code: '555',
    dma_description: 'SYRACUSE',
  },
  {
    zip_code: '14887',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14889',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14891',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14892',
    dma_code: '502',
    dma_description: 'BINGHAMTON',
  },
  {
    zip_code: '14893',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14894',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14895',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14897',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '14898',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14901',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14902',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14903',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14904',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14905',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '14925',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '15001',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15003',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15004',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15005',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15006',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15007',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15009',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15010',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15012',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15014',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15015',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15017',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15018',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15019',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15020',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15021',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15022',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15024',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15025',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15026',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15027',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15028',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15030',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15031',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15032',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15033',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15034',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15035',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15037',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15038',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15042',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15043',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15044',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15045',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15046',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15047',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15049',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15050',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15051',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15052',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15053',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15054',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15055',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15056',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15057',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15059',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15060',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15061',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15062',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15063',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15064',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15065',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15066',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15067',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15068',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15069',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15071',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15072',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15074',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15075',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15076',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15077',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15078',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15081',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15082',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15083',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15084',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15085',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15086',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15087',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15088',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15089',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15090',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15091',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15095',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15096',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15101',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15102',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15104',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15106',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15108',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15110',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15112',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15116',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15120',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15122',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15123',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15126',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15127',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15129',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15131',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15132',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15133',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15134',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15135',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15136',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15137',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15139',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15140',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15142',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15143',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15144',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15145',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15146',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15147',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15148',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15201',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15202',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15203',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15204',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15205',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15206',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15207',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15208',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15209',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15210',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15211',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15212',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15213',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15214',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15215',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15216',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15217',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15218',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15219',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15220',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15221',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15222',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15223',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15224',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15225',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15226',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15227',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15228',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15229',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15230',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15231',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15232',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15233',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15234',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15235',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15236',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15237',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15238',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15239',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15240',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15241',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15242',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15243',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15244',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15250',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15252',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15253',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15254',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15255',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15257',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15258',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15259',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15260',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15261',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15262',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15263',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15265',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15267',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15268',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15270',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15272',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15275',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15276',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15277',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15278',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15279',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15281',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15282',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15283',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15285',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15286',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15289',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15290',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15301',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15310',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15311',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15312',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15313',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15314',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15315',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15316',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15317',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15320',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15321',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15322',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15323',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15324',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15325',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15327',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15329',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15330',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15331',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15332',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15333',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15334',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15336',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15337',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15338',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15339',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15340',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15341',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15342',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15344',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15345',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15346',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15347',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15348',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15349',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15350',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15351',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15352',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15353',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15357',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15358',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15359',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15360',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15361',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15362',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15363',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15364',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15365',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15366',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15367',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15368',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15370',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15376',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15377',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15378',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15379',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15380',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15401',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15410',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15411',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15412',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15413',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15415',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15416',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15417',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15419',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15420',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15421',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15422',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15423',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15424',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15425',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15427',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15428',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15429',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15430',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15431',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15432',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15433',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15434',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15435',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15436',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15437',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15438',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15439',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15440',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15442',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15443',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15444',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15445',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15446',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15447',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15448',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15449',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15450',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15451',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15454',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15455',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15456',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15458',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15459',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15460',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15461',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15462',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15463',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15464',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15465',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15466',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15467',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15468',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15469',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15470',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15472',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15473',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15474',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15475',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15476',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15477',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15478',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15479',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15480',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15482',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15483',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15484',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15485',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15486',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15488',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15489',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15490',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15492',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15501',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15502',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15510',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15520',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15521',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15522',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15530',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15531',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15532',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15533',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15534',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15535',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15536',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '15537',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15538',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15539',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15540',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15541',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15542',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15544',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15545',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15546',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15547',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15548',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15549',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15550',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15551',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15552',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15553',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15554',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15555',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15557',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15558',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15559',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15560',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15561',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15562',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15563',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15564',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15565',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15601',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15605',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15606',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15610',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15611',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15612',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15613',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15615',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15616',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15617',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15618',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15619',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15620',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15621',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15622',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15623',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15624',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15625',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15626',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15627',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15628',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15629',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15631',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15632',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15633',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15634',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15635',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15636',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15637',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15638',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15639',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15640',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15641',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15642',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15644',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15646',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15647',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15650',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15655',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15656',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15658',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15660',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15661',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15662',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15663',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15664',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15665',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15666',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15668',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15670',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15671',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15672',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15673',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15674',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15675',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15676',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15677',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15678',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15679',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15680',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15681',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15682',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15683',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15684',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15685',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15686',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15687',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15688',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15689',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15690',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15691',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15692',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15693',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15695',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15696',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15697',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15698',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15701',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15705',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15710',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15711',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15712',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15713',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15714',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15715',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15716',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15717',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15720',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15721',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15722',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15723',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15724',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15725',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15727',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15728',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15729',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15730',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15731',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15732',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15733',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15734',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15736',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15737',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15738',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15739',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15740',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15741',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15742',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15744',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15745',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15746',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15747',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15748',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15750',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15752',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15753',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15754',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15756',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15757',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15758',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15759',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15760',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15761',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15762',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15763',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15764',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15765',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15767',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15770',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15771',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15772',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15773',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15774',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15775',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15776',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15777',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15778',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15779',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15780',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15781',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15783',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15784',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15801',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15821',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15822',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15823',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15824',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15825',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15827',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15828',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15829',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15831',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15832',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15834',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15840',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15841',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15845',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15846',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15847',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15848',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15849',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15851',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15853',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15856',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15857',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15860',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15861',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15863',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15864',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15865',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15866',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15868',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15870',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15901',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15902',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15904',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15905',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15906',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15907',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15909',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15920',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15921',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15922',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15923',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15924',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15925',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15926',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15927',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15928',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15929',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15930',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15931',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15934',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15935',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15936',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15937',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15938',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15940',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15942',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15943',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15944',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15945',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15946',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15948',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15949',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15951',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15952',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15953',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15954',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15955',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15956',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15957',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '15958',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15959',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15960',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15961',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15962',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '15963',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16001',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16002',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16003',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16016',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16017',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16018',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16020',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16022',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16023',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16024',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16025',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16027',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16028',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16029',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16030',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16033',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16034',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16035',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16036',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16037',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16038',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16039',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16040',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16041',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16045',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16046',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16048',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16049',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16050',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16051',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16052',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16053',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16054',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16055',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16056',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16057',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16058',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16059',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16061',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16063',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16066',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16101',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16102',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16103',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16105',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16107',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16108',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16110',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16111',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16112',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16113',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16114',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16115',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16116',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16117',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16120',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16121',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16123',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16124',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16125',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16127',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16130',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16131',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16132',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16133',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16134',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16136',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16137',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16140',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16141',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16142',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16143',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16145',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16146',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16148',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16150',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16151',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16153',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16154',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16155',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16156',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16157',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16159',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16160',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16161',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16172',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16201',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16210',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16211',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16212',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16213',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16214',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16215',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16217',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16218',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16220',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16221',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16222',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16223',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16224',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16225',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16226',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16228',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16229',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16230',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16232',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16233',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16234',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16235',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16236',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16238',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16239',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16240',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16242',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16244',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16245',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16246',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16248',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16249',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16250',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16253',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16254',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16255',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16256',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16257',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16258',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16259',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16260',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16261',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16262',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16263',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16301',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16311',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '16312',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16313',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16314',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16316',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16317',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16319',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16321',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16322',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16323',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16326',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16327',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16328',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16329',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16331',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16332',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16333',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16334',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16335',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16340',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16341',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16342',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16343',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16344',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16345',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16346',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16347',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16350',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16351',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16352',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16353',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16354',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16360',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16361',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16362',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16364',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16365',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16366',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16367',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16368',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16369',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16370',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16371',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16372',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16373',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16374',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16375',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '16401',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16402',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16403',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16404',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16405',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16406',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16407',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16410',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16411',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16412',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16413',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16415',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16416',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16417',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16420',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16421',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16422',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16423',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16424',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16426',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16427',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16428',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16430',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16432',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16433',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16434',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16435',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16436',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16438',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16440',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16441',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16442',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16443',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16444',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16475',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16501',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16502',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16503',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16504',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16505',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16506',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16507',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16508',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16509',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16510',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16511',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16512',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16514',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16522',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16530',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16531',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16532',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16533',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16534',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16538',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16541',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16544',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16546',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16550',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16553',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16554',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16563',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16565',
    dma_code: '516',
    dma_description: 'ERIE',
  },
  {
    zip_code: '16601',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16602',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16603',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16611',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16613',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16616',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16617',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16619',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16620',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16621',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16622',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16623',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16624',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16625',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16627',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16629',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16630',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16631',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16633',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16634',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16635',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16636',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16637',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16638',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16639',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16640',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16641',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16644',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16645',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16646',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16647',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16648',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16650',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16651',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16652',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16654',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16655',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16656',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16657',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16659',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16660',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16661',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16662',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16663',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16664',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16665',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16666',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16667',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16668',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16669',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16670',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16671',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16672',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16673',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16674',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16675',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16677',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16678',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16679',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16680',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16681',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16682',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16683',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16684',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16685',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16686',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16689',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '16691',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '16692',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16693',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16694',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16695',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16698',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16699',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16701',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16720',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16724',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16725',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16726',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16727',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16728',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16729',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16730',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16731',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16732',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16733',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16734',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16735',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16738',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16740',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16743',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16744',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16745',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16746',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16748',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16749',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16750',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16801',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16802',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16803',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16804',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16805',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16820',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16821',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16822',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '16823',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16825',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16826',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16827',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16828',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16829',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16830',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16832',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16833',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16834',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16835',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16836',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16837',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16838',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16839',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16840',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16841',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16843',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16844',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16845',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16847',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16848',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '16849',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16850',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16851',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16852',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16853',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16854',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16855',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16856',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16858',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16859',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16860',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16861',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16863',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16864',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16865',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16866',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16868',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16870',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16871',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16872',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16873',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16874',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16875',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16876',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16877',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16878',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16879',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16881',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16882',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '16901',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16910',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '16911',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16912',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16914',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '16915',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16917',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16918',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16920',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16921',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16922',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16923',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16925',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '16926',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '16927',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16928',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16929',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16930',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16932',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16933',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16935',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16936',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16937',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16938',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16939',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16940',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16941',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16942',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16943',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16945',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '16946',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '16947',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '16948',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '16950',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '17001',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17002',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17003',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17004',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17005',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17006',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17007',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17008',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17009',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17010',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17011',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17012',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17013',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17014',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17015',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17016',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17017',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17018',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17019',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17020',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17021',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17022',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17023',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17024',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17025',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17026',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17027',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17028',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17029',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17030',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17032',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17033',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17034',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17035',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17036',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17037',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17038',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17039',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17040',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17041',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17042',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17043',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17044',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17045',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17046',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17047',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17048',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17049',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17050',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17051',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17052',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '17053',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17054',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17055',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17056',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17057',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17058',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17059',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17060',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '17061',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17062',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17063',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17064',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17065',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17066',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '17067',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17068',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17069',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17070',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17071',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17072',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17073',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17074',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17075',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17076',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17077',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17078',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17080',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17081',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17082',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17083',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17084',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17085',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17086',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17087',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17088',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17089',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17090',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17093',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17094',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17097',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17098',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17099',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17101',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17102',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17103',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17104',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17105',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17106',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17107',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17108',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17109',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17110',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17111',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17112',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17113',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17120',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17121',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17122',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17124',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17125',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17126',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17127',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17128',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17129',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17130',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17140',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17177',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17201',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17202',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17210',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17211',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '17212',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '17213',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '17214',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17215',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '17217',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17219',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17220',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17221',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17222',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17223',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '17224',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17225',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17228',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '17229',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '17231',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17232',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17233',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '17235',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17236',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17237',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17238',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '17239',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '17240',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17241',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17243',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '17244',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17246',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17247',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17249',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '17250',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17251',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17252',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17253',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '17254',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17255',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '17256',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17257',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17260',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '17261',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17262',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17263',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17264',
    dma_code: '574',
    dma_description: 'JOHNSTOWN - ALTOONA',
  },
  {
    zip_code: '17265',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17266',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17267',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '17268',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17270',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17271',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17272',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17301',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17302',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17303',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17304',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17306',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17307',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17309',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17310',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17311',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17312',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17313',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17314',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17315',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17316',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17317',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17318',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17319',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17320',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17321',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17322',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17323',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17324',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17325',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17326',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17327',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17329',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17331',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17332',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17333',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17334',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17337',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17339',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17340',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17342',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17343',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17344',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17345',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17347',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17349',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17350',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17352',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17353',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17354',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17355',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17356',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17358',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17360',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17361',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17362',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17363',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17364',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17365',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17366',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17368',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17370',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17371',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17372',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17375',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17401',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17402',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17403',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17404',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17405',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17406',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17407',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17408',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17415',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17501',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17502',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17503',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17504',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17505',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17506',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17507',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17508',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17509',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17512',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17516',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17517',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17518',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17519',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17520',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17521',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17522',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17527',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17528',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17529',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17532',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17533',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17534',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17535',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17536',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17537',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17538',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17540',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17543',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17545',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17547',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17549',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17550',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17551',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17552',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17554',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17555',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17557',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17560',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17562',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17563',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17564',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17565',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17566',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17567',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17568',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17569',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17570',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17572',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17573',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17575',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17576',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17578',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17579',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17580',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17581',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17582',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17583',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17584',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17585',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17601',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17602',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17603',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17604',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17605',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17606',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17607',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17608',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17622',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17699',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17701',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17702',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17703',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17705',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17720',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17721',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17723',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17724',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17726',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17727',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17728',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17729',
    dma_code: '514',
    dma_description: 'BUFFALO',
  },
  {
    zip_code: '17730',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17731',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17735',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17737',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17738',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17739',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17740',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17742',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17744',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17745',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17747',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17748',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17749',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17750',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17751',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17752',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17754',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17756',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17758',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17760',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17762',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17763',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17764',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17765',
    dma_code: '565',
    dma_description: 'ELMIRA (CORNING)',
  },
  {
    zip_code: '17767',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17768',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17769',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17771',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17772',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17773',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17774',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17776',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17777',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17778',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17779',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17801',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17810',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17812',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17813',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17814',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17815',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17820',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17821',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17822',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17823',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17824',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17827',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17829',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17830',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17831',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17832',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17833',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17834',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17835',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17836',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17837',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17839',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17840',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17841',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '17842',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17843',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17844',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17845',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17846',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17847',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17850',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17851',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17853',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17855',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17856',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17857',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17858',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17859',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17860',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17861',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17862',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17864',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17865',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17866',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17867',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17868',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17870',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17872',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17876',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17877',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17878',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17880',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17881',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17882',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17883',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17884',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17885',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17886',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17887',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17888',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17889',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17901',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17920',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17921',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17922',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17923',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17925',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17929',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17930',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17931',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17932',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17933',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17934',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17935',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17936',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17938',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17941',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17942',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17943',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17944',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17945',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17946',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17948',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17949',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17951',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17952',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17953',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17954',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17957',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17959',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17960',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17961',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17963',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17964',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17965',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17966',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17967',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17968',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17970',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17972',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17974',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17976',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17978',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17979',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17980',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17981',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17982',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17983',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '17985',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18001',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18002',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18003',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18010',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18011',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18012',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18013',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18014',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18015',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18016',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18017',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18018',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18020',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18025',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18030',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18031',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18032',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18034',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18035',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18036',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18037',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18038',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18039',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18040',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18041',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18042',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18043',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18044',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18045',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18046',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18049',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18050',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18051',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18052',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18053',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18054',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18055',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18056',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18058',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18059',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18060',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18062',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18063',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18064',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18065',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18066',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18067',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18068',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18069',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18070',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18071',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18072',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18073',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18074',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18076',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18077',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18078',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18079',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18080',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18081',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18083',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18084',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18085',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18086',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18087',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18088',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18091',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18092',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18098',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18099',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18101',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18102',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18103',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18104',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18105',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18106',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18109',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18195',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18201',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18202',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18210',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18211',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18212',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18214',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18216',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18218',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18219',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18220',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18221',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18222',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18223',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18224',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18225',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18229',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18230',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18231',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18232',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18234',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18235',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18237',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18239',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18240',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18241',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18242',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18244',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18245',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18246',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18247',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18248',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18249',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18250',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18251',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18252',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18254',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18255',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18256',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18301',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18302',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18320',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18321',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18322',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18323',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18324',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '18325',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18326',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18327',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18328',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '18330',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18331',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18332',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18333',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18334',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18335',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18336',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '18337',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '18340',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '18341',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18342',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18343',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18344',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18346',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18347',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18348',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18349',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18350',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18351',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18352',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18353',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18354',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18355',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18356',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18357',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18360',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18370',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18371',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '18372',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18403',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18405',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18407',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18410',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18411',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18413',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18414',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18415',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18416',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18417',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18419',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18420',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18421',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18424',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18425',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '18426',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '18427',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18428',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '18430',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18431',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18433',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18434',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18435',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '18436',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18437',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18438',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18439',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18440',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18441',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18443',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18444',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18445',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18446',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18447',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18448',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18449',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18451',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '18452',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18453',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18454',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18455',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18456',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18457',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '18458',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '18459',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18460',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18461',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18462',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18463',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18464',
    dma_code: '501',
    dma_description: 'NEW YORK',
  },
  {
    zip_code: '18465',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18466',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18469',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18470',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18471',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18472',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18473',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18501',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18502',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18503',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18504',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18505',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18507',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18508',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18509',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18510',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18512',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18514',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18515',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18517',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18518',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18519',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18522',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18577',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18601',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18602',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18603',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18610',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18611',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18612',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18614',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18615',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18616',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18617',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18618',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18619',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18621',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18622',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18623',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18624',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18625',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18626',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18627',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18628',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18629',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18630',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18631',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18632',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18634',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18635',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18636',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18640',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18641',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18642',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18643',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18644',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18651',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18653',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18654',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18655',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18656',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18657',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18660',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18661',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18690',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18701',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18702',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18703',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18704',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18705',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18706',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18707',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18708',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18709',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18710',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18711',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18762',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18764',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18765',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18766',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18767',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18769',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18773',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18801',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18810',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18812',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18813',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18814',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18815',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18816',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18817',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18818',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18820',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18821',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18822',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18823',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18824',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18825',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18826',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18827',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18828',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18829',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18830',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18831',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18832',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18833',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18834',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18837',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18840',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18842',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18843',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18844',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18845',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18846',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18847',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18848',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18850',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18851',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18853',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18854',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '18901',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18902',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18910',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18911',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18912',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18913',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18914',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18915',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18916',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18917',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18918',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18920',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18921',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18922',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18923',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18924',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18925',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18926',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18927',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18928',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18929',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18930',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18931',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18932',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18933',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18934',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18935',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18936',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18938',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18940',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18942',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18943',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18944',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18946',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18947',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18949',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18950',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18951',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18953',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18954',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18955',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18956',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18957',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18958',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18960',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18962',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18963',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18964',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18966',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18968',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18969',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18970',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18971',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18972',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18974',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18976',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18977',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18979',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18980',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18981',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '18991',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19001',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19002',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19003',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19004',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19006',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19007',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19008',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19009',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19010',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19012',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19013',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19014',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19015',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19016',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19017',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19018',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19019',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19020',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19021',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19022',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19023',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19025',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19026',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19027',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19028',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19029',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19030',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19031',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19032',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19033',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19034',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19035',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19036',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19037',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19038',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19039',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19040',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19041',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19043',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19044',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19046',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19047',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19048',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19049',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19050',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19052',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19053',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19054',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19055',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19056',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19057',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19058',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19060',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19061',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19063',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19064',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19065',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19066',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19067',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19070',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19072',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19073',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19074',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19075',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19076',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19078',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19079',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19080',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19081',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19082',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19083',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19085',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19086',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19087',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19088',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19089',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19090',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19091',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19092',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19093',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19094',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19095',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19096',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19098',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19099',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19101',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19102',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19103',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19104',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19105',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19106',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19107',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19108',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19109',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19110',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19111',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19112',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19113',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19114',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19115',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19116',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19118',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19119',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19120',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19121',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19122',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19123',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19124',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19125',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19126',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19127',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19128',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19129',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19130',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19131',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19132',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19133',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19134',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19135',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19136',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19137',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19138',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19139',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19140',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19141',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19142',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19143',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19144',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19145',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19146',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19147',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19148',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19149',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19150',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19151',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19152',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19153',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19154',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19155',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19160',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19161',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19162',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19170',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19171',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19172',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19173',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19175',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19176',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19177',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19178',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19179',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19181',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19182',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19183',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19184',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19185',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19187',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19188',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19191',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19192',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19193',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19194',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19195',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19196',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19197',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19244',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19255',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19301',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19310',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19311',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19312',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19316',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19317',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19318',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19319',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19320',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19330',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19331',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19333',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19335',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19339',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19340',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19341',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19342',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19343',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19344',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19345',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19346',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19347',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19348',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19350',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19351',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19352',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19353',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19354',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19355',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19357',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19358',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19360',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19362',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19363',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19365',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19366',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19367',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19369',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19371',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19372',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19373',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19374',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19375',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19376',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19380',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19381',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19382',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19383',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19388',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19390',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19395',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19399',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19401',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19403',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19404',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19405',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19406',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19407',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19408',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19409',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19415',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19420',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19421',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19422',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19423',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19424',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19425',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19426',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19428',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19429',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19430',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19432',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19435',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19436',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19437',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19438',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19440',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19441',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19442',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19443',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19444',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19446',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19450',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19451',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19453',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19454',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19455',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19456',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19457',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19460',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19462',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19464',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19465',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19468',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19470',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19472',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19473',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19474',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19475',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19477',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19478',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19480',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19481',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19482',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19483',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19484',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19486',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19487',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19488',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19489',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19490',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19492',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19494',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19495',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19496',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19501',
    dma_code: '566',
    dma_description: 'HARRISBURG - LNCSTR - LEB - YORK',
  },
  {
    zip_code: '19503',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19504',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19505',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19506',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19507',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19508',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19510',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19511',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19512',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19516',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19518',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19519',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19520',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19522',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19523',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19525',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19526',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19529',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19530',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19533',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19534',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19535',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19536',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19538',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19539',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19540',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19541',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19542',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19543',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19544',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19545',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19547',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19548',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19549',
    dma_code: '577',
    dma_description: 'WILKES BARRE - SCRANTON',
  },
  {
    zip_code: '19550',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19551',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19554',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19555',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19559',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19560',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19562',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19564',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19565',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19567',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19601',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19602',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19603',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19604',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19605',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19606',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19607',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19608',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19609',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19610',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19611',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19612',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19640',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19701',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19702',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19703',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19706',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19707',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19708',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19709',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19710',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19711',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19712',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19713',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19714',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19715',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19716',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19717',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19718',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19720',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19721',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19725',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19726',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19730',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19731',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19732',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19733',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19734',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19735',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19736',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19801',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19802',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19803',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19804',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19805',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19806',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19807',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19808',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19809',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19810',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19850',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19880',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19884',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19885',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19886',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19887',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19889',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19890',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19893',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19894',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19895',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19897',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19898',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19899',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19901',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19902',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19903',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19904',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19905',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19906',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19930',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19931',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19933',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19934',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19936',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19938',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19939',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19940',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19941',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19943',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19944',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19945',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19946',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19947',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19950',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19951',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19952',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19953',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19954',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19955',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19956',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19958',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19960',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19961',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19962',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19963',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19964',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19966',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19967',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19968',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19969',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19970',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19971',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19973',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19975',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '19977',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19979',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '19980',
    dma_code: '504',
    dma_description: 'PHILADELPHIA',
  },
  {
    zip_code: '20001',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20002',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20003',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20004',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20005',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20006',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20007',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20008',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20009',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20010',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20011',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20012',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20013',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20015',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20016',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20017',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20018',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20019',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20020',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20022',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20023',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20024',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20026',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20027',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20029',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20030',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20032',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20033',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20035',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20036',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20037',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20038',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20039',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20040',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20041',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20042',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20043',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20044',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20045',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20046',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20047',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20049',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20050',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20051',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20052',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20053',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20056',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20057',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20058',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20059',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20060',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20061',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20062',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20063',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20064',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20065',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20066',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20067',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20068',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20069',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20070',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20071',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20073',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20074',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20075',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20076',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20077',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20078',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20080',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20081',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20082',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20090',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20091',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20097',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20098',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20101',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20102',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20103',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20104',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20105',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20106',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20107',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20108',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20109',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20110',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20111',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20112',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20113',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20115',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20116',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20117',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20118',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20119',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20120',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20121',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20122',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20124',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20128',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20129',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20130',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20131',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20132',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20134',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20135',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20136',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20137',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20138',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20139',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20140',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20141',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20142',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20143',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20144',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20146',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20147',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20148',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20149',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20151',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20152',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20153',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20155',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20156',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20158',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20159',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20160',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20163',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20164',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20165',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20166',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20167',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20168',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20169',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20170',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20171',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20172',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20175',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20176',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20177',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20178',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20180',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20181',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20182',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20184',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20185',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20186',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20187',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20188',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20189',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20190',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20191',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20192',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20193',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20194',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20195',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20196',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20197',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20198',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20199',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20201',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20202',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20203',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20204',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20206',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20207',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20208',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20210',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20211',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20212',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20213',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20214',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20215',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20216',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20217',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20218',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20219',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20220',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20221',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20222',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20223',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20224',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20226',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20227',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20228',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20229',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20230',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20232',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20233',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20235',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20237',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20238',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20239',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20240',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20241',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20242',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20244',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20245',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20250',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20251',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20254',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20260',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20261',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20262',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20265',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20268',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20270',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20277',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20299',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20301',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20303',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20306',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20307',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20310',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20314',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20317',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20318',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20319',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20330',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20340',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20350',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20355',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20370',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20372',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20373',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20374',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20375',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20376',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20380',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20388',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20390',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20391',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20392',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20393',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20394',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20395',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20398',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20401',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20402',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20403',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20404',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20405',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20406',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20407',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20409',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20410',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20411',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20412',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20413',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20414',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20415',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20416',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20418',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20419',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20420',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20421',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20422',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20423',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20424',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20425',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20426',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20427',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20429',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20431',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20433',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20434',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20435',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20436',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20437',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20439',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20441',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20442',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20444',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20447',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20451',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20453',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20456',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20460',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20463',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20469',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20470',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20472',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20500',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20501',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20502',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20503',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20504',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20505',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20506',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20507',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20508',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20509',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20510',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20511',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20515',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20520',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20521',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20522',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20523',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20524',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20525',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20526',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20527',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20528',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20529',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20530',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20531',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20532',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20533',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20534',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20535',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20536',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20537',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20538',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20539',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20540',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20541',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20542',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20543',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20544',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20546',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20547',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20548',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20549',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20551',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20552',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20553',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20554',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20555',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20557',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20559',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20560',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20565',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20566',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20570',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20571',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20573',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20575',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20576',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20577',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20578',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20579',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20580',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20585',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20586',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20590',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20591',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20593',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20594',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20598',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20601',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20602',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20603',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20604',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20606',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20607',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20608',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20609',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20610',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20611',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20612',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20613',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20615',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20616',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20617',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20618',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20619',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20620',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20621',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20622',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20623',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20624',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20625',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20626',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20627',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20628',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20629',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20630',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20632',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20634',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20635',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20636',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20637',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20639',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20640',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20643',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20645',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20646',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20650',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20653',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20656',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20657',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20658',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20659',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20660',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20661',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20662',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20664',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20667',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20670',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20674',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20675',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20676',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20677',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20678',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20680',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20682',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20684',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20685',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20686',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20687',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20688',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20689',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20690',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20692',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20693',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20695',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20697',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20701',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20703',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20704',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20705',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20706',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20707',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20708',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20709',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20710',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20711',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20712',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20714',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20715',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20716',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20717',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20718',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20719',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20720',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20721',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20722',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20723',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20724',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20725',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20726',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20731',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20732',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20733',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20735',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20736',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20737',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20738',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20740',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20741',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20742',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20743',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20744',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20745',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20746',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20747',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20748',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20749',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20750',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20751',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20752',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20753',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20754',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20755',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20757',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20758',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20759',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20762',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20763',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20764',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20765',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20768',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20769',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20770',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20771',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20772',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20773',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20774',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20775',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20776',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20777',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20778',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20779',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20781',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20782',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20783',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20784',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20785',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20787',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20788',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20790',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20791',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20792',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20794',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '20797',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20799',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20810',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20811',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20812',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20813',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20814',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20815',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20816',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20817',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20818',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20824',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20825',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20827',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20830',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20832',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20833',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20837',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20838',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20839',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20841',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20842',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20847',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20848',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20849',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20850',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20851',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20852',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20853',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20854',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20855',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20857',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20859',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20860',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20861',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20862',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20866',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20868',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20871',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20872',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20874',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20875',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20876',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20877',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20878',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20879',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20880',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20882',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20883',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20884',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20885',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20886',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20889',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20891',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20892',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20894',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20895',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20896',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20897',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20898',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20899',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20901',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20902',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20903',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20904',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20905',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20906',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20907',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20908',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20910',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20911',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20912',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20913',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20914',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20915',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20916',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20918',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '20993',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21001',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21005',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21009',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21010',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21012',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21013',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21014',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21015',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21017',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21018',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21020',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21022',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21023',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21027',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21028',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21029',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21030',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21031',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21032',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21034',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21035',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21036',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21037',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21040',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21041',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21042',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21043',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21044',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21045',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21046',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21047',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21048',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21050',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21051',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21052',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21053',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21054',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21056',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21057',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21060',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21061',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21062',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21065',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21071',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21074',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21075',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21076',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21077',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21078',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21082',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21084',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21085',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21087',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21088',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21090',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21092',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21093',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21094',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21098',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21102',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21104',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21105',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21106',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21108',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21111',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21113',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21114',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21117',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21120',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21122',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21123',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21128',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21130',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21131',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21132',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21133',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21136',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21139',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21140',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21144',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21146',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21150',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21152',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21153',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21154',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21155',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21156',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21157',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21158',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21160',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21161',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21162',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21163',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21201',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21202',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21203',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21204',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21205',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21206',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21207',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21208',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21209',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21210',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21211',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21212',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21213',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21214',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21215',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21216',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21217',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21218',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21219',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21220',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21221',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21222',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21223',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21224',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21225',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21226',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21227',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21228',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21229',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21230',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21231',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21233',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21234',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21235',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21236',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21237',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21239',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21240',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21241',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21244',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21250',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21251',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21252',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21260',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21261',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21263',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21264',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21265',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21268',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21270',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21273',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21274',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21275',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21278',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21279',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21280',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21281',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21282',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21283',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21284',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21285',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21286',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21287',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21288',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21289',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21290',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21297',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21298',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21401',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21402',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21403',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21404',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21405',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21409',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21411',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21412',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21501',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21502',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21503',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21504',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21505',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21520',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '21521',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21522',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '21523',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '21524',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21528',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21529',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21530',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21531',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '21532',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21536',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '21538',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '21539',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21540',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21541',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '21542',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21543',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21545',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21550',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '21555',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21556',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21557',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21560',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21561',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '21562',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21601',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21606',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21607',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21609',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21610',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21612',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21613',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21617',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21619',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21620',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21622',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21623',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21624',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21625',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21626',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21627',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21628',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21629',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21631',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21632',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21634',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21635',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21636',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21638',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21639',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21640',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21641',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21643',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21644',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21645',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21647',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21648',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21649',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21650',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21651',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21652',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21653',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21654',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21655',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21656',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21657',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21658',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21659',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21660',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21661',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21662',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21663',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21664',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21665',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21666',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21667',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21668',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21669',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21670',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21671',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21672',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21673',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21675',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21676',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21677',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21678',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21679',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21681',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21682',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21683',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21685',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21687',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21688',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21690',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21701',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21702',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21703',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21704',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21705',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21709',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21710',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21711',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21713',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21714',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21715',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21716',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21717',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21718',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21719',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21720',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21721',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21722',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21723',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21727',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21733',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21734',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21737',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21738',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21740',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21741',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21742',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21746',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21748',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21749',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21750',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21754',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21755',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21756',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21757',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21758',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21759',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21762',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21765',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21766',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21767',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21769',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21770',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21771',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21773',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21774',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21775',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21776',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21777',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21778',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21779',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21780',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21781',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21782',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21783',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21784',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21787',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21788',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21790',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21791',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21792',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21793',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21794',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21795',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21797',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21798',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '21801',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21802',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21803',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21804',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21810',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21811',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21813',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21814',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21817',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21821',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21822',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21824',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21826',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21829',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21830',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21835',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21836',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21837',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21838',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21840',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21841',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21842',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21843',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21849',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21850',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21851',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21852',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21853',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21856',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21857',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21861',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21862',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21863',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21864',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21865',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21866',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21867',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21869',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21871',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21872',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21874',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21875',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21890',
    dma_code: '576',
    dma_description: 'SALISBURY',
  },
  {
    zip_code: '21901',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21902',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21903',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21904',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21911',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21912',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21913',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21914',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21915',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21916',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21917',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21918',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21919',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21920',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21921',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21922',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '21930',
    dma_code: '512',
    dma_description: 'BALTIMORE',
  },
  {
    zip_code: '22003',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22009',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22015',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22025',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22026',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22027',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22030',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22031',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22032',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22033',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22035',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22037',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22038',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22039',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22040',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22041',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22042',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22043',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22044',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22046',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22047',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22060',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22066',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22067',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22079',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22081',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22082',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22092',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22093',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22095',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22096',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22101',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22102',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22103',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22106',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22107',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22108',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22109',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22116',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22118',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22119',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22120',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22121',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22122',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22124',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22125',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22134',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22135',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22150',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22151',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22152',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22153',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22156',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22158',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22159',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22160',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22161',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22172',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22180',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22181',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22182',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22183',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22184',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22185',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22191',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22192',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22193',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22194',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22195',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22199',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22201',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22202',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22203',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22204',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22205',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22206',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22207',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22209',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22210',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22211',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22212',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22213',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22214',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22215',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22216',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22217',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22218',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22219',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22222',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22223',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22225',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22226',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22227',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22229',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22230',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22234',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22240',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22241',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22243',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22244',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22245',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22246',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22301',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22302',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22303',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22304',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22305',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22306',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22307',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22308',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22309',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22310',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22311',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22312',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22313',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22314',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22315',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22320',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22321',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22331',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22332',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22333',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22334',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22336',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22401',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22402',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22403',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22404',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22405',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22406',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22407',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22408',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22412',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22427',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22428',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22430',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22432',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22433',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22435',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22436',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22437',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22438',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22442',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22443',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22446',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22448',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22451',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22454',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22456',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22460',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22463',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22469',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22471',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22472',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22473',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22476',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22480',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22481',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22482',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22485',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22488',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22501',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22503',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22504',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22507',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22508',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22509',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22511',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22513',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22514',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22517',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22520',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22523',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22524',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22526',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22528',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22529',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22530',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22534',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22535',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22538',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22539',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22542',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22544',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22545',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22546',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22547',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22548',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22551',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22552',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22553',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22554',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22555',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22556',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22558',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22560',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22565',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22567',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22570',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22572',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22576',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22577',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22578',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22579',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22580',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '22581',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22601',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22602',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22603',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22604',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22610',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22611',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22620',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22622',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22623',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22624',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22625',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22626',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22627',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22630',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22637',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22638',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22639',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22640',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22641',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22642',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22643',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22644',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22645',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22646',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22649',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22650',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22652',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22654',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22655',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22656',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22657',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22660',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22663',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22664',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22701',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22709',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22711',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22712',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22713',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22714',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22715',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22716',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22718',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22719',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22720',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22721',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22722',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22723',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22724',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22725',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22726',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22727',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22728',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22729',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22730',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22731',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22732',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22733',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22734',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22735',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22736',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22737',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22738',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22739',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22740',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22741',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22742',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22743',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22746',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22747',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22748',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22749',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22801',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22802',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22803',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22807',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22810',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22811',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22812',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22815',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22820',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22821',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22824',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22827',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22830',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22831',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22832',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22833',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22834',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22835',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22840',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22841',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22842',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22843',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22844',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22845',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22846',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22847',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22848',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22849',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22850',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22851',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '22853',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22901',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22902',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22903',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22904',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22905',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22906',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22907',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22908',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22909',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22910',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22911',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22920',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '22922',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '22923',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22924',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22931',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22932',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22935',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22936',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22937',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22938',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '22939',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22940',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22942',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22943',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22945',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22946',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22947',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22948',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22949',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '22952',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22957',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22958',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '22959',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22960',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22963',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22964',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '22965',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22967',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '22968',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22969',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '22971',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '22972',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22973',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22974',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22976',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '22980',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '22987',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '22989',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '23001',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23002',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23003',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23004',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23005',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23009',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23011',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23014',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23015',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23018',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23021',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23022',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '23023',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23024',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23025',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23027',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23030',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23031',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23032',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23035',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23038',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23039',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23040',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23043',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23045',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23047',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23050',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23055',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '23056',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23058',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23059',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23060',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23061',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23062',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23063',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23064',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23065',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23066',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23067',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23068',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23069',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23070',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23071',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23072',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23075',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23076',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23079',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23081',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23083',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23084',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '23085',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23086',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23089',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23090',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23091',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23092',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23093',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23101',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23102',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23103',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23105',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23106',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23107',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23108',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23109',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23110',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23111',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23112',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23113',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23114',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23115',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23116',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23117',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23119',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23120',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23123',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23124',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23125',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23126',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23127',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23128',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23129',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23130',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23131',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23138',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23139',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23140',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23141',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23146',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23147',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23148',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23149',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23150',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23153',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23154',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23155',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23156',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23160',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23161',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23162',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23163',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23168',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23169',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23170',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23173',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23175',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23176',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23177',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23178',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23180',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23181',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23183',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23184',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23185',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23186',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23187',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23188',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23190',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23192',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23218',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23219',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23220',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23221',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23222',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23223',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23224',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23225',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23226',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23227',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23228',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23229',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23230',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23231',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23232',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23233',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23234',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23235',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23236',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23237',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23238',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23240',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23241',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23242',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23249',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23250',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23255',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23260',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23261',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23269',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23273',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23274',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23276',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23278',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23279',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23282',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23284',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23285',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23286',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23288',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23289',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23290',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23291',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23292',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23293',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23294',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23295',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23297',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23298',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23301',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23302',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23303',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23304',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23306',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23307',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23308',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23310',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23313',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23314',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23315',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23316',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23320',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23321',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23322',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23323',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23324',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23325',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23326',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23327',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23328',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23336',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23337',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23341',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23345',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23347',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23350',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23354',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23356',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23357',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23358',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23359',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23389',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23395',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23396',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23397',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23398',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23399',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23401',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23404',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23405',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23407',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23408',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23409',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23410',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23412',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23413',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23414',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23415',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23416',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23417',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23418',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23419',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23420',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23421',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23422',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23423',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23424',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23426',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23427',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23429',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23430',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23431',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23432',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23433',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23434',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23435',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23436',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23437',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23438',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23439',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23440',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23441',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23442',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23443',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23450',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23451',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23452',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23453',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23454',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23455',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23456',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23457',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23458',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23459',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23460',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23461',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23462',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23463',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23464',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23465',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23466',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23467',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23471',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23479',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23480',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23482',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23483',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23486',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23487',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23488',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23501',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23502',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23503',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23504',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23505',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23506',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23507',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23508',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23509',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23510',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23511',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23512',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23513',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23514',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23515',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23517',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23518',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23519',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23521',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23523',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23529',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23541',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23551',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23601',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23602',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23603',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23604',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23605',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23606',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23607',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23608',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23609',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23612',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23628',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23630',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23651',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23661',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23662',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23663',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23664',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23665',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23666',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23667',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23668',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23669',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23670',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23681',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23690',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23691',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23692',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23693',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23694',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23696',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23701',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23702',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23703',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23704',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23705',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23707',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23708',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23709',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23801',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23803',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23804',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23805',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23806',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23821',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23824',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23827',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23828',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23829',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23830',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23831',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23832',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23833',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23834',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23836',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23837',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23838',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23839',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23840',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23841',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23842',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23843',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23844',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23845',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23846',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23847',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23850',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23851',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23856',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23857',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23860',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23866',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23867',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23868',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23870',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23872',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23873',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23874',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23875',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23876',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23878',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23879',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23881',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23882',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23883',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23884',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23885',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23887',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23888',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23889',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23890',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23891',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23893',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23894',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23897',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23898',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23899',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '23901',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23909',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23915',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '23917',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '23919',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '23920',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23921',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23922',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23923',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '23924',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '23927',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '23930',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23934',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '23936',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23937',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '23938',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23939',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '23941',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23942',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23943',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23944',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23947',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '23950',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '23952',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23954',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23955',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23958',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '23959',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '23960',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23962',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '23963',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '23964',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '23966',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23967',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '23968',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '23970',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '23974',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '23976',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24001',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24002',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24003',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24004',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24005',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24006',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24007',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24008',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24009',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24010',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24011',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24012',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24013',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24014',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24015',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24016',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24017',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24018',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24019',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24020',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24022',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24023',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24024',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24025',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24026',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24027',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24028',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24029',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24030',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24031',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24032',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24033',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24034',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24035',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24036',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24037',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24038',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24040',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24042',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24043',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24044',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24045',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24048',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24050',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24053',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '24054',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24055',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24058',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24059',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24060',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24061',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24062',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24063',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24064',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24065',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24066',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24067',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24068',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24069',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24070',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24072',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24073',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24076',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '24077',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24078',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24079',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24082',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '24083',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24084',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24085',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24086',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24087',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24088',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24089',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24090',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24091',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24092',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24093',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24095',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24101',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24102',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24104',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24105',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24111',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24112',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24113',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24114',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24115',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24120',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '24121',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24122',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24124',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24126',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24127',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24128',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24129',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24130',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24131',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24132',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24133',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '24134',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24136',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24137',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24138',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24139',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24141',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24142',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24143',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24146',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24147',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24148',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24149',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24150',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24151',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24153',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24155',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24157',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24161',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24162',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24165',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24167',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24168',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24171',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '24174',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24175',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24176',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24177',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '24178',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24179',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24184',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24185',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '24201',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24202',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24203',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24205',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24209',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24210',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24211',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24212',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24215',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24216',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24217',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24218',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24219',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24220',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24221',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24224',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24225',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24226',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24228',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24230',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24236',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24237',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24239',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24243',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24244',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24245',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24246',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24248',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24250',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24251',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24256',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24258',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24260',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24263',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24265',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24266',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24269',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24270',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24271',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24272',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24273',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24277',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24279',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24280',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24281',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24282',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24283',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24290',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24292',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24293',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24301',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24311',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24312',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24313',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24314',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24315',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24316',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24317',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24318',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24319',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24322',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24323',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24324',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24325',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24326',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24327',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24328',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24330',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24333',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24340',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24343',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24347',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24348',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24350',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24351',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24352',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24354',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24360',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24361',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24363',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24366',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24368',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24370',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24374',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24375',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24377',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24378',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24380',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24381',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24382',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24401',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24402',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24411',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24412',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24413',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24415',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24416',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24421',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24422',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24426',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24430',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24431',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24432',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24433',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24435',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24437',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24438',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24439',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24440',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24441',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24442',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24445',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24448',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24450',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24457',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24458',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24459',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24460',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24463',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24464',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24465',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24467',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24468',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24469',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24471',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24472',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24473',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24474',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24476',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24477',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24479',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24482',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24483',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24484',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24485',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24486',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '24487',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24501',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24502',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24503',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24504',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24505',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24506',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24512',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24513',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24514',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24517',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24520',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24521',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24522',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24523',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24526',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24527',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24528',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24529',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '24530',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24531',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24533',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24534',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24535',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24536',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24538',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24539',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24540',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24541',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24543',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24544',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24549',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24550',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24551',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24553',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24554',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24555',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24556',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24557',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24558',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24562',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '24563',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24565',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24566',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24569',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24570',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24571',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24572',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24574',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24576',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24577',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24578',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24579',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24580',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '24581',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24586',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24588',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24589',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24590',
    dma_code: '584',
    dma_description: 'CHARLOTTESVILLE',
  },
  {
    zip_code: '24592',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24593',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24594',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24595',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24597',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24598',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24599',
    dma_code: '556',
    dma_description: 'RICHMOND - PETERSBURG',
  },
  {
    zip_code: '24601',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24602',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24603',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24604',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24605',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24606',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24607',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24608',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24609',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24612',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24613',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24614',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24619',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24620',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24622',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24624',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24627',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24628',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24630',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24631',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24634',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24635',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24637',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24639',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24640',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24641',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24646',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24647',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24649',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24651',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24656',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24657',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24658',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '24701',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24712',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24714',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24715',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24716',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24719',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24724',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24726',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24729',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24731',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24732',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24733',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24736',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24737',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24738',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24739',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24740',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24747',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24751',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24801',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24808',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24811',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24813',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24815',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24816',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24817',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24818',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24822',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24823',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24824',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24826',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24827',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24828',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24829',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24830',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24831',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24834',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24836',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24839',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24842',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24843',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24844',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24845',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24846',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24847',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24848',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24849',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24850',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24851',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '24853',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24854',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24855',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24857',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24859',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24860',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24861',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24862',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24866',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24867',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24868',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24869',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24870',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24871',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24872',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24873',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24874',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24878',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24879',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24880',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24881',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24882',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24884',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24887',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24888',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24892',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24894',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24895',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24898',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24901',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24902',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24910',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24915',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24916',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24918',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24920',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24924',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24925',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24927',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24931',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24934',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24935',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24938',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24941',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24943',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24944',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24945',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24946',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24951',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24954',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '24957',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24961',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24962',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24963',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24966',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24970',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24974',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24976',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24977',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24981',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24983',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24984',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24985',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24986',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24991',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '24993',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25002',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25003',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25005',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25007',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25008',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25009',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25011',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25015',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25019',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25021',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25022',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25024',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25025',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25026',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25028',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25030',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25031',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25033',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25035',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25036',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25039',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25040',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25043',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25044',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25045',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25047',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25048',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25049',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25051',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25053',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25054',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25057',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25059',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25060',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25061',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25062',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25063',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25064',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25067',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25070',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25071',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25075',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25076',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25079',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25081',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25082',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25083',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25085',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25086',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25088',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25090',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25093',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25102',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25103',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25106',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25107',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25108',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25109',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25110',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25111',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25112',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25113',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25114',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25115',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25118',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25119',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25121',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25123',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25124',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25125',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25126',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25130',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25132',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25133',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25134',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25136',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25139',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25140',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25141',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25142',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25143',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25148',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25149',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25152',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25154',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25156',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25159',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25160',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25161',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25162',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25164',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25165',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25168',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25169',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25173',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25174',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25177',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25180',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25181',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25183',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25185',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25186',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25187',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25193',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25201',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25202',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25203',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25204',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25205',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25206',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25208',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25209',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25211',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25213',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25214',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25231',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25234',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25235',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25239',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25241',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25243',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25244',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25245',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25247',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25248',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25251',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25252',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25253',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25259',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25260',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25261',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25262',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25264',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25265',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25266',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25267',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '25268',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25270',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25271',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25275',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25276',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25285',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25286',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25287',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25301',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25302',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25303',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25304',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25305',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25306',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25309',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25311',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25312',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25313',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25314',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25315',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25317',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25320',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25321',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25322',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25323',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25324',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25325',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25326',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25327',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25328',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25329',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25330',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25331',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25332',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25333',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25334',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25335',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25336',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25337',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25338',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25339',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25356',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25357',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25358',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25360',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25361',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25362',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25364',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25365',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25375',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25387',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25389',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25392',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25396',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25401',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25402',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25403',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25404',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25405',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25410',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25411',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25413',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25414',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25419',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25420',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25421',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25422',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25423',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25425',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25427',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25428',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25429',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25430',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25431',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25432',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25434',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25437',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25438',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25440',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25441',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25442',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25443',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25444',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25446',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '25501',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25502',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25503',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25504',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25505',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25506',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25507',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25508',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25510',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25511',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25512',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25514',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25515',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25517',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25520',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25521',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25523',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25524',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25526',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25529',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25530',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25534',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25535',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25537',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25540',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25541',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25544',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25545',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25547',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25550',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25555',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25557',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25559',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25560',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25562',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25564',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25565',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25567',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25569',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25570',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25571',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25572',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25573',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25601',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25606',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25607',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25608',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25611',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25612',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25614',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25617',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25621',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25624',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25625',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25628',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25630',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25632',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25634',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25635',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25637',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25638',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25639',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25644',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25646',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25647',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25649',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25650',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25651',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25652',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25653',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25654',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25661',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25665',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25666',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25667',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25669',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25670',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25671',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25672',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25674',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25676',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25678',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25685',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25686',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25688',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25690',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25691',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25692',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25696',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25697',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25699',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25701',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25702',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25703',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25704',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25705',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25706',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25707',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25708',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25709',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25710',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25711',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25712',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25713',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25714',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25715',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25716',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25717',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25718',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25719',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25720',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25721',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25722',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25723',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25724',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25725',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25726',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25727',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25728',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25729',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25755',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25770',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25772',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25773',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25774',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25775',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25776',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25777',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25778',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25779',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '25801',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25802',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25810',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25811',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25812',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25813',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25816',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25817',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25818',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25820',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25823',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25825',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25826',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25827',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25831',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25832',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25833',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25836',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25837',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25839',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25840',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25841',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25843',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25844',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25845',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25846',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25848',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25849',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25851',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25853',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25854',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25855',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25857',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25860',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25862',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25864',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25865',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25866',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25868',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25870',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25871',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25873',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25875',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25876',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25878',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25879',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25880',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25882',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25901',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25902',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25904',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25906',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25907',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25908',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25909',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25911',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25913',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25914',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25915',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25916',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25917',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25918',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25919',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25920',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25921',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25922',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25926',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25927',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25928',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25932',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25936',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25938',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25942',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25943',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25951',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25958',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25962',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25965',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25966',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25969',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25971',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25972',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25976',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25977',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25978',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25979',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25981',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25984',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25985',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25986',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '25989',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '26003',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26030',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26031',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26032',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26033',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26034',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26035',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26036',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26037',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26038',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26039',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26040',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26041',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26047',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26050',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26055',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26056',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26058',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26059',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26060',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26062',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26070',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26074',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26075',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26101',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26102',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26103',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26104',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26105',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26106',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26120',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26121',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26133',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26134',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26136',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26137',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26138',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26141',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26142',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26143',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26146',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26147',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26148',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26149',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26150',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26151',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26152',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26155',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26159',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26160',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26161',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26162',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26164',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26167',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26169',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26170',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26175',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26178',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26180',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26181',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26184',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26186',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26187',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '26201',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26202',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26203',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26205',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26206',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26208',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26209',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '26210',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26215',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26217',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26218',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26219',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26222',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26224',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26228',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26229',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26230',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26234',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26236',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26237',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26238',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26241',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26250',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26253',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26254',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26257',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26259',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26260',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26261',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26263',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26264',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '26266',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26267',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26268',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26269',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26270',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26271',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26273',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26275',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26276',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26278',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26280',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26282',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26283',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26285',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26287',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26288',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26289',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26291',
    dma_code: '573',
    dma_description: 'ROANOKE - LYNCHBURG',
  },
  {
    zip_code: '26292',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26293',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26294',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26296',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26298',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26301',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26302',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26306',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26320',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26321',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26323',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26325',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26327',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26330',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26335',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26337',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26338',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26339',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26342',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26343',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26346',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26347',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26348',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26349',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26351',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26354',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26361',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26362',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26366',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26369',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26372',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26374',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26376',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26377',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26378',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26384',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26385',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26386',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26404',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26405',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26408',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26410',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26411',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26412',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26415',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26416',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26419',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26421',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26422',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26424',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26425',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26426',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26430',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26431',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26434',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26435',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26436',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26437',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26438',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26440',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26443',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26444',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26447',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26448',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26451',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26452',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26456',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26461',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26463',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26501',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26502',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26504',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26505',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26506',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26507',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26508',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26519',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26520',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26521',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26524',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26525',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26527',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26531',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26534',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26537',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26541',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26542',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26543',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26544',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26546',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26547',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26554',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26555',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26559',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26560',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26561',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26562',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26563',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26566',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26568',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26570',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26571',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26572',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26574',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26575',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26576',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26578',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26581',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '26582',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26585',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26586',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26587',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26588',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26590',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26591',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26601',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26610',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26611',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26615',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26617',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26619',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26621',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26623',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26624',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26627',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26629',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26631',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26636',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26638',
    dma_code: '598',
    dma_description: 'CLARKSBURG - WESTON',
  },
  {
    zip_code: '26651',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26656',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26660',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26662',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26667',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26671',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26675',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26676',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26678',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26679',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26680',
    dma_code: '559',
    dma_description: 'BLUEFIELD - BECKLEY - OAK HILL',
  },
  {
    zip_code: '26681',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26684',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26690',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26691',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '26704',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26705',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26707',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26710',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26711',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26714',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26716',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26717',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26719',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26720',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26722',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26726',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26731',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26739',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26743',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26750',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26753',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26755',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26757',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26761',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26763',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26764',
    dma_code: '508',
    dma_description: 'PITTSBURGH',
  },
  {
    zip_code: '26767',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26801',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26802',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '26804',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '26807',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '26808',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26810',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26812',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26814',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '26815',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '26817',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26818',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26823',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26833',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26836',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26838',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26845',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26847',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26851',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26852',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26855',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26865',
    dma_code: '511',
    dma_description: 'WASHINGTON, DC (HAGRSTWN)',
  },
  {
    zip_code: '26866',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '26884',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '26886',
    dma_code: '569',
    dma_description: 'HARRISONBURG',
  },
  {
    zip_code: '27006',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27007',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27009',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27010',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27011',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27012',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27013',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '27014',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27016',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27017',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27018',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27019',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27020',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27021',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27022',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27023',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27024',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27025',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27027',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27028',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27030',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27031',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27040',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27041',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27042',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27043',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27045',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27046',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27047',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27048',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27049',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27050',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27051',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27052',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27053',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27054',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '27055',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27094',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27098',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27099',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27101',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27102',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27103',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27104',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27105',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27106',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27107',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27108',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27109',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27110',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27111',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27113',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27114',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27115',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27116',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27117',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27120',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27127',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27130',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27150',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27151',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27152',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27155',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27156',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27157',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27198',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27199',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27201',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27202',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27203',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27204',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27205',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27207',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27208',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27209',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27212',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27213',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27214',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27215',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27216',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27217',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27220',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27228',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27229',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27230',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27231',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27233',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27235',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27237',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27239',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27242',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27243',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27244',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27247',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27248',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27249',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27252',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27253',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27256',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27258',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27259',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27260',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27261',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27262',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27263',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27264',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27265',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27278',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27281',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27282',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27283',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27284',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27285',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27288',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27289',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27291',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27292',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27293',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27294',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27295',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27298',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27299',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27301',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27302',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27305',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27306',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27310',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27311',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27312',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27313',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27314',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27315',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27316',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27317',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27320',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27321',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27322',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27323',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27325',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27326',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27330',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27331',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27332',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27340',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27341',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27342',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27343',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27344',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27349',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27350',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27351',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27355',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27356',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27357',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27358',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27359',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27360',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27361',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27370',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27371',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27373',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27374',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27375',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27376',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27377',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27379',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27395',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27401',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27402',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27403',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27404',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27405',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27406',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27407',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27408',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27409',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27410',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27411',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27412',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27413',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27415',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27416',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27417',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27419',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27420',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27425',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27427',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27429',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27435',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27438',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27455',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27495',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27497',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27498',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '27501',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27502',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27503',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27504',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27505',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27506',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27507',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27508',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27509',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27510',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27511',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27512',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27513',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27514',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27515',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27516',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27517',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27518',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27519',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27520',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27521',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27522',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27523',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27524',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27525',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27526',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27527',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27528',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27529',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27530',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27531',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27532',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27533',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27534',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27536',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27537',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27539',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27540',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27541',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27542',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27543',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27544',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27545',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27546',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27549',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27551',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27552',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27553',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27555',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27556',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27557',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27559',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27560',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27562',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27563',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27565',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27568',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27569',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27570',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27571',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27572',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27573',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27574',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27576',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27577',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27581',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27582',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27583',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27584',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27586',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27587',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27588',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27589',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27591',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27592',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27593',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27594',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27596',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27597',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27599',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27601',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27602',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27603',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27604',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27605',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27606',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27607',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27608',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27609',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27610',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27611',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27612',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27613',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27614',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27615',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27616',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27617',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27619',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27620',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27622',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27623',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27624',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27626',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27627',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27628',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27629',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27634',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27635',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27636',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27640',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27650',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27656',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27658',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27661',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27668',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27675',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27690',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27695',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27697',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27698',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27699',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27701',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27702',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27703',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27704',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27705',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27706',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27707',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27708',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27709',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27710',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27711',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27712',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27713',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27715',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27717',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27722',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27801',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27802',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27803',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27804',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27805',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27806',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27807',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27808',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27809',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27810',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27811',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27812',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27813',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27814',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27815',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27816',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27817',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27818',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27819',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27820',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27821',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27822',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27823',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27824',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27825',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27826',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27827',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27828',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27829',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27830',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27831',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27832',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27833',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27834',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27835',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27836',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27837',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27839',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27840',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27841',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27842',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27843',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27844',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27845',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27846',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27847',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27849',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27850',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27851',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27852',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27853',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27854',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27855',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27856',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27857',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27858',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27860',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27861',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27862',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27863',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27864',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27865',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27866',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27867',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27868',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27869',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27870',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27871',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27872',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27873',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27874',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27875',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27876',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27877',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27878',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27879',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27880',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27881',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27882',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27883',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27884',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27885',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27886',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27887',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27888',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27889',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27890',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27891',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27892',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27893',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27894',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27895',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27896',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '27897',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27906',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27907',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27909',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27910',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27915',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27916',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27917',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27919',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27920',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27921',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27922',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27923',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27924',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27925',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27926',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27927',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27928',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27929',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27930',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27932',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27935',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27936',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27937',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27938',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27939',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27941',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27942',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27943',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27944',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27946',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27947',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27948',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27949',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27950',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27953',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27954',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27956',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27957',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27958',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27959',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27960',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27962',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27964',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27965',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27966',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27967',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27968',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27969',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27970',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27972',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27973',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27974',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27976',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27978',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27979',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27980',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27981',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27982',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27983',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '27985',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '27986',
    dma_code: '544',
    dma_description: 'NORFOLK - PORTSMTH - NEWPT NWS',
  },
  {
    zip_code: '28001',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28002',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28006',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28007',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28009',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28010',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28012',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28016',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28017',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28018',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28019',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28020',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28021',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28023',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28024',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28025',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28026',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28027',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28031',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28032',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28033',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28034',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28035',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28036',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28037',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28038',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28039',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28040',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28041',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28042',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28043',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28052',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28053',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28054',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28055',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28056',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28070',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28071',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28072',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28073',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28074',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28075',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28076',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28077',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28078',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28079',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28080',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28081',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28082',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28083',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28086',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28088',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28089',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28090',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28091',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28092',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28093',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28097',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28098',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28101',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28102',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28103',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28104',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28105',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28106',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28107',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28108',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28109',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28110',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28111',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28112',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28114',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28115',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28117',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28119',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28120',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28123',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28124',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28125',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28126',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28127',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28128',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28129',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28130',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28133',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28134',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28135',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28136',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28137',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28138',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28139',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28144',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28145',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28146',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28147',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28150',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28151',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28152',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28159',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28160',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28163',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28164',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28166',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28167',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28168',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28169',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28170',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28173',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28174',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28201',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28202',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28203',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28204',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28205',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28206',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28207',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28208',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28209',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28210',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28211',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28212',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28213',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28214',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28215',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28216',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28217',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28218',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28219',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28220',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28221',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28222',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28223',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28224',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28226',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28227',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28228',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28229',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28230',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28231',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28232',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28233',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28234',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28235',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28236',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28237',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28241',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28242',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28243',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28244',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28246',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28247',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28250',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28253',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28254',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28255',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28256',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28258',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28260',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28262',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28263',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28266',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28269',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28270',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28271',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28272',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28273',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28274',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28277',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28278',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28280',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28281',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28282',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28284',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28285',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28287',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28288',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28289',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28290',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28296',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28297',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28299',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28301',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28302',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28303',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28304',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28305',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28306',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28307',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28308',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28309',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28310',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28311',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28312',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28314',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28315',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28318',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28319',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28320',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28323',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28325',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28326',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28327',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28328',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28329',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28330',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28331',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28332',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28333',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28334',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28335',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28337',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28338',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28339',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28340',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28341',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28342',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28343',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28344',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28345',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28347',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28348',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28349',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28350',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28351',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28352',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28353',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28355',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28356',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28357',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28358',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28359',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28360',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28362',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28363',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28364',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28365',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28366',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28367',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28368',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28369',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28370',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28371',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28372',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28373',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28374',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28375',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28376',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28377',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28378',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28379',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28380',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28382',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28383',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28384',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28385',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28386',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28387',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28388',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28390',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28391',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28392',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28393',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28394',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28395',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28396',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '28398',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28399',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28401',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28402',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28403',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28404',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28405',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28406',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28407',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28408',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28409',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28410',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28411',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28412',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28420',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28421',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28422',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28423',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28424',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28425',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28428',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28429',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28430',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28431',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28432',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28433',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28434',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28435',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28436',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28438',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28439',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28441',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28442',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28443',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28444',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28445',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28447',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28448',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28449',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28450',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28451',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28452',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28453',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28454',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28455',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28456',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28457',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28458',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28459',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28460',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28461',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28462',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28463',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28464',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28465',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28466',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28467',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28468',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28469',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28470',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28472',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28478',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28479',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28480',
    dma_code: '550',
    dma_description: 'WILMINGTON',
  },
  {
    zip_code: '28501',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28502',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28503',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28504',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28508',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28509',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28510',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28511',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28512',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28513',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28515',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28516',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28518',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28519',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28520',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28521',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28522',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28523',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28524',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28525',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28526',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28527',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28528',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28529',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28530',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28531',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28532',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28533',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28537',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28538',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28539',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28540',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28541',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28542',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28543',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28544',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28545',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28546',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28547',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28551',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28552',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28553',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28554',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28555',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28556',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28557',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28560',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28561',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28562',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28563',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28564',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28570',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28571',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28572',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28573',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28574',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28575',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28577',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28578',
    dma_code: '560',
    dma_description: 'RALEIGH - DURHAM (FAYETVLLE)',
  },
  {
    zip_code: '28579',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28580',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28581',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28582',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28583',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28584',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28585',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28586',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28587',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28589',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28590',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28594',
    dma_code: '545',
    dma_description: 'GREENVILLE - N. BERN - WASHNGTN',
  },
  {
    zip_code: '28601',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28602',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28603',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28604',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28605',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28606',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28607',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28608',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28609',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28610',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28611',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28612',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28613',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28615',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28616',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28617',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28618',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28619',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28621',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28622',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28623',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28624',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28625',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28626',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28627',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28628',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28629',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28630',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28631',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28633',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28634',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28635',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28636',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28637',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28638',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28640',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28641',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28642',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28643',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28644',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28645',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28646',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28647',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28649',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28650',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28651',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28652',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28653',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28654',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28655',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28656',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28657',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28658',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28659',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28660',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28661',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28662',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28663',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28664',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28665',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28666',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28667',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28668',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28669',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28670',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28671',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28672',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28673',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28674',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28675',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28676',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28677',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28678',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28679',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28680',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28681',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28682',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28683',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28684',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28685',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28687',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28688',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28689',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28690',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28691',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28692',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28693',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28694',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28697',
    dma_code: '518',
    dma_description: 'GREENSBORO - H. POINT - W. SALEM',
  },
  {
    zip_code: '28698',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28699',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '28701',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28702',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28704',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28705',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28707',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28708',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28709',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28710',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28711',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28712',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28713',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28714',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28715',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28716',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28717',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28718',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28719',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28720',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28721',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28722',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28723',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28724',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28725',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28726',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28727',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28728',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28729',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28730',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28731',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28732',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28733',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28734',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28735',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28736',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28737',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28738',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28739',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28740',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28741',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28742',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28743',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28744',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28745',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28746',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28747',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28748',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28749',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28750',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28751',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28752',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28753',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28754',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28755',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28756',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28757',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28758',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28759',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28760',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28761',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28762',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28763',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28765',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28766',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28768',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28770',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28771',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28772',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28773',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28774',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28775',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28776',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28777',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28778',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28779',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28781',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '28782',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28783',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28784',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28785',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28786',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28787',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28788',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28789',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28790',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28791',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28792',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28793',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28801',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28802',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28803',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28804',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28805',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28806',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28810',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28813',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28814',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28815',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28816',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '28901',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '28902',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '28903',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '28904',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '28905',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '28906',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '28909',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '29001',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29002',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29003',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29006',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29009',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29010',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29014',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29015',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29016',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29018',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29020',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29021',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29030',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29031',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29032',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29033',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29036',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29037',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29038',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29039',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29040',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29041',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29042',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29044',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29045',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29046',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29047',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29048',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29051',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29052',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29053',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29054',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29055',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29056',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29058',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29059',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29061',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29062',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29063',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29065',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29067',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29069',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29070',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29071',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29072',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29073',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29074',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29075',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29078',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29079',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29080',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29081',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29082',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29101',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29102',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29104',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29105',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29107',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29108',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29111',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29112',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29113',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29114',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29115',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29116',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29117',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29118',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29122',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29123',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29125',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29126',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29127',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29128',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29129',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29130',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29132',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29133',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29135',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29137',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29138',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29142',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29143',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29145',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29146',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29147',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29148',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29150',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29151',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29152',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29153',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29154',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29160',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29161',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29162',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29163',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29164',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29166',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29168',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29169',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29170',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29171',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29172',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29175',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29177',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29178',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29180',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29201',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29202',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29203',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29204',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29205',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29206',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29207',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29208',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29209',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29210',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29211',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29212',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29214',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29215',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29216',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29217',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29218',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29219',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29220',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29221',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29223',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29224',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29225',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29226',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29227',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29228',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29229',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29230',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29240',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29250',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29260',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29290',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29292',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29301',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29302',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29303',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29304',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29305',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29306',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29307',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29316',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29318',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29319',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29320',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29321',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29322',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29323',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29324',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29325',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29329',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29330',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29331',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29332',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29333',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29334',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29335',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29336',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29338',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29340',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29341',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29342',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29346',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29348',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29349',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29351',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29353',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29355',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29356',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29360',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29364',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29365',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29368',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29369',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29370',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29372',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29373',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29374',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29375',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29376',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29377',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29378',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29379',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29384',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29385',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29386',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29388',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29390',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29391',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29395',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29401',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29402',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29403',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29404',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29405',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29406',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29407',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29409',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29410',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29412',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29413',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29414',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29415',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29416',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29417',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29418',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29419',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29420',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29422',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29423',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29424',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29425',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29426',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29429',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29430',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29431',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29432',
    dma_code: '546',
    dma_description: 'COLUMBIA, SC',
  },
  {
    zip_code: '29433',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29434',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29435',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29436',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29437',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29438',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29439',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29440',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29442',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29445',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29446',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29447',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29448',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29449',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29450',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29451',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29452',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29453',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29455',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29456',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29457',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29458',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29461',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29464',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29465',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29466',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29468',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29469',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29470',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29471',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29472',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29474',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29475',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29476',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29477',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29479',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29481',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29482',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29483',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29484',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29485',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29487',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29488',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29492',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29493',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29501',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29502',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29503',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29504',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29505',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29506',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29510',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29511',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29512',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29516',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29518',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29519',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29520',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29525',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29526',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29527',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29528',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29530',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29532',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29536',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29540',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29541',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29543',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29544',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29545',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29546',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29547',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29550',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29551',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29554',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29555',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29556',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29560',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29563',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29564',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29565',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29566',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29567',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29568',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29569',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29570',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29571',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29572',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29573',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29574',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29575',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29576',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29577',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29578',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29579',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29580',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29581',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29582',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29583',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29584',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29585',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29587',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29588',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29589',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29590',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29591',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29592',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29593',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29594',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29596',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29597',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29598',
    dma_code: '570',
    dma_description: 'MYRTLE BEACH - FLORENCE',
  },
  {
    zip_code: '29601',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29602',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29603',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29604',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29605',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29606',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29607',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29608',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29609',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29610',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29611',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29612',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29613',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29614',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29615',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29616',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29617',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29620',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29621',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29622',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29623',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29624',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29625',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29626',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29627',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29628',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29630',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29631',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29632',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29633',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29634',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29635',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29636',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29638',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29639',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29640',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29641',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29642',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29643',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29644',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29645',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29646',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29647',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29648',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29649',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29650',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29651',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29652',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29653',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29654',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29655',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29656',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29657',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29658',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29659',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29661',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29662',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29664',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29665',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29666',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29667',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29669',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29670',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29671',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29672',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29673',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29675',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29676',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29677',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29678',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29679',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29680',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29681',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29682',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29683',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29684',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29685',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29686',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29687',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29688',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29689',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29690',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29691',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29692',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29693',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29695',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29696',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29697',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29698',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29702',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29703',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29704',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29706',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29707',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29708',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29709',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29710',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29712',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29714',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29715',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29716',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29717',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29718',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29720',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29721',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29722',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29724',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29726',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29727',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29728',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29729',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29730',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29731',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29732',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29733',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29734',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29741',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29742',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29743',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29744',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29745',
    dma_code: '517',
    dma_description: 'CHARLOTTE',
  },
  {
    zip_code: '29801',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29802',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29803',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29804',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29805',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29808',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29809',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29810',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29812',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29813',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29816',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29817',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29819',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29821',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29822',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29824',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29826',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29827',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29828',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29829',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29831',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29832',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29834',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29835',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29836',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29838',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29839',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29840',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29841',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29842',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29843',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29844',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29845',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29846',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29847',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29848',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '29849',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29850',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29851',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29853',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29856',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29860',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29861',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29899',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '29901',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29902',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29903',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29904',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29905',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29906',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29907',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29909',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29910',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29911',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29912',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29913',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29914',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29915',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29916',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29918',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29920',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29921',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29922',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29923',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29924',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29925',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29926',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29927',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29928',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29929',
    dma_code: '519',
    dma_description: 'CHARLESTON, SC',
  },
  {
    zip_code: '29931',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29932',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29933',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29934',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29935',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29936',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29938',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29939',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29940',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29941',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29943',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29944',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '29945',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30002',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30003',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30004',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30005',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30006',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30007',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30008',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30009',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30010',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30011',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30012',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30013',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30014',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30015',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30016',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30017',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30018',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30019',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30021',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30022',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30023',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30024',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30025',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30026',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30028',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30030',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30031',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30032',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30033',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30034',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30035',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30036',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30037',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30038',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30039',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30040',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30041',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30042',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30043',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30044',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30045',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30046',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30047',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30048',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30049',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30052',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30054',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30055',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30056',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30058',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30060',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30061',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30062',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30063',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30064',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30065',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30066',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30067',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30068',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30069',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30070',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30071',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30072',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30073',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30074',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30075',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30076',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30077',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30078',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30079',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30080',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30081',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30082',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30083',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30084',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30085',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30086',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30087',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30088',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30090',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30091',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30092',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30093',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30094',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30095',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30096',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30097',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30098',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30099',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30101',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30102',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30103',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30104',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30105',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30106',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30107',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30108',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30109',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30110',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30111',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30112',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30113',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30114',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30115',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30116',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30117',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30118',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30119',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30120',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30121',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30122',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30123',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30124',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30125',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30126',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30127',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30129',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30132',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30133',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30134',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30135',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30137',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30138',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30139',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30140',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30141',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30142',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30143',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30144',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30145',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30146',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30147',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30148',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30149',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30150',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30151',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30152',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30153',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30154',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30156',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30157',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30160',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30161',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30162',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30163',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30164',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30165',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30168',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30169',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30170',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30171',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30172',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30173',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30175',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30176',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30177',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30178',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30179',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30180',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30182',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30183',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30184',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30185',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30187',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30188',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30189',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30204',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30205',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30206',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30212',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30213',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30214',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30215',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30216',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30217',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30218',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30219',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30220',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30222',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30223',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30224',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30228',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30229',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30230',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30233',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30234',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30236',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30237',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30238',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30240',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30241',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30248',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30250',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30251',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30252',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30253',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30256',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30257',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30258',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30259',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30260',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30261',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30263',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30264',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30265',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30266',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30268',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30269',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30270',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30271',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30272',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30273',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30274',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30275',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30276',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30277',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30281',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30284',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30285',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30286',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30287',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30288',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30289',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30290',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30291',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30292',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30293',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30294',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30295',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30296',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30297',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30298',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30301',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30302',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30303',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30304',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30305',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30306',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30307',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30308',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30309',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30310',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30311',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30312',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30313',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30314',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30315',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30316',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30317',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30318',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30319',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30320',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30321',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30322',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30324',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30325',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30326',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30327',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30328',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30329',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30330',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30331',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30332',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30333',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30334',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30336',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30337',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30338',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30339',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30340',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30341',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30342',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30343',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30344',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30345',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30346',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30347',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30348',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30349',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30350',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30353',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30354',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30355',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30356',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30357',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30358',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30359',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30360',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30361',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30362',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30363',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30364',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30366',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30368',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30369',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30370',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30371',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30374',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30375',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30377',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30380',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30384',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30385',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30386',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30387',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30388',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30389',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30390',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30392',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30396',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30398',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30399',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30401',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30410',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30411',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '30412',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30413',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30414',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30415',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30417',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30420',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30421',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30423',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30424',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30425',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30426',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30427',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30428',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '30429',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30434',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30436',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30438',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30439',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30441',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30442',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30445',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30446',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30447',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30448',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30449',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30450',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30451',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30452',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30453',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30454',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '30455',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30456',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30457',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '30458',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30459',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30460',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30461',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30464',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30467',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30470',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30471',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30473',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30474',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30475',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30477',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30499',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '30501',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30502',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30503',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30504',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30506',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30507',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30510',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30511',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30512',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30513',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30514',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30515',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30516',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '30517',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30518',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30519',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30520',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '30521',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '30522',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30523',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30525',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30527',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30528',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30529',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30530',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30531',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30533',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30534',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30535',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30536',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30537',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30538',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '30539',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30540',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30541',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30542',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30543',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30544',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30545',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30546',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30547',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30548',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30549',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30552',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30553',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '30554',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30555',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30557',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '30558',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30559',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30560',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30562',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30563',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30564',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30565',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30566',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30567',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30568',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30571',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30572',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30573',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30575',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30576',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30577',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '30580',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30581',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30582',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30596',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30597',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30598',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '30599',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30601',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30602',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30603',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30604',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30605',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30606',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30607',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30608',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30609',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30612',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30619',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30620',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30621',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30622',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30623',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30624',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '30625',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30627',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30628',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30629',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30630',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30631',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30633',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30634',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '30635',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '30638',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30639',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '30641',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30642',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30643',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '30645',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30646',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30647',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30648',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30650',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30655',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30656',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30660',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30662',
    dma_code: '567',
    dma_description: 'GREENVLL - SPART - ASHEVLL - AND',
  },
  {
    zip_code: '30663',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30664',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30665',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30666',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30667',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30668',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30669',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30671',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30673',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30677',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30678',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30680',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30683',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30701',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30703',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30705',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30707',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30708',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30710',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30711',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30719',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30720',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30721',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30722',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30724',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30725',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30726',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30728',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30730',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30731',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30732',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30733',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30734',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30735',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30736',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30738',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30739',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30740',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30741',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30742',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30746',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30747',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30750',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30751',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30752',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30753',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '30755',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30756',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30757',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '30802',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30803',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30805',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30806',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30807',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30808',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30809',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30810',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30811',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30812',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30813',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30814',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30815',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30816',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30817',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30818',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30819',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30820',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30821',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30822',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30823',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30824',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30828',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30830',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30833',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30901',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30903',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30904',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30905',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30906',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30907',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30909',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30911',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30912',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30914',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30916',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30917',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30919',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '30999',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '31001',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31002',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '31003',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31004',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31005',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31006',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31007',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31008',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31009',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31010',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31011',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31012',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31013',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31014',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31015',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31016',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31017',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31018',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31019',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31020',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31021',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31022',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31023',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31024',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31025',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31026',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31027',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31028',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31029',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31030',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31031',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31032',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31033',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31034',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31035',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31036',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31037',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31038',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31039',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31040',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31041',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31042',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31044',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31045',
    dma_code: '520',
    dma_description: 'AUGUSTA',
  },
  {
    zip_code: '31046',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31047',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31049',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31050',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31051',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31052',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31054',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31055',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31057',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31058',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31059',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31060',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31061',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31062',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31063',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31064',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31065',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31066',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31067',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31068',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31069',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31070',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31071',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31072',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31075',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31076',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31077',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31078',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31079',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31081',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31082',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31083',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31084',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31085',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31086',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31087',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31088',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31089',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31090',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31091',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31092',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31093',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31094',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31095',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31096',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31097',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31098',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31099',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31106',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31107',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31119',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31120',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31126',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31131',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31136',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31139',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31141',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31145',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31146',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31150',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31156',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31192',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31193',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31196',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31197',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31198',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31199',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31201',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31202',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31203',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31204',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31205',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31206',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31207',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31208',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31209',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31210',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31211',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31212',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31213',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31216',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31217',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31220',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31221',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31294',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31295',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31296',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31297',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31301',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31302',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31303',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31304',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31305',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31307',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31308',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31309',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31310',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31312',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31313',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31314',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31315',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31316',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31318',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31319',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31320',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31321',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31322',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31323',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31324',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31326',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31327',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31328',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31329',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31331',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31333',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31401',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31402',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31403',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31404',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31405',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31406',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31407',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31408',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31409',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31410',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31411',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31412',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31414',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31415',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31416',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31418',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31419',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31420',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31421',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31501',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31502',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31503',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31510',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31512',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31513',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31515',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31516',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31518',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31519',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31520',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31521',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31522',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31523',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31524',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31525',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31527',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31532',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31533',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31534',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31535',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31537',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31539',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31542',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31543',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31544',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31545',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31546',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31547',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31548',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31549',
    dma_code: '503',
    dma_description: 'MACON',
  },
  {
    zip_code: '31550',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31551',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31552',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31553',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31554',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31555',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31556',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31557',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31558',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31560',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31561',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31562',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31563',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31564',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31565',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31566',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31567',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31568',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31569',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '31598',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31599',
    dma_code: '507',
    dma_description: 'SAVANNAH',
  },
  {
    zip_code: '31601',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31602',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31603',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31604',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31605',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31606',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31620',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31622',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31623',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31624',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31625',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31626',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31627',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31629',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31630',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31631',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31632',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31634',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31635',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31636',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31637',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31638',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31639',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31641',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31642',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31643',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31645',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31647',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31648',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31649',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31650',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31698',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31699',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31701',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31702',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31703',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31704',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31705',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31706',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31707',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31708',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31709',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31710',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31711',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31712',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31714',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31716',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31719',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31720',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31721',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31722',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31727',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31730',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31733',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31735',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31738',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31739',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31743',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31744',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31747',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31749',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31750',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31753',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31756',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31757',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31758',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31760',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31763',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31764',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31765',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31768',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31769',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31771',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31772',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31773',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31774',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31775',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31776',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31778',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31779',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31780',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31781',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31782',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31783',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31784',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31787',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31788',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31789',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31790',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31791',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31792',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31793',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31794',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31795',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31796',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31798',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '31799',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '31801',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31803',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31804',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31805',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31806',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31807',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31808',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31810',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31811',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31812',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31814',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31815',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31816',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31820',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31821',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31822',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31823',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31824',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31825',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31826',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31827',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31829',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31830',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31831',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31832',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31833',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '31836',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31901',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31902',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31903',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31904',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31905',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31906',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31907',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31908',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31909',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31914',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31917',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31993',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31995',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31997',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31998',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '31999',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '32003',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32004',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32006',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32007',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32008',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32009',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32011',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32013',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32024',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32025',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32026',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32030',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32033',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32034',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32035',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32038',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32040',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32041',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32042',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32043',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32044',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32046',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32050',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32052',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32053',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32054',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32055',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32056',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32058',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32059',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32060',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32061',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32062',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32063',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32064',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32065',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32066',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32067',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32068',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32071',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32072',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32073',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32079',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32080',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32081',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32082',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32083',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32084',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32085',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32086',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32087',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32091',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32092',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32094',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32095',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32096',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32097',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32099',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32102',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32105',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32110',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32111',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32112',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32113',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32114',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32115',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32116',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32117',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32118',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32119',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32120',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32121',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32122',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32123',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32124',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32125',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32126',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32127',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32128',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32129',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32130',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32131',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32132',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32133',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32134',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32135',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32136',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32137',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32138',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32139',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32140',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32141',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32142',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32145',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32147',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32148',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32149',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32157',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32158',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32159',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32160',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32162',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32164',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32168',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32169',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32170',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32173',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32174',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32175',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32176',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32177',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32178',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32179',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32180',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32181',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32182',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32183',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32185',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32187',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32189',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32190',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32192',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32193',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32195',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32198',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32201',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32202',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32203',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32204',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32205',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32206',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32207',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32208',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32209',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32210',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32211',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32212',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32214',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32215',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32216',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32217',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32218',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32219',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32220',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32221',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32222',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32223',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32224',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32225',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32226',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32227',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32228',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32229',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32230',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32231',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32232',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32233',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32234',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32235',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32236',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32237',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32238',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32239',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32240',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32241',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32244',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32245',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32246',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32247',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32250',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32254',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32255',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32256',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32257',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32258',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32259',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32260',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32266',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32267',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32277',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32290',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32301',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32302',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32303',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32304',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32305',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32306',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32307',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32308',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32309',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32310',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32311',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32312',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32313',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32314',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32315',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32316',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32317',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32318',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32320',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32321',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32322',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32323',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32324',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32326',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32327',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32328',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32329',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32330',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32331',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32332',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32333',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32334',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32335',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32336',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32337',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32340',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32341',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32343',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32344',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32345',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32346',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32347',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32348',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32350',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32351',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32352',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32353',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32355',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32356',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32357',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32358',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32359',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32360',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32361',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32362',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32395',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32399',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '32401',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32402',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32403',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32404',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32405',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32406',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32407',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32408',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32409',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32410',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32411',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32412',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32413',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32417',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32420',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32421',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32422',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32423',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32424',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32425',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32426',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32427',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32428',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32430',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32431',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32432',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32433',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32434',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32435',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32437',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32438',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32439',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32440',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32442',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32443',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32444',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32445',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32446',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32447',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32448',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32449',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32452',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32454',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32455',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32456',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32457',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32459',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32460',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32461',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32462',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32463',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32464',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32465',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32466',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32501',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32502',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32503',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32504',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32505',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32506',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32507',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32508',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32509',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32511',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32512',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32513',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32514',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32516',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32520',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32521',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32522',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32523',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32524',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32526',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32530',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32531',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32533',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32534',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32535',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32536',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32537',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32538',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32539',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32540',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32541',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32542',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32544',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32547',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32548',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32549',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32550',
    dma_code: '656',
    dma_description: 'PANAMA CITY',
  },
  {
    zip_code: '32559',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32560',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32561',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32562',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32563',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32564',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32565',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32566',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32567',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32568',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32569',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32570',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32571',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32572',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32577',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32578',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32579',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32580',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32583',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32588',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32591',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '32601',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32602',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32603',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32604',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32605',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32606',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32607',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32608',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32609',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32610',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32611',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32612',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32613',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32614',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32615',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32616',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32617',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32618',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32619',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32621',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32622',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32625',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32626',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32627',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32628',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32631',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32633',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32634',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32635',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32639',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32640',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32641',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32643',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32644',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32648',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32653',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32654',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32655',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32656',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32658',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32662',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32663',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32664',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32666',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32667',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32668',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32669',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32680',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32681',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32683',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32686',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32692',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32693',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32694',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32696',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '32697',
    dma_code: '561',
    dma_description: 'JACKSONVILLE',
  },
  {
    zip_code: '32701',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32702',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32703',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32704',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32706',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32707',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32708',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32709',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32710',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32712',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32713',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32714',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32715',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32716',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32718',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32719',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32720',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32721',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32722',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32723',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32724',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32725',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32726',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32727',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32728',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32730',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32732',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32733',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32735',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32736',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32738',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32739',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32744',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32746',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32747',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32750',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32751',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32752',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32753',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32754',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32756',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32757',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32759',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32762',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32763',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32764',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32765',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32766',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32767',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32768',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32771',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32772',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32773',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32774',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32775',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32776',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32777',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32778',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32779',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32780',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32781',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32782',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32783',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32784',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32789',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32790',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32791',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32792',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32793',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32794',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32795',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32796',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32798',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32801',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32802',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32803',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32804',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32805',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32806',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32807',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32808',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32809',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32810',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32811',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32812',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32814',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32815',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32816',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32817',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32818',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32819',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32820',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32821',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32822',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32824',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32825',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32826',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32827',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32828',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32829',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32830',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32831',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32832',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32833',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32835',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32836',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32837',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32839',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32853',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32854',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32855',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32856',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32857',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32858',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32859',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32860',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32861',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32862',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32867',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32868',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32869',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32872',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32877',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32878',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32885',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32886',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32887',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32890',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32891',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32893',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32897',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32898',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32899',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32901',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32902',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32903',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32904',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32905',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32906',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32907',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32908',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32909',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32910',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32911',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32912',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32919',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32920',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32922',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32923',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32924',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32925',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32926',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32927',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32931',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32932',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32934',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32935',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32936',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32937',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32940',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32941',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32948',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32949',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32950',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32951',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32952',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32953',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32954',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32955',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32956',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32957',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32958',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32959',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32960',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32961',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32962',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32963',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32964',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32965',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32966',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32967',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32968',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32969',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32970',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32971',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '32976',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '32978',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33001',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33002',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33004',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33008',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33009',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33010',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33011',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33012',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33013',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33014',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33015',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33016',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33017',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33018',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33019',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33020',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33021',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33022',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33023',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33024',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33025',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33026',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33027',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33028',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33029',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33030',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33031',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33032',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33033',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33034',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33035',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33036',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33037',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33039',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33040',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33041',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33042',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33043',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33045',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33050',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33051',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33052',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33054',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33055',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33056',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33060',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33061',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33062',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33063',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33064',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33065',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33066',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33067',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33068',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33069',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33070',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33071',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33072',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33073',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33074',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33075',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33076',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33077',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33081',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33082',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33083',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33084',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33090',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33092',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33093',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33097',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33101',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33102',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33107',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33109',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33110',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33111',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33112',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33114',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33116',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33119',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33121',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33122',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33124',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33125',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33126',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33127',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33128',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33129',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33130',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33131',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33132',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33133',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33134',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33135',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33136',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33137',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33138',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33139',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33140',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33141',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33142',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33143',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33144',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33145',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33146',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33147',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33148',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33149',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33150',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33151',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33152',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33153',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33154',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33155',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33156',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33157',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33158',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33159',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33160',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33161',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33162',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33163',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33164',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33165',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33166',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33167',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33168',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33169',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33170',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33172',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33173',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33174',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33175',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33176',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33177',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33178',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33179',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33180',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33181',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33182',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33183',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33184',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33185',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33186',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33187',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33188',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33189',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33190',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33193',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33194',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33195',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33196',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33197',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33199',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33222',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33231',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33233',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33234',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33238',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33239',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33242',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33243',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33245',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33247',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33255',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33256',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33257',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33261',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33265',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33266',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33269',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33280',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33283',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33296',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33299',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33301',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33302',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33303',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33304',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33305',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33306',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33307',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33308',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33309',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33310',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33311',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33312',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33313',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33314',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33315',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33316',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33317',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33318',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33319',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33320',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33321',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33322',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33323',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33324',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33325',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33326',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33327',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33328',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33329',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33330',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33331',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33332',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33334',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33335',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33336',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33337',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33338',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33339',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33340',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33345',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33346',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33348',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33349',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33351',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33355',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33359',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33388',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33394',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33401',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33402',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33403',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33404',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33405',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33406',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33407',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33408',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33409',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33410',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33411',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33412',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33413',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33414',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33415',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33416',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33417',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33418',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33419',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33420',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33421',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33422',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33424',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33425',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33426',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33427',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33428',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33429',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33430',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33431',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33432',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33433',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33434',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33435',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33436',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33437',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33438',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33439',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33440',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33441',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33442',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33443',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '33444',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33445',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33446',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33447',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33448',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33449',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33454',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33455',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33458',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33459',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33460',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33461',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33462',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33463',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33464',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33465',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33466',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33467',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33468',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33469',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33470',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33471',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33472',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33473',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33474',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33475',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33476',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33477',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33478',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33480',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33481',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33482',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33483',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33484',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33486',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33487',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33488',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33493',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33496',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33497',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33498',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33499',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '33503',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33508',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33509',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33510',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33511',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33513',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '33514',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '33521',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '33523',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33524',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33525',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33526',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33527',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33530',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33534',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33537',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33538',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '33539',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33540',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33541',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33542',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33543',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33544',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33545',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33547',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33548',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33549',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33550',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33556',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33558',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33559',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33563',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33564',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33565',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33566',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33567',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33568',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33569',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33570',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33571',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33572',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33573',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33574',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33575',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33576',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33578',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33579',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33583',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33584',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33585',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '33586',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33587',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33592',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33593',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33594',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33595',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33596',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33597',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '33598',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33601',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33602',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33603',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33604',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33605',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33606',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33607',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33608',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33609',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33610',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33611',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33612',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33613',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33614',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33615',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33616',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33617',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33618',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33619',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33620',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33621',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33622',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33623',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33624',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33625',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33626',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33629',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33630',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33631',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33633',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33634',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33635',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33637',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33646',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33647',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33650',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33651',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33655',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33660',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33661',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33662',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33663',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33664',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33672',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33673',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33674',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33675',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33677',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33679',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33680',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33681',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33682',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33684',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33685',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33686',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33687',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33688',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33689',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33690',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33694',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33697',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33701',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33702',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33703',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33704',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33705',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33706',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33707',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33708',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33709',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33710',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33711',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33712',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33713',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33714',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33715',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33716',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33729',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33730',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33731',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33732',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33733',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33734',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33736',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33737',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33738',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33740',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33741',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33742',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33743',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33744',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33747',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33755',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33756',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33757',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33758',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33759',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33760',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33761',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33762',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33763',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33764',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33765',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33766',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33767',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33769',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33770',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33771',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33772',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33773',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33774',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33775',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33776',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33777',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33778',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33779',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33780',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33781',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33782',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33784',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33785',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33786',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33801',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33802',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33803',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33804',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33805',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33806',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33807',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33809',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33810',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33811',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33812',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33813',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33815',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33820',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33823',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33825',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33826',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33827',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33830',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33831',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33834',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33835',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33836',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33837',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33838',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33839',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33840',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33841',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33843',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33844',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33845',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33846',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33847',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33848',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '33849',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33850',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33851',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33852',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33853',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33854',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33855',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33856',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33857',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33858',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33859',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33860',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33862',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33863',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33865',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33867',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33868',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33870',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33871',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33872',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33873',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33875',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33876',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33877',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33880',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33881',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33882',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33883',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33884',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33885',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33888',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33890',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33896',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33897',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33898',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33901',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33902',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33903',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33904',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33905',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33906',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33907',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33908',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33909',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33910',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33911',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33912',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33913',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33914',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33915',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33916',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33917',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33918',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33919',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33920',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33921',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33922',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33924',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33927',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33928',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33929',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33930',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33931',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33932',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33935',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33936',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33938',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33944',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33945',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33946',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33947',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33948',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33949',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33950',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33951',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33952',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33953',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33954',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33955',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33956',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33957',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33960',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '33965',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33966',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33967',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33970',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33971',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33972',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33973',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33974',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33975',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33976',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33980',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33981',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33982',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33983',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33990',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33991',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33993',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '33994',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34101',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34102',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34103',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34104',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34105',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34106',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34107',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34108',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34109',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34110',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34112',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34113',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34114',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34116',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34117',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34119',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34120',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34133',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34134',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34135',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34136',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34137',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34138',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34139',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34140',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34141',
    dma_code: '528',
    dma_description: 'MIAMI - FT. LAUDERDALE',
  },
  {
    zip_code: '34142',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34143',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34145',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34146',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34201',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34202',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34203',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34204',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34205',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34206',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34207',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34208',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34209',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34210',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34211',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34212',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34215',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34216',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34217',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34218',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34219',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34220',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34221',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34222',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34223',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34224',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34228',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34229',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34230',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34231',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34232',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34233',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34234',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34235',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34236',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34237',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34238',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34239',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34240',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34241',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34242',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34243',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34250',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34251',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34260',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34264',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34265',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34266',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34267',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34268',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34269',
    dma_code: '571',
    dma_description: 'FT. MYERS - NAPLES',
  },
  {
    zip_code: '34270',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34272',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34274',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34275',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34276',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34277',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34278',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34280',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34281',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34282',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34284',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34285',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34286',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34287',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34288',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34289',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34290',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34291',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34292',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34293',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34295',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34420',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34421',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34423',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34428',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34429',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34430',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34431',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34432',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34433',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34434',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34436',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34442',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34445',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34446',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34447',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34448',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34449',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '34450',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34451',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34452',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34453',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34460',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34461',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34464',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34465',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34470',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34471',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34472',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34473',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34474',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34475',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34476',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34477',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34478',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34479',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34480',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34481',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34482',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34483',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34484',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34487',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34488',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34489',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34491',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34492',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34498',
    dma_code: '592',
    dma_description: 'GAINESVILLE',
  },
  {
    zip_code: '34601',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34602',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34603',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34604',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34605',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34606',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34607',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34608',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34609',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34610',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34611',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34613',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34614',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34636',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34637',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34638',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34639',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34652',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34653',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34654',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34655',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34656',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34660',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34661',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34667',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34668',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34669',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34673',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34674',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34677',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34679',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34680',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34681',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34682',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34683',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34684',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34685',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34688',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34689',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34690',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34691',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34692',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34695',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34697',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34698',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34705',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34711',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34712',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34713',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34714',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34715',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34729',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34731',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34734',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34736',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34737',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34739',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34740',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34741',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34742',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34743',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34744',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34745',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34746',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34747',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34748',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34749',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34753',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34755',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34756',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34758',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34759',
    dma_code: '539',
    dma_description: 'TAMPA - ST. PETE (SARASOTA)',
  },
  {
    zip_code: '34760',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34761',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34762',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34769',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34770',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34771',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34772',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34773',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34777',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34778',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34785',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34786',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34787',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34788',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34789',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34797',
    dma_code: '534',
    dma_description: 'ORLANDO - DAYTONA BCH - MELBRN',
  },
  {
    zip_code: '34945',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34946',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34947',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34948',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34949',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34950',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34951',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34952',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34953',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34954',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34956',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34957',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34958',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34972',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34973',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34974',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34979',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34981',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34982',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34983',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34984',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34985',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34986',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34987',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34988',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34990',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34991',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34992',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34994',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34995',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34996',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '34997',
    dma_code: '548',
    dma_description: 'WEST PALM BEACH - FT. PIERCE',
  },
  {
    zip_code: '35004',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35005',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35006',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35007',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35010',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '35011',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '35013',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35014',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35015',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35016',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35019',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35020',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35021',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35022',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35023',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35031',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35032',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35033',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35034',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35035',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35036',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35038',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35040',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35041',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35042',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35043',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35044',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35045',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35046',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35048',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35049',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35051',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35052',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35053',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35054',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35055',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35056',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35057',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35058',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35060',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35061',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35062',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35063',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35064',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35068',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35070',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35071',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35072',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35073',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35074',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35077',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35078',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35079',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35080',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35082',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35083',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35085',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35087',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35089',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35091',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35094',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35096',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35097',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35098',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35111',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35112',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35114',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35115',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35116',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35117',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35118',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35119',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35120',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35121',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35123',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35124',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35125',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35126',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35127',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35128',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35130',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35131',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35133',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35135',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35136',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35137',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35139',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35142',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35143',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35144',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35146',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35147',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35148',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35149',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35150',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35151',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35160',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35161',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35171',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35172',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35173',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35175',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35176',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35178',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35179',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35180',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35181',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35182',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35183',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35184',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35185',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35186',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35187',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35188',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35201',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35202',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35203',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35204',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35205',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35206',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35207',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35208',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35209',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35210',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35211',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35212',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35213',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35214',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35215',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35216',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35217',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35218',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35219',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35220',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35221',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35222',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35223',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35224',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35225',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35226',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35228',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35229',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35230',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35231',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35232',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35233',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35234',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35235',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35236',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35237',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35238',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35240',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35242',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35243',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35244',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35245',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35246',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35249',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35253',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35254',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35255',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35259',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35260',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35261',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35263',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35266',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35277',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35278',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35279',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35280',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35281',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35282',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35283',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35285',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35286',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35287',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35288',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35290',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35291',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35292',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35293',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35294',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35295',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35296',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35297',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35298',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35299',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35401',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35402',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35403',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35404',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35405',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35406',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35407',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35440',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35441',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35442',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35443',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35444',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35446',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35447',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35448',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35449',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35452',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35453',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35456',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35457',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35458',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35459',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '35460',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '35461',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35462',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35463',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35464',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '35466',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35468',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35469',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35470',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '35471',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35473',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35474',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35475',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35476',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35477',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '35478',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35480',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35481',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35482',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35486',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35487',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35490',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35491',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35501',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35502',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35503',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35504',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35540',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35541',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35542',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35543',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35544',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '35545',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35546',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35548',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35549',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35550',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35551',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35552',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '35553',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35554',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35555',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35559',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35560',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35563',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35564',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35565',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35570',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35571',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35572',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35573',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35574',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '35575',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35576',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '35577',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35578',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35579',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35580',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35581',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35582',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35584',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35585',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35586',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '35587',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35592',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '35593',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35594',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35601',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35602',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35603',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35609',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35610',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35611',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35612',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35613',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35614',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35615',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35616',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35617',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35618',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35619',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35620',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35621',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35622',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35630',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35631',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35632',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35633',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35634',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35640',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35643',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35645',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35646',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35647',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35648',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35649',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35650',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35651',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35652',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35653',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35654',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35660',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35661',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35662',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35670',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35671',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35672',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35673',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35674',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35677',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35699',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35739',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35740',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35741',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35742',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35744',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35745',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35746',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35747',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35748',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35749',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35750',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35751',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35752',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35754',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35755',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35756',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35757',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35758',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35759',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35760',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35761',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35762',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35763',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35764',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35765',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35766',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35767',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35768',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35769',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35771',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35772',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35773',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35774',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35775',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35776',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35801',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35802',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35803',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35804',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35805',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35806',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35807',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35808',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35809',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35810',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35811',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35812',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35813',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35814',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35815',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35816',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35824',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35893',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35894',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35895',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35896',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35897',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35898',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35899',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35901',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35902',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35903',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35904',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35905',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35906',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35907',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35950',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35951',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35952',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35953',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35954',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35956',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35957',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35958',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35959',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35960',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35961',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35962',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35963',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35964',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35966',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35967',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35968',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35971',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35972',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35973',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35974',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35975',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35976',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35978',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35979',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35980',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35981',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35983',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35984',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35986',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35987',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '35988',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35989',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '35990',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36003',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36005',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36006',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36008',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36009',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36010',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36013',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36015',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36016',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36017',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36020',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36022',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36023',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36024',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36025',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36026',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36027',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36028',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36029',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36030',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36031',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36032',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36033',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36034',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36035',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36036',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36037',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36038',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36039',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36040',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36041',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36042',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36043',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36045',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36046',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36047',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36048',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36049',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36051',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36052',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36053',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36054',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36057',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36061',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36062',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36064',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36065',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36066',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36067',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36068',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36069',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36071',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36072',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36075',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36078',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36079',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36080',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36081',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36082',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36083',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36087',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36088',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36089',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36091',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36092',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36093',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36101',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36102',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36103',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36104',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36105',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36106',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36107',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36108',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36109',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36110',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36111',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36112',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36113',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36114',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36115',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36116',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36117',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36118',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36120',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36121',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36123',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36124',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36125',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36130',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36131',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36132',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36133',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36134',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36135',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36140',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36141',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36142',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36177',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36191',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36201',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36202',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36203',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36204',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36205',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36206',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36207',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36250',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36251',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36253',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36254',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36255',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36256',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36257',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36258',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36260',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36261',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '36262',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '36263',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '36264',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '36265',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36266',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36267',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36268',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36269',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '36271',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36272',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36273',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '36274',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '36275',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36276',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '36277',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36278',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '36279',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36280',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '36301',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36302',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36303',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36304',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36305',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36310',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36311',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36312',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36313',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36314',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36316',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36317',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36318',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36319',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36320',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36321',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36322',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36323',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36330',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36331',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36340',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36343',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36344',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36345',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36346',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36349',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36350',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36351',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36352',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36353',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36360',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36361',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36362',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36370',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36371',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36373',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36374',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36375',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36376',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36401',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36420',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36421',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36425',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36426',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36427',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36429',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36432',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36435',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36436',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36439',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36441',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36442',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36444',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36445',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36446',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36449',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36451',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36453',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36454',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36455',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36456',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36457',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36458',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36460',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36461',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36462',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36467',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36470',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36471',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36473',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36474',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36475',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36476',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36477',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '36480',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36481',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36482',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36483',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36501',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36502',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36503',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36504',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36505',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36507',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36509',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36511',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36512',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36513',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36515',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36518',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36521',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36522',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36523',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36524',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36525',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36526',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36527',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36528',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36529',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36530',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36532',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36533',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36535',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36536',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36538',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36539',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36540',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36541',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36542',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36543',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36544',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36545',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36547',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36548',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36549',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36550',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36551',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36553',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36555',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36556',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36558',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36559',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36560',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36561',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36562',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36564',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36567',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36568',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36569',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36571',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36572',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36574',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36575',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36576',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36577',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36578',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36579',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36580',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36581',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36582',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36583',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36584',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36585',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36587',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36590',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36601',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36602',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36603',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36604',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36605',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36606',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36607',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36608',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36609',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36610',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36611',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36612',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36613',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36615',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36616',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36617',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36618',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36619',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36621',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36622',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36625',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36628',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36630',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36633',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36640',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36644',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36652',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36660',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36663',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36670',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36671',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36675',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36685',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36688',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36689',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36690',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36691',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36693',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36695',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36701',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36702',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36703',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36720',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36721',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36722',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36723',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36726',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36727',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36728',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36732',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36736',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36738',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36740',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36741',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36742',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36744',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36745',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36748',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36749',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36750',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36751',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36752',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36753',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36754',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36756',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36758',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36759',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36761',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36762',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36763',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36764',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36765',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36766',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36767',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36768',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36769',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36773',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36775',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36776',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36782',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36783',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36784',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '36785',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36786',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36790',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36792',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36793',
    dma_code: '630',
    dma_description: 'BIRMINGHAM (ANN & TUSC)',
  },
  {
    zip_code: '36801',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36802',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36803',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36804',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36830',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36831',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36832',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36849',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36850',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36851',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36852',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36853',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36854',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36855',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36856',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36858',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36859',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36860',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36861',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36862',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36863',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36865',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36866',
    dma_code: '698',
    dma_description: 'MONTGOMERY (SELMA)',
  },
  {
    zip_code: '36867',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36868',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36869',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36870',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36871',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36872',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36874',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36875',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36877',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36879',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '36901',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '36904',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '36907',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '36908',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '36910',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '36912',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '36913',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '36915',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '36916',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '36919',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '36921',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '36922',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '36925',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '37010',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37011',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37012',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37013',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37014',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37015',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37016',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37018',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37019',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37020',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37022',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37023',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37024',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37025',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37026',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37027',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37028',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37029',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37030',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37031',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37032',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37033',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37034',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37035',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37036',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37037',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37040',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37041',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37042',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37043',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37044',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37046',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37047',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37048',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37049',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37050',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37051',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37052',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37055',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37056',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37057',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37058',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37059',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37060',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37061',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37062',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37063',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37064',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37065',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37066',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37067',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37068',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37069',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37070',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37071',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37072',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37073',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37074',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37075',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37076',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37077',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37078',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37079',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37080',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37082',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37083',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37085',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37086',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37087',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37088',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37089',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37090',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37091',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37095',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37096',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37097',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37098',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37101',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37110',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37111',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37115',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37116',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37118',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37119',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37121',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37122',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37127',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37128',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37129',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37130',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37131',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37132',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37133',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37134',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37135',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37136',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37137',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37138',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37140',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37141',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37142',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37143',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37144',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '37145',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37146',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37148',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37149',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37150',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37151',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37152',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37153',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37160',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37161',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37162',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37165',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37166',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37167',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37171',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37172',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37174',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37175',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37178',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37179',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37180',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37181',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37183',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37184',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37185',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37186',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37187',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37188',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37189',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37190',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37191',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37201',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37202',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37203',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37204',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37205',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37206',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37207',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37208',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37209',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37210',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37211',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37212',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37213',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37214',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37215',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37216',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37217',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37218',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37219',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37220',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37221',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37222',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37224',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37227',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37228',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37229',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37230',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37232',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37234',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37235',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37236',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37237',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37238',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37240',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37241',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37242',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37243',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37245',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37246',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37247',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37249',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37250',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37301',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37302',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37303',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37304',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37305',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37306',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37307',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37308',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37309',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37310',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37311',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37312',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37313',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37314',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37315',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37316',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37317',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37318',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37320',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37321',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37322',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37323',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37324',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37325',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37326',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37327',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37328',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '37329',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37330',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37331',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37332',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37333',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37334',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '37335',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '37336',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37337',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37338',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37339',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37340',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37341',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37342',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37343',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37345',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37347',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37348',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '37349',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37350',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37351',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37352',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37353',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37354',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37355',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37356',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37357',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37359',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '37360',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37361',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37362',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37363',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37364',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37365',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37366',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37367',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37369',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37370',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37371',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37373',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37374',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37375',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37376',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37377',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37378',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37379',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37380',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37381',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37382',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37383',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37384',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37385',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37387',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37388',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37389',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37391',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37394',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37396',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37397',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37398',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '37401',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37402',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37403',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37404',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37405',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37406',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37407',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37408',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37409',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37410',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37411',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37412',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37414',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37415',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37416',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37419',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37421',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37422',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37424',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37450',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37501',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '37544',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '37601',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37602',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37604',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37605',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37614',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37615',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37616',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37617',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37618',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37620',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37621',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37625',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37640',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37641',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37642',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37643',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37644',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37645',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37650',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37656',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37657',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37658',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37659',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37660',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37662',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37663',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37664',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37665',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37669',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37680',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37681',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37682',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37683',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37684',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37686',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37687',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37688',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37690',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37691',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37692',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37694',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37701',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37705',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37707',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37708',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37709',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37710',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37711',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37713',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37714',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37715',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37716',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37717',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37719',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37721',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37722',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37723',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37724',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37725',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37726',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37727',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37729',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37730',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37731',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37732',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37733',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37737',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37738',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37742',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37743',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37744',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37745',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37748',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37752',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37753',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37754',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37755',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37756',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37757',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37760',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37762',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37763',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37764',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37765',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37766',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37769',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37770',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37771',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37772',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37773',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37774',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37777',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37778',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37779',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37801',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37802',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37803',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37804',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37806',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37807',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37809',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37810',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37811',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37813',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37814',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37815',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37816',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37818',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37819',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37820',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37821',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37822',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37824',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37825',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37826',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37828',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37829',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37830',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37831',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37840',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37841',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37843',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37845',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37846',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37847',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37848',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37849',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37851',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37852',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37853',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37854',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37857',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37860',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37861',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37862',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37863',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37864',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37865',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37866',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37867',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37868',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37869',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37870',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37871',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37872',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37873',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '37874',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37876',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37877',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37878',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37879',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37880',
    dma_code: '575',
    dma_description: 'CHATTANOOGA',
  },
  {
    zip_code: '37881',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37882',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37885',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37886',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37887',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37888',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37890',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37891',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37892',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37901',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37902',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37909',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37912',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37914',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37915',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37916',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37917',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37918',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37919',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37920',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37921',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37922',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37923',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37924',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37927',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37928',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37929',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37930',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37931',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37932',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37933',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37934',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37938',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37939',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37940',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37950',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37990',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37995',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37996',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37997',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '37998',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '38001',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38002',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38004',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38006',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38007',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38008',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38010',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38011',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38012',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38014',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38015',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38016',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38017',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38018',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38019',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38021',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38023',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38024',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38025',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38027',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38028',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38029',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38030',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38034',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38036',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38037',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38039',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38040',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38041',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38042',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38044',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38045',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38046',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38047',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38048',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38049',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38050',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38052',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38053',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38054',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38055',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38057',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38058',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38059',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38060',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38061',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38063',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38066',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38067',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38068',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38069',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38070',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38071',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38075',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38076',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38077',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38079',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38080',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38083',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38088',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38101',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38103',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38104',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38105',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38106',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38107',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38108',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38109',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38110',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38111',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38112',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38113',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38114',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38115',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38116',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38117',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38118',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38119',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38120',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38122',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38124',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38125',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38126',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38127',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38128',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38130',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38131',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38132',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38133',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38134',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38135',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38136',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38137',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38138',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38139',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38141',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38142',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38145',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38147',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38148',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38150',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38151',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38152',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38157',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38159',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38161',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38163',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38165',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38166',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38167',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38168',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38173',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38174',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38175',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38177',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38181',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38182',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38183',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38184',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38186',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38187',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38188',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38190',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38193',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38194',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38197',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38201',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38220',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38221',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38222',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38223',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38224',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38225',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38226',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38229',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38230',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38231',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38232',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38233',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38235',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38236',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38237',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38238',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38240',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38241',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38242',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38251',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38253',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38254',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38255',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38256',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38257',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38258',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38259',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38260',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38261',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38271',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38281',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '38301',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38302',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38303',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38305',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38308',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38310',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38311',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38313',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38314',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38315',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38316',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38317',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38318',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38320',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38321',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38324',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38326',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38327',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38328',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38329',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38330',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38331',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38332',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38333',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38334',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38336',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38337',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38338',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38339',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38340',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38341',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38342',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38343',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38344',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38345',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38346',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38347',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38348',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38351',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38352',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38355',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38356',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38357',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38358',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38359',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38361',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38362',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38363',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38365',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38366',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38367',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38368',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38369',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38370',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38371',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38372',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38374',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38375',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38376',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38377',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38378',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38379',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38380',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38381',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38382',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38387',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38388',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38389',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38390',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38391',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38392',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38393',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38401',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38402',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38425',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38449',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38450',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38451',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38452',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38453',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '38454',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38455',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38456',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38457',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38459',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '38460',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38461',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38462',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38463',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38464',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38468',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38469',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38471',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38472',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38473',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38474',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38475',
    dma_code: '639',
    dma_description: 'JACKSON, TN',
  },
  {
    zip_code: '38476',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38477',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38478',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38481',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38482',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38483',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38485',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38486',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38487',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38488',
    dma_code: '691',
    dma_description: 'HUNTSVILLE - DECATUR (FLOR)',
  },
  {
    zip_code: '38501',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38502',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38503',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38504',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '38505',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38506',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38541',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38542',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38543',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38544',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38545',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38547',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38548',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38549',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38550',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38551',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38552',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38553',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '38554',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38555',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '38556',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '38557',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '38558',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '38559',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38560',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38562',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38563',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38564',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38565',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '38567',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38568',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38569',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38570',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38571',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '38572',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '38573',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38574',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38575',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38577',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '38578',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '38579',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38580',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38581',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38582',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38583',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38585',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38587',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38588',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38589',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '38601',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38602',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38603',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38606',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38609',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38610',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38611',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38614',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38617',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38618',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38619',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38620',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38621',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38622',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38623',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38625',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38626',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38627',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38628',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38629',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38630',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38631',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38632',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38633',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38634',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38635',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38637',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38638',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38639',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38641',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38642',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38643',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38644',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38645',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38646',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38647',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38649',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38650',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38651',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38652',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38654',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38655',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38658',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38659',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38661',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38663',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38664',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38665',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38666',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38668',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38669',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38670',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38671',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38672',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38673',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38674',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38675',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38676',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38677',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38679',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38680',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38683',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38685',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38686',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38701',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38702',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38703',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38704',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38720',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38721',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '38722',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38723',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38725',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38726',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38730',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38731',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38732',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38733',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38736',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38737',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38738',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38739',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38740',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38744',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38745',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '38746',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38748',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38749',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38751',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38753',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38754',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '38756',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38759',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38760',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38761',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38762',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38764',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38765',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '38767',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38768',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38769',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38771',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38772',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38773',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38774',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38776',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38778',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38780',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38781',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38782',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38801',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38802',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38803',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38804',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38820',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38821',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38824',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38825',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38826',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38827',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38828',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38829',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38833',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38834',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38835',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38838',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38839',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38841',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38843',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38844',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38846',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38847',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38848',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38849',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38850',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38851',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38852',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38855',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38856',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38857',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38858',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38859',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38860',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38862',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38863',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38864',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38865',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38866',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38868',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38869',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38870',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38871',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38873',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38874',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38875',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38876',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38877',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38878',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38879',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38880',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38901',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38902',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38913',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38914',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38915',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38916',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38917',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38920',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38921',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38922',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38923',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38924',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '38925',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38926',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38927',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38928',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38929',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38930',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38935',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38940',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38941',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38943',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38944',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38945',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38946',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38947',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38948',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38949',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38950',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38951',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38952',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38953',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38954',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38955',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38957',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38958',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38959',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38960',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38961',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38962',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38963',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38964',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '38965',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '38966',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '38967',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39038',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39039',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39040',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39041',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39042',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39043',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39044',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39045',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39046',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39047',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39051',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39054',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39056',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39057',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39058',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39059',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39060',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39061',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39062',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39063',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39066',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39067',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39069',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39071',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39072',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39073',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39074',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39077',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39078',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39079',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39080',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39081',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39082',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39083',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39086',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39087',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39088',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39090',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39092',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39094',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39095',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39096',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39097',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39098',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39107',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39108',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39109',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39110',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39111',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39113',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39114',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39115',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39116',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39117',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39119',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39120',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39121',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39122',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39130',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39140',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39144',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39145',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39146',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39148',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39149',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39150',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39151',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39152',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39153',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39154',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39156',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39157',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39158',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39159',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39160',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39161',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39162',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39163',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39165',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39166',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39167',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39168',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39169',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39170',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39171',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39173',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39174',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39175',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39176',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '39177',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39179',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39180',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39181',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39182',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39183',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39189',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39190',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39191',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39192',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39193',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39194',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39201',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39202',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39203',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39204',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39205',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39206',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39207',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39208',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39209',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39210',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39211',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39212',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39213',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39215',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39216',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39217',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39218',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39225',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39232',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39235',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39236',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39250',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39269',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39271',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39272',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39282',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39283',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39284',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39286',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39288',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39289',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39296',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39298',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39301',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39302',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39303',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39304',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39305',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39307',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39309',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39320',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39322',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39323',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39324',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39325',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39326',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39327',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39328',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39330',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39332',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39335',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39336',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39337',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39338',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39339',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39341',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39342',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39345',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39346',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39347',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39348',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39350',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39352',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39354',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39355',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39356',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39358',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39359',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39360',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39361',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39362',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '39363',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39364',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39365',
    dma_code: '711',
    dma_description: 'MERIDIAN',
  },
  {
    zip_code: '39366',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39367',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39401',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39402',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39403',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39404',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39406',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39407',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39421',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39422',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39423',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39425',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39426',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '39427',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39428',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39429',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39436',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39437',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39439',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39440',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39441',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39442',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39443',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39451',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '39452',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39455',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39456',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '39457',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '39459',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39460',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39461',
    dma_code: '686',
    dma_description: 'MOBILE - PENSACOLA (FT WALT)',
  },
  {
    zip_code: '39462',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39463',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '39464',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39465',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39466',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '39470',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '39474',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39475',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39476',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39477',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39478',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39479',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39480',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39481',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39482',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39483',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39501',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39502',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39503',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39505',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39506',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39507',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39520',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '39521',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '39522',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '39525',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '39529',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '39530',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39531',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39532',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39533',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39534',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39535',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39540',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39552',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39553',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39555',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39556',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '39558',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '39560',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39561',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39562',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39563',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39564',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39565',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39566',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39567',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39568',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39569',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39571',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39572',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '39573',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39574',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39576',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '39577',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39581',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39595',
    dma_code: '746',
    dma_description: 'BILOXI - GULFPORT',
  },
  {
    zip_code: '39601',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39602',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39603',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39629',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39630',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39631',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '39632',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39633',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '39635',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39638',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '39641',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39643',
    dma_code: '710',
    dma_description: 'HATTIESBURG - LAUREL',
  },
  {
    zip_code: '39645',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '39647',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39648',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39649',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39652',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39653',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39654',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39656',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39657',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39661',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39662',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39663',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39664',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '39665',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39666',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39667',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39668',
    dma_code: '718',
    dma_description: 'JACKSON, MS',
  },
  {
    zip_code: '39669',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '39701',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39702',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39703',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39704',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39705',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39710',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39730',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39735',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39736',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39737',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39739',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39740',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39741',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39743',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39744',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39745',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39746',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39747',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39750',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39751',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39752',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39753',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39754',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39755',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39756',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39759',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39760',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39762',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39766',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39767',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39769',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39771',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39772',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39773',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39776',
    dma_code: '673',
    dma_description: 'COLUMBUS - TUPELO - WEST POINT',
  },
  {
    zip_code: '39813',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '39815',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '39817',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '39818',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '39819',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '39823',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '39824',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '39825',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '39826',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '39827',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '39828',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '39829',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '39832',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '39834',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '39836',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '39837',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '39840',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '39841',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '39842',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '39845',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '39846',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '39851',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '39852',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '39854',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '39859',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '39861',
    dma_code: '606',
    dma_description: 'DOTHAN',
  },
  {
    zip_code: '39862',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '39866',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '39867',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '39870',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '39877',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '39885',
    dma_code: '525',
    dma_description: 'ALBANY, GA',
  },
  {
    zip_code: '39886',
    dma_code: '522',
    dma_description: 'COLUMBUS, GA',
  },
  {
    zip_code: '39897',
    dma_code: '530',
    dma_description: 'TALLAHASSEE - THOMASVILLE',
  },
  {
    zip_code: '39901',
    dma_code: '524',
    dma_description: 'ATLANTA',
  },
  {
    zip_code: '40003',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40004',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40006',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40007',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40008',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40009',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40010',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40011',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40012',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40013',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40014',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40018',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40019',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40020',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40022',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40023',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40025',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40026',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40027',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40031',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40032',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40033',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40036',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40037',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40040',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40041',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40045',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40046',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40047',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40048',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40049',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40050',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40051',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40052',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40055',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40056',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40057',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40058',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40059',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40060',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40061',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40062',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40063',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40065',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40066',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40067',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40068',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40069',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40070',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40071',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40075',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40076',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40077',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40078',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40104',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40107',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40108',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40109',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40110',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40111',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40115',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40117',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40118',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40119',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40121',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40129',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40140',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40142',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40143',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40144',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40145',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40146',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40150',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40152',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40153',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40155',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40157',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40159',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40160',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40161',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40162',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40165',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40170',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40171',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40175',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40176',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40177',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40178',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40201',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40202',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40203',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40204',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40205',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40206',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40207',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40208',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40209',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40210',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40211',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40212',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40213',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40214',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40215',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40216',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40217',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40218',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40219',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40220',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40221',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40222',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40223',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40224',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40225',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40228',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40229',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40232',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40233',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40241',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40242',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40243',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40245',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40250',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40251',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40252',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40253',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40255',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40256',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40257',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40258',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40259',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40261',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40266',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40268',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40269',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40270',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40272',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40280',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40281',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40282',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40283',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40285',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40287',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40289',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40290',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40291',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40292',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40293',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40294',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40296',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40297',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40298',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40299',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40310',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40311',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40312',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40313',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40316',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40317',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40319',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40322',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40324',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40328',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '40330',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40334',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40336',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40337',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40339',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40340',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40342',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40346',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40347',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40348',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40350',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40351',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40353',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40355',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '40356',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40357',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40358',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40359',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '40360',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40361',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40362',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40363',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '40366',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40370',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40371',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40372',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40374',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40376',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40379',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40380',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40383',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40384',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40385',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40386',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40387',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40390',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40391',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40392',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40402',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40403',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40404',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40405',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40409',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40410',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40419',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40422',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40423',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40434',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40437',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40440',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40442',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40444',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40445',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40446',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40447',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40448',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40452',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40456',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40460',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40461',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40464',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40468',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40472',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40473',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40475',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40476',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40481',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40484',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40486',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40488',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40489',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40492',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40495',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40502',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40503',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40504',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40505',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40506',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40507',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40508',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40509',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40510',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40511',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40512',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40513',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40514',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40515',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40516',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40517',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40522',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40523',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40524',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40526',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40533',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40536',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40544',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40546',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40550',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40555',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40574',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40575',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40576',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40577',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40578',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40579',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40580',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40581',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40582',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40583',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40588',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40591',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40598',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40601',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40602',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40603',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40604',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40618',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40619',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40620',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40621',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40622',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40701',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40702',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40724',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40729',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40730',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40734',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40737',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40740',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40741',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40743',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40744',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40745',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40754',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40755',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40759',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40763',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40769',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40771',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40801',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40803',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '40806',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40807',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40808',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40810',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40813',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40815',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40816',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '40818',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40819',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40820',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40823',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40824',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40826',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '40827',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '40828',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40829',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40830',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40831',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40840',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '40843',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40844',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '40845',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40847',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40849',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40854',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40855',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40856',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40858',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '40862',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '40863',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40865',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40868',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '40870',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40873',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40874',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '40902',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40903',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40906',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40913',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40914',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40915',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40921',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40923',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40927',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40930',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40932',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40935',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40939',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40940',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40941',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40943',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40944',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40946',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40949',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40951',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40953',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40955',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40958',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40962',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40964',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40965',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40972',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40977',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40979',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '40981',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40982',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40983',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40988',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '40995',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40997',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '40999',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41001',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41002',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41003',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41004',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41005',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41006',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41007',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41008',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '41010',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41011',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41012',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41014',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41015',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41016',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41017',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41018',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41019',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41022',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41030',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41031',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41033',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41034',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41035',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41037',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41039',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41040',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41041',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41042',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41043',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41044',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41045',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '41046',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41048',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41049',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41051',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41052',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41053',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41054',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41055',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41056',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41059',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41061',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41062',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41063',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41064',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41065',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41071',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41072',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41073',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41074',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41075',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41076',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41080',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41081',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41083',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '41085',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41086',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41091',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41092',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41093',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41094',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41095',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41096',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41097',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41098',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '41099',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '41101',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41102',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41105',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41114',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41121',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41124',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41128',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41129',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41132',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41135',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41139',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41141',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41142',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41143',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41144',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41146',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41149',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41159',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41160',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41164',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41166',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41168',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41169',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41171',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41173',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41174',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41175',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41179',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41180',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41181',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41183',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41189',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41201',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41203',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41204',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41214',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41216',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41219',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41222',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41224',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41226',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41230',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41231',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41232',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41234',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41238',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41240',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41250',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41254',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41255',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41256',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41257',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41260',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41262',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41263',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41264',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41265',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41267',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41268',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41271',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41274',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41301',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41307',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41310',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41311',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41313',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41314',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41317',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41332',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41333',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41338',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41339',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41347',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41348',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41351',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41352',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41360',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41362',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41364',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41365',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41366',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41367',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41368',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41385',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41386',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41390',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41397',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41408',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41413',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41421',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41425',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41426',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41433',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41451',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41459',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41464',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41465',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41472',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41477',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41501',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41502',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41503',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41512',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41513',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41514',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41517',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41519',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41520',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41522',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41524',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41526',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41527',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41528',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41531',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41534',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41535',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41537',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41538',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41539',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41540',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41542',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41543',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41544',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41547',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41548',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41549',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41553',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41554',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41555',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41557',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41558',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41559',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41560',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41561',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41562',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41563',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41564',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41566',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41567',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41568',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41571',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41572',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41601',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41602',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41603',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41604',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41605',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41606',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41607',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41612',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41615',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41616',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41619',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41621',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41622',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41630',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41631',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41632',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41635',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41636',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41640',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41642',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41643',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41645',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41647',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41649',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41650',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41651',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41653',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41655',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41659',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41660',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41663',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41666',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41667',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41669',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '41701',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41702',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41712',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41713',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41714',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41719',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41721',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41722',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41723',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41725',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41727',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41729',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41731',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41735',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41736',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41739',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41740',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41743',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41745',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41746',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41747',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41749',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41751',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41754',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41759',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41760',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41762',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41763',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41764',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41766',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41772',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41773',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41774',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41775',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41776',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41777',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41778',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41804',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41810',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41812',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41815',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41817',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41819',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41821',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41822',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41824',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41825',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41826',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41828',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41831',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41832',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41833',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41834',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41835',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41836',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41837',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41838',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41839',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41840',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41843',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41844',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41845',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41847',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41848',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41849',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41855',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41858',
    dma_code: '531',
    dma_description: 'TRI - CITIES, TN - VA',
  },
  {
    zip_code: '41859',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41861',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '41862',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42001',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42002',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42003',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42020',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42021',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42022',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42023',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42024',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42025',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42027',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42028',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42029',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42031',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42032',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42033',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42035',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42036',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42037',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42038',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42039',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42040',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42041',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42044',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42045',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42047',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42048',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42049',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42050',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42051',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42053',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42054',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42055',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42056',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42058',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42060',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42061',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42063',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42064',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42066',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42069',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42070',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42071',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42076',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42078',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42079',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42081',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42082',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42083',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42084',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42085',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42086',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42087',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42088',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42101',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42102',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42103',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42104',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42120',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42122',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42123',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42124',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42127',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42128',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42129',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42130',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42131',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42133',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42134',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42135',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42140',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42141',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42142',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42151',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42152',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42153',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42154',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42156',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42157',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42159',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42160',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42163',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42164',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42166',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42167',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42170',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42171',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42201',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42202',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42204',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42206',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42207',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42210',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42211',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42214',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42215',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42216',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42217',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42219',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42220',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42221',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42223',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42232',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42234',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42236',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42240',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42241',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42252',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42254',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42256',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42259',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42261',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42262',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42265',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42266',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42273',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42274',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42275',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42276',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42280',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42283',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42285',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42286',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42287',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42288',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42301',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42302',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42303',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42304',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42320',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42321',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42322',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42323',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42324',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42325',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42326',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42327',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42328',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42330',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42332',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42333',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42334',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42337',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42338',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42339',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42343',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42344',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42345',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42347',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42348',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42349',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42350',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42351',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42352',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42354',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42355',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42356',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42361',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42364',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42366',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42367',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42368',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42369',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42370',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42371',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42372',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42374',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42375',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42376',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42377',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42378',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42402',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42403',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42404',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42406',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42408',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42409',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42410',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42411',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42413',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42419',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42420',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42431',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42436',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42437',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42440',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42441',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42442',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42444',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42445',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '42450',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42451',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42452',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42453',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42455',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42456',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42457',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42458',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42459',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42460',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42461',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42462',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42463',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42464',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '42501',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42502',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42503',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42516',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42518',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42519',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42528',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42533',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42539',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42541',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42544',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42553',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42558',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42564',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42565',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42566',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42567',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42602',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42603',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42629',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42631',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '42633',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42634',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '42635',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '42638',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '42642',
    dma_code: '541',
    dma_description: 'LEXINGTON',
  },
  {
    zip_code: '42647',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '42649',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '42653',
    dma_code: '557',
    dma_description: 'KNOXVILLE',
  },
  {
    zip_code: '42701',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42702',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42712',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42713',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42715',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42716',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42717',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42718',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42719',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42720',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42721',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42722',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42724',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42726',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42728',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42729',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42731',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42732',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42733',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42740',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42741',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42742',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42743',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42746',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42748',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42749',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42753',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42754',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42755',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42757',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42758',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42759',
    dma_code: '659',
    dma_description: 'NASHVILLE',
  },
  {
    zip_code: '42762',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42764',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42765',
    dma_code: '736',
    dma_description: 'BOWLING GREEN',
  },
  {
    zip_code: '42776',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42782',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42784',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '42788',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '43001',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43002',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43003',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43004',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43005',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43006',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43007',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43008',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43009',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43010',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43011',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43013',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43014',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43015',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43016',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43017',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43018',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43019',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43021',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43022',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43023',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43025',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43026',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43027',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43028',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43029',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43030',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43031',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43032',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43033',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43035',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43036',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43037',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43040',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43041',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43044',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43045',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43046',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43047',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43048',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43050',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43054',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43055',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43056',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43058',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43060',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43061',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43062',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43064',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43065',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43066',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43067',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43068',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43069',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43070',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43071',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43072',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43073',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43074',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43076',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43077',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43078',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43080',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43081',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43082',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43083',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43084',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43085',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43086',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43093',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43098',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43101',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43102',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43103',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43105',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43106',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43107',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43109',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43110',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43111',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43112',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43113',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43115',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43116',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43117',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43119',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43123',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43125',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43126',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43127',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43128',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43130',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43135',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43136',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43137',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43138',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43140',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43142',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43143',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43144',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43145',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43146',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43147',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43148',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43149',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43150',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43151',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43152',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43153',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43154',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43155',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43156',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43157',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43158',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43160',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43162',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43163',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43164',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43195',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43196',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43198',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43199',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43201',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43202',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43203',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43204',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43205',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43206',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43207',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43209',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43210',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43211',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43212',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43213',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43214',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43215',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43216',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43217',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43218',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43219',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43220',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43221',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43222',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43223',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43224',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43226',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43227',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43228',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43229',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43230',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43231',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43232',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43234',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43235',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43236',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43240',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43251',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43260',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43265',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43266',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43268',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43270',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43271',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43272',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43279',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43287',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43291',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43299',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43301',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43302',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43306',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43307',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43310',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43311',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43314',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43315',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43316',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43317',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43318',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43319',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43320',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43321',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43322',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43323',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43324',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43325',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43326',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43330',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43331',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43332',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43333',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43334',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43335',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43336',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43337',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43338',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43340',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43341',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43342',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43343',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43344',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43345',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43346',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43347',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43348',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43349',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43350',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43351',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43356',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43357',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43358',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43359',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43360',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '43402',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43403',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43406',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43407',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43408',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43410',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43412',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43413',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43414',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43416',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43420',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43430',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43431',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43432',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43433',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43434',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43435',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43436',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43437',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43438',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '43439',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43440',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43441',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43442',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43443',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43445',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43446',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43447',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43449',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43450',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43451',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43452',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43456',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43457',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43458',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43460',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43462',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43463',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43464',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43465',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43466',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43467',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43468',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43469',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43501',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43502',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43504',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43505',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43506',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43510',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43511',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43512',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43515',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43516',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43517',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43518',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43519',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43520',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43521',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43522',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43523',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43524',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43525',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43526',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43527',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43528',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43529',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43530',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43531',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43532',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43533',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43534',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43535',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43536',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43537',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43540',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43541',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43542',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43543',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43545',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43547',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43548',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43549',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43550',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43551',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43552',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43553',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43554',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43555',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43556',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43557',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43558',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43560',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43565',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43566',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43567',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43569',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43570',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43571',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43601',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43603',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43604',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43605',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43606',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43607',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43608',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43609',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43610',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43611',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43612',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43613',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43614',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43615',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43616',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43617',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43618',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43619',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43620',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43623',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43635',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43652',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43654',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43656',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43657',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43659',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43660',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43661',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43666',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43667',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43681',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43682',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43697',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43699',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '43701',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43702',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43711',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43713',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43716',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43717',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43718',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43719',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43720',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43721',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43722',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43723',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43724',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43725',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43727',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43728',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43730',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43731',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43732',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43733',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43734',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43735',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43736',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43738',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43739',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43740',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43746',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43747',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43748',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43749',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43750',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43752',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43754',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43755',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43756',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43757',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43758',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43759',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43760',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43761',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43762',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43764',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43766',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43767',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43768',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43771',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43772',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43773',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43777',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43778',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43779',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43780',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43782',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43783',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43786',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43787',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43788',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43789',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43791',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43793',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43802',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43803',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43804',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '43805',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43811',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43812',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43821',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43822',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43824',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43828',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43830',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43832',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '43836',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43837',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '43840',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '43842',
    dma_code: '596',
    dma_description: 'ZANESVILLE',
  },
  {
    zip_code: '43843',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43844',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43845',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '43901',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43902',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43903',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43905',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43906',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43907',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43908',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43909',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43910',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43912',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43913',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43914',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43915',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43916',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43917',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43920',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '43925',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43926',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43927',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43928',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43930',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43931',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43932',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43933',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43934',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43935',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43937',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43938',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43939',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43940',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43941',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43942',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43943',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43944',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43945',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '43946',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43947',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43948',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43950',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43951',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43952',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43953',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43961',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43962',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '43963',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43964',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43967',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43968',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '43970',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43971',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43972',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43973',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43974',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43976',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43977',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43981',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43983',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43984',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43985',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43986',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '43988',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '44001',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44003',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44004',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44005',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44010',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44011',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44012',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44017',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44021',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44022',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44023',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44024',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44026',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44028',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44030',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44032',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44033',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44035',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44036',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44039',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44040',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44041',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44044',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44045',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44046',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44047',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44048',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44049',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44050',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44052',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44053',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44054',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44055',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44056',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44057',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44060',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44061',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44062',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44064',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44065',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44067',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44068',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44070',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44072',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44073',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44074',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44076',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44077',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44080',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44081',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44082',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44084',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44085',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44086',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44087',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44088',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44089',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44090',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44092',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44093',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44094',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44095',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44096',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44097',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44099',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44101',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44102',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44103',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44104',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44105',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44106',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44107',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44108',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44109',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44110',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44111',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44112',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44113',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44114',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44115',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44116',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44117',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44118',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44119',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44120',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44121',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44122',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44123',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44124',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44125',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44126',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44127',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44128',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44129',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44130',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44131',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44132',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44133',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44134',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44135',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44136',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44137',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44138',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44139',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44140',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44141',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44142',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44143',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44144',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44145',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44146',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44147',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44149',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44178',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44181',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44185',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44188',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44189',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44190',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44191',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44192',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44193',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44194',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44195',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44197',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44198',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44199',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44201',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44202',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44203',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44210',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44211',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44212',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44214',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44215',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44216',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44217',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44221',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44222',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44223',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44224',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44230',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44231',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44232',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44233',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44234',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44235',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44236',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44237',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44240',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44241',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44242',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44243',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44250',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44251',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44253',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44254',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44255',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44256',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44258',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44260',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44262',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44264',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44265',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44266',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44270',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44272',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44273',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44274',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44275',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44276',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44278',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44280',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44281',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44282',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44285',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44286',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44287',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44288',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44301',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44302',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44303',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44304',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44305',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44306',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44307',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44308',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44309',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44310',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44311',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44312',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44313',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44314',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44315',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44316',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44317',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44319',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44320',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44321',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44322',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44325',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44326',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44328',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44333',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44334',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44372',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44393',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44396',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44398',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44401',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44402',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44403',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44404',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44405',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44406',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44408',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44410',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44411',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44412',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44413',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44415',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44416',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44417',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44418',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44420',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44422',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44423',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44424',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44425',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44427',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44428',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44429',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44430',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44431',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44432',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44436',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44437',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44438',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44439',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44440',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44441',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44442',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44443',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44444',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44445',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44446',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44449',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44450',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44451',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44452',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44453',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44454',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44455',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44460',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44470',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44471',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44473',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44481',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44482',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44483',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44484',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44485',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44486',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44488',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44490',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44491',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44492',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44493',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44501',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44502',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44503',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44504',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44505',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44506',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44507',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44509',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44510',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44511',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44512',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44513',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44514',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44515',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44555',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44601',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44606',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44607',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44608',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44609',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44610',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44611',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44612',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44613',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44614',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44615',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44617',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44618',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44619',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44620',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44621',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44622',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44624',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44625',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44626',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44627',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44628',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44629',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44630',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44631',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44632',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44633',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44634',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44636',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44637',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44638',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44639',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44640',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44641',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44643',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44644',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44645',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44646',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44647',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44648',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44650',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44651',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44652',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44653',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44654',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44656',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44657',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44659',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44660',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44661',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44662',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44663',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44665',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44666',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44667',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44669',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44670',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44671',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44672',
    dma_code: '536',
    dma_description: 'YOUNGSTOWN',
  },
  {
    zip_code: '44675',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44676',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44677',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44678',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44679',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44680',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44681',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44682',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44683',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44685',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44687',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44688',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44689',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44690',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44691',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44693',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '44695',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '44697',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44699',
    dma_code: '554',
    dma_description: 'WHEELING - STEUBENVILLE',
  },
  {
    zip_code: '44701',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44702',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44703',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44704',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44705',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44706',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44707',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44708',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44709',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44710',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44711',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44712',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44714',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44718',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44720',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44721',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44730',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44735',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44750',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44767',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44799',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44802',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44804',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44805',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44807',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44809',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44811',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44813',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44814',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44815',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44816',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44817',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44818',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44820',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '44822',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44824',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44825',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '44826',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44827',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '44828',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44830',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44833',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '44836',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44837',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44838',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44839',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44840',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44841',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44842',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44843',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44844',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44845',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44846',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44847',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44848',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44849',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44850',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44851',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44853',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44854',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '44855',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44856',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '44857',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44859',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44860',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '44861',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44862',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44864',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44865',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44866',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44867',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44870',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44871',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44874',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44875',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44878',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44880',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44881',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '44882',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44883',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '44887',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '44888',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44889',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44890',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44901',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44902',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44903',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44904',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44905',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44906',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44907',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '44999',
    dma_code: '510',
    dma_description: 'CLEVELAND - AKRON (CANTON)',
  },
  {
    zip_code: '45001',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45002',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45003',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45004',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45005',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45011',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45012',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45013',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45014',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45015',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45018',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45025',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45026',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45030',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45032',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45033',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45034',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45036',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45039',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45040',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45041',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45042',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45043',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45044',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45050',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45051',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45052',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45053',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45054',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45055',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45056',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45061',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45062',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45063',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45064',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45065',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45066',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45067',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45068',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45069',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45070',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45071',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45101',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45102',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45103',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45105',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45106',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45107',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45110',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45111',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45112',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45113',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45114',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45115',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45118',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45119',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45120',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45121',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45122',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45123',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45130',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45131',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45132',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45133',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45135',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45138',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45140',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45142',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45144',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45145',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45146',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45147',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45148',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45150',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45152',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45153',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45154',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45155',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45156',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45157',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45158',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45159',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45160',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45162',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45164',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45166',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45167',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45168',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45169',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45171',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45172',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45174',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45176',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45177',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45201',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45202',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45203',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45204',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45205',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45206',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45207',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45208',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45209',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45211',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45212',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45213',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45214',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45215',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45216',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45217',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45218',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45219',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45220',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45221',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45222',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45223',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45224',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45225',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45226',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45227',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45228',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45229',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45230',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45231',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45232',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45233',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45234',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45235',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45236',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45237',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45238',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45239',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45240',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45241',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45242',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45243',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45244',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45245',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45246',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45247',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45248',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45249',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45250',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45251',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45252',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45253',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45254',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45255',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45258',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45262',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45263',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45264',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45267',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45268',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45269',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45270',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45271',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45273',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45274',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45275',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45277',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45296',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45298',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45299',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45301',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45302',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45303',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45304',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45305',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45306',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45307',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45308',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45309',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45310',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45311',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45312',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45314',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45315',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45316',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45317',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45318',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45319',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45320',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45321',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45322',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45323',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45324',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45325',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45326',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45327',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45328',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45330',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45331',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45332',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45333',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45334',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45335',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45336',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45337',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45338',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45339',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45340',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45341',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45342',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45343',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45344',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45345',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45346',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45347',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45348',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45349',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45350',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45351',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45352',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45353',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45354',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45356',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45358',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45359',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45360',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45361',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45362',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45363',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45365',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45367',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45368',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45369',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45370',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45371',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45372',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45373',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45374',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45377',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45378',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45380',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45381',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45382',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45383',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45384',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45385',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45387',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45388',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45389',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45390',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45400',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45401',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45402',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45403',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45404',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45405',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45406',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45408',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45409',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45410',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45412',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45413',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45414',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45415',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45416',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45417',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45418',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45419',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45420',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45422',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45423',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45424',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45426',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45427',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45428',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45429',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45430',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45431',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45432',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45433',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45434',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45435',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45437',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45439',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45440',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45441',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45448',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45449',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45454',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45458',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45459',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45463',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45469',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45470',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45475',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45479',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45481',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45482',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45490',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45501',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45502',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45503',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45504',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45505',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45506',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45601',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45612',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45613',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45614',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45616',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45617',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45618',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45619',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45620',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45621',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45622',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45623',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45624',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45628',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45629',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45630',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45631',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45633',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45634',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45636',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45638',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45640',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45642',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45643',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45644',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45645',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45646',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45647',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45648',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45650',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45651',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45652',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45653',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45654',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45656',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45657',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45658',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45659',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45660',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45661',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45662',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45663',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45669',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45671',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45672',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45673',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45674',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45675',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45677',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45678',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45679',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45680',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45681',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45682',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45683',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45684',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45685',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45686',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45687',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45688',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45690',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45692',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45693',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45694',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45695',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45696',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45697',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '45698',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45699',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45701',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45710',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45711',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45712',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45713',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45714',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45715',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45716',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45717',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45719',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45720',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45721',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45723',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45724',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45727',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45729',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45732',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45734',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45735',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45739',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45740',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45741',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45742',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45743',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45744',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45745',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45746',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45750',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45760',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45761',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45764',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45766',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45767',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45768',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45769',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45770',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45771',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45772',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45773',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45775',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45776',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45777',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45778',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45779',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45780',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45782',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45783',
    dma_code: '564',
    dma_description: 'CHARLESTON - HUNTINGTON',
  },
  {
    zip_code: '45784',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45786',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45787',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45788',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45789',
    dma_code: '597',
    dma_description: 'PARKERSBURG',
  },
  {
    zip_code: '45801',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45802',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45804',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45805',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45806',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45807',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45808',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45809',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45810',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45812',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45813',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45814',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '45815',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45816',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '45817',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45819',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45820',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45821',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45822',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45826',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45827',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45828',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45830',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45831',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45832',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45833',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45835',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45836',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45837',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45838',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45839',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '45840',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '45841',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '45843',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45844',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45845',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45846',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45848',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45849',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45850',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45851',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45853',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45854',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45855',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45856',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45858',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '45859',
    dma_code: '535',
    dma_description: 'COLUMBUS, OH',
  },
  {
    zip_code: '45860',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45861',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45862',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45863',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45864',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45865',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45866',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45867',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '45868',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '45869',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45870',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45871',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45872',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '45873',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45874',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45875',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45876',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45877',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45879',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45880',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45881',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '45882',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45883',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '45884',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45885',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45886',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45887',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45888',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45889',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '45890',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '45891',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45893',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45894',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45895',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45896',
    dma_code: '558',
    dma_description: 'LIMA',
  },
  {
    zip_code: '45897',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '45898',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45899',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '45999',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '46001',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46011',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46012',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46013',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46014',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46015',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46016',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46017',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46018',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46030',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46031',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46032',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46033',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46034',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46035',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46036',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46037',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46038',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46039',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46040',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46041',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46044',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46045',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46047',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46048',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46049',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46050',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46051',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46052',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46055',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46056',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46057',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46058',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46060',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46061',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46062',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46063',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46064',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46065',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46067',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46068',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46069',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46070',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46071',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46072',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46074',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46075',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46076',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46077',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46082',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46085',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46102',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46103',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46104',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46105',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46106',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46107',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46110',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46111',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46112',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46113',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46115',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46117',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46118',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46120',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46121',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46122',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46123',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46124',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46125',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46126',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46127',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46128',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46129',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46130',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46131',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46133',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46135',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46140',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46142',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46143',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46144',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46146',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46147',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46148',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46149',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46150',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46151',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46154',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46155',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46156',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46157',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46158',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46160',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46161',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46162',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46163',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46164',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46165',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46166',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46167',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46168',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46170',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46171',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46172',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46173',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46175',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46176',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46180',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46181',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46182',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46183',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46184',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46186',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46201',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46202',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46203',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46204',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46205',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46206',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46207',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46208',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46209',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46211',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46214',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46216',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46217',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46218',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46219',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46220',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46221',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46222',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46223',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46224',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46225',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46226',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46227',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46228',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46229',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46230',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46231',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46234',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46235',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46236',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46237',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46239',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46240',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46241',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46242',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46244',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46247',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46249',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46250',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46251',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46253',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46254',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46255',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46256',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46259',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46260',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46262',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46266',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46268',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46274',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46275',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46277',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46278',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46280',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46282',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46283',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46285',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46290',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46291',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46295',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46296',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46298',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46301',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46302',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46303',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46304',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46307',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46308',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46310',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46311',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46312',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46319',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46320',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46321',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46322',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46323',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46324',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46325',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46327',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46340',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46341',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46342',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46345',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46346',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46347',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46348',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46349',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46350',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46352',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46355',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46356',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46360',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46361',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46365',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46366',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46368',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46371',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46372',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46373',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46374',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46375',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46376',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46377',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46379',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46380',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46381',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46382',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46383',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46384',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46385',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46390',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46391',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46392',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46393',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46394',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46401',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46402',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46403',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46404',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46405',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46406',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46407',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46408',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46409',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46410',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46411',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '46501',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46502',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46504',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46506',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46507',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46508',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46510',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46511',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46513',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46514',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46515',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46516',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46517',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46524',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46526',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46527',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46528',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46530',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46531',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46532',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46534',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46536',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46537',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46538',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46539',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46540',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46542',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46543',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46544',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46545',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46546',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46550',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46552',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46553',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46554',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46555',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46556',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46561',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46562',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46563',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46565',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46567',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46570',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46571',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46572',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46573',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46574',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46580',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46581',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46582',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46590',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46595',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46601',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46604',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46613',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46614',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46615',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46616',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46617',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46619',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46620',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46624',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46626',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46628',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46634',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46635',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46637',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46660',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46680',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46699',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46701',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46702',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46703',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46704',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46705',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46706',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46710',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46711',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46713',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46714',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46721',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46723',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46725',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46730',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46731',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46732',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46733',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46737',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46738',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46740',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46741',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46742',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46743',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46745',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46746',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46747',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46748',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46750',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46755',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46759',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46760',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46761',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46763',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46764',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46765',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46766',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46767',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46769',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46770',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46771',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46772',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46773',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46774',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46776',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46777',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46778',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46779',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46780',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46781',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46782',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46783',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46784',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46785',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46786',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46787',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46788',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46789',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46791',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46792',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46793',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46794',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46795',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46796',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46797',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46798',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46799',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46801',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46802',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46803',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46804',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46805',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46806',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46807',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46808',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46809',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46814',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46815',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46816',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46818',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46819',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46825',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46835',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46845',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46850',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46851',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46852',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46853',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46854',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46855',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46856',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46857',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46858',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46859',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46860',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46861',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46862',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46863',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46864',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46865',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46866',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46867',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46868',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46869',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46885',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46895',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46896',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46897',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46898',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46899',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46901',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46902',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46903',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46904',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46910',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46911',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46912',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46913',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46914',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46915',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46916',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46917',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46919',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46920',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46921',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46922',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46923',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46926',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46928',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46929',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46930',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46931',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46932',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46933',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46935',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46936',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46937',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46938',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46939',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46940',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46941',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46942',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46943',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46945',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46946',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46947',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46950',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46951',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46952',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46953',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46957',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46958',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46959',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46960',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46961',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46962',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46965',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46967',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46968',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46970',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46971',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46974',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46975',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46977',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46978',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46979',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46980',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46982',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46984',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46985',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46986',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46987',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46988',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46989',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46990',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46991',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46992',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '46994',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46995',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '46996',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '46998',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47001',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47003',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47006',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47010',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47011',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47012',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47016',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47017',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47018',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47019',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47020',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47021',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47022',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47023',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47024',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47025',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47030',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47031',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47032',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47033',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47034',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47035',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47036',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47037',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47038',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47039',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47040',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47041',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47042',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47043',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47060',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47102',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47104',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47106',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47107',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47108',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47110',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47111',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47112',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47114',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47115',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47116',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47117',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47118',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47119',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47120',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47122',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47123',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47124',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47125',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47126',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47129',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47130',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47131',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47132',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47133',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47134',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47135',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47136',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47137',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47138',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47139',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47140',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47141',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47142',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47143',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47144',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47145',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47146',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47147',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47150',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47151',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47160',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47161',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47162',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47163',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47164',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47165',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47166',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47167',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47170',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47172',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47174',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47175',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47177',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47190',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47199',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47201',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47202',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47203',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47220',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47223',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47224',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47225',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47226',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47227',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47228',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47229',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47230',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47231',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47232',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47234',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47235',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47236',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47240',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47243',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47244',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47245',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47246',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47247',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47249',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47250',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47260',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47261',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47263',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47264',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47265',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47270',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47272',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47273',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47274',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47280',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47281',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47282',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47283',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47302',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47303',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47304',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47305',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47306',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47307',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47308',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47320',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47322',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47324',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '47325',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47326',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '47327',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '47330',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '47331',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47334',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47335',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '47336',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '47337',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47338',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47339',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '47340',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47341',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '47342',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47344',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47345',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '47346',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '47348',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47351',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47352',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47353',
    dma_code: '515',
    dma_description: 'CINCINNATI',
  },
  {
    zip_code: '47354',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47355',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47356',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47357',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '47358',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47359',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47360',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47361',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47362',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47366',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47367',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47368',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47369',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '47370',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '47371',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '47373',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '47374',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '47375',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '47380',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47381',
    dma_code: '509',
    dma_description: 'FT. WAYNE',
  },
  {
    zip_code: '47382',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47383',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47384',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47385',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47386',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47387',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47388',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47390',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47392',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '47393',
    dma_code: '542',
    dma_description: 'DAYTON',
  },
  {
    zip_code: '47394',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47396',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47401',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47402',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47403',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47404',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47405',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47406',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47407',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47408',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47420',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47421',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47424',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47426',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47427',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47429',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47430',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47431',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47432',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47433',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47434',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47435',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47436',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47437',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47438',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47439',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47441',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47443',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47445',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47446',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47448',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47449',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47451',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47452',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47453',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47454',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47455',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47456',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47457',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47458',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47459',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47460',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47462',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47463',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47464',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47465',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47467',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47468',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47469',
    dma_code: '529',
    dma_description: 'LOUISVILLE',
  },
  {
    zip_code: '47470',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47471',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47490',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47501',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47512',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47513',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47514',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47515',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47516',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47519',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47520',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47521',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47522',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47523',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47524',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47525',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47527',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47528',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47529',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47531',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47532',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47535',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47536',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47537',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47541',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47542',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47545',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47546',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47547',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47549',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47550',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47551',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47552',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47553',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47556',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47557',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47558',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47561',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47562',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47564',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47567',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47568',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47573',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47574',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47575',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47576',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47577',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47578',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47579',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47580',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47581',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47584',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47585',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47586',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47588',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47590',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47591',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47596',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47597',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47598',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47601',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47610',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47611',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47612',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47613',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47614',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47615',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47616',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47617',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47618',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47619',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47620',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47629',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47630',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47631',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47633',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47634',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47635',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47637',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47638',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47639',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47640',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47647',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47648',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47649',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47654',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47660',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47665',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47666',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47670',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47683',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47701',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47702',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47703',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47704',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47705',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47706',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47708',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47710',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47711',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47712',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47713',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47714',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47715',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47716',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47719',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47720',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47721',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47722',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47724',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47725',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47727',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47728',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47730',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47731',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47732',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47733',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47734',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47735',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47736',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47737',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47739',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47740',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47741',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47744',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47747',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47750',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '47801',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47802',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47803',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47804',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47805',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47807',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47808',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47809',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47811',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47812',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47813',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47814',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47830',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47831',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47832',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47833',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47834',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47836',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47837',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47838',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47840',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47841',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47842',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47845',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47846',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47847',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47848',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47849',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47850',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47851',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47852',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47853',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47854',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47855',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47856',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47857',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47858',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47859',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47860',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47861',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47862',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47863',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47864',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47865',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47866',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47868',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47869',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47870',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47871',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47872',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47874',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47875',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47876',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47878',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47879',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47880',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47881',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47882',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47884',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47885',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47901',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47902',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47903',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47904',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47905',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47906',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47907',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47909',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47916',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47917',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47918',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47920',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47921',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47922',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '47923',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47924',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47925',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47926',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47928',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47929',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47930',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47932',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47933',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47934',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47935',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47936',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47937',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47938',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47939',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47940',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47941',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47942',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47943',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '47944',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47946',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '47948',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '47949',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47950',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47951',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '47952',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47954',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47955',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47957',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '47958',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47959',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47960',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47962',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47963',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '47964',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '47965',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47966',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47967',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47968',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47969',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47970',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47971',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47974',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '47975',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47977',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '47978',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '47980',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47981',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47982',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47983',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47984',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47986',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47987',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47988',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47989',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47990',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47991',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47992',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47993',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47994',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47995',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '47996',
    dma_code: '582',
    dma_description: 'LAFAYETTE, IN',
  },
  {
    zip_code: '47997',
    dma_code: '527',
    dma_description: 'INDIANAPOLIS',
  },
  {
    zip_code: '48001',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48002',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48003',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48004',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48005',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48006',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48007',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48009',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48012',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48014',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48015',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48017',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48021',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48022',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48023',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48025',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48026',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48027',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48028',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48030',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48032',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48033',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48034',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48035',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48036',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48037',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48038',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48039',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48040',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48041',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48042',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48043',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48044',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48045',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48046',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48047',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48048',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48049',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48050',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48051',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48054',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48059',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48060',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48061',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48062',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48063',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48064',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48065',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48066',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48067',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48068',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48069',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48070',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48071',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48072',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48073',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48074',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48075',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48076',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48079',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48080',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48081',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48082',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48083',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48084',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48085',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48086',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48088',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48089',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48090',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48091',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48092',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48093',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48094',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48095',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48096',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48097',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48098',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48099',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48101',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48103',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48104',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48105',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48106',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48107',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48108',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48109',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48110',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48111',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48112',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48113',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48114',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48115',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48116',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48117',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48118',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48120',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48121',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48122',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48123',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48124',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48125',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48126',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48127',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48128',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48130',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48131',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48133',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48134',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48135',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48136',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48137',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48138',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48139',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48140',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48141',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48143',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48144',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48145',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48146',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48150',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48151',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48152',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48153',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48154',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48157',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48158',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48159',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48160',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48161',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48162',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48164',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48165',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48166',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48167',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48168',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48169',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48170',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48173',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48174',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48175',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48176',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48177',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48178',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48179',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48180',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48182',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48183',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48184',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48185',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48186',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48187',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48188',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48189',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48190',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48191',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48192',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48193',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48195',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48197',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48198',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48201',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48202',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48203',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48204',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48205',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48206',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48207',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48208',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48209',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48210',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48211',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48212',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48213',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48214',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48215',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48216',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48217',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48218',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48219',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48220',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48221',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48222',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48223',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48224',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48225',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48226',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48227',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48228',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48229',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48230',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48231',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48232',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48233',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48234',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48235',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48236',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48237',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48238',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48239',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48240',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48242',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48243',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48244',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48255',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48260',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48264',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48265',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48266',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48267',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48268',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48269',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48272',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48275',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48277',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48278',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48279',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48288',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48301',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48302',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48303',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48304',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48306',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48307',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48308',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48309',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48310',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48311',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48312',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48313',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48314',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48315',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48316',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48317',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48318',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48320',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48321',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48322',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48323',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48324',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48325',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48326',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48327',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48328',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48329',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48330',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48331',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48332',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48333',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48334',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48335',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48336',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48340',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48341',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48342',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48343',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48346',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48347',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48348',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48350',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48353',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48356',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48357',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48359',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48360',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48361',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48362',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48363',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48366',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48367',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48370',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48371',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48374',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48375',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48376',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48377',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48380',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48381',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48382',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48383',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48386',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48387',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48390',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48393',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48397',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48401',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48410',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48411',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48412',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48413',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48414',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48415',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48416',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48417',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48418',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48419',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48420',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48421',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48422',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48423',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48426',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48427',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48428',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48429',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48430',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48432',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48433',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48434',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48435',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48436',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48437',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48438',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48439',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48440',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48441',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48442',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48444',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48445',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48446',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48449',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48450',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48451',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48453',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48454',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48455',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48456',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48457',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48458',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48460',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48461',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48462',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48463',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48464',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48465',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48466',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48467',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48468',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48469',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48470',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48471',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48472',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48473',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48475',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48476',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48480',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48501',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48502',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48503',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48504',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48505',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48506',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48507',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48509',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48519',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48529',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48531',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48532',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48550',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48551',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48552',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48553',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48554',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48555',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48556',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48557',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48559',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48601',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48602',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48603',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48604',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48605',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48606',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48607',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48608',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48609',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48610',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48611',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48612',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48613',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48614',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48615',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48616',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48617',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48618',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48619',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48620',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48621',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48622',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48623',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48624',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48625',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48626',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48627',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48628',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48629',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48630',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48631',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48632',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48633',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48634',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48635',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48636',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48637',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48638',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48640',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48641',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48642',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48647',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48649',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48650',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48651',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48652',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48653',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48654',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48655',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48656',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '48657',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48658',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48659',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48661',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48662',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48663',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48667',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48670',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48674',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48686',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48701',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48703',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48705',
    dma_code: '583',
    dma_description: 'ALPENA',
  },
  {
    zip_code: '48706',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48707',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48708',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48710',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48720',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48721',
    dma_code: '583',
    dma_description: 'ALPENA',
  },
  {
    zip_code: '48722',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48723',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48724',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48725',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48726',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48727',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48728',
    dma_code: '583',
    dma_description: 'ALPENA',
  },
  {
    zip_code: '48729',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48730',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48731',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48732',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48733',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48734',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48735',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48736',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48737',
    dma_code: '583',
    dma_description: 'ALPENA',
  },
  {
    zip_code: '48738',
    dma_code: '583',
    dma_description: 'ALPENA',
  },
  {
    zip_code: '48739',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48740',
    dma_code: '583',
    dma_description: 'ALPENA',
  },
  {
    zip_code: '48741',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48742',
    dma_code: '583',
    dma_description: 'ALPENA',
  },
  {
    zip_code: '48743',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48744',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48745',
    dma_code: '583',
    dma_description: 'ALPENA',
  },
  {
    zip_code: '48746',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48747',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48748',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48749',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48750',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48754',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48755',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48756',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48757',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48758',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48759',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48760',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48761',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48762',
    dma_code: '583',
    dma_description: 'ALPENA',
  },
  {
    zip_code: '48763',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48764',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48765',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48766',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48767',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48768',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48769',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48770',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48787',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48801',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48802',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48804',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48805',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48806',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48807',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48808',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48809',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48811',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48812',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48813',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48815',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48816',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48817',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48818',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48819',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48820',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48821',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48822',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48823',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48824',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48825',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48826',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48827',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48829',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48830',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48831',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48832',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48833',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48834',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48835',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48836',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48837',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48838',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48840',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48841',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48842',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48843',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48844',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48845',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48846',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48847',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48848',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48849',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48850',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48851',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48852',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48853',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48854',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48855',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48856',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48857',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48858',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48859',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48860',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48861',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48862',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48863',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '48864',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48865',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48866',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48867',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48870',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48871',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48872',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48873',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48874',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48875',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48876',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48877',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48878',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48879',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48880',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48881',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48882',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48883',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48884',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48885',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48886',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48887',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48888',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48889',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48890',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48891',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48892',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48893',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48894',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48895',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48896',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '48897',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '48901',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48906',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48908',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48909',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48910',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48911',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48912',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48913',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48915',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48916',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48917',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48918',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48919',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48921',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48922',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48929',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48930',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48933',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48937',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48950',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48951',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48956',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '48980',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49001',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49002',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49003',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49004',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49005',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49006',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49007',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49008',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49009',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49010',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49011',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49012',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49013',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49014',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49015',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49016',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49017',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49018',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49019',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49020',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49021',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49022',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49023',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49024',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49026',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49027',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49028',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49029',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49030',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49031',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49032',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49033',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49034',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49035',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49036',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49037',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49038',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49039',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49040',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49041',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49042',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49043',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49045',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49046',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49047',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49048',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49050',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49051',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49052',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49053',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49055',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49056',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49057',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49058',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49060',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49061',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49062',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49063',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49064',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49065',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49066',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49067',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49068',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49069',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49070',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49071',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49072',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49073',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49074',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49075',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49076',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49077',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49078',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49079',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49080',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49081',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49082',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49083',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49084',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49085',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49087',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49088',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49089',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49090',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49091',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49092',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49093',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49094',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49095',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49096',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49097',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49098',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49099',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49101',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49102',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49103',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49104',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49106',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49107',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49111',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49112',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49113',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49115',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49116',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49117',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49119',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49120',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49121',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49125',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49126',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49127',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49128',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49129',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49130',
    dma_code: '588',
    dma_description: 'SOUTH BEND - ELKHART',
  },
  {
    zip_code: '49201',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49202',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49203',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49204',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49220',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49221',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49224',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49227',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49228',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49229',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49230',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49232',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49233',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49234',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49235',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49236',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49237',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49238',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49239',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49240',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49241',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49242',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49245',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49246',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49247',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49248',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49249',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49250',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49251',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49252',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49253',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49254',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49255',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49256',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49257',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49258',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49259',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49261',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49262',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49263',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49264',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49265',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49266',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49267',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '49268',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49269',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49270',
    dma_code: '505',
    dma_description: 'DETROIT',
  },
  {
    zip_code: '49271',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49272',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49274',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49276',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49277',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49279',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49281',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49282',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49283',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49284',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49285',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49286',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49287',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49288',
    dma_code: '551',
    dma_description: 'LANSING',
  },
  {
    zip_code: '49289',
    dma_code: '547',
    dma_description: 'TOLEDO',
  },
  {
    zip_code: '49301',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49302',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49303',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49304',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49305',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49306',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49307',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49309',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49310',
    dma_code: '513',
    dma_description: 'FLINT - SAGINAW - BAY CITY',
  },
  {
    zip_code: '49311',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49312',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49314',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49315',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49316',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49317',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49318',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49319',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49320',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49321',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49322',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49323',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49325',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49326',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49327',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49328',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49329',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49330',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49331',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49332',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49333',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49335',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49336',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49337',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49338',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49339',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49340',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49341',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49342',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49343',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49344',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49345',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49346',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49347',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49348',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49349',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49351',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49355',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49356',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49357',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49401',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49402',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49403',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49404',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49405',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49406',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49408',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49409',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49410',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49411',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49412',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49413',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49415',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49416',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49417',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49418',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49419',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49420',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49421',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49422',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49423',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49424',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49425',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49426',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49427',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49428',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49429',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49430',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49431',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49434',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49435',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49436',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49437',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49440',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49441',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49442',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49443',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49444',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49445',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49446',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49448',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49449',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49450',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49451',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49452',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49453',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49454',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49455',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49456',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49457',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49458',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49459',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49460',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49461',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49463',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49464',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49468',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49501',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49502',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49503',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49504',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49505',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49506',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49507',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49508',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49509',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49510',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49512',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49514',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49515',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49516',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49518',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49519',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49523',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49525',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49528',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49530',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49534',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49544',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49546',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49548',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49550',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49555',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49560',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49588',
    dma_code: '563',
    dma_description: 'GRAND RAPIDS - KALMZOO - B. CRK',
  },
  {
    zip_code: '49601',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49610',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49611',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49612',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49613',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49614',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49615',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49616',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49617',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49618',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49619',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49620',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49621',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49622',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49623',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49625',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49626',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49627',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49628',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49629',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49630',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49631',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49632',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49633',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49634',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49635',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49636',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49637',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49638',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49639',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49640',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49642',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49643',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49644',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49645',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49646',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49648',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49649',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49650',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49651',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49653',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49654',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49655',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49656',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49657',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49659',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49660',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49663',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49664',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49665',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49666',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49667',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49668',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49670',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49673',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49674',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49675',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49676',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49677',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49679',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49680',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49682',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49683',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49684',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49685',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49686',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49688',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49689',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49690',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49696',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49701',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49705',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49706',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49707',
    dma_code: '583',
    dma_description: 'ALPENA',
  },
  {
    zip_code: '49709',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49710',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49711',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49712',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49713',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49715',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49716',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49717',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49718',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49719',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49720',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49721',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49722',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49723',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49724',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49725',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49726',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49727',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49728',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49729',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49730',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49733',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49734',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49735',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49736',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49737',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49738',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49739',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49740',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49743',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49744',
    dma_code: '583',
    dma_description: 'ALPENA',
  },
  {
    zip_code: '49745',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49746',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49747',
    dma_code: '583',
    dma_description: 'ALPENA',
  },
  {
    zip_code: '49748',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49749',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49751',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49752',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49753',
    dma_code: '583',
    dma_description: 'ALPENA',
  },
  {
    zip_code: '49755',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49756',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49757',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49759',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49760',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49761',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49762',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49764',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49765',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49766',
    dma_code: '583',
    dma_description: 'ALPENA',
  },
  {
    zip_code: '49768',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49769',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49770',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49774',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49775',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49776',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49777',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49779',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49780',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49781',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49782',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49783',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49784',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49785',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49786',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49788',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49790',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49791',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49792',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49793',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49795',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49796',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49797',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49799',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49801',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49802',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49805',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49806',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49807',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49808',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49812',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '49814',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49815',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49816',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49817',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49818',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49819',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49820',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49821',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '49822',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49825',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49826',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49827',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49829',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49831',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49833',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49834',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49835',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49836',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49837',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49838',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49839',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49840',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49841',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49845',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '49847',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '49848',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '49849',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49852',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49853',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49854',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49855',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49858',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '49861',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49862',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49863',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '49864',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49865',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49866',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49868',
    dma_code: '540',
    dma_description: 'TRAVERSE CITY - CADILLAC',
  },
  {
    zip_code: '49870',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49871',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49872',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49873',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '49874',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '49876',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49877',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49878',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49879',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49880',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49881',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49883',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49884',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49885',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49886',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '49887',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '49891',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49892',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49893',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '49894',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49895',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49896',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '49901',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49902',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49903',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49905',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49908',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49910',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49911',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '49912',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49913',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49915',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49916',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49917',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49918',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49919',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49920',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49921',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49922',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49925',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49927',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49929',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49930',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49931',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49934',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49935',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49938',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '49942',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49945',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49946',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49947',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '49948',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49950',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49952',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49953',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49955',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49958',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49959',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '49960',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49961',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49962',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49963',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49964',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49965',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49967',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49968',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '49969',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '49970',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '49971',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '50001',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50002',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50003',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50005',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50006',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50007',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50008',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50009',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50010',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50011',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50012',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50013',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50014',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50020',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '50021',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50022',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '50023',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50025',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50026',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50027',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50028',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50029',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50031',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50032',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50033',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50034',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50035',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50036',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50037',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50038',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50039',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50040',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50041',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50042',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50043',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50044',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50046',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50047',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50048',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50049',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50050',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50051',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50052',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50054',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50055',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50056',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50057',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50058',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50059',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50060',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50061',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50062',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50063',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50064',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50065',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50066',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50067',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50068',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50069',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50070',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50071',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50072',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50073',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50074',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50075',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50076',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50078',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50101',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50102',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50103',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50104',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50105',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50106',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50107',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50108',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50109',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50110',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50111',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50112',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50115',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50116',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50117',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50118',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50119',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50120',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50122',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50123',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50124',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50125',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50126',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50127',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50128',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50129',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50130',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50131',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50132',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50133',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50134',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50135',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50136',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50137',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50138',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50139',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50140',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50141',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50142',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50143',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50144',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50145',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50146',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50147',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50148',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50149',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50150',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50151',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50152',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50153',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50154',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50155',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50156',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50157',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50158',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50160',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50161',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50162',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50163',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50164',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50165',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50166',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50167',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50168',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50169',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50170',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50171',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50173',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50174',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50201',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50206',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50207',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50208',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50210',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50211',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50212',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50213',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50214',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50216',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50217',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50218',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50219',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50220',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50222',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50223',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50225',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50226',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50227',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50228',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50229',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50230',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50231',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50232',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50233',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50234',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50235',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50236',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50237',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50238',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50239',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50240',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50241',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50242',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50243',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50244',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50246',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50247',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50248',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50249',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50250',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50251',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50252',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50254',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50255',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50256',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50257',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50258',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50259',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50261',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50262',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50263',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50264',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50265',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50266',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50268',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50269',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50271',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50272',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50273',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50274',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '50275',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50276',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50277',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50278',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50301',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50302',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50303',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50304',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50305',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50306',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50307',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50309',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50310',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50311',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50312',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50313',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50314',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50315',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50316',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50317',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50318',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50319',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50320',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50321',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50322',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50323',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50324',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50325',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50327',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50328',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50329',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50330',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50331',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50332',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50333',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50334',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50335',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50336',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50339',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50340',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50347',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50350',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50360',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50361',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50362',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50363',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50367',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50368',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50369',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50381',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50391',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50392',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50393',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50394',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50398',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50401',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50402',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50420',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50421',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50423',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50424',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50426',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50427',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50428',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50430',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50431',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50432',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50433',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50434',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50435',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50436',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50438',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50439',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50440',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50441',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50444',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50446',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50447',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50448',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50449',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50450',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50451',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50452',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50453',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50454',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50455',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50456',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50457',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50458',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50459',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50460',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50461',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50464',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50465',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50466',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50467',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50468',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50469',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50470',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50471',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50472',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50473',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50475',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50476',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50477',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50478',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50479',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50480',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50481',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50482',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50483',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50484',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50501',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50510',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50511',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50514',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50515',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50516',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50517',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50518',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50519',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50520',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50521',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50522',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50523',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50524',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50525',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50526',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50527',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50528',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50529',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50530',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50531',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50532',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50533',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50535',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50536',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50538',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50539',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50540',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50541',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50542',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50543',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50544',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50545',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50546',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50548',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50551',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50552',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50554',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50556',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50557',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50558',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50559',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50560',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50561',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50562',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50563',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50565',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50566',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50567',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50568',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50569',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50570',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50571',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50573',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50574',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50575',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50576',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50577',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50578',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50579',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50581',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50582',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50583',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50585',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50586',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50588',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50590',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50591',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50592',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50593',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50594',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50595',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50597',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '50598',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50599',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50601',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50602',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50603',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50604',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50605',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50606',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50607',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50608',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50609',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50611',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50612',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50613',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50614',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50616',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50619',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50620',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50621',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50622',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50623',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50624',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50625',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50626',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50627',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50628',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50629',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50630',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50631',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50632',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50633',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50634',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50635',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50636',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50638',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50641',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50642',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50643',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50644',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50645',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50647',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50648',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50649',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50650',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50651',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50652',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50653',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '50654',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50655',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50657',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50658',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50659',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50660',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50661',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50662',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50664',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50665',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50666',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50667',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50668',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50669',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50670',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50671',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50672',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50673',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50674',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50675',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50676',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50677',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50680',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50681',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50682',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50701',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50702',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50703',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50704',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50706',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50707',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '50801',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50830',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50831',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50833',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50835',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50836',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50837',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50839',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50840',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50841',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50842',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50843',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '50845',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50846',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50847',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '50848',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50849',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50851',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50853',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '50854',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50857',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50858',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50859',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50860',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50861',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50862',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50863',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50864',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '50936',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50947',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50950',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '50981',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51001',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51002',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51003',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51004',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51005',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51006',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51007',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51008',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51009',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51010',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51011',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51012',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51014',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51015',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51016',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51018',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51019',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51020',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51022',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51023',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51024',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51025',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51026',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51027',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51028',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51029',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51030',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51031',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51033',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51034',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51035',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51036',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51037',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51038',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51039',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51040',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51041',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51044',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51045',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51046',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51047',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51048',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51049',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51050',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51051',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51052',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51053',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51054',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51055',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51056',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51058',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51060',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51061',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51062',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51063',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51101',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51102',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51103',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51104',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51105',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51106',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51108',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51109',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51111',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51201',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51230',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '51231',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51232',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '51234',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51235',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '51237',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '51238',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51239',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51240',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '51241',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '51242',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '51243',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '51244',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51245',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51246',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '51247',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51248',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51249',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '51250',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51301',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51331',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51333',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51334',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51338',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51340',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51341',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51342',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51343',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51344',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51345',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '51346',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51347',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51350',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '51351',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51354',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '51355',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51357',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51358',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51360',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51363',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51364',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51365',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51366',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51401',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51430',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51431',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51432',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51433',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51436',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51439',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51440',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51441',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51442',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51443',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51444',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51445',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51446',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51447',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51448',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51449',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51450',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51451',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51452',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51453',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51454',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51455',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51458',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51459',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51460',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51461',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51462',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51463',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51465',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51466',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51467',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51501',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51502',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51503',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51510',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51520',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51521',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51523',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51525',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51526',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51527',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51528',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51529',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51530',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51531',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51532',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51533',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51534',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51535',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51536',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51537',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51540',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51541',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51542',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51543',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51544',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51545',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51546',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51548',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51549',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51550',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51551',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51552',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51553',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51554',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51555',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51556',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51557',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51558',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51559',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51560',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51561',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51562',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51563',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51564',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51565',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51566',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51570',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51571',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51572',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '51573',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51575',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51576',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51577',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51578',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51579',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51591',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51593',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51601',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51602',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51603',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51630',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51631',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51632',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51636',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51637',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51638',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51639',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51640',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51645',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51646',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '51647',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51648',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51649',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51650',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51651',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51652',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51653',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51654',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '51656',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '52001',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52002',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52003',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52004',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52030',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52031',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52032',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52033',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52035',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52036',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52037',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52038',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52039',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52040',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52041',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52042',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52043',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52044',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52045',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52046',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52047',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52048',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52049',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52050',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52052',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52053',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52054',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52056',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52057',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52060',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52064',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52065',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52066',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52068',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52069',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52070',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52071',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52072',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52073',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52074',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52075',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52076',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52077',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52078',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52079',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52101',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52132',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52133',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52134',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '52135',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52136',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '52140',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52141',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52142',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52144',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52146',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52147',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52149',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52151',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52154',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52155',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '52156',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52157',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52158',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52159',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52160',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52161',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52162',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52163',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '52164',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52165',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52166',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52168',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52169',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52170',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52171',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52172',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52175',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52201',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52202',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52203',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52204',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52205',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52206',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52207',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52208',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52209',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52210',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52211',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52212',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52213',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52214',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52215',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52216',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52217',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52218',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52219',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52220',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52221',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52222',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52223',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52224',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52225',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52227',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52228',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52229',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52231',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52232',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52233',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52235',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52236',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52237',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52240',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52241',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52242',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52243',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52244',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52245',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52246',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52247',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52248',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52249',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52251',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52252',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52253',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52254',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52255',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52257',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52301',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52302',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52305',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52306',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52307',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52308',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52309',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52310',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52312',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52313',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52314',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52315',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52316',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52317',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52318',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52319',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52320',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52321',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52322',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52323',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52324',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52325',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52326',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52327',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52328',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52329',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52330',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52332',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52333',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52334',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52335',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52336',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52337',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52338',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52339',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52340',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52341',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52342',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52344',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52345',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52346',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52347',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52348',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52349',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52350',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52351',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52352',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52353',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52354',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52355',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52356',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52358',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52359',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52361',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52362',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52401',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52402',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52403',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52404',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52405',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52406',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52407',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52408',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52409',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52410',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52411',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52498',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52499',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52501',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52530',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52531',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52533',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52534',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52535',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52536',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52537',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52540',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52542',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52543',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52544',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52548',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52549',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52550',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52551',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52552',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52553',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52554',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52555',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52556',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52557',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52560',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52561',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52562',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52563',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52565',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52566',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52567',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52568',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52569',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52570',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52571',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52572',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52573',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52574',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52576',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52577',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52580',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52581',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52583',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52584',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52585',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52586',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52588',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52590',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52591',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52593',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52594',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52595',
    dma_code: '679',
    dma_description: 'DES MOINES - AMES',
  },
  {
    zip_code: '52601',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52619',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '52620',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52621',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52623',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52624',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '52625',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '52626',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52627',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '52630',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52631',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '52632',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '52635',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52637',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52638',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52639',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '52640',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52641',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52642',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52644',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52645',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52646',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52647',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52648',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '52649',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52650',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52651',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '52652',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52653',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52654',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52655',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52656',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '52657',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '52658',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '52659',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52660',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52701',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52720',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52721',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52722',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52726',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52727',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52728',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52729',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52730',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52731',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52732',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52733',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52734',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52736',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52737',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52738',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52739',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52742',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52745',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52746',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52747',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52748',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52749',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52750',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52751',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52752',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52753',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52754',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52755',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52756',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52757',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52758',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52759',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52760',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52761',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52765',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52766',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52767',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52768',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52769',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52771',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52772',
    dma_code: '637',
    dma_description: 'CEDAR RAPIDS - WTRLO - IWC&DUB',
  },
  {
    zip_code: '52773',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52774',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52776',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52777',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52778',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52801',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52802',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52803',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52804',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52805',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52806',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52807',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52808',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '52809',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '53001',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53002',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53003',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53004',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53005',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53006',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53007',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53008',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53010',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53011',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53012',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53013',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53014',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53015',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53016',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53017',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53018',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53019',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53020',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53021',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53022',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53023',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53024',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53026',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53027',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53029',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53031',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53032',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53033',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53034',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53035',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53036',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53037',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53038',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53039',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53040',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53042',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53044',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53045',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53046',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53047',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53048',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53049',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53050',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53051',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53052',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53056',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53057',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53058',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53059',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53060',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53061',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53062',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53063',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53064',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53065',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53066',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53069',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53070',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53072',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53073',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53074',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53075',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53076',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53078',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53079',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53080',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53081',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53082',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53083',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53085',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53086',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53088',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53089',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53090',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53091',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53092',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53093',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53094',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53095',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53097',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53098',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53099',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53101',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53102',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53103',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53104',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53105',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53108',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53109',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53110',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53114',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53115',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53118',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53119',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53120',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53121',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53122',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53125',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53126',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53127',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53128',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53129',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53130',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53132',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53137',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53138',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53139',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53140',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53141',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53142',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53143',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53144',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53146',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53147',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53148',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53149',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53150',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53151',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53152',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53153',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53154',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53156',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53157',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53158',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53159',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53167',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53168',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53170',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53171',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53172',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53176',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53177',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53178',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53179',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53181',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53182',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53183',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53184',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53185',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53186',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53187',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53188',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53189',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53190',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53191',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53192',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53194',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53195',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53201',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53202',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53203',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53204',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53205',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53206',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53207',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53208',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53209',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53210',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53211',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53212',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53213',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53214',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53215',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53216',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53217',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53218',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53219',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53220',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53221',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53222',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53223',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53224',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53225',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53226',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53227',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53228',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53233',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53234',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53235',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53237',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53259',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53263',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53267',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53268',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53274',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53278',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53288',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53290',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53293',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53295',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53401',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53402',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53403',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53404',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53405',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53406',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53407',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53408',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53490',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53501',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53502',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53503',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53504',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53505',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53506',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53507',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53508',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53510',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53511',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53512',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53515',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53516',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53517',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53518',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53520',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53521',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53522',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53523',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53525',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53526',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53527',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53528',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53529',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53530',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53531',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53532',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53533',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53534',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53535',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53536',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53537',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53538',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53540',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53541',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53542',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53543',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53544',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53545',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53546',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53547',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53548',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53549',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53550',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53551',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53553',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53554',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53555',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53556',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53557',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53558',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53559',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53560',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53561',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53562',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53563',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53565',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53566',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53569',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53570',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53571',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53572',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53573',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53574',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53575',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53576',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53577',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53578',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53579',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53580',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53581',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53582',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53583',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53584',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53585',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53586',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53587',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53588',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53589',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53590',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53593',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53594',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53595',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53596',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53597',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53598',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53599',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53701',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53702',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53703',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53704',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53705',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53706',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53707',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53708',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53711',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53713',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53714',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53715',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53716',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53717',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53718',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53719',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53725',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53726',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53744',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53774',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53777',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53778',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53779',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53782',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53783',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53784',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53785',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53786',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53788',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53789',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53790',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53791',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53792',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53793',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53794',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53801',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53802',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53803',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53804',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53805',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53806',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53807',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53808',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53809',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53810',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53811',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53812',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53813',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53816',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53817',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53818',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53820',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53821',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '53824',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53825',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53826',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '53827',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53901',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53910',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '53911',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53913',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53916',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53919',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53920',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53922',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53923',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53924',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53925',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53926',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53927',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '53928',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53929',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53930',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53931',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53932',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53933',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53934',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '53935',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53936',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '53937',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53939',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53940',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53941',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53942',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53943',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53944',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53946',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53947',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '53948',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53949',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53950',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53951',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53952',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53953',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53954',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53955',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53956',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53957',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53958',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53959',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53960',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53961',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53962',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53963',
    dma_code: '617',
    dma_description: 'MILWAUKEE',
  },
  {
    zip_code: '53964',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53965',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53968',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '53969',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '54001',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54002',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54003',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54004',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54005',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54006',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54007',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54009',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54010',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54011',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54013',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54014',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54015',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54016',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54017',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54020',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54021',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54022',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54023',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54024',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54025',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54026',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54027',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54028',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54082',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54101',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54102',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54103',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54104',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54106',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54107',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54110',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54111',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54112',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54113',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54114',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54115',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54119',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54120',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '54121',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '54123',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54124',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54125',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54126',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54127',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54128',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54129',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54130',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54131',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54135',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54136',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54137',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54138',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54139',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54140',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54141',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54143',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54149',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54150',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54151',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54152',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54153',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54154',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54155',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54156',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54157',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54159',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54160',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54161',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54162',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54165',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54166',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54169',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54170',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54171',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54173',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54174',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54175',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54177',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54180',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54182',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54201',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54202',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54204',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54205',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54207',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54208',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54209',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54210',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54211',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54212',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54213',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54214',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54215',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54216',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54217',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54220',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54221',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54226',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54227',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54228',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54229',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54230',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54232',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54234',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54235',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54240',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54241',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54245',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54246',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54247',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54301',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54302',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54303',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54304',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54305',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54306',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54307',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54308',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54311',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54313',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54324',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54344',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54401',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54402',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54403',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54404',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54405',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54406',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54407',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54408',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54409',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54410',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54411',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54412',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54413',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54414',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54415',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54416',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54417',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54418',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54420',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54421',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54422',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54423',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54424',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54425',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54426',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54427',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54428',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54429',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54430',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54432',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54433',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54434',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54435',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54436',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54437',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54439',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54440',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54441',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54442',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54443',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54446',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54447',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54448',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54449',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54450',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54451',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54452',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54454',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54455',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54456',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54457',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54458',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54459',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54460',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54462',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54463',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54464',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54465',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54466',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54467',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54469',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54470',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54471',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54472',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54473',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54474',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54475',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54476',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54479',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54480',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54481',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54482',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54484',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54485',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54486',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54487',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54488',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54489',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54490',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54491',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54492',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54493',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54494',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54495',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54498',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54499',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54501',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54511',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54512',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54513',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54514',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54515',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54517',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54519',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54520',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54521',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54524',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54525',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54526',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54527',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54529',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54530',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54531',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54532',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54534',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54536',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54537',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54538',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54539',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54540',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54541',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54542',
    dma_code: '553',
    dma_description: 'MARQUETTE',
  },
  {
    zip_code: '54543',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54545',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54546',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54547',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54548',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54550',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54552',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54554',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54555',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54556',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54557',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54558',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54559',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54560',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54561',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54562',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54563',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54564',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54565',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54566',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54568',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54601',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54602',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54603',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54610',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54611',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54612',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54613',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54614',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54615',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54616',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54618',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '54619',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54620',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54621',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54622',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54623',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54624',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54625',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54626',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54627',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54628',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54629',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54630',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54631',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54632',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54634',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54635',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54636',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54637',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '54638',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54639',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54640',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54641',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '54642',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54643',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54644',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54645',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54646',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '54648',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54649',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54650',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54651',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54652',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54653',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54654',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54655',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54656',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54657',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54658',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54659',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54660',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54661',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54662',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54664',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '54665',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54666',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54667',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54669',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54670',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54701',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54702',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54703',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54720',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54721',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54722',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54723',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54724',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54725',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54726',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54727',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54728',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54729',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54730',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54731',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54732',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54733',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54734',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54735',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54736',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54737',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54738',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54739',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54740',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54741',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54742',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54743',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54745',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54746',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54747',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54748',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54749',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54750',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54751',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54754',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54755',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54756',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54757',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54758',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54759',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54760',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54761',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54762',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54763',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54764',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54765',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54766',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54767',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54768',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54769',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54770',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54771',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54772',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54773',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54774',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54801',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54805',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54806',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54810',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54812',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54813',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54814',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54816',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54817',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54818',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54819',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54820',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54821',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54822',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54824',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54826',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54827',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54828',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54829',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54830',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54832',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54834',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54835',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54836',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54837',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54838',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54839',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54840',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54841',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54842',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54843',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54844',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54845',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54846',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54847',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54848',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54849',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54850',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54853',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54854',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54855',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54856',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54857',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54858',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54859',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54861',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54862',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54864',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54865',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54867',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54868',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54870',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54871',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54872',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54873',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54874',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54875',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54876',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54880',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54888',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54889',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54890',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54891',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54893',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '54895',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '54896',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '54901',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54902',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54903',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54904',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54906',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54909',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54911',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54912',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54913',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54914',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54915',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54919',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54921',
    dma_code: '705',
    dma_description: 'WAUSAU - RHINELANDER',
  },
  {
    zip_code: '54922',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54923',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54926',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54927',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54928',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54929',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54930',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54931',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54932',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54933',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54934',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54935',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54936',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54937',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54940',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54941',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54942',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54943',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54944',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54945',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54946',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54947',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54948',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54949',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54950',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54952',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54956',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54957',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54960',
    dma_code: '669',
    dma_description: 'MADISON',
  },
  {
    zip_code: '54961',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54962',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54963',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54964',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54965',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54966',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54967',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54968',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54969',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54970',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54971',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54974',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54976',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54977',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54978',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54979',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54980',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54981',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54982',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54983',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54984',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54985',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54986',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '54990',
    dma_code: '658',
    dma_description: 'GREEN BAY - APPLETON',
  },
  {
    zip_code: '55001',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55002',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55003',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55005',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55006',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55007',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55008',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55009',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55010',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55011',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55012',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55013',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55014',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55016',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55017',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55018',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55019',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55020',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55021',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55024',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55025',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55026',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55027',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55029',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55030',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55031',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55032',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55033',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55036',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55037',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55038',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55040',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55041',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55042',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55043',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55044',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55045',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55046',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55047',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55049',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55051',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55052',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55053',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55054',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55055',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55056',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55057',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55060',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55063',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55065',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55066',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55067',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55068',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55069',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55070',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55071',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55072',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55073',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55074',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55075',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55076',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55077',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55078',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55079',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55080',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55082',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55083',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55084',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55085',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55087',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55088',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55089',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55090',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55092',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55101',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55102',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55103',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55104',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55105',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55106',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55107',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55108',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55109',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55110',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55111',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55112',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55113',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55114',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55115',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55116',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55117',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55118',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55119',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55120',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55121',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55122',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55123',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55124',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55125',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55126',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55127',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55128',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55129',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55130',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55133',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55144',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55145',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55146',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55150',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55155',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55161',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55164',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55165',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55168',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55169',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55170',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55171',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55175',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55177',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55187',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55191',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55301',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55302',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55303',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55304',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55305',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55306',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55307',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55308',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55309',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55310',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55311',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55312',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55313',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55314',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55315',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55316',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55317',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55318',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55319',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55320',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55321',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55322',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55323',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55324',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55325',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55327',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55328',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55329',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55330',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55331',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55332',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55333',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55334',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55335',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55336',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55337',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55338',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55339',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55340',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55341',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55342',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55343',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55344',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55345',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55346',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55347',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55348',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55349',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55350',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55352',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55353',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55354',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55355',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55356',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55357',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55358',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55359',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55360',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55361',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55362',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55363',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55364',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55366',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55367',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55368',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55369',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55370',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55371',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55372',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55373',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55374',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55375',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55376',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55377',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55378',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55379',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55380',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55381',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55382',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55383',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55384',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55385',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55386',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55387',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55388',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55389',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55390',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55391',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55392',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55394',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55395',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55396',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55397',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55398',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55401',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55402',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55403',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55404',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55405',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55406',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55407',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55408',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55409',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55410',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55411',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55412',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55413',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55414',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55415',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55416',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55417',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55418',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55419',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55420',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55421',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55422',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55423',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55424',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55425',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55426',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55427',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55428',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55429',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55430',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55431',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55432',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55433',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55434',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55435',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55436',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55437',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55438',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55439',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55440',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55441',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55442',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55443',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55444',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55445',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55446',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55447',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55448',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55449',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55450',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55454',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55455',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55458',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55459',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55460',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55467',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55468',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55472',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55474',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55478',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55479',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55480',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55483',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55484',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55485',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55486',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55487',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55488',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55553',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55555',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55560',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55564',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55601',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55602',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55603',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55604',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55605',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55606',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55607',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55609',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55612',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55613',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55614',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55615',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55616',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55701',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55702',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55703',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55704',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55705',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55706',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55707',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55708',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55709',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55710',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55711',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55712',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55713',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55716',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55717',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55718',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55719',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55720',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55721',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55722',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55723',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55724',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55725',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55726',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55730',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55731',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55732',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55733',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55734',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55735',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55736',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55738',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55741',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55742',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55744',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55745',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55746',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55747',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55748',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55749',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55750',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55751',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55752',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55753',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55756',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55757',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55758',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55760',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55763',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55764',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55765',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55766',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55767',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55768',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55769',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55771',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55772',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55775',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55777',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55779',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55780',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55781',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55782',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55783',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55784',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55785',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55786',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55787',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55790',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55791',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55792',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55793',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55795',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55796',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55797',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55798',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55801',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55802',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55803',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55804',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55805',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55806',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55807',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55808',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55810',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55811',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55812',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55814',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55815',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55816',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '55901',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55902',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55903',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55904',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55905',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55906',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55909',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55910',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55912',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55917',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55918',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55919',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55920',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55921',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55922',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55923',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55924',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55925',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55926',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55927',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55929',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55931',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55932',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55933',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55934',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55935',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55936',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55939',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55940',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55941',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55942',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55943',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55944',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55945',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55946',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55947',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55949',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55950',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55951',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55952',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55953',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55954',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55955',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55956',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55957',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55959',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55960',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55961',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55962',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55963',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55964',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55965',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55967',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55968',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55969',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55970',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55971',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55972',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55973',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55974',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55975',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55976',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55977',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55979',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55981',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55982',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55983',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55985',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55987',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55988',
    dma_code: '702',
    dma_description: 'LA CROSSE - EAU CLAIRE',
  },
  {
    zip_code: '55990',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '55991',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '55992',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56001',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56002',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56003',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56007',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '56009',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '56010',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56011',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56013',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56014',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56016',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '56017',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56019',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56020',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '56021',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56022',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56023',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56024',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56025',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56026',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56027',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56028',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56029',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '56030',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56031',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56032',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '56033',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56034',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56035',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '56036',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '56037',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56039',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56041',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56042',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '56043',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '56044',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56045',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '56046',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56047',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56048',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56050',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56051',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56052',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56054',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56055',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56056',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56057',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56058',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56060',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56062',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56063',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56065',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56068',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56069',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56071',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56072',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56073',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56074',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56075',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56078',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56080',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56081',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56082',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56083',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56084',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56085',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56087',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56088',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56089',
    dma_code: '611',
    dma_description: 'ROCHESTR - MASON CITY - AUSTIN',
  },
  {
    zip_code: '56090',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56091',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56093',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56096',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56097',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56098',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56101',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56110',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56111',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56113',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56114',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56115',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56116',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56117',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56118',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56119',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56120',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56121',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56122',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56123',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56125',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56127',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56128',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56129',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56131',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56132',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56134',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56136',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56137',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56138',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56139',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56140',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56141',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56142',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56143',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56144',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56145',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56146',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56147',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56149',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56150',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56151',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56152',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56153',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56155',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56156',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56157',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56158',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56159',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56160',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56161',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56162',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56164',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56165',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56166',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56167',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56168',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56169',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56170',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56171',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56172',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56173',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56174',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56175',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56176',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56177',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56178',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56180',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56181',
    dma_code: '737',
    dma_description: 'MANKATO',
  },
  {
    zip_code: '56183',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56185',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56186',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56187',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '56201',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56207',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56208',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56209',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56210',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56211',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56212',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56214',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56215',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56216',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56218',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56219',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56220',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56221',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56222',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56223',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56224',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56225',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56226',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56227',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56228',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56229',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56230',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56231',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56232',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56235',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56236',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56237',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56239',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56240',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56241',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56243',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56244',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56245',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56248',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56249',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56251',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56252',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56253',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56255',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56256',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56257',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56258',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56260',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56262',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56263',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56264',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56265',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56266',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56267',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56270',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56271',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56273',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56274',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56276',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56277',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56278',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56279',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56280',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56281',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56282',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56283',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56284',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56285',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56287',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56288',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56289',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56291',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56292',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56293',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56294',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56295',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56296',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56297',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56301',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56302',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56303',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56304',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56307',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56308',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56309',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56310',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56311',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56312',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56313',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56314',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56315',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56316',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56317',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56318',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56319',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56320',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56321',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56323',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56324',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56325',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56326',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56327',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56328',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56329',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56330',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56331',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56332',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56333',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56334',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56335',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56336',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56338',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56339',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56340',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56341',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56342',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56343',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56344',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56345',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56347',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56349',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56350',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56352',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56353',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56354',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56355',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56356',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56357',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56358',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56359',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56360',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56361',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56362',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56363',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56364',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56367',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56368',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56369',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56371',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56372',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56373',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56374',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56375',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56376',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56377',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56378',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56379',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56381',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56382',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56384',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56385',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56386',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56387',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56389',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56393',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56395',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56396',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56397',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56398',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56399',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56401',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56425',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56430',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56431',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56433',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56434',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56435',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56436',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56437',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56438',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56440',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56441',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56442',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56443',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56444',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56446',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56447',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56448',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56449',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56450',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56452',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56453',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56455',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56456',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56458',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56459',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56461',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56464',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56465',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56466',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56467',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56468',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56469',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56470',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56472',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56473',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56474',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56475',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56477',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56478',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56479',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56481',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56482',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56484',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56501',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56502',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56510',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56511',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56514',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56515',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56516',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56517',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56518',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56519',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56520',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56521',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56522',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56523',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56524',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56525',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56527',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56528',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56529',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56531',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56533',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56534',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56535',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56536',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56537',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56538',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56540',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56541',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56542',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56543',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56544',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56545',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56546',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56547',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56548',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56549',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56550',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56551',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56552',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56553',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56554',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56556',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56557',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56560',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56561',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56562',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56563',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56565',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56566',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56567',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56568',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56569',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56570',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56571',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56572',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56573',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56574',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56575',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56576',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56577',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56578',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56579',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56580',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56581',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56583',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56584',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56585',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56586',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56587',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56588',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56589',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56590',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56591',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56592',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56593',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56594',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56601',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56619',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56621',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56623',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56626',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56627',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56628',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56629',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56630',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56631',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56633',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56634',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56636',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56637',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56639',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56641',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56644',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56646',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56647',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56649',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56650',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56651',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56652',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56653',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56654',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56655',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56657',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56658',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56659',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56660',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56661',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56662',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56663',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56666',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56667',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56668',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56669',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56670',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56671',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56672',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56673',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56676',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56678',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56679',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56680',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56681',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56682',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56683',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56684',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56685',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56686',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56687',
    dma_code: '613',
    dma_description: 'MINNEAPOLIS - ST. PAUL',
  },
  {
    zip_code: '56688',
    dma_code: '676',
    dma_description: 'DULUTH - SUPERIOR',
  },
  {
    zip_code: '56701',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56710',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56711',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56713',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56714',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56715',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56716',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56720',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56721',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56722',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56723',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56724',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56725',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56726',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56727',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56728',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56729',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56731',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56732',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56733',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56734',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56735',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56736',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56737',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56738',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56740',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56741',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56742',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56744',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56748',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56750',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56751',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56754',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56755',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56756',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56757',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56758',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56759',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56760',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56761',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56762',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '56763',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '57001',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '57002',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57003',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57004',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '57005',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57006',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57007',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57010',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57012',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57013',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57014',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57015',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57016',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57017',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57018',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57020',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57021',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57022',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57024',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57025',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '57026',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57027',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57028',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57029',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57030',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57031',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57032',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57033',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57034',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57035',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57036',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57037',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57038',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '57039',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57040',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57041',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57042',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57043',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57045',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57046',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57047',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57048',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57049',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '57050',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57051',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57052',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57053',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57054',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57055',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57056',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57057',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57058',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57059',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57061',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57062',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57063',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57064',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57065',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57066',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57067',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57068',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57069',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57070',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57071',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57072',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57073',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57075',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57076',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57077',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57078',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57079',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57101',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57103',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57104',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57105',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57106',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57107',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57108',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57109',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57110',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57117',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57118',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57186',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57188',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57189',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57192',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57193',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57194',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57197',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57201',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57212',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57213',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57214',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57216',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57217',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57218',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57219',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57220',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57221',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57223',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57224',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57225',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57226',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57227',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57231',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57232',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57233',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57234',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57235',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57236',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57237',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57238',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57239',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57241',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57242',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57243',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57245',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57246',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57247',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57248',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57249',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57251',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57252',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57253',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57255',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57256',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57257',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57258',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57259',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57260',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57261',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57262',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57263',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57264',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57265',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57266',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57268',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57269',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57270',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57271',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57272',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57273',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57274',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57276',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57278',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57279',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57301',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57311',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57312',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57313',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57314',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57315',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57317',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57319',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57321',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57322',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57323',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57324',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57325',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57328',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57329',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57330',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57331',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57332',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57334',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57335',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57337',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57339',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57340',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57341',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57342',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57344',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57345',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57346',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57348',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57349',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57350',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57353',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57354',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57355',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57356',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57358',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57359',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57361',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57362',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57363',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57364',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57365',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57366',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57367',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57368',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57369',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57370',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57371',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57373',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57374',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57375',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57376',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57379',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57380',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57381',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57382',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57383',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57384',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57385',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57386',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57399',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57401',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57402',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57420',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57421',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57422',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57424',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57426',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57427',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57428',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57429',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57430',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57432',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57433',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57434',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57435',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57436',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57437',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57438',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57439',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57440',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57441',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57442',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57445',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57446',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57448',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57449',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57450',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57451',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57452',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57454',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57455',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57456',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57457',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57460',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57461',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57465',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57466',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57467',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57468',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57469',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57470',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57471',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57472',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57473',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57474',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57475',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57476',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57477',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57479',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57481',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57501',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57520',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57521',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57522',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57523',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57528',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57529',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57531',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57532',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57533',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57534',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57536',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57537',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57538',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57540',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57541',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57543',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57544',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57547',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57548',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57551',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57552',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57553',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57555',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57559',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57560',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57562',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57563',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57564',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57566',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57567',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57568',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57569',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57570',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57571',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57572',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57574',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57576',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57577',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57579',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57580',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57584',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57585',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57601',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57620',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57621',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '57622',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57623',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57625',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57626',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57630',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57631',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57632',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57633',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57634',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '57636',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57638',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57639',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '57640',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57641',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '57642',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '57644',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57645',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '57646',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57648',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57649',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57650',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57651',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57652',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57656',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57657',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '57658',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '57659',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '57660',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '57661',
    dma_code: '725',
    dma_description: 'SIOUX FALLS (MITCHELL)',
  },
  {
    zip_code: '57701',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57702',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57703',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57706',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57709',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57714',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57716',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57717',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57718',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57719',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57720',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57722',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57724',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57725',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57730',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57732',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57735',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57737',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57738',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57741',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57744',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57745',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57747',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57748',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57750',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57751',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57752',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57754',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57755',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57756',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57758',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57759',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57760',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57761',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57762',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57763',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57764',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57766',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57767',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57769',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57770',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57772',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57773',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57775',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57776',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57779',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57780',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57782',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57783',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57785',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57787',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57788',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57790',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57791',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57792',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57793',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57794',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '57799',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '58001',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58002',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58004',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58005',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58006',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58007',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58008',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58009',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58011',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58012',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58013',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58015',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58016',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58017',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58018',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58021',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58027',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58029',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58030',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58031',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58032',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58033',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58035',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58036',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58038',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58040',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58041',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58042',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58043',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58045',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58046',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58047',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58048',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58049',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58051',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58052',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58053',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58054',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58056',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58057',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58058',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58059',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58060',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58061',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58062',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58063',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58064',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58065',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58067',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58068',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58069',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58071',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58072',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58074',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58075',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58076',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58077',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58078',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58079',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58081',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58102',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58103',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58104',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58105',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58106',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58107',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58108',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58109',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58121',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58122',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58124',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58125',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58126',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58201',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58202',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58203',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58204',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58205',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58206',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58207',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58208',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58210',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58212',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58214',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58216',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58218',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58219',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58220',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58222',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58223',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58224',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58225',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58227',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58228',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58229',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58230',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58231',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58233',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58235',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58236',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58237',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58238',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58239',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58240',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58241',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58243',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58244',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58249',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58250',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58251',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58254',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58255',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58256',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58257',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58258',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58259',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58260',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58261',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58262',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58265',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58266',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58267',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58269',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58270',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58271',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58272',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58273',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58274',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58275',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58276',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58277',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58278',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58281',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58282',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58301',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58310',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58311',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58313',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58316',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58317',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58318',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58319',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58321',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58323',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58324',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58325',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58327',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58329',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58330',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58331',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58332',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58335',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58338',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58339',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58341',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58343',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58344',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58345',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58346',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58348',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58351',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58352',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58353',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58355',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58356',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58357',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58361',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58362',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58363',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58365',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58366',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58367',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58368',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58369',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58370',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58372',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58374',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58377',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58379',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58380',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58381',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58382',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58384',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58385',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58386',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58401',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58402',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58405',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58413',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58415',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58416',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58418',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58420',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58421',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58422',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58423',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58424',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58425',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58426',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58428',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58429',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58430',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58431',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58433',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58436',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58438',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58439',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58440',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58441',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58442',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58443',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58444',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58445',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58448',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58451',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58452',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58454',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58455',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58456',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58458',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58460',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58461',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58463',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58464',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58466',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58467',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58472',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58474',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58475',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58476',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58477',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58478',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58479',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58480',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58481',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58482',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58483',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58484',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58486',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58487',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58488',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58490',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58492',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58494',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58495',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58496',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58497',
    dma_code: '724',
    dma_description: 'FARGO - VALLEY CITY',
  },
  {
    zip_code: '58501',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58502',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58503',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58504',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58505',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58506',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58507',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58520',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58521',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58523',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58524',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58528',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58529',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58530',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58531',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58532',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58533',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58535',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58538',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58540',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58541',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58542',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58544',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58545',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58549',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58552',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58554',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58558',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58559',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58560',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58561',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58562',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58563',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58564',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58565',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58566',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58568',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58569',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58570',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58571',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58572',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58573',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58575',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58576',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58577',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58579',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58580',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58581',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58601',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58602',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58620',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58621',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58622',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58623',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58625',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58626',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58627',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58630',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58631',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58632',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58634',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58636',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58638',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58639',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58640',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58641',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58642',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58643',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58644',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58645',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58646',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58647',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58649',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58650',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58651',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58652',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58653',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58654',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58655',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58656',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58701',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58702',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58703',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58704',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58705',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58707',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58710',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58711',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58712',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58713',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58716',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58718',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58721',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58722',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58723',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58725',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58727',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58730',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58731',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58733',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58734',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58735',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58736',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58737',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58740',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58741',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58744',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58746',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58748',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58750',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58752',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58755',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58756',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58757',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58758',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58759',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58760',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58761',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58762',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58763',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58765',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58768',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58769',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58770',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58771',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58772',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58773',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58775',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58776',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58778',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58779',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58781',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58782',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58783',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58784',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58785',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58787',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58788',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58789',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58790',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58792',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58793',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58794',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58795',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58801',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58802',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58830',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58831',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58833',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58835',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58838',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58843',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58844',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58845',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58847',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58849',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58852',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58853',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58854',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '58856',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59001',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59002',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59003',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59004',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59006',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59007',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59008',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59010',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59011',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59012',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59013',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59014',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59015',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59016',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59018',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59019',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59020',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59022',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59024',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59025',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59026',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59027',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59028',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59029',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59030',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59031',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59032',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59033',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59034',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59035',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59036',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59037',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59038',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59039',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59041',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59043',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59044',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59046',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59047',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59050',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59052',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59053',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59054',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59055',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59057',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59058',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59059',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59061',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59062',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59063',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59064',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59065',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59066',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59067',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59068',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59069',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59070',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59071',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59072',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59073',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59074',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59075',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59076',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59077',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59078',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59079',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59081',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59082',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59083',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59084',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59085',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59086',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59087',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59088',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59089',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59101',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59102',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59103',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59104',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59105',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59106',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59107',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59108',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59111',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59112',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59114',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59115',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59116',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59117',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59201',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59211',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59212',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59213',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59214',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59215',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59217',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59218',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59219',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59221',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59222',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59223',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59225',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59226',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59230',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59231',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59240',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59241',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59242',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59243',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59244',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59247',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59248',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59250',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59252',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59253',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59254',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59255',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59256',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59257',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59258',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59259',
    dma_code: '798',
    dma_description: 'GLENDIVE',
  },
  {
    zip_code: '59260',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59261',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59262',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59263',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59270',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59273',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59274',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59275',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59276',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59301',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59311',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '59312',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59313',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59314',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59315',
    dma_code: '798',
    dma_description: 'GLENDIVE',
  },
  {
    zip_code: '59316',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '59317',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59318',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59319',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '59322',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59323',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59324',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '59326',
    dma_code: '798',
    dma_description: 'GLENDIVE',
  },
  {
    zip_code: '59327',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59330',
    dma_code: '798',
    dma_description: 'GLENDIVE',
  },
  {
    zip_code: '59332',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '59333',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59336',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59337',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59338',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59339',
    dma_code: '798',
    dma_description: 'GLENDIVE',
  },
  {
    zip_code: '59341',
    dma_code: '798',
    dma_description: 'GLENDIVE',
  },
  {
    zip_code: '59343',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59344',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59345',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59347',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59349',
    dma_code: '798',
    dma_description: 'GLENDIVE',
  },
  {
    zip_code: '59351',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59353',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59354',
    dma_code: '687',
    dma_description: 'MINOT - BISMARCK - DICKINSON',
  },
  {
    zip_code: '59401',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59402',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59403',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59404',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59405',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59406',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59410',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59411',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59412',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59414',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59416',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59417',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59418',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59419',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59420',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59421',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59422',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59424',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59425',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59427',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59430',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59432',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59433',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59434',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59435',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59436',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59440',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59441',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59442',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59443',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59444',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59446',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59447',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59448',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59450',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59451',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59452',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59453',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59454',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59456',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59457',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59460',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59461',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59462',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59463',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59464',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59465',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59466',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59467',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59468',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59469',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59471',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59472',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59474',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59477',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59479',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59480',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59482',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59483',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59484',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59485',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59486',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59487',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59489',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59501',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59520',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59521',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59522',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59523',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59524',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59525',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59526',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59527',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59528',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59529',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59530',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59531',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59532',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59535',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59537',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59538',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59540',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59542',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59544',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59545',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59546',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59547',
    dma_code: '755',
    dma_description: 'GREAT FALLS',
  },
  {
    zip_code: '59601',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59602',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59604',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59620',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59623',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59624',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59625',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59626',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59631',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59632',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59633',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59634',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59635',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59636',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59638',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59639',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59640',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59641',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59642',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59643',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59644',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59645',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '59647',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59648',
    dma_code: '766',
    dma_description: 'HELENA',
  },
  {
    zip_code: '59701',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59702',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59703',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59707',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59710',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59711',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59713',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59714',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59715',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59716',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59717',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59718',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59719',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59720',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59721',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59722',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59724',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59725',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59727',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59728',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59729',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59730',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59731',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59732',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59733',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59735',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59736',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59739',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59740',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59741',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59743',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59745',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59746',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59747',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59748',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59749',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59750',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59751',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59752',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59754',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59755',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59756',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59758',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59759',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59760',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59761',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59762',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59771',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59772',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59773',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59801',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59802',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59803',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59804',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59806',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59807',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59808',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59812',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59820',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59821',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59823',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59824',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59825',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59826',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59827',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59828',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59829',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59830',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59831',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59832',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59833',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59834',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59835',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59837',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59840',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59841',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59842',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59843',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59844',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59845',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59846',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59847',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59848',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59851',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59853',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59854',
    dma_code: '754',
    dma_description: 'BUTTE - BOZEMAN',
  },
  {
    zip_code: '59855',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59856',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59858',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59859',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59860',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59863',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59864',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59865',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59866',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59867',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59868',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59870',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59871',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59872',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59873',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59874',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59875',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59901',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59903',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59904',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59910',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59911',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59912',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59913',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59914',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59915',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59916',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59917',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '59918',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '59919',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59920',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59921',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59922',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59923',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '59925',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59926',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59927',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59928',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59929',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59930',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '59931',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59932',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59933',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '59934',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '59935',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '59936',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '59937',
    dma_code: '762',
    dma_description: 'MISSOULA',
  },
  {
    zip_code: '60001',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60002',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60004',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60005',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60006',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60007',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60008',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60009',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60010',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60011',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60012',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60013',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60014',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60015',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60016',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60017',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60018',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60019',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60020',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60021',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60022',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60025',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60026',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60029',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60030',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60031',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60033',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60034',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60035',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60037',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60038',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60039',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60040',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60041',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60042',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60043',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60044',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60045',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60046',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60047',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60048',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60049',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60050',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60051',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60053',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60055',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60056',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60060',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60061',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60062',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60064',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60065',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60067',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60068',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60069',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60070',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60071',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60072',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60073',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60074',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60075',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60076',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60077',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60078',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60079',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60081',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60082',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60083',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60084',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60085',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60086',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60087',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60088',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60089',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60090',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60091',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60093',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60094',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60095',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60096',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60097',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60098',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60099',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60101',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60102',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60103',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60104',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60105',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60106',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60107',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60108',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60109',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60110',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60111',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60112',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60113',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '60115',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60116',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60117',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60118',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60119',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60120',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60121',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60122',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60123',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60124',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60125',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60126',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60128',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60129',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60130',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60131',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60132',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60133',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60134',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60135',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60136',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60137',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60138',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60139',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60140',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60141',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60142',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60143',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60144',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60145',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60146',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60147',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60148',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60150',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60151',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60152',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60153',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60154',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60155',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60156',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60157',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60159',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60160',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60161',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60162',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60163',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60164',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60165',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60168',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60169',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60170',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60171',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60172',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60173',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60174',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60175',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60176',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60177',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60178',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60179',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60180',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60181',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60183',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60184',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60185',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60186',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60187',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60188',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60189',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60190',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60191',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60192',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60193',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60194',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60195',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60196',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60197',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60199',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60201',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60202',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60203',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60204',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60208',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60209',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60290',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60296',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60297',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60301',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60302',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60303',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60304',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60305',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60399',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60401',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60402',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60403',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60404',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60406',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60407',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60408',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60409',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60410',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60411',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60412',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60415',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60416',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60417',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60419',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60420',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '60421',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60422',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60423',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60424',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60425',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60426',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60428',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60429',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60430',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60431',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60432',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60433',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60434',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60435',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60436',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60437',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60438',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60439',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60440',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60441',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60442',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60443',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60444',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60445',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60446',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60447',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60448',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60449',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60450',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60451',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60452',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60453',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60454',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60455',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60456',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60457',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60458',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60459',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60460',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '60461',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60462',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60463',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60464',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60465',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60466',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60467',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60468',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60469',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60470',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60471',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60472',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60473',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60474',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60475',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60476',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60477',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60478',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60479',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60480',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60481',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60482',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60483',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60484',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60487',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60490',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60491',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60499',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60501',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60502',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60503',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60504',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60505',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60506',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60507',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60510',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60511',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60512',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60513',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60514',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60515',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60516',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60517',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60518',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60519',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60520',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60521',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60522',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60523',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60525',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60526',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60527',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60530',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '60531',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60532',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60534',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60536',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60537',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60538',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60539',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60540',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60541',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60542',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60543',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60544',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60545',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60546',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60548',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60549',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60550',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60551',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60552',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60553',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '60554',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60555',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60556',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60557',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60558',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60559',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60560',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60561',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60563',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60564',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60565',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60566',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60567',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60568',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60570',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60572',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60585',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60586',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60597',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60598',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60601',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60602',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60603',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60604',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60605',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60606',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60607',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60608',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60609',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60610',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60611',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60612',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60613',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60614',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60615',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60616',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60617',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60618',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60619',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60620',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60621',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60622',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60623',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60624',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60625',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60626',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60628',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60629',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60630',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60631',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60632',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60633',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60634',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60636',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60637',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60638',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60639',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60640',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60641',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60642',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60643',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60644',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60645',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60646',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60647',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60649',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60651',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60652',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60653',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60654',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60655',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60656',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60657',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60659',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60660',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60661',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60663',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60664',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60666',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60668',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60669',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60670',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60673',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60674',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60675',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60677',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60678',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60679',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60680',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60681',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60682',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60684',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60685',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60686',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60687',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60688',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60689',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60690',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60691',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60693',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60694',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60695',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60696',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60697',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60699',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60701',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60706',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60707',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60712',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60714',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60803',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60804',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60805',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60827',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60901',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60910',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60911',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60912',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60913',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60914',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60915',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60917',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60918',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60919',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60920',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '60921',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '60922',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60924',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60926',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60927',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60928',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60929',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '60930',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60931',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60932',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60933',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60934',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '60935',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60936',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60938',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60939',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60940',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60941',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60942',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60944',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60945',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60946',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60948',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60949',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60950',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60951',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60952',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60953',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60954',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60955',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60956',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60957',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60958',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60959',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60960',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60961',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60962',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60963',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60964',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60966',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60967',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60968',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60969',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '60970',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60973',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '60974',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61001',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61006',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61007',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61008',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61010',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61011',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61012',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61013',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61014',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61015',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61016',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61018',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61019',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61020',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61021',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61024',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61025',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61027',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61028',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61030',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61031',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61032',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61036',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61037',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61038',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61039',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61041',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61042',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61043',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61044',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61046',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61047',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61048',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61049',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61050',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61051',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61052',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61053',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61054',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61057',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61058',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61059',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61060',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61061',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61062',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61063',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61064',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61065',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61067',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61068',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61070',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61071',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61072',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61073',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61074',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61075',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61077',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61078',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61079',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61080',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61081',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61084',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61085',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61087',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61088',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61089',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61091',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61101',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61102',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61103',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61104',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61105',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61106',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61107',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61108',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61109',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61110',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61111',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61112',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61114',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61115',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61125',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61126',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61130',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61131',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61132',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61201',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61204',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61230',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61231',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61232',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61233',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61234',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61235',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61236',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61237',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61238',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61239',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61240',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61241',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61242',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61243',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61244',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61250',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61251',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61252',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61254',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61256',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61257',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61258',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61259',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61260',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61261',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61262',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61263',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61264',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61265',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61266',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61270',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61272',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61273',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61274',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61275',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61276',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61277',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61278',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61279',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61281',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61282',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61283',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61284',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61285',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61299',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61301',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61310',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61311',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61312',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61313',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61314',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61315',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61316',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61317',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61318',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61319',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61320',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61321',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61322',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61323',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61324',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61325',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61326',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61327',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61328',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61329',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61330',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61331',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61332',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61333',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61334',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61335',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61336',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61337',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61338',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61340',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61341',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61342',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61344',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61345',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61346',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61348',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61349',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61350',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61353',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61354',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61356',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61358',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61359',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61360',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61361',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61362',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61363',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61364',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61367',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61368',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61369',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61370',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61371',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61372',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61373',
    dma_code: '602',
    dma_description: 'CHICAGO',
  },
  {
    zip_code: '61374',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61375',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61376',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61377',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61378',
    dma_code: '610',
    dma_description: 'ROCKFORD',
  },
  {
    zip_code: '61379',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61401',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61402',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61410',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61411',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '61412',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61413',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61414',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61415',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61416',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '61417',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61418',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61419',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61420',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '61421',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61422',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '61423',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61424',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61425',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61426',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61427',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61428',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61430',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61431',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61432',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61433',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61434',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61435',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61436',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61437',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61438',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '61439',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61440',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '61441',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61442',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61443',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61447',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61448',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61449',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61450',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '61451',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61452',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '61453',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61454',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61455',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '61458',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61459',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61460',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61462',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61465',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61466',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61467',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61468',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61469',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61470',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '61471',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61472',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61473',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61474',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61475',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '61476',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61477',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61478',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61479',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61480',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61482',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61483',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61484',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61485',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61486',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61488',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61489',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61490',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61491',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61501',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61516',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61517',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61519',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61520',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61523',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61524',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61525',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61526',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61528',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61529',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61530',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61531',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61532',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61533',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61534',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61535',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61536',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61537',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61539',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61540',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61541',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61542',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61543',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61544',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61545',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61546',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61547',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61548',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61550',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61552',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61553',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61554',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61555',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61558',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61559',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61560',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61561',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61562',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61563',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61564',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61565',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61567',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61568',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61569',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61570',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61571',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61572',
    dma_code: '682',
    dma_description: 'DAVENPORT - R. ISLAND - MOLINE',
  },
  {
    zip_code: '61601',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61602',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61603',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61604',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61605',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61606',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61607',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61610',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61611',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61612',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61613',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61614',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61615',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61616',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61625',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61629',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61630',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61633',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61634',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61635',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61636',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61637',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61638',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61639',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61641',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61643',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61650',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61651',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61652',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61653',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61654',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61655',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61656',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61701',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61702',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61704',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61705',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61709',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61710',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61720',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61721',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61722',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61723',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61724',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61725',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61726',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61727',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61728',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61729',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61730',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61731',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61732',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61733',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61734',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61735',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61736',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61737',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61738',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61739',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61740',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61741',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61742',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61743',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61744',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61745',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61747',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61748',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61749',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61750',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61751',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61752',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61753',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61754',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61755',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61756',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61758',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61759',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61760',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61761',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61764',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61769',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61770',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61771',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61772',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61773',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61774',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61775',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61776',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61777',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61778',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61790',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61791',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61799',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '61801',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61802',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61803',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61810',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61811',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61812',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61813',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61814',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61815',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61816',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61817',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61818',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61820',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61821',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61822',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61824',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61825',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61826',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61830',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61831',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61832',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61833',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61834',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61839',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61840',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61841',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61842',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61843',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61844',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61845',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61846',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61847',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61848',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61849',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61850',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61851',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61852',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61853',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61854',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61855',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61856',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61857',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61858',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61859',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61862',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61863',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61864',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61865',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61866',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61870',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61871',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61872',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61873',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61874',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61875',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61876',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61877',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61878',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61880',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61882',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61883',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61884',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61910',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61911',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61912',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61913',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61914',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61917',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61919',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61920',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61924',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61925',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61928',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61929',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61930',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61931',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61932',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61933',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61936',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61937',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61938',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61940',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61941',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61942',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61943',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61944',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61949',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61951',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61953',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61955',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61956',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '61957',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62001',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62002',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62006',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62009',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62010',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62011',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62012',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62013',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62014',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62015',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62016',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62017',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62018',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62019',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62021',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62022',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62023',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62024',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62025',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62026',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62027',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62028',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62030',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62031',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62032',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62033',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62034',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62035',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62036',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62037',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62040',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62044',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62045',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62046',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62047',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62048',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62049',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62050',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62051',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62052',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62053',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62054',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62056',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62058',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62059',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62060',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62061',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62062',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62063',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62065',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62067',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62069',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62070',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62071',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62074',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62075',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62076',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62077',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62078',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62079',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62080',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62081',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62082',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62083',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62084',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62085',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62086',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62087',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62088',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62089',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62090',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62091',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62092',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62093',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62094',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62095',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62097',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62098',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62201',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62202',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62203',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62204',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62205',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62206',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62207',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62208',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62214',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62215',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62216',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62217',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62218',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62219',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62220',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62221',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62222',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62223',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62224',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62225',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62226',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62230',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62231',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62232',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62233',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62234',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62236',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62237',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62238',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62239',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62240',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62241',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62242',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62243',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62244',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62245',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62246',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62247',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62248',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62249',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62250',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62252',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62253',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62254',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62255',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62256',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62257',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62258',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62259',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62260',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62261',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62262',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62263',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62264',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62265',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62266',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62268',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62269',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62271',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62272',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62273',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62274',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62275',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62277',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62278',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62279',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62280',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62281',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62282',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62284',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62285',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62286',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62288',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62289',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62292',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62293',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62294',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62295',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62297',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62298',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62301',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62305',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62306',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62311',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62312',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62313',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62314',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62316',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62319',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62320',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62321',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62323',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62324',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62325',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62326',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62329',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62330',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62334',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62336',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62338',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62339',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62340',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62341',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62343',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62344',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62345',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62346',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62347',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62348',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62349',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62351',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62352',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62353',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62354',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62355',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62356',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62357',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62358',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62359',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62360',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62361',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62362',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62363',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62365',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62366',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62367',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62370',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62373',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62374',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62375',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62376',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62378',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62379',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62380',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62401',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62410',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62411',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62413',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62414',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62417',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62418',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62419',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62420',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62421',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62422',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62423',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62424',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62425',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62426',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62427',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62428',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62431',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62432',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62433',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62434',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62435',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62436',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62438',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62439',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62440',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62441',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62442',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62443',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62444',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62445',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62446',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62447',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62448',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62449',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62450',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62451',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62452',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62454',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62458',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62459',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62460',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62461',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62462',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62463',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62464',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62465',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62466',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62467',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62468',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62469',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62471',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62473',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62474',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62475',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62476',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62477',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62478',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62479',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62480',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62481',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62501',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62510',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62512',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62513',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62514',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62515',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62517',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62518',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62519',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62520',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62521',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62522',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62523',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62524',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62525',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62526',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62530',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62531',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62532',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62533',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62534',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62535',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62536',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62537',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62538',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62539',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62540',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62541',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62543',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62544',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62545',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62546',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62547',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62548',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62549',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62550',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62551',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62553',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62554',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62555',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62556',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62557',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62558',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62560',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62561',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62563',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62565',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62567',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62568',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62570',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62571',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62572',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62573',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62601',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62610',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62611',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62612',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62613',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62615',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62617',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '62618',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62621',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62622',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62624',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62625',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62626',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62627',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62628',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62629',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62630',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62631',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62633',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '62634',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62635',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62638',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62639',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62640',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62642',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62643',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62644',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '62649',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62650',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62651',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62655',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '62656',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62659',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62660',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62661',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62662',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62663',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62664',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '62665',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62666',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62667',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62668',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62670',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62671',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62672',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62673',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62674',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62675',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62677',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62681',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62682',
    dma_code: '675',
    dma_description: 'PEORIA - BLOOMINGTON',
  },
  {
    zip_code: '62683',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62684',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62685',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62688',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62689',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62690',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62691',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62692',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62693',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62694',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '62695',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62701',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62702',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62703',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62704',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62705',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62706',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62707',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62708',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62711',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62712',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62713',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62715',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62716',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62719',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62721',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62722',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62723',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62726',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62736',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62739',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62746',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62756',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62761',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62762',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62763',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62764',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62765',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62766',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62767',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62769',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62776',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62777',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62781',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62786',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62791',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62794',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62796',
    dma_code: '648',
    dma_description: 'CHAMPAIGN & SPRNGFLD - DECATUR',
  },
  {
    zip_code: '62801',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62803',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62805',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62806',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62807',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62808',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62809',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62810',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62811',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62812',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62814',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62815',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62816',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62817',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62818',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62819',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62820',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62821',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62822',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62823',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62824',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62825',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62827',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62828',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62829',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62830',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62831',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62832',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62833',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62834',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62835',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62836',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62837',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62838',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62839',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62840',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62841',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62842',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62843',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62844',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62846',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62848',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62849',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62850',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62851',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62852',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62853',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62854',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62855',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62856',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62857',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62858',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62859',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62860',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62861',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62862',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62863',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62864',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62865',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62866',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62867',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62868',
    dma_code: '581',
    dma_description: 'TERRE HAUTE',
  },
  {
    zip_code: '62869',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62870',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62871',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62872',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62874',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62875',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62876',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62877',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62878',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62879',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62880',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62881',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62882',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62883',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62884',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62885',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62886',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62887',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62888',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62889',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62890',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62891',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62892',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62893',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62894',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62895',
    dma_code: '649',
    dma_description: 'EVANSVILLE',
  },
  {
    zip_code: '62896',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62897',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62898',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62899',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '62901',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62902',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62903',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62905',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62906',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62907',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62908',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62909',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62910',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62912',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62914',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62915',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62916',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62917',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62918',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62919',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62920',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62921',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62922',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62923',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62924',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62926',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62927',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62928',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62930',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62931',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62932',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62933',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62934',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62935',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62938',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62939',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62940',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62941',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62942',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62943',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62946',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62947',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62948',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62949',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62950',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62951',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62952',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62953',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62954',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62955',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62956',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62957',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62958',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62959',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62960',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62961',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62962',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62963',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62964',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62965',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62966',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62967',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62969',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62970',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62971',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62972',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62973',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62974',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62975',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62976',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62977',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62979',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62982',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62983',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62984',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62985',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62987',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62988',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62990',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62992',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62993',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62994',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62995',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62996',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62997',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62998',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '62999',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63001',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63005',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63006',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63010',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63011',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63012',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63013',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63014',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63015',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63016',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63017',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63019',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63020',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63021',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63022',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63023',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63024',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63025',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63026',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63028',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63030',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63031',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63032',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63033',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63034',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63036',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63037',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63038',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63039',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63040',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63041',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63042',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63043',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63044',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63045',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63047',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63048',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63049',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63050',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63051',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63052',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63053',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63055',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63056',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63057',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63060',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63061',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63065',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63066',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63068',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63069',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63070',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63071',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63072',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63073',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63074',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63077',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63079',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63080',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63084',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63087',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63088',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63089',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63090',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63091',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63099',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63101',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63102',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63103',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63104',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63105',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63106',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63107',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63108',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63109',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63110',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63111',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63112',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63113',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63114',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63115',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63116',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63117',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63118',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63119',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63120',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63121',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63122',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63123',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63124',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63125',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63126',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63127',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63128',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63129',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63130',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63131',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63132',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63133',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63134',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63135',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63136',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63137',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63138',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63139',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63140',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63141',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63143',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63144',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63145',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63146',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63147',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63150',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63151',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63155',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63156',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63157',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63158',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63160',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63163',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63164',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63166',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63167',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63169',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63171',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63177',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63178',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63179',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63180',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63182',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63188',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63190',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63195',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63196',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63198',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63199',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63301',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63302',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63303',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63304',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63330',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63332',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63333',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '63334',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63336',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63338',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63339',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63341',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63342',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63343',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63344',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63345',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '63346',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63347',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63348',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63349',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63350',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '63351',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '63352',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '63353',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63357',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63359',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '63361',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '63362',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63363',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '63365',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63366',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63367',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63368',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63369',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63370',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63373',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63376',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63377',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63378',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63379',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63381',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63382',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '63383',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63384',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '63385',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63386',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63387',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63388',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '63389',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63390',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63401',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63430',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63431',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63432',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63433',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63434',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63435',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63436',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63437',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63438',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63439',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63440',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63441',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63442',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63443',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63445',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63446',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63447',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63448',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63450',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63451',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63452',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63453',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63454',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63456',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63457',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63458',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63459',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63460',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63461',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63462',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63463',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63464',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63465',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63466',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63467',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63468',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63469',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63471',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63472',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63473',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63474',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63501',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63530',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63531',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63532',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63533',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63534',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63535',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63536',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63537',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63538',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63539',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63540',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63541',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63543',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63544',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63545',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63546',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63547',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '63548',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63549',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63551',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63552',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63555',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63556',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63557',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '63558',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63559',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63560',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63561',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63563',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63565',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63566',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63567',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '63601',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63620',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63621',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63622',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63623',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63624',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63625',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63626',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63627',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63628',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63629',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63630',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63631',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63632',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63633',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63636',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63637',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63638',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63640',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63645',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63648',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63650',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63651',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63653',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63654',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63655',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63656',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63660',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63662',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63663',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63664',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63665',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63666',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63670',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63673',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63674',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63675',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '63701',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63702',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63703',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63730',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63732',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63735',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63736',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63737',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63738',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63739',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63740',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63742',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63743',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63744',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63745',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63746',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63747',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63748',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63750',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63751',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63752',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63755',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63758',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63760',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63763',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63764',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63766',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63767',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63769',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63770',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63771',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63774',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63775',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63776',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63779',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63780',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63781',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63782',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63783',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63784',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63785',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63787',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63801',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63820',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63821',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63822',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63823',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63824',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63825',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63826',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '63827',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '63828',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63829',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63830',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '63833',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63834',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63837',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63839',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '63840',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '63841',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63845',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63846',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63847',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63848',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63849',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '63850',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63851',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '63852',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63853',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '63855',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63857',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63860',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63862',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63863',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63866',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63867',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63868',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63869',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63870',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63873',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63874',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63875',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63876',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63877',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '63878',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63879',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '63880',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63881',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63882',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63901',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63902',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63931',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63932',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63933',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63934',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63935',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63936',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63937',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63938',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63939',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63940',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63941',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63942',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63943',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63944',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63945',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63950',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63951',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63952',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63953',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63954',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63955',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63956',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63957',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63960',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63961',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63962',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63963',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63964',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63965',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63966',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '63967',
    dma_code: '632',
    dma_description: 'PADUCAH - CAPE GIRAR D - HARSBG',
  },
  {
    zip_code: '64001',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64002',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64011',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64012',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64013',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64014',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64015',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64016',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64017',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64018',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64019',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64020',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64021',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64022',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64024',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64028',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64029',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64030',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64034',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64035',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64036',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64037',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64040',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64048',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64050',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64051',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64052',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64053',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64054',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64055',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64056',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64057',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64058',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64060',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64061',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64062',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64063',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64064',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64065',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64066',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64067',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64068',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64069',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64070',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64071',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64072',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64073',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64074',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64075',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64076',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64077',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64078',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64079',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64080',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64081',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64082',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64083',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64084',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64085',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64086',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64088',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64089',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64090',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64092',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64093',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64096',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64097',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64098',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64101',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64102',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64105',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64106',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64108',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64109',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64110',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64111',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64112',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64113',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64114',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64116',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64117',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64118',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64119',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64120',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64121',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64123',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64124',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64125',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64126',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64127',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64128',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64129',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64130',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64131',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64132',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64133',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64134',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64136',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64137',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64138',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64139',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64141',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64144',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64145',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64146',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64147',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64148',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64149',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64150',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64151',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64152',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64153',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64154',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64155',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64156',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64157',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64158',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64161',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64163',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64164',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64165',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64166',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64167',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64168',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64170',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64171',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64179',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64180',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64183',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64185',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64187',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64188',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64190',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64192',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64193',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64195',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64196',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64197',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64198',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64199',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64401',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64402',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64420',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64421',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64422',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64423',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64424',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64426',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64427',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64428',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64429',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64430',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64431',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64432',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64433',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64434',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64436',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64437',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64438',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64439',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64440',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64441',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64442',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64443',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64444',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64445',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64446',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '64447',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64448',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64449',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64451',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64453',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64454',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64455',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64456',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64457',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64458',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64459',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64461',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64463',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64465',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64466',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64467',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64468',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64469',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64470',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64471',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64473',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64474',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64475',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64476',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64477',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64479',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64480',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64481',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64482',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '64483',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64484',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64485',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64486',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64487',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64489',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64490',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64491',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '64492',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64493',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64494',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64496',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '64497',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64498',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '64499',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64501',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64502',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64503',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64504',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64505',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64506',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64507',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64508',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '64601',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64620',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64622',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64623',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64624',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64625',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64628',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64630',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64631',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64632',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64633',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64635',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64636',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64637',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64638',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64639',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64640',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64641',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64642',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64643',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64644',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64645',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '64646',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '64647',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64648',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64649',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64650',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64651',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64652',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64653',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64654',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64655',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '64656',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64657',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64658',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64659',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64660',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '64661',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64664',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64667',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '64668',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64670',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64671',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64672',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '64673',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64674',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64676',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '64679',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64680',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64681',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '64682',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64683',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64686',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64688',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64689',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64701',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64720',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64722',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64723',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64724',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '64725',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64726',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64728',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64730',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64733',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64734',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64735',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64738',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '64739',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64740',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64741',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64742',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64743',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64744',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '64745',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64746',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64747',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64748',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64750',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64752',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64755',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64756',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '64759',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64761',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64762',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64763',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '64765',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64766',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64767',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64769',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64770',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64771',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64772',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64776',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '64778',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64779',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64780',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64781',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '64783',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64784',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64788',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64789',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '64790',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64801',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64802',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64803',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64804',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64830',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64831',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64832',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64833',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64834',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64835',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64836',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64840',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64841',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64842',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64843',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64844',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64847',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64848',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '64849',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64850',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64853',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64854',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64855',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64856',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64857',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64858',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64859',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64861',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64862',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64863',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64864',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64865',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64866',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64867',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64868',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64869',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64870',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '64873',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '64874',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '64944',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '64999',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65001',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65010',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65011',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65013',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65014',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65016',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65017',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65018',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65020',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65023',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65024',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65025',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65026',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65032',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65034',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65035',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65036',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65037',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65038',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65039',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65040',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65041',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65042',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65043',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65046',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65047',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65048',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65049',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65050',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65051',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65052',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65053',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65054',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65055',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65058',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65059',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65061',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65062',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65063',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65064',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65065',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65066',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65067',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65068',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65069',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65072',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65074',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65075',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65076',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65077',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65078',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65079',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65080',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65081',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65082',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65083',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65084',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65085',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65101',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65102',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65103',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65104',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65105',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65106',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65107',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65108',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65109',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65110',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65111',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65201',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65202',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65203',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65205',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65211',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65212',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65215',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65216',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65217',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65218',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65230',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65231',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65232',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65233',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65236',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65237',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65239',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65240',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65243',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65244',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65246',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65247',
    dma_code: '631',
    dma_description: 'OTTUMWA - KIRKSVILLE',
  },
  {
    zip_code: '65248',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65250',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65251',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65254',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65255',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65256',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65257',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65258',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '65259',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65260',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65261',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65262',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65263',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '65264',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65265',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65270',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65274',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65275',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '65276',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65278',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65279',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65280',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65281',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65282',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '65283',
    dma_code: '717',
    dma_description: 'QUINCY - HANNIBAL - KEOKUK',
  },
  {
    zip_code: '65284',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65285',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65286',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65287',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65299',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65301',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65302',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65305',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65320',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65321',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65322',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65323',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65324',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65325',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65326',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65327',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65329',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65330',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65332',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65333',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65334',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65335',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65336',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65337',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65338',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65339',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65340',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65344',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65345',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65347',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65348',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65349',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65350',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65351',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65354',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65355',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65360',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '65401',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65402',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65409',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65436',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65438',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65439',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65440',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65441',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65443',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65444',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65446',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65449',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65452',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65453',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65456',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65457',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65459',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65461',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65462',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65463',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65464',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65466',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65468',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65470',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65473',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65479',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65483',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65484',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65486',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65501',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65529',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65532',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65534',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65535',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65536',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65541',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65542',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65543',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65546',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65548',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65550',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65552',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65555',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65556',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65557',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65559',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65560',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65564',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65565',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65566',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65567',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65570',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65571',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65580',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65582',
    dma_code: '604',
    dma_description: 'COLUMBIA - JEFFERSON CITY',
  },
  {
    zip_code: '65583',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65584',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65586',
    dma_code: '609',
    dma_description: 'ST. LOUIS',
  },
  {
    zip_code: '65588',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65589',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65590',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65591',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65601',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65603',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65604',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65605',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65606',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65607',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65608',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65609',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65610',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65611',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65612',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65613',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65614',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65615',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65616',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65617',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65618',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65619',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65620',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65622',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65623',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65624',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65625',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65626',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65627',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65629',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65630',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65631',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65632',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65633',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65634',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65635',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65636',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65637',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65638',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65640',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65641',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65644',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65645',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65646',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65647',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65648',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65649',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65650',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65652',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65653',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65654',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65655',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65656',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65657',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65658',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65660',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65661',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65662',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65663',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65664',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65666',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65667',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65668',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65669',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65672',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65673',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65674',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65675',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65676',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65679',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65680',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65681',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65682',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65685',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65686',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65688',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65689',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65690',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65692',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65701',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65702',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65704',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65705',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65706',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65707',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65708',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65710',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65711',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65712',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65713',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65714',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65715',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65717',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65720',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65721',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65722',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65723',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65724',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65725',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65726',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65727',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65728',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65729',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65730',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '65731',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65732',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65733',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65734',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65735',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65737',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65738',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65739',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65740',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65741',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65742',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65744',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65745',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65746',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65747',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65752',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65753',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65754',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65755',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65756',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65757',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65759',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65760',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65761',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65762',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65764',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65765',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65766',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65767',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65768',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65769',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65770',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65771',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65772',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65773',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65774',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65775',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65776',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65777',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65778',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65779',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65781',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65783',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65784',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65785',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65786',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65787',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65788',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65789',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65790',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65791',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65793',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65801',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65802',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65803',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65804',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65805',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65806',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65807',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65808',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65809',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65810',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65814',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65890',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65897',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65898',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '65899',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '66002',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66006',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66007',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66008',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '66010',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66012',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66013',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66014',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66015',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66016',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66017',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '66018',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66019',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66020',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66021',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66023',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66024',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '66025',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66026',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66027',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66030',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66031',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66032',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66033',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66035',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '66036',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66039',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66040',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66041',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66042',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66043',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66044',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66045',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66046',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66047',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66048',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66049',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66050',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66051',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66052',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66053',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66054',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66056',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66058',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66060',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66061',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66062',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66063',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66064',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66066',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66067',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66070',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66071',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66072',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66073',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66075',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66076',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66077',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66078',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66079',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66080',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66083',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66085',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66086',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66087',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '66088',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66090',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '66091',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66092',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66093',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66094',
    dma_code: '638',
    dma_description: 'ST. JOSEPH',
  },
  {
    zip_code: '66095',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66097',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66101',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66102',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66103',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66104',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66105',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66106',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66109',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66110',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66111',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66112',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66113',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66115',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66117',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66118',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66119',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66160',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66201',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66202',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66203',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66204',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66205',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66206',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66207',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66208',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66209',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66210',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66211',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66212',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66213',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66214',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66215',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66216',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66217',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66218',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66219',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66220',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66221',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66222',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66223',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66224',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66225',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66226',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66227',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66250',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66251',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66276',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66279',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66282',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66283',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66285',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66286',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66401',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66402',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66403',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66404',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66406',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66407',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66408',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66409',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66411',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66412',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66413',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66414',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66415',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66416',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66417',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66418',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66419',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66420',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66422',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66423',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66424',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66425',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66426',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66427',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66428',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66429',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66431',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66432',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66434',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66436',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66438',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66439',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66440',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66441',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66442',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66449',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66451',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66501',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66502',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66503',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66505',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66506',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66507',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66508',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66509',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66510',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66512',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66514',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66515',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66516',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66517',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66518',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66520',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66521',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66522',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66523',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66524',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66526',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66527',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66528',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66531',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66532',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66533',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66534',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66535',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66536',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66537',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66538',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66539',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66540',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66541',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66542',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66543',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66544',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66546',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66547',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66548',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66549',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66550',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66552',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66554',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66601',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66603',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66604',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66605',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66606',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66607',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66608',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66609',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66610',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66611',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66612',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66614',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66615',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66616',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66617',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66618',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66619',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66620',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66621',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66622',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66624',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66625',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66626',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66628',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66629',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66636',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66637',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66642',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66647',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66652',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66653',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66667',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66675',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66683',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66699',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66701',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66710',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66711',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66712',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66713',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66714',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66716',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66717',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66720',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66724',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66725',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66728',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66732',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66733',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66734',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66735',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66736',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66738',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66739',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66740',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66741',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66742',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66743',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66746',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66748',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66749',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66751',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66753',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66754',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66755',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66756',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66757',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66758',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66759',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66760',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66761',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66762',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66763',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66767',
    dma_code: '616',
    dma_description: 'KANSAS CITY',
  },
  {
    zip_code: '66769',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66770',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66771',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66772',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66773',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66775',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66776',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66777',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66778',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66779',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66780',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66781',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66782',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66783',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '66801',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66830',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66833',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66834',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66835',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66838',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66839',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66840',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66842',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66843',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66845',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66846',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66849',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66850',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66851',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66852',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66853',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66854',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66855',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66856',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66857',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66858',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66859',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66860',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66861',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66862',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66863',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66864',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66865',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66866',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66868',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66869',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66870',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '66871',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66872',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66873',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66901',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66930',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66932',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66933',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66935',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66936',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66937',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66938',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66939',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66940',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66941',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66942',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66943',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66944',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66945',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66946',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66948',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66949',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66951',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66952',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66953',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66955',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66956',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66958',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66959',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66960',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66961',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66962',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66963',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66964',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66966',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66967',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '66968',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '66970',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '67001',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67002',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67003',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67004',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67005',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67008',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67009',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67010',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67012',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67013',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67016',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67017',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67018',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67019',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67020',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67021',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67022',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67023',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67024',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67025',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67026',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67028',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67029',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67030',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67031',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67035',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67036',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67037',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67038',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67039',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67041',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67042',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67045',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67047',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67049',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67050',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67051',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67052',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67053',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67054',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67055',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67056',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67057',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67058',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67059',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67060',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67061',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67062',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67063',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67065',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67066',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67067',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67068',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67070',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67071',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67072',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67073',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67074',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67101',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67102',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67103',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67104',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67105',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67106',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67107',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67108',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67109',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67110',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67111',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67112',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67114',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67117',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67118',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67119',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67120',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67122',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67123',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67124',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67127',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67131',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67132',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67133',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67134',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67135',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67137',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67138',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67140',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67142',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67143',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67144',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67146',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67147',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67149',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67150',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67151',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67152',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67154',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67155',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67156',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67159',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67201',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67202',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67203',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67204',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67205',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67206',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67207',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67208',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67209',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67210',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67211',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67212',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67213',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67214',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67215',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67216',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67217',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67218',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67219',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67220',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67221',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67223',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67226',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67227',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67228',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67230',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67232',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67235',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67260',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67275',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67277',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67278',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67301',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67330',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '67332',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '67333',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67334',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67335',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67336',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '67337',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67340',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67341',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '67342',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '67344',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67345',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67346',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67347',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67349',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67351',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67352',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67353',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67354',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '67355',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67356',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '67357',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '67360',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67361',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67363',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67364',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '67401',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67402',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67410',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67416',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67417',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '67418',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67420',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67422',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67423',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67425',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67427',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67428',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67430',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67431',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67432',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '67436',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67437',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67438',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67439',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67441',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67442',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67443',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67444',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67445',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '67446',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67447',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '67448',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67449',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67450',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67451',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67452',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67454',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67455',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67456',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67457',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67458',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '67459',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67460',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67464',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67466',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '67467',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67468',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '67470',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67473',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67474',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67475',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67476',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67478',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67480',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67481',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67482',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67483',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67484',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67485',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67487',
    dma_code: '605',
    dma_description: 'TOPEKA',
  },
  {
    zip_code: '67490',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67491',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67492',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67501',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67502',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67504',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67505',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67510',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67511',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67512',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67513',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67514',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67515',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67516',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67518',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67519',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67520',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67521',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67522',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67523',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67524',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67525',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67526',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67529',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67530',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67543',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67544',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67545',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67546',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67547',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67548',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67550',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67552',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67553',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67554',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67556',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67557',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67559',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67560',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67561',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67563',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67564',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67565',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67566',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67567',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67568',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67570',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67572',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67573',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67574',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67575',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67576',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67578',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67579',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67581',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67583',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67584',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67585',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67601',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67621',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '67622',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67623',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67625',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67626',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67627',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67628',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '67629',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67631',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67632',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67634',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67635',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67637',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67638',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '67639',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '67640',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67642',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67643',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67644',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '67645',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67646',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '67647',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '67648',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67649',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67650',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67651',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67653',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67654',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67656',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67657',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67658',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67659',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67660',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67661',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '67663',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67664',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '67665',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67667',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67669',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67671',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67672',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67673',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67674',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67675',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67701',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67730',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67731',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67732',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67733',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67734',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67735',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67736',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67737',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67738',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67739',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67740',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67741',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67743',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67744',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67745',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67747',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67748',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67749',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67751',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67752',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67753',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67756',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67757',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67758',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67761',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67762',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67764',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67801',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67831',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67834',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67835',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67836',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67837',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67838',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67839',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67840',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67841',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67842',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67843',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67844',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67846',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67849',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67850',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67851',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67853',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67854',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67855',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67857',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67859',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67860',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67861',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67862',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67863',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67864',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67865',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67867',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67868',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67869',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67870',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67871',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67876',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67877',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67878',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67879',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67880',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67882',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67901',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67905',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67950',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67951',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67952',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67953',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '67954',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '68001',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68002',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68003',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68004',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68005',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68007',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68008',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68010',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68014',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68015',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68016',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68017',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68018',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68019',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68020',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68022',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68023',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68025',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68026',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68028',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68029',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68030',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68031',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68033',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68034',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68036',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68037',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68038',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68039',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68040',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68041',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68042',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68044',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68045',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68046',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68047',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68048',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68050',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68055',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68056',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68057',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68058',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68059',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68061',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68062',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68063',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68064',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68065',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68066',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68067',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68068',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68069',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68070',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68071',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68072',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68073',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68101',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68102',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68103',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68104',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68105',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68106',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68107',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68108',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68109',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68110',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68111',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68112',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68113',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68114',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68116',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68117',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68118',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68119',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68120',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68122',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68123',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68124',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68127',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68128',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68130',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68131',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68132',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68133',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68134',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68135',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68136',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68137',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68138',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68139',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68142',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68144',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68145',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68147',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68152',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68154',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68155',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68157',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68164',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68172',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68175',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68176',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68178',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68179',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68180',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68181',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68182',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68183',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68197',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68198',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68301',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68303',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68304',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68305',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68307',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68309',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68310',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68313',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68314',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68315',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68316',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68317',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68318',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68319',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68320',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68321',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68322',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68323',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68324',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68325',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68326',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68327',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68328',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68329',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68330',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68331',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68332',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68333',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68335',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68336',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68337',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68338',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68339',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68340',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68341',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68342',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68343',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68344',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68345',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68346',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68347',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68348',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68349',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68350',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68351',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68352',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68354',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68355',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68357',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68358',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68359',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68360',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68361',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68362',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68364',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68365',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68366',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68367',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68368',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68370',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68371',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68372',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68375',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68376',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68377',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68378',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68379',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68380',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68381',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68382',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68401',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68402',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68403',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68404',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68405',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68406',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68407',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68409',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68410',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68413',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68414',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68415',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68416',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68417',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68418',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68419',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68420',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68421',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68422',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68423',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68424',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68428',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68429',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68430',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68431',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68433',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68434',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68436',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68437',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68438',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68439',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68440',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68441',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68442',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68443',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68444',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68445',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68446',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68447',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68448',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68450',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68452',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68453',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68454',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68455',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68456',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68457',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68458',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68460',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68461',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68462',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68463',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68464',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68465',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68466',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68467',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68501',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68502',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68503',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68504',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68505',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68506',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68507',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68508',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68509',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68510',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68512',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68514',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68516',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68517',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68520',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68521',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68522',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68523',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68524',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68526',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68527',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68528',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68529',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68531',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68532',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68542',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68583',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68588',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68601',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68602',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68620',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68621',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68622',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68623',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68624',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68626',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68627',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68628',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68629',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68631',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68632',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68633',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68634',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68635',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68636',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68637',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68638',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68640',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68641',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68642',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68643',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68644',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68647',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68648',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68649',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68651',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68652',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68653',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68654',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68655',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68658',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68659',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68660',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68661',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68662',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68663',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68664',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68665',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68666',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68667',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68669',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68701',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68702',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68710',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68711',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68713',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68714',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68715',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68716',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68717',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68718',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68719',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68720',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68722',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68723',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68724',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68725',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68726',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68727',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68728',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68729',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68730',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68731',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68732',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68733',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68734',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68735',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68736',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68738',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68739',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68740',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68741',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68742',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68743',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68745',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68746',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68747',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68748',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68749',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68751',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68752',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68753',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68755',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68756',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68757',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68758',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68759',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68760',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68761',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68763',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68764',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68765',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68766',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68767',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68768',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68769',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68770',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68771',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68773',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68774',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68776',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68777',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68778',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68779',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68780',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68781',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68783',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68784',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68785',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68786',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68787',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68788',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68789',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68790',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68791',
    dma_code: '652',
    dma_description: 'OMAHA',
  },
  {
    zip_code: '68792',
    dma_code: '624',
    dma_description: 'SIOUX CITY',
  },
  {
    zip_code: '68801',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68802',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68803',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68810',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68812',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68813',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68814',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68815',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68816',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68817',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68818',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68820',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68821',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68822',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68823',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68824',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68825',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68826',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68827',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68828',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68831',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68832',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68833',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68834',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68835',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68836',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68837',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68838',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68840',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68841',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68842',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68843',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68844',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68845',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68846',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68847',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68848',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68849',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68850',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68852',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68853',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68854',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68855',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68856',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68858',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68859',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68860',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68861',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68862',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68863',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68864',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68865',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68866',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68869',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68870',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68871',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68872',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68873',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68874',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68875',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68876',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68878',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68879',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68881',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68882',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68883',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68901',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68902',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68920',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68922',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68923',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68924',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68925',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68926',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68927',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68928',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68929',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68930',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68932',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68933',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68934',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68935',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68936',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68937',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68938',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68939',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68940',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68941',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68942',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68943',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68944',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68945',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68946',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68947',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68948',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68949',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68950',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68952',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68954',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68955',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68956',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68957',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68958',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68959',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68960',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68961',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68964',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68966',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68967',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68969',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68970',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68971',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68972',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68973',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68974',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68975',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68976',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68977',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68978',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68979',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68980',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68981',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '68982',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69001',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69020',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69021',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '69022',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69023',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69024',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69025',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69026',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69027',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69028',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69029',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69030',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '69032',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69033',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69034',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69036',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69037',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '69038',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69039',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69040',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69041',
    dma_code: '678',
    dma_description: 'WICHITA - HUTCHINSON PLUS',
  },
  {
    zip_code: '69042',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69043',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69044',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69045',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69046',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69101',
    dma_code: '740',
    dma_description: 'NORTH PLATTE',
  },
  {
    zip_code: '69103',
    dma_code: '740',
    dma_description: 'NORTH PLATTE',
  },
  {
    zip_code: '69120',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69121',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69122',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69123',
    dma_code: '740',
    dma_description: 'NORTH PLATTE',
  },
  {
    zip_code: '69125',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '69127',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69128',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69129',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69130',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69131',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69132',
    dma_code: '740',
    dma_description: 'NORTH PLATTE',
  },
  {
    zip_code: '69133',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69134',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69135',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69138',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69140',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69141',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69142',
    dma_code: '740',
    dma_description: 'NORTH PLATTE',
  },
  {
    zip_code: '69143',
    dma_code: '740',
    dma_description: 'NORTH PLATTE',
  },
  {
    zip_code: '69144',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69145',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69146',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69147',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69148',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69149',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69150',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69151',
    dma_code: '740',
    dma_description: 'NORTH PLATTE',
  },
  {
    zip_code: '69152',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69153',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69154',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69155',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69156',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69157',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69160',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69161',
    dma_code: '740',
    dma_description: 'NORTH PLATTE',
  },
  {
    zip_code: '69162',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69163',
    dma_code: '740',
    dma_description: 'NORTH PLATTE',
  },
  {
    zip_code: '69165',
    dma_code: '740',
    dma_description: 'NORTH PLATTE',
  },
  {
    zip_code: '69166',
    dma_code: '740',
    dma_description: 'NORTH PLATTE',
  },
  {
    zip_code: '69167',
    dma_code: '740',
    dma_description: 'NORTH PLATTE',
  },
  {
    zip_code: '69168',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69169',
    dma_code: '740',
    dma_description: 'NORTH PLATTE',
  },
  {
    zip_code: '69170',
    dma_code: '740',
    dma_description: 'NORTH PLATTE',
  },
  {
    zip_code: '69171',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69190',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69201',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69210',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69211',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69212',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69214',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69216',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69217',
    dma_code: '722',
    dma_description: 'LINCOLN & HSTNGS - KRNY',
  },
  {
    zip_code: '69218',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69219',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69220',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69221',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69301',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69331',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '69333',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69334',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '69335',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69336',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '69337',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69339',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69340',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69341',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '69343',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69345',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69346',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '69347',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69348',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69350',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69351',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69352',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '69353',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '69354',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69355',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '69356',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '69357',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '69358',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '69360',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69361',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '69363',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '69365',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69366',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '69367',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '70001',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70002',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70003',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70004',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70005',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70006',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70009',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70010',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70011',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70030',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70031',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70032',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70033',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70036',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70037',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70038',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70039',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70040',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70041',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70043',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70044',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70047',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70049',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70050',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70051',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70052',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70053',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70054',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70055',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70056',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70057',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70058',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70059',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70060',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70062',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70063',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70064',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70065',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70067',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70068',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70069',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70070',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70071',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70072',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70073',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70075',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70076',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70078',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70079',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70080',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70081',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70082',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70083',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70084',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70085',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70086',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70087',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70090',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70091',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70092',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70093',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70094',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70096',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70112',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70113',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70114',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70115',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70116',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70117',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70118',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70119',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70121',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70122',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70123',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70124',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70125',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70126',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70127',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70128',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70129',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70130',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70131',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70139',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70140',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70141',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70142',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70143',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70146',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70148',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70150',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70151',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70152',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70153',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70154',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70156',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70157',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70158',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70159',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70160',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70161',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70162',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70163',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70164',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70165',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70166',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70167',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70170',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70172',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70174',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70175',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70176',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70177',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70178',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70179',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70181',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70182',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70183',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70184',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70185',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70186',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70187',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70189',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70190',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70195',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70301',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70302',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70310',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70339',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70340',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70341',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70342',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70343',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70344',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70345',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70346',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70352',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70353',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70354',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70355',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70356',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70357',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70358',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70359',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70360',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70361',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70363',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70364',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70371',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70372',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70373',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70374',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70375',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70377',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70380',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70381',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70390',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70391',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70392',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70393',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70394',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70395',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70397',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70401',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70402',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70403',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70404',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70420',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70421',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70422',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70426',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70427',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70429',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70431',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70433',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70434',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70435',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70436',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70437',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70438',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70441',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70442',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70443',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70444',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70445',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70446',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70447',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70448',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70449',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70450',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70451',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70452',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70453',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70454',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70455',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70456',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70457',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70458',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70459',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70460',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70461',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70462',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70463',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70464',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70465',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70466',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70467',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70469',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70470',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70471',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70501',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70502',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70503',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70504',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70505',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70506',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70507',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70508',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70509',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70510',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70511',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70512',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70513',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70514',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70515',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70516',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70517',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70518',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70519',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70520',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70521',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70522',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70523',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70524',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70525',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70526',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70527',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70528',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70529',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70531',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70532',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70533',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70534',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70535',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70537',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70538',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70540',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70541',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70542',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70543',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70544',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70546',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70548',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70549',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70550',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70551',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70552',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70554',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70555',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70556',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70558',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70559',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70560',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70562',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70563',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70569',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70570',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70571',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70575',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70576',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70577',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70578',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70580',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70581',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70582',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70583',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70584',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70585',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70586',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70589',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70591',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70592',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70593',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70595',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70596',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70598',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70601',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70602',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70605',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70606',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70607',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70609',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70611',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70612',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70615',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70616',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70629',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70630',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70631',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70632',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70633',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70634',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70637',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70638',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70639',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '70640',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70643',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70644',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70645',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70646',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70647',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70648',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70650',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70651',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70652',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70653',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70654',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70655',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70656',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '70657',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70658',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70659',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '70660',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70661',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70662',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70663',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70664',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70665',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70668',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70669',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '70704',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70706',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70707',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70710',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70711',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70712',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70714',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70715',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70718',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70719',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70721',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70722',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70723',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70725',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70726',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70727',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70728',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70729',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70730',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70732',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70733',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70734',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70736',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70737',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70738',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70739',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70740',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70743',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70744',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70747',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70748',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70749',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70750',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '70752',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70753',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70754',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70755',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70756',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70757',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70759',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70760',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70761',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70762',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70763',
    dma_code: '622',
    dma_description: 'NEW ORLEANS',
  },
  {
    zip_code: '70764',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70765',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70767',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70769',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70770',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70772',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70773',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70774',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70775',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70776',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70777',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70778',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70780',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70782',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70783',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70784',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70785',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70786',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70787',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70788',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70789',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70791',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70801',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70802',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70803',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70804',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70805',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70806',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70807',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70808',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70809',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70810',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70811',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70812',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70813',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70814',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70815',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70816',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70817',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70818',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70819',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70820',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70821',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70822',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70823',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70825',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70826',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70827',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70831',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70833',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70835',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70836',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70837',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70874',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70879',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70883',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70884',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70891',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70892',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70893',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70894',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70895',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70896',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '70898',
    dma_code: '716',
    dma_description: 'BATON ROUGE',
  },
  {
    zip_code: '71001',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71002',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71003',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71004',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71006',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71007',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71008',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71009',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71016',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71018',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71019',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71021',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71023',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71024',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71027',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71028',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71029',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71030',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71031',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71032',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71033',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71034',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71037',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71038',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71039',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71040',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71043',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71044',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71045',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71046',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71047',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71048',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71049',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71050',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71051',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71052',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71055',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71058',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71060',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71061',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71063',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71064',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71065',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71066',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71067',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71068',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71069',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71070',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71071',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71072',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71073',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71075',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71078',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71079',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71080',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71082',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71101',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71102',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71103',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71104',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71105',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71106',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71107',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71108',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71109',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71110',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71111',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71112',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71113',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71115',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71118',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71119',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71120',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71129',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71130',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71133',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71134',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71135',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71136',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71137',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71138',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71148',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71149',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71151',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71152',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71153',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71156',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71161',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71162',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71163',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71164',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71165',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71166',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71171',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71172',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71201',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71202',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71203',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71207',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71208',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71209',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71210',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71211',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71212',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71213',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71217',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71218',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71219',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71220',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71221',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71222',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71223',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71225',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71226',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71227',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71229',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71230',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71232',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71233',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71234',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71235',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71237',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71238',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71240',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71241',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71242',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71243',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71245',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71247',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71249',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71250',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71251',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71253',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71254',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71256',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71259',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71260',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71261',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71263',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71264',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71266',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71268',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71269',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71270',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71272',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71273',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71275',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71276',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71277',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71279',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71280',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71281',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71282',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71284',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71286',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71291',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71292',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71294',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71295',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71301',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71302',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71303',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71306',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71307',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71309',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71315',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71316',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71320',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71322',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71323',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71324',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71325',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71326',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71327',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71328',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71329',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71330',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71331',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71333',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71334',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71336',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71339',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71340',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71341',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71342',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71343',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71345',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '71346',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71348',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71350',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71351',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71353',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '71354',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71355',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71356',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '71357',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71358',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '71359',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71360',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71361',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71362',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71363',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71365',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71366',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71367',
    dma_code: '642',
    dma_description: 'LAFAYETTE, LA',
  },
  {
    zip_code: '71368',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71369',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71371',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71373',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71375',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71377',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71378',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71401',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71403',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71404',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71405',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71406',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71407',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71409',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71410',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71411',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71414',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71415',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71416',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71417',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71418',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71419',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71422',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71423',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71424',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71425',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71426',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71427',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71428',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71429',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71430',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71431',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71432',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71433',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71434',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71435',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71438',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71439',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71440',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71441',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71443',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71446',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71447',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71448',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71449',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71450',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71452',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71454',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71455',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71456',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71457',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71458',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71459',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71460',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71461',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71462',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71463',
    dma_code: '643',
    dma_description: 'LAKE CHARLES',
  },
  {
    zip_code: '71465',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71466',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71467',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71468',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71469',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71471',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71472',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71473',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71474',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71475',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71477',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71479',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71480',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71483',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71485',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71486',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71496',
    dma_code: '644',
    dma_description: 'ALEXANDRIA, LA',
  },
  {
    zip_code: '71497',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71601',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71602',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71603',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71611',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71612',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71613',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71630',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71631',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71635',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71638',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '71639',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71640',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '71642',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71643',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71644',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71646',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71647',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71651',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71652',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71653',
    dma_code: '647',
    dma_description: 'GREENWOOD - GREENVILLE',
  },
  {
    zip_code: '71654',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71655',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71656',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71657',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71658',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71659',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71660',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71661',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71662',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71663',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71665',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71666',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71667',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71670',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71671',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71674',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71675',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71676',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71677',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71678',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71701',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71711',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71720',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71721',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71722',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71724',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71725',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71726',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71728',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71730',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71731',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71740',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71742',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71743',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71744',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71745',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71747',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71748',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71749',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71750',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71751',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71752',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71753',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71754',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71758',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71759',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71762',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71763',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71764',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71765',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71766',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71768',
    dma_code: '628',
    dma_description: 'MONROE - EL DORADO',
  },
  {
    zip_code: '71770',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71772',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71801',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71802',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71820',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71822',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71823',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71825',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71826',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71827',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71828',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71831',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71832',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71833',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71834',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71835',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71836',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71837',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71838',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71839',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71840',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71841',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71842',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71844',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71845',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71846',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71847',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71851',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71852',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71853',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71854',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71855',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71857',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71858',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71859',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71860',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71861',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71862',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71864',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71865',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71866',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71901',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71902',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71903',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71909',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71910',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71913',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71914',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71920',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71921',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71922',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71923',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71929',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71932',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71933',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71935',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71937',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71940',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71941',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71942',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71943',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71944',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71945',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71949',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71950',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71951',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71952',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71953',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71956',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71957',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71958',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71959',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71960',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71961',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71962',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71964',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71965',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71966',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71968',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71969',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71970',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71971',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '71972',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71973',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71998',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '71999',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72001',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72002',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72003',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72004',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72005',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72006',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72007',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72010',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72011',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72012',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72013',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72014',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72015',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72016',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72017',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72018',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72019',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72020',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72021',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72022',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72023',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72024',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72025',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72026',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72027',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72028',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72029',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72030',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72031',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72032',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72033',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72034',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72035',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72036',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72037',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72038',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72039',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72040',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72041',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72042',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72043',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72044',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72045',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72046',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72047',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72048',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72051',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72052',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72053',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72055',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72057',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72058',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72059',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72060',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72061',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72063',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72064',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72065',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72066',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72067',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72068',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72069',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72070',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72072',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72073',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72074',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72075',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72076',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72078',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72079',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72080',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72081',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72082',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72083',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72084',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72085',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72086',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72087',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72088',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72089',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72099',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72101',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72102',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72103',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72104',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72105',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72106',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72107',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72108',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72110',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72111',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72112',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72113',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72114',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72115',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72116',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72117',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72118',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72119',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72120',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72121',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72122',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72123',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72124',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72125',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72126',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72127',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72128',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72129',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72130',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72131',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72132',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72133',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72134',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72135',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72136',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72137',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72139',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72140',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72141',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72142',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72143',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72145',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72149',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72150',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72152',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72153',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72156',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72157',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72160',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72164',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72165',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72166',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72167',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72168',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72169',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72170',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72173',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72175',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72176',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72178',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72179',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72180',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72181',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72182',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72183',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72189',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72190',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72198',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72199',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72201',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72202',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72203',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72204',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72205',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72206',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72207',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72209',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72210',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72211',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72212',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72214',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72215',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72216',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72217',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72219',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72221',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72222',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72223',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72225',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72227',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72231',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72260',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72295',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72301',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72303',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72310',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72311',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72312',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72313',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72315',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72316',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72319',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72320',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72321',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72322',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72324',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72325',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72326',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72327',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72328',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72329',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72330',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72331',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72332',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72333',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72335',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72336',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72338',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72339',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72340',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72341',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72342',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72346',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72347',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72348',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72350',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72351',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72352',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72353',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72354',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72355',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72358',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72359',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72360',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72364',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72365',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72366',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72367',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72368',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72369',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72370',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72372',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72373',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72374',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72376',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72377',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72379',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72383',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72384',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72386',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72387',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72389',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72390',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72391',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72392',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72394',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72395',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72396',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72401',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72402',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72403',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72404',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72410',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72411',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72412',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72413',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72414',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72415',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72416',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72417',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72419',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72421',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72422',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72424',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72425',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72426',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72427',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72428',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72429',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72430',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72431',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72432',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72433',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72434',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72435',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72436',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72437',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72438',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72439',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72440',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72441',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72442',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72443',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72444',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72445',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72447',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72449',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72450',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72451',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72453',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72454',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72455',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72456',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72457',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72458',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72459',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72460',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72461',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72462',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72464',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72465',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72466',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72467',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72469',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72470',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72471',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72472',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72473',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72474',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72475',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72476',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72478',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72479',
    dma_code: '640',
    dma_description: 'MEMPHIS',
  },
  {
    zip_code: '72482',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72501',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72503',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72512',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72513',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72515',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72517',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72519',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72520',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72521',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72522',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72523',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72524',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72525',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72526',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72527',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72528',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72529',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72530',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72531',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72532',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72533',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72534',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72536',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72537',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72538',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72539',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72540',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72542',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72543',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72544',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72545',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72546',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72550',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72553',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72554',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72555',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72556',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72560',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72561',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72562',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72564',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72565',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72566',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72567',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72568',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72569',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72571',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72572',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72573',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72575',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72576',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72577',
    dma_code: '734',
    dma_description: 'JONESBORO',
  },
  {
    zip_code: '72578',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72579',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72581',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72583',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72584',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72585',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72587',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72601',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72602',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72611',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72613',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72615',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72616',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72617',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72619',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72623',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72624',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72626',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72628',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72629',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72630',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72631',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72632',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72633',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72634',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72635',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72636',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72638',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72639',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72640',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72641',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72642',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72644',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72645',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72648',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72650',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72651',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72653',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72654',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72655',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72657',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72658',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72659',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72660',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72661',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72662',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72663',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72666',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72668',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72669',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72670',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72672',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72675',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72677',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72679',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72680',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72682',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72683',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72685',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72686',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72687',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72701',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72702',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72703',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72704',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72711',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72712',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72714',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72715',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72716',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72717',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72718',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72719',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72721',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72722',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72727',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72728',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72729',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72730',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72732',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72733',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72734',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72735',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72736',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72737',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72738',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72739',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72740',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72741',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72742',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72744',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72745',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72747',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72749',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72751',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72752',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72753',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72756',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72757',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72758',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72760',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72761',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72762',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72764',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72765',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72766',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72768',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72769',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72770',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72773',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72774',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72776',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72801',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72802',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72811',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72812',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72820',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72821',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72823',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72824',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72826',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72827',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72828',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72829',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72830',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72832',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72833',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72834',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72835',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72837',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72838',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72839',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72840',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72841',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72842',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72843',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72845',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72846',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72847',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72851',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72852',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72853',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72854',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72855',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72856',
    dma_code: '619',
    dma_description: 'SPRINGFIELD, MO',
  },
  {
    zip_code: '72857',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72858',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72860',
    dma_code: '693',
    dma_description: 'LITTLE ROCK - PINE BLUFF',
  },
  {
    zip_code: '72863',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72865',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72901',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72902',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72903',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72904',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72905',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72906',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72908',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72913',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72914',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72916',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72917',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72918',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72919',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72921',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72923',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72926',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72927',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72928',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72930',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72932',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72933',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72934',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72935',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72936',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72937',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72938',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72940',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72941',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72943',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72944',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72945',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72946',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72947',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72948',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72949',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72950',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72951',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72952',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72955',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72956',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72957',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72958',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '72959',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '73001',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73002',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73003',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73004',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73005',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73006',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73007',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73008',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73009',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73010',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73011',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73012',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73013',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73014',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73015',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73016',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73017',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73018',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73019',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73020',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73021',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73022',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73023',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73024',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73025',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73026',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73027',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73028',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73029',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73030',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73031',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73032',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73033',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73034',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73036',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73038',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73040',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73041',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73042',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73043',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73044',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73045',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73047',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73048',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73049',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73050',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73051',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73052',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73053',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73054',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73055',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73056',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73057',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73058',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73059',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73061',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73062',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73063',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73064',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73065',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73066',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73067',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73068',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73069',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73070',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73071',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73072',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73073',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73074',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73075',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73077',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73078',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73079',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73080',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73082',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73083',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73084',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73085',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73086',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73089',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73090',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73092',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73093',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73094',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73095',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73096',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73097',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73098',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73099',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73101',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73102',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73103',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73104',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73105',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73106',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73107',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73108',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73109',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73110',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73111',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73112',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73113',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73114',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73115',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73116',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73117',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73118',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73119',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73120',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73121',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73122',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73123',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73124',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73125',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73126',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73127',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73128',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73129',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73130',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73131',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73132',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73134',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73135',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73136',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73137',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73139',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73140',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73141',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73142',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73143',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73144',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73145',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73146',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73147',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73148',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73149',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73150',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73151',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73152',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73153',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73154',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73155',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73156',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73157',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73159',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73160',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73162',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73165',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73169',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73170',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73172',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73173',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73178',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73179',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73184',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73185',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73189',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73190',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73193',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73194',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73195',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73196',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73197',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73198',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73199',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73301',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '73344',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '73401',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73402',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73403',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73425',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73430',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73432',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73433',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73434',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73435',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73436',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73437',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73438',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73439',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73440',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73441',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73442',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73443',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73444',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73446',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73447',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73448',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73449',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73450',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73453',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73455',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73456',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73458',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73459',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73460',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73461',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73463',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73481',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73487',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73488',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '73491',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73501',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73502',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73503',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73505',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73506',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73507',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73520',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73521',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73522',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73523',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73526',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73527',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73528',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73529',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73530',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73531',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73532',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73533',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73534',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73536',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73537',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73538',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73539',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73540',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73541',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73542',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73543',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73544',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73546',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73547',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73548',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73549',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73550',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73551',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73552',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73553',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73554',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73555',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73556',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73557',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73558',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73559',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73560',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73561',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73562',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73564',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73565',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73566',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73567',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73568',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73569',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73570',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73571',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73572',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73573',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '73601',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73620',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73622',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73624',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73625',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73626',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73627',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73628',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73632',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73638',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73639',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73641',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73642',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73644',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73645',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73646',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73647',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73648',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73650',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73651',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73654',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73655',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73658',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73659',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73660',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73661',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73662',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73663',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73664',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73666',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73667',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73668',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73669',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73673',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73701',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73702',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73703',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73705',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73706',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73716',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73717',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73718',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73719',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73720',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73722',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73724',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73726',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73727',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73728',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73729',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73730',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73731',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73733',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73734',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73735',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73736',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73737',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73738',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73739',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73741',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73742',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73743',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73744',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73746',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73747',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73749',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73750',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73753',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73754',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73755',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73756',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73757',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73758',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73759',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73760',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73761',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73762',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73763',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73764',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73766',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73768',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73770',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73771',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73772',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73773',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73801',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73802',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73832',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73834',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73835',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73838',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73840',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73841',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73842',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73843',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73844',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73848',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73851',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73852',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73853',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73855',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73857',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73858',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73859',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73860',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '73901',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73931',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73932',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73933',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73937',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73938',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73939',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73942',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73944',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73945',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73946',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73947',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73949',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73950',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '73951',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '74001',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74002',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74003',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74004',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74005',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74006',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74008',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74010',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74011',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74012',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74013',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74014',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74015',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74016',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74017',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74018',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74019',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74020',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74021',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74022',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74023',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74026',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74027',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74028',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74029',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74030',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74031',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74032',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74033',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74034',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74035',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74036',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74037',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74038',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74039',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74041',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74042',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74043',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74044',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74045',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74046',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74047',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74048',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74050',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74051',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74052',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74053',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74054',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74055',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74056',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74058',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74059',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74060',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74061',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74062',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74063',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74066',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74067',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74068',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74070',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74071',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74072',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74073',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74074',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74075',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74076',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74077',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74078',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74079',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74080',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74081',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74082',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74083',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74084',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74085',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74101',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74102',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74103',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74104',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74105',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74106',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74107',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74108',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74110',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74112',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74114',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74115',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74116',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74117',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74119',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74120',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74121',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74126',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74127',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74128',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74129',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74130',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74131',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74132',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74133',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74134',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74135',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74136',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74137',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74141',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74145',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74146',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74147',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74148',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74149',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74150',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74152',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74153',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74155',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74156',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74157',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74158',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74159',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74169',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74170',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74171',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74172',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74182',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74183',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74184',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74186',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74187',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74189',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74192',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74193',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74194',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74301',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74330',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74331',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '74332',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74333',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '74335',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '74337',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74338',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74339',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '74340',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74342',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74343',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '74344',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74345',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74346',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74347',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74349',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74350',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74352',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74354',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '74355',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '74358',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '74359',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74360',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '74361',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74362',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74363',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '74364',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74365',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74366',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74367',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74368',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74369',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74370',
    dma_code: '603',
    dma_description: 'JOPLIN - PITTSBURG',
  },
  {
    zip_code: '74401',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74402',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74403',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74421',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74422',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74423',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74425',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74426',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74427',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74428',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74429',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74430',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74431',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74432',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74434',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74435',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74436',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74437',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74438',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74441',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74442',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74444',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74445',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74446',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74447',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74450',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74451',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74452',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74454',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74455',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74456',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74457',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74458',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74459',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74460',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74461',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74462',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74463',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74464',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74465',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74467',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74468',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74469',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74470',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74471',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74472',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74477',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74501',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74502',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74521',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74522',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74523',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74525',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74528',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74529',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74530',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74531',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74533',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74534',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74535',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74536',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74538',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74540',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74542',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74543',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74545',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74546',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74547',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74549',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74552',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74553',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74554',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74555',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74556',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74557',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74558',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74559',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74560',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74561',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74562',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74563',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74565',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74567',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74569',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74570',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74571',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74572',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74574',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74576',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74577',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74578',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74601',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74602',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74604',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74630',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74631',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74632',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74633',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74636',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74637',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74640',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74641',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74643',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74644',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74646',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74647',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74650',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74651',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74652',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74653',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74701',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74702',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74720',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74721',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74722',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74723',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74724',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74726',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74727',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74728',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74729',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74730',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74731',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74733',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74734',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74735',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74736',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74737',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74738',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74740',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74741',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74743',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74745',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74747',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74748',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74750',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74752',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74753',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74754',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74755',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74756',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74759',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74760',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74761',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74764',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74766',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74801',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74802',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74804',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74818',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74820',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74821',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74824',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74825',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74826',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74827',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74829',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74830',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74831',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74832',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74833',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74834',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74836',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74837',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74839',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74840',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74842',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74843',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74844',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74845',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74848',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74849',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74850',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74851',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74852',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74854',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74855',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74856',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74857',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74859',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74860',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74864',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74865',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74866',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74867',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74868',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74869',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74871',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '74872',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74873',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74875',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74878',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74880',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74881',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74883',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74884',
    dma_code: '650',
    dma_description: 'OKLAHOMA CITY',
  },
  {
    zip_code: '74901',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74902',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74930',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74931',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74932',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74935',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74936',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74937',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74939',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74940',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74941',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74942',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74943',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74944',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74945',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74946',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74947',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74948',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74949',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74951',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74953',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74954',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74955',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74956',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74957',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74959',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74960',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74962',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '74963',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '74964',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74965',
    dma_code: '671',
    dma_description: 'TULSA',
  },
  {
    zip_code: '74966',
    dma_code: '670',
    dma_description: 'FT. SMITH - FAY - SPRNGDL - RGRS',
  },
  {
    zip_code: '75001',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75002',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75006',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75007',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75009',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75010',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75011',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75013',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75014',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75015',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75016',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75017',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75019',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75020',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '75021',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '75022',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75023',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75024',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75025',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75026',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75027',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75028',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75029',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75030',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75032',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75034',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75035',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75037',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75038',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75039',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75040',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75041',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75042',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75043',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75044',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75045',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75046',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75047',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75048',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75049',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75050',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75051',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75052',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75053',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75054',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75056',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75057',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75058',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '75060',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75061',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75062',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75063',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75065',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75067',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75068',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75069',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75070',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75071',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75074',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75075',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75076',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '75077',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75078',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75080',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75081',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75082',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75083',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75085',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75086',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75087',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75088',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75089',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75090',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '75091',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '75092',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '75093',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75094',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75097',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75098',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75099',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75101',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75102',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75103',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75104',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75105',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75106',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75109',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75110',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75114',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75115',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75116',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75117',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75118',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75119',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75120',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75121',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75123',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75124',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75125',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75126',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75127',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75132',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75134',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75135',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75137',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75138',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75140',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75141',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75142',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75143',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75144',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75146',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75147',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75148',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75149',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75150',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75151',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75152',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75153',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75154',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75155',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75156',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75157',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75158',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75159',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75160',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75161',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75163',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75164',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75165',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75166',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75167',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75168',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75169',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75172',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75173',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75180',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75181',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75182',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75185',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75187',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75189',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75201',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75202',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75203',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75204',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75205',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75206',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75207',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75208',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75209',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75210',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75211',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75212',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75214',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75215',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75216',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75217',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75218',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75219',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75220',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75221',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75222',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75223',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75224',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75225',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75226',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75227',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75228',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75229',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75230',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75231',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75232',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75233',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75234',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75235',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75236',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75237',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75238',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75240',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75241',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75242',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75243',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75244',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75245',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75246',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75247',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75248',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75249',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75250',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75251',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75252',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75253',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75254',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75258',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75260',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75261',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75262',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75265',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75266',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75267',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75270',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75275',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75277',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75283',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75284',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75285',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75286',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75287',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75301',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75303',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75310',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75312',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75313',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75315',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75320',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75323',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75326',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75334',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75336',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75339',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75340',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75342',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75343',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75353',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75354',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75355',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75356',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75357',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75358',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75359',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75360',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75363',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75364',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75367',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75368',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75370',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75371',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75372',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75373',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75374',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75376',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75378',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75379',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75380',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75381',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75382',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75387',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75388',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75389',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75390',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75391',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75392',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75393',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75394',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75395',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75396',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75397',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75401',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75402',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75403',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75404',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75407',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75409',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75410',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75411',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75412',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75413',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75414',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '75415',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75416',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75417',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75418',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75420',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75421',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75422',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75423',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75424',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75425',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75426',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75428',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75429',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75431',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75432',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75433',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75434',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75435',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75436',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75437',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75438',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75439',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75440',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75441',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75442',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75443',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75444',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75446',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75447',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75448',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75449',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75450',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75451',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75452',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75453',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75454',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75455',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75456',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75457',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75458',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75459',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '75460',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75461',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75462',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75468',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75469',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75470',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75471',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75472',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75473',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75474',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75475',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75476',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75477',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75478',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75479',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75480',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75481',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75482',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75483',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75485',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75486',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75487',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75488',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75489',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '75490',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75491',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '75492',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75493',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75494',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75495',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '75496',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75497',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75501',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75503',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75504',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75505',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75507',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75550',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75551',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75554',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75555',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75556',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75558',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75559',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75560',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75561',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75562',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75563',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75564',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75565',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75566',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75567',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75568',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75569',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75570',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75571',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75572',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75573',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75574',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75599',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75601',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75602',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75603',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75604',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75605',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75606',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75607',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75608',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75615',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75630',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75631',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75633',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75636',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75637',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75638',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75639',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75640',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75641',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75642',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75643',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75644',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75645',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75647',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75650',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75651',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75652',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75653',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75654',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75656',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75657',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75658',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75659',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75660',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75661',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75662',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75663',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75666',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75667',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75668',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75669',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75670',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75671',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75672',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75680',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75681',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75682',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75683',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75684',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75685',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75686',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75687',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75688',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75689',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75691',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75692',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75693',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75694',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75701',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75702',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75703',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75704',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75705',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75706',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75707',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75708',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75709',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75710',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75711',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75712',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75713',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75750',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75751',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75752',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75754',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75755',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75756',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75757',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75758',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75759',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75760',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75762',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75763',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75764',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75765',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75766',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75770',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75771',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75772',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75773',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75778',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75779',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75780',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75782',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75783',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75784',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75785',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75788',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75789',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75790',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75791',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75792',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75797',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75798',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75799',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75801',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75802',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75803',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75831',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '75832',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75833',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '75834',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '75835',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75838',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75839',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75840',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75844',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75845',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '75846',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '75847',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75848',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75849',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75850',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '75851',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75852',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '75853',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75855',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '75856',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '75858',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75859',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75860',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75861',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75862',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '75865',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '75880',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75882',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75884',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75886',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '75901',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75902',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75903',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75904',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75915',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75925',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75926',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '75928',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '75929',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75930',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75931',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '75932',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '75933',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '75934',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '75935',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75936',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '75937',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75938',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '75939',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '75941',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75942',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '75943',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75944',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75946',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75948',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75949',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75951',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '75954',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75956',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '75958',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75959',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75960',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '75961',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75962',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75963',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75964',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75965',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75966',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '75968',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75969',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75972',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75973',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75974',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75975',
    dma_code: '612',
    dma_description: 'SHREVEPORT',
  },
  {
    zip_code: '75976',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75977',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '75978',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75979',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '75980',
    dma_code: '709',
    dma_description: 'TYLER - LONGVIEW (LFKN & NCGD)',
  },
  {
    zip_code: '75990',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '76001',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76002',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76003',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76004',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76005',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76006',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76007',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76008',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76009',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76010',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76011',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76012',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76013',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76014',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76015',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76016',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76017',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76018',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76019',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76020',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76021',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76022',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76023',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76028',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76031',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76033',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76034',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76035',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76036',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76039',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76040',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76041',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76043',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76044',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76048',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76049',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76050',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76051',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76052',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76053',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76054',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76055',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76058',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76059',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76060',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76061',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76063',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76064',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76065',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76066',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76067',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76068',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76070',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76071',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76073',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76077',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76078',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76082',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76084',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76085',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76086',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76087',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76088',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76092',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76093',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76094',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76095',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76096',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76097',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76098',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76099',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76101',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76102',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76103',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76104',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76105',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76106',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76107',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76108',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76109',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76110',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76111',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76112',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76113',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76114',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76115',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76116',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76117',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76118',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76119',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76120',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76121',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76122',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76123',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76124',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76126',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76127',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76129',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76130',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76131',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76132',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76133',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76134',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76135',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76136',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76137',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76140',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76147',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76148',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76150',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76155',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76161',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76162',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76163',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76164',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76166',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76177',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76179',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76180',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76181',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76182',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76185',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76191',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76192',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76193',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76195',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76196',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76197',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76198',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76199',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76201',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76202',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76203',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76204',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76205',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76206',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76207',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76208',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76209',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76210',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76225',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76226',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76227',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76228',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76230',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76233',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '76234',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76238',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76239',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76240',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76241',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76244',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76245',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '76246',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76247',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76248',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76249',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76250',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76251',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76252',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76253',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76255',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76258',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76259',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76261',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76262',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76263',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76264',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '76265',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76266',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76267',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76268',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '76270',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76271',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '76272',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76273',
    dma_code: '657',
    dma_description: 'SHERMAN - ADA',
  },
  {
    zip_code: '76299',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76301',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76302',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76305',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76306',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76307',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76308',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76309',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76310',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76311',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76351',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76352',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76354',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76357',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76360',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76363',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76364',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76365',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76366',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76367',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76369',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76370',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76371',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76372',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76373',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76374',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76377',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76379',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76380',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76384',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76385',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76388',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76389',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76401',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76402',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76424',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76426',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76427',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76429',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76430',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76431',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76432',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76433',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76435',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76436',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76437',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76439',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76442',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76443',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76444',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76445',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76446',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76448',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76449',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76450',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76452',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76453',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76454',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76455',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76457',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76458',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76459',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76460',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76461',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76462',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76463',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76464',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76465',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76466',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76467',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76468',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76469',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76470',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76471',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76472',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76474',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76475',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76476',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76481',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '76483',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76484',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76485',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76486',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76487',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76490',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76491',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76501',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76502',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76503',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76504',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76505',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76508',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76511',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76513',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76518',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76519',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76520',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76522',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76523',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76524',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76525',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76526',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76527',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '76528',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76530',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '76531',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76533',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76534',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76537',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '76538',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76539',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76540',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76541',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76542',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76543',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76544',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76545',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76546',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76547',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76548',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76549',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76550',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76554',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76556',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76557',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76558',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76559',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76561',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76564',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76565',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76566',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76567',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76569',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76570',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76571',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76573',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '76574',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '76577',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76578',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '76579',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76596',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76597',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76598',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76599',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76621',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76622',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76623',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76624',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76626',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76627',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76628',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76629',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76630',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76631',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76632',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76633',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76634',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76635',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76636',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76637',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76638',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76639',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76640',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76641',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76642',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76643',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76644',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76645',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76648',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76649',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76650',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76651',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76652',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76653',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76654',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76655',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76656',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76657',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76660',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76661',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76664',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76665',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76666',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76667',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76670',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76671',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76673',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76676',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76678',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76679',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76680',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76681',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76682',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76684',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76685',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76686',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76687',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76689',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76690',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76691',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76692',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76693',
    dma_code: '623',
    dma_description: 'DALLAS - FT. WORTH',
  },
  {
    zip_code: '76701',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76702',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76703',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76704',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76705',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76706',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76707',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76708',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76710',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76711',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76712',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76714',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76715',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76716',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76795',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76797',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76798',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76799',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76801',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76802',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76803',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76804',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76820',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '76821',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76823',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76824',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76825',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76827',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76828',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76831',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '76832',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76834',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76836',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76837',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76841',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76842',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '76844',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76845',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76848',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76849',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76852',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76853',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76854',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76855',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76856',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '76857',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76858',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76859',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76861',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76862',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76864',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76865',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76866',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76869',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '76870',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76871',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76872',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76873',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76874',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76875',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76877',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76878',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76880',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '76882',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76883',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '76884',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76885',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '76886',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76887',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76888',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76890',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '76901',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76902',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76903',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76904',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76905',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76906',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76908',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76909',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76930',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76932',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '76933',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76934',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76935',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76936',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76937',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76939',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76940',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76941',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76943',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76945',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76949',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76950',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76951',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76953',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76955',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76957',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '76958',
    dma_code: '661',
    dma_description: 'SAN ANGELO',
  },
  {
    zip_code: '77001',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77002',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77003',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77004',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77005',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77006',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77007',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77008',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77009',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77010',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77011',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77012',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77013',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77014',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77015',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77016',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77017',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77018',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77019',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77020',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77021',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77022',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77023',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77024',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77025',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77026',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77027',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77028',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77029',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77030',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77031',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77032',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77033',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77034',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77035',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77036',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77037',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77038',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77039',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77040',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77041',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77042',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77043',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77044',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77045',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77046',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77047',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77048',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77049',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77050',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77051',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77052',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77053',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77054',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77055',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77056',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77057',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77058',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77059',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77060',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77061',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77062',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77063',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77064',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77065',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77066',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77067',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77068',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77069',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77070',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77071',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77072',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77073',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77074',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77075',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77076',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77077',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77078',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77079',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77080',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77081',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77082',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77083',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77084',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77085',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77086',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77087',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77088',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77089',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77090',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77091',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77092',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77093',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77094',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77095',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77096',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77098',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77099',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77201',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77204',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77205',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77206',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77207',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77208',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77209',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77210',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77212',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77213',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77215',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77217',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77218',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77219',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77220',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77221',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77222',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77223',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77224',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77225',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77226',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77227',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77228',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77229',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77230',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77231',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77233',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77234',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77235',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77236',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77237',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77238',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77240',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77241',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77242',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77243',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77244',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77245',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77248',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77249',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77251',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77252',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77253',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77254',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77255',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77256',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77257',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77258',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77259',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77260',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77261',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77262',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77263',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77265',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77266',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77267',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77268',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77269',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77270',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77271',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77272',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77273',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77274',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77275',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77277',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77279',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77280',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77282',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77284',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77287',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77288',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77289',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77290',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77291',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77292',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77293',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77297',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77298',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77299',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77301',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77302',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77303',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77304',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77305',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77306',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77315',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77316',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77318',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77320',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77325',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77326',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77327',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77328',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77331',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77332',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77333',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77334',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77335',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77336',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77337',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77338',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77339',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77340',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77341',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77342',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77343',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77344',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77345',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77346',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77347',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77348',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77349',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77350',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77351',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77353',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77354',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77355',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77356',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77357',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77358',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77359',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77360',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77362',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77363',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77364',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77365',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77367',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77368',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77369',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77371',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77372',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77373',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77374',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77375',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77376',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77377',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77378',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77379',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77380',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77381',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77382',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77383',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77384',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77385',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77386',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77387',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77388',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77389',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77391',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77393',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77396',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77399',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77401',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77402',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77404',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77406',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77407',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77410',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77411',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77412',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77413',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77414',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77415',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77417',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77418',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77419',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77420',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77422',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77423',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77426',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77428',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77429',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77430',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77431',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77432',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77433',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77434',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77435',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77436',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77437',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77440',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77441',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77442',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77443',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77442',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77443',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77444',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77445',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77446',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77447',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77448',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77449',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77450',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77451',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77452',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77453',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77454',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77455',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77456',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77457',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77458',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77459',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77460',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77461',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77463',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77464',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77465',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77466',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77467',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77468',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77469',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77470',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77471',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77473',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77474',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77475',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77476',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77477',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77478',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77479',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77480',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77481',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77482',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77483',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77484',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77485',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77486',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77487',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77488',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77489',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77491',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77492',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77493',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77494',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77496',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77497',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77498',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77501',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77502',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77503',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77504',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77505',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77506',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77507',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77508',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77510',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77511',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77512',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77514',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77515',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77516',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77517',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77518',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77519',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77520',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77521',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77522',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77523',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77530',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77531',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77532',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77533',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77534',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77535',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77536',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77538',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77539',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77541',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77542',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77545',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77546',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77547',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77549',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77550',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77551',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77552',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77553',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77554',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77555',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77560',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77561',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77562',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77563',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77564',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77565',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77566',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77568',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77571',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77572',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77573',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77574',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77575',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77577',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77578',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77580',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77581',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77582',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77583',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77584',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77585',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77586',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77587',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77588',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77590',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77591',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77592',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77597',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77598',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77611',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77612',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77613',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77614',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77615',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77616',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77617',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77619',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77622',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77623',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77624',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77625',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77626',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77627',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77629',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77630',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77631',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77632',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77639',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77640',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77641',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77642',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77643',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77650',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77651',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77655',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77656',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77657',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77659',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77660',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77661',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77662',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77663',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77664',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77665',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77670',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77701',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77702',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77703',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77704',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77705',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77706',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77707',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77708',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77709',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77710',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77713',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77720',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77725',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77726',
    dma_code: '692',
    dma_description: 'BEAUMONT - PORT ARTHUR',
  },
  {
    zip_code: '77801',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77802',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77803',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77805',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77806',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77807',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77808',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77830',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77831',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77833',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77834',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77835',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77836',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77837',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77838',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77840',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77841',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77842',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77843',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77844',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77845',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77850',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77852',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77853',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '77855',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77856',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77857',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77859',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77861',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77862',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77863',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77864',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77865',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77866',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77867',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77868',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77869',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77870',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77871',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77872',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77873',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77875',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77876',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77878',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77879',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77880',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77881',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77882',
    dma_code: '625',
    dma_description: 'WACO - TEMPLE - BRYAN',
  },
  {
    zip_code: '77901',
    dma_code: '626',
    dma_description: 'VICTORIA',
  },
  {
    zip_code: '77902',
    dma_code: '626',
    dma_description: 'VICTORIA',
  },
  {
    zip_code: '77903',
    dma_code: '626',
    dma_description: 'VICTORIA',
  },
  {
    zip_code: '77904',
    dma_code: '626',
    dma_description: 'VICTORIA',
  },
  {
    zip_code: '77905',
    dma_code: '626',
    dma_description: 'VICTORIA',
  },
  {
    zip_code: '77950',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '77951',
    dma_code: '626',
    dma_description: 'VICTORIA',
  },
  {
    zip_code: '77954',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '77957',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77960',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '77961',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77962',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77963',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '77964',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '77967',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '77968',
    dma_code: '626',
    dma_description: 'VICTORIA',
  },
  {
    zip_code: '77969',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77970',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77971',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77973',
    dma_code: '626',
    dma_description: 'VICTORIA',
  },
  {
    zip_code: '77974',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '77975',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '77976',
    dma_code: '626',
    dma_description: 'VICTORIA',
  },
  {
    zip_code: '77977',
    dma_code: '626',
    dma_description: 'VICTORIA',
  },
  {
    zip_code: '77978',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77979',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77982',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77983',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77984',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '77986',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '77987',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '77988',
    dma_code: '626',
    dma_description: 'VICTORIA',
  },
  {
    zip_code: '77989',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '77990',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '77991',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '77993',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '77994',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '77995',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78001',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78002',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78003',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78004',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78005',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78006',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78007',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78008',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78009',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78010',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78011',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78012',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78013',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78014',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78015',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78016',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78017',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78019',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78021',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78022',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78023',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78024',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78025',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78026',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78027',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78028',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78029',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78039',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78040',
    dma_code: '749',
    dma_description: 'LAREDO',
  },
  {
    zip_code: '78041',
    dma_code: '749',
    dma_description: 'LAREDO',
  },
  {
    zip_code: '78042',
    dma_code: '749',
    dma_description: 'LAREDO',
  },
  {
    zip_code: '78043',
    dma_code: '749',
    dma_description: 'LAREDO',
  },
  {
    zip_code: '78044',
    dma_code: '749',
    dma_description: 'LAREDO',
  },
  {
    zip_code: '78045',
    dma_code: '749',
    dma_description: 'LAREDO',
  },
  {
    zip_code: '78046',
    dma_code: '749',
    dma_description: 'LAREDO',
  },
  {
    zip_code: '78049',
    dma_code: '749',
    dma_description: 'LAREDO',
  },
  {
    zip_code: '78050',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78052',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78054',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78055',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78056',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78057',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78058',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78059',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78060',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78061',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78062',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78063',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78064',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78065',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78066',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78067',
    dma_code: '749',
    dma_description: 'LAREDO',
  },
  {
    zip_code: '78069',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78070',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78071',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78072',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78073',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78074',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78075',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78076',
    dma_code: '749',
    dma_description: 'LAREDO',
  },
  {
    zip_code: '78101',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78102',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78104',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78107',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78108',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78109',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78111',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78112',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78113',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78114',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78115',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78116',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78117',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78118',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78119',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78121',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78122',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78123',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78124',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78125',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78130',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78131',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78132',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78133',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78135',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78140',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78141',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78142',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78143',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78144',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78145',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78146',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78147',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78148',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78150',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78151',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78152',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78154',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78155',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78156',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78159',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78160',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78161',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78162',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78163',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78164',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78201',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78202',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78203',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78204',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78205',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78206',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78207',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78208',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78209',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78210',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78211',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78212',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78213',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78214',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78215',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78216',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78217',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78218',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78219',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78220',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78221',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78222',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78223',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78224',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78225',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78226',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78227',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78228',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78229',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78230',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78231',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78232',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78233',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78234',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78235',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78236',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78237',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78238',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78239',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78240',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78241',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78242',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78243',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78244',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78245',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78246',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78247',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78248',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78249',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78250',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78251',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78252',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78253',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78254',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78255',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78256',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78257',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78258',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78259',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78260',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78261',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78262',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78263',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78264',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78265',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78266',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78268',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78269',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78270',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78275',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78278',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78279',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78280',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78283',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78284',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78286',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78287',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78288',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78289',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78291',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78292',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78293',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78294',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78295',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78296',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78297',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78298',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78299',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78330',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78332',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78333',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78335',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78336',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78338',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78339',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78340',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78341',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78342',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78343',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78344',
    dma_code: '749',
    dma_description: 'LAREDO',
  },
  {
    zip_code: '78347',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78349',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78350',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78351',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78352',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78353',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78355',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78357',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78358',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78359',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78360',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78361',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78362',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78363',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78364',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78368',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78369',
    dma_code: '749',
    dma_description: 'LAREDO',
  },
  {
    zip_code: '78370',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78371',
    dma_code: '749',
    dma_description: 'LAREDO',
  },
  {
    zip_code: '78372',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78373',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78374',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78375',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78376',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78377',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78379',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78380',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78381',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78382',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78383',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78384',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78385',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78387',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78389',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78390',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78391',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78393',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78401',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78402',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78403',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78404',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78405',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78406',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78407',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78408',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78409',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78410',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78411',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78412',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78413',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78414',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78415',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78416',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78417',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78418',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78419',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78426',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78427',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78460',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78461',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78463',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78465',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78466',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78467',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78468',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78469',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78470',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78471',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78472',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78473',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78475',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78476',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78477',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78478',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78480',
    dma_code: '600',
    dma_description: 'CORPUS CHRISTI',
  },
  {
    zip_code: '78501',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78502',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78503',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78504',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78505',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78516',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78520',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78521',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78522',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78523',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78526',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78535',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78536',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78537',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78538',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78539',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78540',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78541',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78542',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78543',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78545',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78547',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78548',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78549',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78550',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78551',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78552',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78553',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78557',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78558',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78559',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78560',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78561',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78562',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78563',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78564',
    dma_code: '749',
    dma_description: 'LAREDO',
  },
  {
    zip_code: '78565',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78566',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78567',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78568',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78569',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78570',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78572',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78573',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78574',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78575',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78576',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78577',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78578',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78579',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78580',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78582',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78583',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78584',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78585',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78586',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78588',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78589',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78590',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78591',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78592',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78593',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78594',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78595',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78596',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78597',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78598',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78599',
    dma_code: '636',
    dma_description: 'HARLINGEN - WSLCO - BRNSVL - MCA',
  },
  {
    zip_code: '78602',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78604',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78605',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78606',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78607',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78608',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78609',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78610',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78611',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78612',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78613',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78614',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78615',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78616',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78617',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78618',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78619',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78620',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78621',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78622',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78623',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78624',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78626',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78627',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78628',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78629',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78630',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78631',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78632',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78633',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78634',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78635',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78636',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78638',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78639',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78640',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78641',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78642',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78643',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78644',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78645',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78646',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78648',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78650',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78651',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78652',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78653',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78654',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78655',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78656',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78657',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78658',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78659',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78660',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78661',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78662',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78663',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78664',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78665',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78666',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78667',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78669',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78670',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78671',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78672',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78673',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78674',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78675',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78676',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78677',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78680',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78681',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78682',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78683',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78691',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78701',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78702',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78703',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78704',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78705',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78708',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78709',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78710',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78711',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78712',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78713',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78714',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78715',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78716',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78717',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78718',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78719',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78720',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78721',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78722',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78723',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78724',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78725',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78726',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78727',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78728',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78729',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78730',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78731',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78732',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78733',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78734',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78735',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78736',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78737',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78738',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78739',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78741',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78742',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78744',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78745',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78746',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78747',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78748',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78749',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78750',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78751',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78752',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78753',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78754',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78755',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78756',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78757',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78758',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78759',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78760',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78761',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78762',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78763',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78764',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78765',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78766',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78767',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78768',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78772',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78773',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78774',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78778',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78779',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78780',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78781',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78783',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78785',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78786',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78788',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78789',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78798',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78799',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78801',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78802',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78827',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78828',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78829',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78830',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78832',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78833',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78834',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78836',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78837',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78838',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78839',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78840',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78841',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78842',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78843',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78847',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78850',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78851',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '78852',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78853',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78860',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78861',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78870',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78871',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78872',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78873',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78877',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78879',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78880',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78881',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78883',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78884',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78885',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78886',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78931',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '78932',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78933',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '78934',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '78935',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '78938',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78940',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78941',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78942',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78943',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '78944',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '78945',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78946',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78947',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78948',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78949',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78950',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '78951',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '78952',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78953',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78954',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78956',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78957',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78959',
    dma_code: '641',
    dma_description: 'SAN ANTONIO',
  },
  {
    zip_code: '78960',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78961',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '78962',
    dma_code: '618',
    dma_description: 'HOUSTON',
  },
  {
    zip_code: '78963',
    dma_code: '635',
    dma_description: 'AUSTIN',
  },
  {
    zip_code: '79001',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79002',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79003',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79005',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79007',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79008',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79009',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79010',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79011',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79012',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79013',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79014',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79015',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79016',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79018',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79019',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79021',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79022',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79024',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79025',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79027',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79029',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79031',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79032',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79033',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79034',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79035',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79036',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79039',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79040',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79041',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79042',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79043',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79044',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79045',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79046',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79051',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79052',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79053',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79054',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79056',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79057',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79058',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79059',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79061',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79062',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79063',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79064',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79065',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79066',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79068',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79070',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79072',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79073',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79077',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79078',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79079',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79080',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79081',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79082',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79083',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79084',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79085',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79086',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79087',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79088',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79091',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79092',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79093',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79094',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79095',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79096',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79097',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79098',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79101',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79102',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79103',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79104',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79105',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79106',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79107',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79108',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79109',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79110',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79111',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79114',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79116',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79117',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79118',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79119',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79120',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79121',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79124',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79159',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79166',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79168',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79174',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79178',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79185',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79187',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79189',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79201',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79220',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79221',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79223',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79225',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '79226',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79227',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '79229',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79230',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79231',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79233',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79234',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79235',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79236',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '79237',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79239',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79240',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79241',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79243',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79244',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79245',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79247',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '79248',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79250',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79251',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79252',
    dma_code: '627',
    dma_description: 'WICHITA FALLS & LAWTON',
  },
  {
    zip_code: '79255',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79256',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79257',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79258',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79259',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79261',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79311',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79312',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79313',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79314',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79316',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79320',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79322',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79323',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79324',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79325',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '79326',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79329',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79330',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79331',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79336',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79338',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79339',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79342',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79343',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79344',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79345',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79346',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79347',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79350',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79351',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79353',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79355',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79356',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79357',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79358',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79359',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79360',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79363',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79364',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79366',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79367',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79369',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79370',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79371',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79372',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79373',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79376',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79377',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79378',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79379',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79380',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79381',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79382',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79383',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79401',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79403',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79404',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79405',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79406',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79407',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79408',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79409',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79410',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79411',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79412',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79413',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79414',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79415',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79416',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79423',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79424',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79430',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79452',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79453',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79457',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79464',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79490',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79491',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79493',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79499',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79501',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79502',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79503',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79504',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79505',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79506',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79508',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79510',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79511',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79512',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79516',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79517',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79518',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79519',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79520',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79521',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79525',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79526',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79527',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79528',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79529',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79530',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79532',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79533',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79534',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79535',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79536',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79537',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79538',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79539',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79540',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79541',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79543',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79544',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79545',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79546',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79547',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79548',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79549',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79550',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79553',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79556',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79560',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79561',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79562',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79563',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79565',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79566',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79567',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79601',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79602',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79603',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79604',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79605',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79606',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79607',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79608',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79697',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79698',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79699',
    dma_code: '662',
    dma_description: 'ABILENE - SWEETWATER',
  },
  {
    zip_code: '79701',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79702',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79703',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79704',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79705',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79706',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79707',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79708',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79710',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79711',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79712',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79713',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79714',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79718',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79719',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79720',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79721',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79730',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79731',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79733',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79734',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79735',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79738',
    dma_code: '651',
    dma_description: 'LUBBOCK',
  },
  {
    zip_code: '79739',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79740',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79741',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79742',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79743',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79744',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79745',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79748',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79749',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79752',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79754',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79755',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79756',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79758',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79759',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79760',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79761',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79762',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79763',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79764',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79765',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79766',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79768',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79769',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79770',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79772',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79776',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79777',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79778',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79780',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79781',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79782',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79783',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79785',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79786',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79788',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79789',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79821',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79830',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79831',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79832',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79834',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79835',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79836',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79837',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79838',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79839',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79842',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79843',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79845',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79846',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79847',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79848',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79849',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79851',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79852',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79853',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79854',
    dma_code: '633',
    dma_description: 'ODESSA - MIDLAND',
  },
  {
    zip_code: '79855',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79901',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79902',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79903',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79904',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79905',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79906',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79907',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79908',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79910',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79911',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79912',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79913',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79914',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79915',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79916',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79917',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79918',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79920',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79922',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79923',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79924',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79925',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79926',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79927',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79928',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79929',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79930',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79931',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79932',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79934',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79935',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79936',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79937',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79938',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79940',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79941',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79942',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79943',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79944',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79945',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79946',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79947',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79948',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79949',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79950',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79951',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79952',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79953',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79954',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79955',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79958',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79960',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79961',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79968',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79976',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79978',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79980',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79995',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79996',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79997',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79998',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '79999',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '80001',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80002',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80003',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80004',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80005',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80006',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80007',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80010',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80011',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80012',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80013',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80014',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80015',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80016',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80017',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80018',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80019',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80020',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80021',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80022',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80023',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80024',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80025',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80026',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80027',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80028',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80030',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80031',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80033',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80034',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80035',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80036',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80037',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80038',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80040',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80041',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80042',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80044',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80045',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80046',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80047',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80101',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80102',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80103',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80104',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80105',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80106',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80107',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80108',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80109',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80110',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80111',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80112',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80113',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80116',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80117',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80118',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80120',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80121',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80122',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80123',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80124',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80125',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80126',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80127',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80128',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80129',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80130',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80131',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80132',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80133',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80134',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80135',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80136',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80137',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80138',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80150',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80151',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80155',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80160',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80161',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80162',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80163',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80165',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80166',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80201',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80202',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80203',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80204',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80205',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80206',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80207',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80208',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80209',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80210',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80211',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80212',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80214',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80215',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80216',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80217',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80218',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80219',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80220',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80221',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80222',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80223',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80224',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80225',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80226',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80227',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80228',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80229',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80230',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80231',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80232',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80233',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80234',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80235',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80236',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80237',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80238',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80239',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80241',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80243',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80244',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80246',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80247',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80248',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80249',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80250',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80251',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80252',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80256',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80257',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80259',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80260',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80261',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80262',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80263',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80264',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80265',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80266',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80271',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80273',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80274',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80279',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80280',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80281',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80290',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80291',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80293',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80294',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80295',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80299',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80301',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80302',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80303',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80304',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80305',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80306',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80307',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80308',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80309',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80310',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80314',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80321',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80322',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80323',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80328',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80329',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80401',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80402',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80403',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80419',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80420',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80421',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80422',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80423',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80424',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80425',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80426',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80427',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80428',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80429',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80430',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80432',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80433',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80434',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80435',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80436',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80437',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80438',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80439',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80440',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80442',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80443',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80444',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80446',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80447',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80448',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80449',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80451',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80452',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80453',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80454',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80455',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80456',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80457',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80459',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80461',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80463',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80465',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80466',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80467',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80468',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80469',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80470',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80471',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80473',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80474',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80475',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80476',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80477',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80478',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80479',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80480',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80481',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80482',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80483',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80487',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80488',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80497',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80498',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80501',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80502',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80503',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80504',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80510',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80511',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80512',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80513',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80514',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80515',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80516',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80517',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80520',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80521',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80522',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80523',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80524',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80525',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80526',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80527',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80528',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80530',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80532',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80533',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80534',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80535',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80536',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80537',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80538',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80539',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80540',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80541',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80542',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80543',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80544',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80545',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80546',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80547',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80549',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80550',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80551',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80553',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80601',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80602',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80603',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80610',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80611',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80612',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80614',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80615',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80620',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80621',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80622',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80623',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80624',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80631',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80632',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80633',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80634',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80638',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80639',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80640',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80642',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80643',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80644',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80645',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80646',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80648',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80649',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80650',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80651',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80652',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80653',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80654',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80701',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80705',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80720',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80721',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80722',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80723',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80726',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80727',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80728',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80729',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80731',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80732',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80733',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80734',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80735',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80736',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80737',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80740',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80741',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80742',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80743',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80744',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80745',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80746',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80747',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80749',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80750',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80751',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80754',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80755',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80757',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80758',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80759',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80801',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80802',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80804',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80805',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80807',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80808',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80809',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80810',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80812',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80813',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80814',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80815',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80816',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80817',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80818',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80819',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80820',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80821',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80822',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80823',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80824',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80825',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80826',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80827',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80828',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80829',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80830',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80831',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80832',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80833',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80834',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80835',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80836',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80840',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80841',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80860',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80861',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80862',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '80863',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80864',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80866',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80901',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80902',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80903',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80904',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80905',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80906',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80907',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80908',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80909',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80910',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80911',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80912',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80913',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80914',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80915',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80916',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80917',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80918',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80919',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80920',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80921',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80922',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80923',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80924',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80925',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80926',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80927',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80928',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80929',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80930',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80931',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80932',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80933',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80934',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80935',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80936',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80937',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80938',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80939',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80941',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80942',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80943',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80944',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80946',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80947',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80949',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80950',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80951',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80960',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80962',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80970',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80977',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '80997',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81001',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81002',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81003',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81004',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81005',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81006',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81007',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81008',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81009',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81010',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81011',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81012',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81019',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81020',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81021',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81022',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81023',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81024',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81025',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81027',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81029',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81030',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81033',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81034',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81036',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81038',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81039',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81040',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81041',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81043',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81044',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81045',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81046',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81047',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81049',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81050',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81052',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81054',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81055',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81057',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81058',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81059',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81062',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81063',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81064',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81067',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81069',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81071',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81073',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81076',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81077',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81081',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81082',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81084',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81087',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81089',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81090',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81091',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81092',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81101',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81102',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81120',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81121',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81122',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81123',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81124',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81125',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81126',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81127',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81128',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81129',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81130',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81131',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81132',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81133',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81134',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81135',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81136',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81137',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81138',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81140',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81141',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81143',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81144',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81146',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81147',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81148',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81149',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81151',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81152',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81153',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81154',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81155',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81157',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81201',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81210',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81211',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81212',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81215',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81220',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81221',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81222',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81223',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81224',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81225',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81226',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81227',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81228',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81230',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81231',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81232',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81233',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81235',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81236',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81237',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81239',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81240',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81241',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81242',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81243',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81244',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81248',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81251',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81252',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81253',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81290',
    dma_code: '752',
    dma_description: 'COLORADO SPRINGS - PUEBLO',
  },
  {
    zip_code: '81301',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81302',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81303',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81320',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81321',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81323',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81324',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81325',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81326',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81327',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81328',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81329',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81330',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81331',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81332',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81334',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81335',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '81401',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81402',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81403',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81410',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81411',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81413',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81414',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81415',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81416',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81418',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81419',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81420',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81422',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81423',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81424',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81425',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81426',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81427',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81428',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81429',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81430',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81431',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81432',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81433',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81434',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81435',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81501',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81502',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81503',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81504',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81505',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81506',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81507',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81520',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81521',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81522',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81523',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81524',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81525',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81526',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81527',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81601',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81602',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81610',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81611',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81612',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81615',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81620',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81621',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81623',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81624',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81625',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81626',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81630',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81631',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81632',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81633',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81635',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81636',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81637',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81638',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81639',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81640',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81641',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81642',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81643',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81645',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81646',
    dma_code: '773',
    dma_description: 'GRAND JUNCTION - MONTROSE',
  },
  {
    zip_code: '81647',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81648',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81649',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81650',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81652',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81653',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81654',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81655',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81656',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81657',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '81658',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82001',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82002',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82003',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82005',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82006',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82007',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82008',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82009',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82010',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82050',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82051',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82052',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82053',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82054',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82055',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82058',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82059',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82060',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82061',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82063',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82070',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82071',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82072',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82073',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82081',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82082',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82083',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82084',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82190',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82201',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82210',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82212',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82213',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82214',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82215',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82217',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82218',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82219',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82221',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82222',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82223',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82224',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82225',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82227',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82229',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82240',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82242',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82243',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82244',
    dma_code: '759',
    dma_description: 'CHEYENNE - SCOTTSBLUF',
  },
  {
    zip_code: '82301',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82310',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82321',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82322',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82323',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82324',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82325',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82327',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82329',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82331',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82332',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82334',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82335',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82336',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82401',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82410',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82411',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82412',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82414',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82420',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82421',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82422',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82423',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82426',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82428',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82430',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82431',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82432',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82433',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82434',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82435',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82440',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82441',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82442',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82443',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82450',
    dma_code: '756',
    dma_description: 'BILLINGS',
  },
  {
    zip_code: '82501',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82510',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82512',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82513',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82514',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82515',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82516',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82520',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82523',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82524',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82601',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82602',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82604',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82605',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82609',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82615',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82620',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82630',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82633',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82635',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82636',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82637',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82638',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82639',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82640',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82642',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82643',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82644',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82646',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82648',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82649',
    dma_code: '767',
    dma_description: 'CASPER - RIVERTON',
  },
  {
    zip_code: '82701',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82710',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82711',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82712',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82714',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82715',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82716',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82717',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82718',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82720',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82721',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82723',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82725',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82727',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82729',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82730',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82731',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82732',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82801',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82831',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82832',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82833',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82834',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82835',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82836',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82837',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82838',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82839',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82840',
    dma_code: '751',
    dma_description: 'DENVER',
  },
  {
    zip_code: '82842',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82844',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82845',
    dma_code: '764',
    dma_description: 'RAPID CITY',
  },
  {
    zip_code: '82901',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82902',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82922',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82923',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82925',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82929',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82930',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82931',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82932',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82933',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82934',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82935',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82936',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82937',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82938',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82939',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82941',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82942',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82943',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82944',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '82945',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83001',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83002',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83011',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83012',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83013',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83014',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83025',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83101',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83110',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83111',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83112',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83113',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83114',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83115',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83116',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83118',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83119',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83120',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83121',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83122',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83123',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83124',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83126',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83127',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83128',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83201',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83202',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83203',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83204',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83205',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83206',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83209',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83210',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83211',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83212',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83213',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83214',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83215',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83217',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83218',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83220',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83221',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83223',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83226',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83227',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83228',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83229',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83230',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83232',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83233',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83234',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83235',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83236',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83237',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83238',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83239',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83241',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83243',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83244',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83245',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83246',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83250',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83251',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83252',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83253',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83254',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83255',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83256',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83261',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83262',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83263',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83271',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83272',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83274',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83276',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83277',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83278',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83281',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83283',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83285',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83286',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83287',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '83301',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83302',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83303',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83311',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83312',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83313',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83314',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83316',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83318',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83320',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83321',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83322',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83323',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83324',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83325',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83327',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83328',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83330',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83332',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83333',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83334',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83335',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83336',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83337',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83338',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83340',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83341',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83342',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83343',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83344',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83346',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83347',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83348',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83349',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83350',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83352',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83353',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83354',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83355',
    dma_code: '760',
    dma_description: 'TWIN FALLS',
  },
  {
    zip_code: '83401',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83402',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83403',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83404',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83405',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83406',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83414',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83415',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83420',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83421',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83422',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83423',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83424',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83425',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83427',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83428',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83429',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83431',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83433',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83434',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83435',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83436',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83438',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83440',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83441',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83442',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83443',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83444',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83445',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83446',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83448',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83449',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83450',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83451',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83452',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83454',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83455',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83460',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83462',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83463',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83464',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83465',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83466',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83467',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83468',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83469',
    dma_code: '758',
    dma_description: 'IDAHO FALLS - POCATELLO',
  },
  {
    zip_code: '83501',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83520',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83522',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83523',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83524',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83525',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83526',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83530',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83531',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83533',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83535',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83536',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83537',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83539',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83540',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83541',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83542',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83543',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83544',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83545',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83546',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83547',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83548',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83549',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83552',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83553',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83554',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83555',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83601',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83602',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83604',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83605',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83606',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83607',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83610',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83611',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83612',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83615',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83616',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83617',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83619',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83622',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83623',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83624',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83626',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83627',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83628',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83629',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83630',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83631',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83632',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83633',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83634',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83635',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83636',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83637',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83638',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83639',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83641',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83642',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83643',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83644',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83645',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83646',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83647',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83648',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83650',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83651',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83652',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83653',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83654',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83655',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83656',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83657',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83660',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83661',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83666',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83669',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83670',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83671',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83672',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83676',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83677',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83680',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83686',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83687',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83701',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83702',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83703',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83704',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83705',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83706',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83707',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83708',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83709',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83711',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83712',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83713',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83714',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83715',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83716',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83717',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83719',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83720',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83721',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83722',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83724',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83725',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83726',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83727',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83728',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83729',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83730',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83731',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83735',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83756',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83757',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '83801',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83802',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83803',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83804',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83805',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83806',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83808',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83809',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83810',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83811',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83812',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83813',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83814',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83815',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83816',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83821',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83822',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83823',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83824',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83825',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83826',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83827',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83830',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83832',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83833',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83834',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83835',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83836',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83837',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83839',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83840',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83841',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83842',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83843',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83844',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83845',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83846',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83847',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83848',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83849',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83850',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83851',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83852',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83853',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83854',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83855',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83856',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83857',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83858',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83860',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83861',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83864',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83865',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83866',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83867',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83868',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83869',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83870',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83871',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83872',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83873',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83874',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83876',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '83877',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '84001',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84002',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84003',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84004',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84005',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84006',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84007',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84008',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84010',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84011',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84013',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84014',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84015',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84016',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84017',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84018',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84020',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84021',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84022',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84023',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84024',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84025',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84026',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84027',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84028',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84029',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84031',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84032',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84033',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84034',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84035',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84036',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84037',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84038',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84039',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84040',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84041',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84042',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84043',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84044',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84045',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84046',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84047',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84049',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84050',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84051',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84052',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84053',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84054',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84055',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84056',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84057',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84058',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84059',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84060',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84061',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84062',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84063',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84064',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84065',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84066',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84067',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84068',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84069',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84070',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84071',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84072',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84073',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84074',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84075',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84076',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84078',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84079',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84080',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84081',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84082',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84083',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84084',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84085',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84086',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84087',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84088',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84089',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84090',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84091',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84092',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84093',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84094',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84095',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84096',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84097',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84098',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84101',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84102',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84103',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84104',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84105',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84106',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84107',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84108',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84109',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84110',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84111',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84112',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84113',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84114',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84115',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84116',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84117',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84118',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84119',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84120',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84121',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84122',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84123',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84124',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84125',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84126',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84127',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84128',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84130',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84131',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84132',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84133',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84134',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84136',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84138',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84139',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84141',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84143',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84144',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84145',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84147',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84148',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84150',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84151',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84152',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84157',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84158',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84165',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84170',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84171',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84180',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84184',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84189',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84190',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84199',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84201',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84244',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84301',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84302',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84304',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84305',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84306',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84307',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84308',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84309',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84310',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84311',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84312',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84313',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84314',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84315',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84316',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84317',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84318',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84319',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84320',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84321',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84322',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84323',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84324',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84325',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84326',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84327',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84328',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84329',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84330',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84331',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84332',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84333',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84334',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84335',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84336',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84337',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84338',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84339',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84340',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84341',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84401',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84402',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84403',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84404',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84405',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84407',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84408',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84409',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84412',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84414',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84415',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84501',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84510',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84511',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84512',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84513',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84515',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84516',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84518',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84520',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84521',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84522',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84523',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84525',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84526',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84528',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84529',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84530',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84531',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84532',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84533',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84534',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84535',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84536',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84537',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84539',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84540',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84542',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84601',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84602',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84603',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84604',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84605',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84606',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84620',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84621',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84622',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84623',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84624',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84626',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84627',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84628',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84629',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84630',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84631',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84632',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84633',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84634',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84635',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84636',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84637',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84638',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84639',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84640',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84642',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84643',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84644',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84645',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84646',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84647',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84648',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84649',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84651',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84652',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84653',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84654',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84655',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84656',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84657',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84660',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84662',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84663',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84664',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84665',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84667',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84701',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84710',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84711',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84712',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84713',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84714',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84715',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84716',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84718',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84719',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84720',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84721',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84722',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84723',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84724',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84725',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84726',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84728',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84729',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84730',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84731',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84732',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84733',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84734',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84735',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84736',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84737',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84738',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84739',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84740',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84741',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84742',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84743',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84744',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84745',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84746',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84747',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84749',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84750',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84751',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84752',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84753',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84754',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84755',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84756',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84757',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84758',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84759',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84760',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84761',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84762',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84763',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84764',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84765',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84766',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84767',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84770',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84771',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84772',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84773',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84774',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84775',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84776',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84779',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84780',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84781',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84782',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84783',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84784',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84790',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '84791',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '85001',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85002',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85003',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85004',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85005',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85006',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85007',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85008',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85009',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85010',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85011',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85012',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85013',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85014',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85015',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85016',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85017',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85018',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85019',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85020',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85021',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85022',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85023',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85024',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85025',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85026',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85027',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85028',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85029',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85030',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85031',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85032',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85033',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85034',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85035',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85036',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85037',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85038',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85039',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85040',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85041',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85042',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85043',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85044',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85045',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85046',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85048',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85050',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85051',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85053',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85054',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85060',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85061',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85062',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85063',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85064',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85066',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85067',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85068',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85069',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85070',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85071',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85072',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85074',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85075',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85076',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85077',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85078',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85079',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85080',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85082',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85083',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85085',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85086',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85087',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85097',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85098',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85099',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85117',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85118',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85119',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85120',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85121',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85122',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85123',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85127',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85128',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85130',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85131',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85132',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85135',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85137',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85138',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85139',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85140',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85141',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85142',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85143',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85145',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85147',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85172',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85173',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85178',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85190',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85191',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85192',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85193',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85194',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85201',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85202',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85203',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85204',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85205',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85206',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85207',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85208',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85209',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85210',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85211',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85212',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85213',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85214',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85215',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85216',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85217',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85218',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85219',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85220',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85221',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85222',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85223',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85224',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85225',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85226',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85227',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85228',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85230',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85231',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85232',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85233',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85234',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85235',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85236',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85237',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85238',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85239',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85240',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85241',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85242',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85243',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85244',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85245',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85246',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85247',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85248',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85249',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85250',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85251',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85252',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85253',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85254',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85255',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85256',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85257',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85258',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85259',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85260',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85261',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85262',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85263',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85264',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85266',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85267',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85268',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85269',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85271',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85272',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85273',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85274',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85275',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85277',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85278',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85280',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85281',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85282',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85283',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85284',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85285',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85286',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85287',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85289',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85290',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85291',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85292',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85293',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85294',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85295',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85296',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85297',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85298',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85299',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85301',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85302',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85303',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85304',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85305',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85306',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85307',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85308',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85309',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85310',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85311',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85312',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85313',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85318',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85320',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85321',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85322',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85323',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85324',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85325',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85326',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85327',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85328',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85329',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85331',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85332',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85333',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '85334',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85335',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85336',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '85337',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85338',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85339',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85340',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85341',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85342',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85343',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85344',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85345',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85346',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85347',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '85348',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85349',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '85350',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '85351',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85352',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '85353',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85354',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85355',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85356',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '85357',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85358',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85359',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85360',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85361',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85362',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85363',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85364',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '85365',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '85366',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '85367',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '85369',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '85371',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85372',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85373',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85374',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85375',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85376',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85377',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85378',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85379',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85380',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85381',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85382',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85383',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85385',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85387',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85388',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85390',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85392',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85395',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85396',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85501',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85502',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85530',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85531',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85532',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85533',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85534',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85535',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85536',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85539',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85540',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85541',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85542',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85543',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85544',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85545',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85546',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85547',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85548',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85550',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85551',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85552',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85553',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85554',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85601',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85602',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85603',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85605',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85606',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85607',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85608',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85609',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85610',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85611',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85613',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85614',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85615',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85616',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85617',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85618',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85619',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85620',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85621',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85622',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85623',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85624',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85625',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85626',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85627',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85628',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85629',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85630',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85631',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85632',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85633',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85634',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85635',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85636',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85637',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85638',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85639',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85640',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85641',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85643',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85644',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85645',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85646',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85648',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85650',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85652',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85653',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85654',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85655',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85658',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85670',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85701',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85702',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85703',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85704',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85705',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85706',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85707',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85708',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85709',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85710',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85711',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85712',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85713',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85714',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85715',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85716',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85717',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85718',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85719',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85721',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85722',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85723',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85724',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85725',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85726',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85728',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85730',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85731',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85732',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85733',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85734',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85735',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85736',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85737',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85738',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85739',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85740',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85741',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85742',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85743',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85744',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85745',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85746',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85747',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85748',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85749',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85750',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85751',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85752',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85754',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85755',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85756',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85757',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85775',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85777',
    dma_code: '789',
    dma_description: 'TUCSON (SIERRA VISTA)',
  },
  {
    zip_code: '85901',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85902',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85911',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85912',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85920',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '85922',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85923',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85924',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '85925',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '85926',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85927',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '85928',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85929',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85930',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '85931',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85932',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '85933',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85934',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85935',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85936',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '85937',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85938',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '85939',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85940',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '85941',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '85942',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86001',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86002',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86003',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86004',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86011',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86015',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86016',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86017',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86018',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86020',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86021',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86022',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86023',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86024',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86025',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86028',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86029',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86030',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86031',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86032',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86033',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86034',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86035',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86036',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86038',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86039',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86040',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86042',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86043',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86044',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86045',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86046',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86047',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86052',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86053',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86054',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86301',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86302',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86303',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86304',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86305',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86312',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86313',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86314',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86315',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86320',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86321',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86322',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86323',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86324',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86325',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86326',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86327',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86329',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86330',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86331',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86332',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86333',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86334',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86335',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86336',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86337',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86338',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86339',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86340',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86341',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86342',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86343',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86351',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86401',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86402',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86403',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86404',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86405',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86406',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86409',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86411',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86412',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86413',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86426',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86427',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86429',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86430',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86431',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86432',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86433',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86434',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86435',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86436',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86437',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86438',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86439',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86440',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86441',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86442',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86443',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86444',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86445',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86446',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86502',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86503',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86504',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86505',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86506',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86507',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86508',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86510',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86511',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86512',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86514',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86515',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86520',
    dma_code: '753',
    dma_description: 'PHOENIX (PRESCOTT)',
  },
  {
    zip_code: '86535',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86538',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86540',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86544',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86545',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86547',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '86556',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87001',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87002',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87004',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87005',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87006',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87007',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87008',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87009',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87010',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87011',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87012',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87013',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87014',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87015',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87016',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87017',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87018',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87020',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87021',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87022',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87023',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87024',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87025',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87026',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87027',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87028',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87029',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87031',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87032',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87034',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87035',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87036',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87037',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87038',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87040',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87041',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87042',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87043',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87044',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87045',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87046',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87047',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87048',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87049',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87051',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87052',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87053',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87056',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87059',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87060',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87061',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87062',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87063',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87064',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87068',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87070',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87072',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87083',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87101',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87102',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87103',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87104',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87105',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87106',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87107',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87108',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87109',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87110',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87111',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87112',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87113',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87114',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87116',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87117',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87119',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87120',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87121',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87122',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87123',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87124',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87125',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87131',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87144',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87151',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87153',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87154',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87158',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87165',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87174',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87176',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87181',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87184',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87185',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87187',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87190',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87191',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87192',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87193',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87194',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87195',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87196',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87197',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87198',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87199',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87301',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87302',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87305',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87310',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87311',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87312',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87313',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87315',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87316',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87317',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87319',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87320',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87321',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87322',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87323',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87325',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87326',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87327',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87328',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87347',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87357',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87364',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87365',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87375',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87401',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87402',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87410',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87412',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87413',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87415',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87416',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87417',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87418',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87419',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87420',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87421',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87455',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87461',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87499',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87501',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87502',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87503',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87504',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87505',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87506',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87507',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87508',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87509',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87510',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87511',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87512',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87513',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87514',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87515',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87516',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87517',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87518',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87519',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87520',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87521',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87522',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87523',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87524',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87525',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87527',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87528',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87529',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87530',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87531',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87532',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87533',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87535',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87537',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87538',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87539',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87540',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87543',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87544',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87545',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87548',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87549',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87551',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87552',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87553',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87554',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87556',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87557',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87558',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87560',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87562',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87564',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87565',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87566',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87567',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87569',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87571',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87573',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87574',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87575',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87576',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87577',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87578',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87579',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87580',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87581',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87582',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87583',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87592',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87594',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87701',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87710',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87711',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87712',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87713',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87714',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87715',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87718',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87722',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87723',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87724',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87728',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87729',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87730',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87731',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87732',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87733',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87734',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87735',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87736',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87740',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87742',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87743',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87745',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87746',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87747',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87749',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87750',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87752',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87753',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87801',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87820',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87821',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87823',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87824',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87825',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87827',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87828',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87829',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87830',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87831',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87832',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87901',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87930',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87931',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87933',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87935',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87936',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '87937',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '87939',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87940',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '87941',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '87942',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '87943',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88001',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88002',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88003',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88004',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88005',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88006',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88007',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88008',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88009',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88011',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88012',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88013',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88020',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88021',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88022',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88023',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88024',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88025',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88026',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88027',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88028',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88029',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88030',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88031',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88032',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88033',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88034',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88036',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88038',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88039',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88040',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88041',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88042',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88043',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88044',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88045',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88046',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88047',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88048',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88049',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88051',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88052',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88053',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88054',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88055',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88056',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88058',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88061',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88062',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88063',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88065',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88072',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88081',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88101',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88102',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88103',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88112',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88113',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88114',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88115',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88116',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88118',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88119',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88120',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88121',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88122',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88123',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88124',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88125',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88126',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88130',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88132',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88133',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88134',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88135',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88136',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88201',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88202',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88203',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88210',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88211',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88213',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88220',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88221',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88230',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88231',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88232',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88240',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88241',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88242',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88244',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88250',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88252',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88253',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88254',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88255',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88256',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88260',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88262',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88263',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88264',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88265',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88267',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88268',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88301',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88310',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88311',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88312',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88314',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88316',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88317',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88318',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88321',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88323',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88324',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88325',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88330',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88336',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88337',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88338',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88339',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88340',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88341',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88342',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88343',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88344',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88345',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88346',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88347',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88348',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88349',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88350',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88351',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88352',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88353',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88354',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88355',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88401',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88410',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88411',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88414',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88415',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88416',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88417',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88418',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88419',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88421',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88422',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88424',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88426',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88427',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88430',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88431',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88433',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88434',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88435',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88436',
    dma_code: '634',
    dma_description: 'AMARILLO',
  },
  {
    zip_code: '88439',
    dma_code: '790',
    dma_description: 'ALBUQUERQUE - SANTA FE',
  },
  {
    zip_code: '88510',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88520',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88538',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88540',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88590',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88595',
    dma_code: '765',
    dma_description: 'EL PASO (LAS CRUCES)',
  },
  {
    zip_code: '88901',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89001',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89002',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89003',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89004',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89005',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89006',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89007',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89008',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89009',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89010',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89011',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89012',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89013',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89014',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89015',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89016',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89017',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89018',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89019',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89020',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89021',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89022',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89023',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89024',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89025',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89026',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89027',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89028',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89029',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89030',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89031',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89032',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89033',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89034',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89036',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89037',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89039',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89040',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89041',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89042',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89043',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89044',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89045',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89046',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89047',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89048',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89049',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89052',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89053',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89054',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89060',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89061',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89070',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89074',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89077',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89081',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89084',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89085',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89086',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89101',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89102',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89103',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89104',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89105',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89106',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89107',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89108',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89109',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89110',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89111',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89112',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89113',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89114',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89115',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89116',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89117',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89118',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89119',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89120',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89121',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89122',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89123',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89124',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89125',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89126',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89127',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89128',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89129',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89130',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89131',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89132',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89133',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89134',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89135',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89136',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89137',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89138',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89139',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89140',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89141',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89142',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89143',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89144',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89145',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89146',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89147',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89148',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89149',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89150',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89151',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89152',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89153',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89154',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89155',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89156',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89157',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89159',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89160',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89161',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89162',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89163',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89164',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89165',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89166',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89169',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89170',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89173',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89177',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89178',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89179',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89180',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89183',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89185',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89191',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89193',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89195',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89199',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89301',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89310',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89311',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89314',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89315',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89316',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89317',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89318',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89319',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89402',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89403',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89404',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89405',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89406',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89407',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89408',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89409',
    dma_code: '839',
    dma_description: 'LAS VEGAS',
  },
  {
    zip_code: '89410',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89411',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89412',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89413',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89414',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89415',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89418',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89419',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89420',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89421',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89422',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89423',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89424',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89425',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89426',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89427',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89428',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89429',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89430',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89431',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89432',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89433',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89434',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89435',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89436',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89438',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89439',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89440',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89441',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89442',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89444',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89445',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89446',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89447',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89448',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89449',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89450',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89451',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89452',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89460',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89496',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89501',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89502',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89503',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89504',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89505',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89506',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89507',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89508',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89509',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89510',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89511',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89512',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89513',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89515',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89519',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89520',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89521',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89523',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89533',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89555',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89557',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89570',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89595',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89599',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89701',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89702',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89703',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89704',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89705',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89706',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89711',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89713',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89714',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89721',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89801',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89802',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89803',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89815',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89820',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '89821',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89822',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89823',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89824',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89825',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89826',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89828',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89830',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89831',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89832',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89833',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89834',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89835',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '89883',
    dma_code: '770',
    dma_description: 'SALT LAKE CITY',
  },
  {
    zip_code: '90001',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90002',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90003',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90004',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90005',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90006',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90007',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90008',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90009',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90010',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90011',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90012',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90013',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90014',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90015',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90016',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90017',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90018',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90019',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90020',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90021',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90022',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90023',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90024',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90025',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90026',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90027',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90028',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90029',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90030',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90031',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90032',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90033',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90034',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90035',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90036',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90037',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90038',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90039',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90040',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90041',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90042',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90043',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90044',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90045',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90046',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90047',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90048',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90049',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90050',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90051',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90052',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90053',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90054',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90055',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90056',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90057',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90058',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90059',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90060',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90061',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90062',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90063',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90064',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90065',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90066',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90067',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90068',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90069',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90070',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90071',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90072',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90073',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90074',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90075',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90076',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90077',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90078',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90079',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90080',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90081',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90082',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90083',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90084',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90086',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90087',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90088',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90089',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90090',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90091',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90093',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90094',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90095',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90096',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90101',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90102',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90103',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90189',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90201',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90202',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90209',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90210',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90211',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90212',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90213',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90220',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90221',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90222',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90223',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90224',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90230',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90231',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90232',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90233',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90239',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90240',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90241',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90242',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90245',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90247',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90248',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90249',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90250',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90251',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90254',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90255',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90260',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90261',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90262',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90263',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90264',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90265',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90266',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90267',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90270',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90272',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90274',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90275',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90277',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90278',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90280',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90290',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90291',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90292',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90293',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90294',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90295',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90296',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90301',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90302',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90303',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90304',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90305',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90306',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90307',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90308',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90309',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90310',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90313',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90397',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90398',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90401',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90402',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90403',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90404',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90405',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90406',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90407',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90408',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90409',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90410',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90411',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90501',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90502',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90503',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90504',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90505',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90506',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90507',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90508',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90509',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90510',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90601',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90602',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90603',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90604',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90605',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90606',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90607',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90608',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90609',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90610',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90612',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90620',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90621',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90622',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90623',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90624',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90630',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90631',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90632',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90633',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90637',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90638',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90639',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90640',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90650',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90651',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90652',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90659',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90660',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90661',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90662',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90670',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90680',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90701',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90702',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90703',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90704',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90706',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90707',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90710',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90711',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90712',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90713',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90714',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90715',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90716',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90717',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90720',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90721',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90723',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90731',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90732',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90733',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90734',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90740',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90742',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90743',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90744',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90745',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90746',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90747',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90748',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90749',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90755',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90801',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90802',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90803',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90804',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90805',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90806',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90807',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90808',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90809',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90810',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90813',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90814',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90815',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90822',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90831',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90832',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90840',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90842',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90844',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90845',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90846',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90847',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90848',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90853',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90888',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90895',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '90899',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91001',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91003',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91006',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91007',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91008',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91009',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91010',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91011',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91012',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91016',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91017',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91020',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91021',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91023',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91024',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91025',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91030',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91031',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91040',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91041',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91042',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91043',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91046',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91066',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91077',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91101',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91102',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91103',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91104',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91105',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91106',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91107',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91108',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91109',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91110',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91114',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91115',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91116',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91117',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91118',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91121',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91123',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91124',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91125',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91126',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91129',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91131',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91182',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91184',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91188',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91189',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91191',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91201',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91202',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91203',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91204',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91205',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91206',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91207',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91208',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91209',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91210',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91214',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91221',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91222',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91224',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91225',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91226',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91301',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91302',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91303',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91304',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91305',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91306',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91307',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91308',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91309',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91310',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91311',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91313',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91316',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91319',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91320',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91321',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91322',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91324',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91325',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91326',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91327',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91328',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91329',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91330',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91331',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91333',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91334',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91335',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91337',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91340',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91341',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91342',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91343',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91344',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91345',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91346',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91350',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91351',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91352',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91353',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91354',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91355',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91356',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91357',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91358',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91359',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91360',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91361',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91362',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91363',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91364',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91365',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91367',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91371',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91372',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91376',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91377',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91380',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91381',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91382',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91384',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91385',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91386',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91387',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91388',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91390',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91392',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91393',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91394',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91395',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91396',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91399',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91401',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91402',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91403',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91404',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91405',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91406',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91407',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91408',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91409',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91410',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91411',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91412',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91413',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91416',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91423',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91426',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91436',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91470',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91482',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91495',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91496',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91499',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91501',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91502',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91503',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91504',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91505',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91506',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91507',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91508',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91510',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91521',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91522',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91523',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91526',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91601',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91602',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91603',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91604',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91605',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91606',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91607',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91608',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91609',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91610',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91611',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91612',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91614',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91615',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91616',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91617',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91618',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91701',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91702',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91706',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91708',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91709',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91710',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91711',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91715',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91716',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91722',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91723',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91724',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91729',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91730',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91731',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91732',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91733',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91734',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91735',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91737',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91739',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91740',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91741',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91743',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91744',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91745',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91746',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91747',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91748',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91749',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91750',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91752',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '91754',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91755',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91756',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91758',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91759',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91761',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91762',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91763',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91764',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91765',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91766',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91767',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91768',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91769',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91770',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91771',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91772',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91773',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91775',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91776',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91778',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91780',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91784',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91785',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91786',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91788',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91789',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91790',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91791',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91792',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91793',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91795',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91797',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91798',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91799',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91801',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91802',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91803',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91841',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '91901',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91902',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91903',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91905',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91906',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91908',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91909',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91910',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91911',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91912',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91913',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91914',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91915',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91916',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91917',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91921',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91931',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91932',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91933',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91934',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91935',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91941',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91942',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91943',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91944',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91945',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91946',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91947',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91948',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91950',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91951',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91962',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91963',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91976',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91977',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91978',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91979',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91980',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91987',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '91990',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92003',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92004',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92007',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92008',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92009',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92010',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92011',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92013',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92014',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92018',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92019',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92020',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92021',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92022',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92023',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92024',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92025',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92026',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92027',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92028',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92029',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92030',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92033',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92036',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92037',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92038',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92039',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92040',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92046',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92049',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92051',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92052',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92054',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92055',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92056',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92057',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92058',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92059',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92060',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92061',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92064',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92065',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92066',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92067',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92068',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92069',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92070',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92071',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92072',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92074',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92075',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92078',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92079',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92081',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92082',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92083',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92084',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92085',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92086',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92088',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92090',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92091',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92092',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92093',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92096',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92101',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92102',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92103',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92104',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92105',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92106',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92107',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92108',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92109',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92110',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92111',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92112',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92113',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92114',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92115',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92116',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92117',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92118',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92119',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92120',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92121',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92122',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92123',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92124',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92126',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92127',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92128',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92129',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92130',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92131',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92132',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92133',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92134',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92135',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92136',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92137',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92138',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92139',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92140',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92142',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92143',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92145',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92147',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92149',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92150',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92152',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92153',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92154',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92155',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92158',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92159',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92160',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92161',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92162',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92163',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92164',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92165',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92166',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92167',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92168',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92169',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92170',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92171',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92172',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92173',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92174',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92175',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92176',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92177',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92178',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92179',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92182',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92184',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92186',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92187',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92190',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92191',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92192',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92193',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92194',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92195',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92196',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92197',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92198',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92199',
    dma_code: '825',
    dma_description: 'SAN DIEGO',
  },
  {
    zip_code: '92201',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92202',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92203',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92210',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92211',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92220',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92222',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92223',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92225',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92226',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92227',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92230',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92231',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92232',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92233',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92234',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92235',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92236',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92239',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92240',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92241',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92242',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92243',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92244',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92247',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92248',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92249',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92250',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92251',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92252',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92253',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92254',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92255',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92256',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92257',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92258',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92259',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92260',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92261',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92262',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92263',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92264',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92266',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92267',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92268',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92270',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92273',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92274',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92275',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92276',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92277',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92278',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92280',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92281',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92282',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92283',
    dma_code: '771',
    dma_description: 'YUMA - EL CENTRO',
  },
  {
    zip_code: '92284',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92285',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92286',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92301',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92304',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92305',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92307',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92308',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92309',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92310',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92311',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92312',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92313',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92314',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92315',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92316',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92317',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92318',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92320',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92321',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92322',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92323',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92324',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92325',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92326',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92327',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92328',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92329',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92331',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92332',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92333',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92334',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92335',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92336',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92337',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92338',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92339',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92340',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92341',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92342',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92344',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92345',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92346',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92347',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92350',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92352',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92354',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92356',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92357',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92358',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92359',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92363',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92364',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92365',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92366',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92368',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92369',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92371',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92372',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92373',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92374',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92375',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92376',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92377',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92378',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92382',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92384',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92385',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92386',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92389',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92391',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92392',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92393',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92394',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92395',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92397',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92398',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92399',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92401',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92402',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92403',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92404',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92405',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92406',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92407',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92408',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92410',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92411',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92412',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92413',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92414',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92415',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92418',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92423',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92424',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92427',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92501',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92502',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92503',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92504',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92505',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92506',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92507',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92508',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92509',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92513',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92514',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92515',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92516',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92517',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92518',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92519',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92521',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92522',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92530',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92531',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92532',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92536',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92539',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92543',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92544',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92545',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92546',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92548',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92549',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92551',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92552',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92553',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92554',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92555',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92556',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92557',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92561',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92562',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92563',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92564',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92567',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92570',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92571',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92572',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92581',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92582',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92583',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92584',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92585',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92586',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92587',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92589',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92590',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92591',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92592',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92593',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92595',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92596',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92599',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92602',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92603',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92604',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92605',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92606',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92607',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92609',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92610',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92612',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92614',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92615',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92616',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92617',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92618',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92619',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92620',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92623',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92624',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92625',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92626',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92627',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92628',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92629',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92630',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92637',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92646',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92647',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92648',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92649',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92650',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92651',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92652',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92653',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92654',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92655',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92656',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92657',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92658',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92659',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92660',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92661',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92662',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92663',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92672',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92673',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92674',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92675',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92676',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92677',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92678',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92679',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92683',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92684',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92685',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92688',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92690',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92691',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92692',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92693',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92694',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92697',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92698',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92701',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92702',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92703',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92704',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92705',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92706',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92707',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92708',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92709',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92710',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92711',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92712',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92725',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92728',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92735',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92780',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92781',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92782',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92799',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92801',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92802',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92803',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92804',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92805',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92806',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92807',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92808',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92809',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92811',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92812',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92814',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92815',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92816',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92817',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92821',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92822',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92823',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92825',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92831',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92832',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92833',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92834',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92835',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92836',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92837',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92838',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92840',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92841',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92842',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92843',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92844',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92845',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92846',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92850',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92856',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92857',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92859',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92860',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92861',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92862',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92863',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92865',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92866',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92867',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92868',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92869',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92870',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92871',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92877',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92878',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92879',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92880',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92881',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92882',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92883',
    dma_code: '804',
    dma_description: 'PALM SPRINGS',
  },
  {
    zip_code: '92885',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92886',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92887',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '92899',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93001',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93002',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93003',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93004',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93005',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93006',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93007',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93009',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93010',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93011',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93012',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93013',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93014',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93015',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93016',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93020',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93021',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93022',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93023',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93024',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93030',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93031',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93032',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93033',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93034',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93035',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93036',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93040',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93041',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93042',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93043',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93044',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93060',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93061',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93062',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93063',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93064',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93065',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93066',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93067',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93093',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93094',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93099',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93101',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93102',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93103',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93105',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93106',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93107',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93108',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93109',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93110',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93111',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93116',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93117',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93118',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93120',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93121',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93130',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93140',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93150',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93160',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93190',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93201',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93202',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93203',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93204',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93205',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93206',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93207',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93208',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93210',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93212',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93215',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93216',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93218',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93219',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93220',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93221',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93222',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93223',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93224',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93225',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93226',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93227',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93230',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93232',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93234',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93235',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93237',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93238',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93239',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93240',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93241',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93242',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93243',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93244',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93245',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93246',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93247',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93249',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93250',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93251',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93252',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93254',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93255',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93256',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93257',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93258',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93260',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93261',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93262',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93263',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93265',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93266',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93267',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93268',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93270',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93271',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93272',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93274',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93275',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93276',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93277',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93278',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93279',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93280',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93282',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93283',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93285',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93286',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93287',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93290',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93291',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93292',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93301',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93302',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93303',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93304',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93305',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93306',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93307',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93308',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93309',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93311',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93312',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93313',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93314',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93380',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93381',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93382',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93383',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93384',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93385',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93386',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93387',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93388',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93389',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93390',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93401',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93402',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93403',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93405',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93406',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93407',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93408',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93409',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93410',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93412',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93420',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93421',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93422',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93423',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93424',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93426',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93427',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93428',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93429',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93430',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93432',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93433',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93434',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93435',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93436',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93437',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93438',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93440',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93441',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93442',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93443',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93444',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93445',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93446',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93447',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93448',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93449',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93450',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93451',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93452',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93453',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93454',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93455',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93456',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93457',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93458',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93460',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93461',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93463',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93464',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93465',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93475',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93483',
    dma_code: '855',
    dma_description: 'SANTABARBRA - SANMAR - SANLUOB',
  },
  {
    zip_code: '93501',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93502',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93504',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93505',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93510',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93512',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '93513',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93514',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93515',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93516',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93517',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '93518',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93519',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93522',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93523',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93524',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93526',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93527',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93528',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93529',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '93530',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93531',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93532',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93534',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93535',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93536',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93539',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93541',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '93542',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93543',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93544',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93545',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93546',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '93549',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93550',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93551',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93552',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93553',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93554',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93555',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93556',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93558',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93560',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93561',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93562',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93563',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93581',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93584',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93586',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93590',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93591',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93592',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93596',
    dma_code: '800',
    dma_description: 'BAKERSFIELD',
  },
  {
    zip_code: '93599',
    dma_code: '803',
    dma_description: 'LOS ANGELES',
  },
  {
    zip_code: '93601',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93602',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93603',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93604',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93605',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93606',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93607',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93608',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93609',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93610',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93611',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93612',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93613',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93614',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93615',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93616',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93618',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93619',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93620',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93621',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93622',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93623',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93624',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93625',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93626',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93627',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93628',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93630',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93631',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93633',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93634',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93635',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93636',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93637',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93638',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93639',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93640',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93641',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93642',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93643',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93644',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93645',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93646',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93647',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93648',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93649',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93650',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93651',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93652',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93653',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93654',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93656',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93657',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93660',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93661',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93662',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93664',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93665',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93666',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93667',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93668',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93669',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93670',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93673',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93675',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93701',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93702',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93703',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93704',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93705',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93706',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93707',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93708',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93709',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93710',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93711',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93712',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93714',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93715',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93716',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93717',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93718',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93720',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93721',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93722',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93723',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93724',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93725',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93726',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93727',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93728',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93729',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93730',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93740',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93741',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93744',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93745',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93747',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93750',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93755',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93760',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93761',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93764',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93765',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93771',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93772',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93773',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93774',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93775',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93776',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93777',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93778',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93779',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93780',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93784',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93786',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93790',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93791',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93792',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93793',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93794',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93844',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93888',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '93901',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93902',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93905',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93906',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93907',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93908',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93912',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93915',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93920',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93921',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93922',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93923',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93924',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93925',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93926',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93927',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93928',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93930',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93932',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93933',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93940',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93942',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93943',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93944',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93950',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93953',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93954',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93955',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93960',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '93962',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '94002',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94005',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94010',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94011',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94013',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94014',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94015',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94016',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94017',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94018',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94019',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94020',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94021',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94022',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94023',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94024',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94025',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94026',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94027',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94028',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94030',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94035',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94037',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94038',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94039',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94040',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94041',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94042',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94043',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94044',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94060',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94061',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94062',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94063',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94064',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94065',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94066',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94070',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94074',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94080',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94083',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94085',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94086',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94087',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94088',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94089',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94101',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94102',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94103',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94104',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94105',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94106',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94107',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94108',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94109',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94110',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94111',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94112',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94114',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94115',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94116',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94117',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94118',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94119',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94120',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94121',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94122',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94123',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94124',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94125',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94126',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94127',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94128',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94129',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94130',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94131',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94132',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94133',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94134',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94135',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94136',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94137',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94138',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94139',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94140',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94141',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94142',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94143',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94144',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94145',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94146',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94147',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94150',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94151',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94152',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94153',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94154',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94155',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94156',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94158',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94159',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94160',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94161',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94162',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94163',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94164',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94171',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94172',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94175',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94177',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94188',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94199',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94203',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94230',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94252',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94274',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94280',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94295',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94296',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94299',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94301',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94302',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94303',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94304',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94305',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94306',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94309',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94401',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94402',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94403',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94404',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94497',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94501',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94502',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94503',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94505',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94506',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94507',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94508',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94509',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94510',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94511',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94512',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94513',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94514',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94515',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94516',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94517',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94518',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94519',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94520',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94521',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94522',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94523',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94524',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94525',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94526',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94527',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94528',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94529',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94530',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94531',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94533',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94534',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94535',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94536',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94537',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94538',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94539',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94540',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94541',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94542',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94543',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94544',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94545',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94546',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94547',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94548',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94549',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94550',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94551',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94552',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94553',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94555',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94556',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94557',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94558',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94559',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94560',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94561',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94562',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94563',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94564',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94565',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94566',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94567',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94568',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94569',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94570',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94571',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94572',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94573',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94574',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94575',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94576',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94577',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94578',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94579',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94580',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94581',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94582',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94583',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94585',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94586',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94587',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94588',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94589',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94590',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94591',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94592',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '94595',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94596',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94597',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94598',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94599',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94601',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94602',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94603',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94604',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94605',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94606',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94607',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94608',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94609',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94610',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94611',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94612',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94613',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94614',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94615',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94617',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94618',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94619',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94620',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94621',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94622',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94623',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94624',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94625',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94649',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94659',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94660',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94661',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94662',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94666',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94701',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94702',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94703',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94704',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94705',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94706',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94707',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94708',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94709',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94710',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94712',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94720',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94801',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94802',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94803',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94804',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94805',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94806',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94807',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94808',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94820',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94850',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94901',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94903',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94904',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94912',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94913',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94914',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94915',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94920',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94922',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94923',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94924',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94925',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94926',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94927',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94928',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94929',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94930',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94931',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94933',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94937',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94938',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94939',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94940',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94941',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94942',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94945',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94946',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94947',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94948',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94949',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94950',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94951',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94952',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94953',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94954',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94955',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94956',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94957',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94960',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94963',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94964',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94965',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94966',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94970',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94971',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94972',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94973',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94974',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94975',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94976',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94977',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94978',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94979',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '94998',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95001',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95002',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95003',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95004',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95005',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95006',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95007',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95008',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95009',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95010',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95011',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95012',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95013',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95014',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95015',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95017',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95018',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95019',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95020',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95021',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95023',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95024',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95026',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95030',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95031',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95032',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95033',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95035',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95036',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95037',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95038',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95039',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95041',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95042',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95043',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95044',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95045',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95046',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95050',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95051',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95052',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95053',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95054',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95055',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95056',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95060',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95061',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95062',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95063',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95064',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95065',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95066',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95067',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95070',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95071',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95073',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95075',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95076',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95077',
    dma_code: '828',
    dma_description: 'MONTEREY - SALINAS',
  },
  {
    zip_code: '95101',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95103',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95106',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95108',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95109',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95110',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95111',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95112',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95113',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95116',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95117',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95118',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95119',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95120',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95121',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95122',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95123',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95124',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95125',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95126',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95127',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95128',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95129',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95130',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95131',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95132',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95133',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95134',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95135',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95136',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95138',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95139',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95140',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95141',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95148',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95150',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95151',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95152',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95153',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95154',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95155',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95156',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95157',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95158',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95159',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95160',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95161',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95164',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95170',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95172',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95173',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95190',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95191',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95192',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95193',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95194',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95196',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95201',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95202',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95203',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95204',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95205',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95206',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95207',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95208',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95209',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95210',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95211',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95212',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95213',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95215',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95219',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95220',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95221',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95222',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95223',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95224',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95225',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95226',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95227',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95228',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95229',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95230',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95231',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95232',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95233',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95234',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95236',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95237',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95240',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95241',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95242',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95245',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95246',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95247',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95248',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95249',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95250',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95251',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95252',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95253',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95254',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95255',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95257',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95258',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95267',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95269',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95296',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95297',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95301',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95303',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95304',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95305',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95306',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95307',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95309',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95310',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95311',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95312',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95313',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95314',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95315',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95316',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95317',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95318',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95319',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95320',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95321',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95322',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95323',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95324',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95325',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95326',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95327',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95328',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95329',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95330',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95333',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95334',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95335',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95336',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95337',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95338',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95340',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95341',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95343',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95344',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95345',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95346',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95347',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95348',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95350',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95351',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95352',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95353',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95354',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95355',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95356',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95357',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95358',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95360',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95361',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95363',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95364',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95365',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95366',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95367',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95368',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95369',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95370',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95372',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95373',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95374',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95375',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95376',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95377',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95378',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95379',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95380',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95381',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95382',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95383',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95385',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95386',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95387',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95388',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95389',
    dma_code: '866',
    dma_description: 'FRESNO - VISALIA',
  },
  {
    zip_code: '95391',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95397',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95401',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95402',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95403',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95404',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95405',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95406',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95407',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95409',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95410',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95412',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95415',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95416',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95417',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95418',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95419',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95420',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95421',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95422',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95423',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95424',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95425',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95426',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95427',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95428',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95429',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95430',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95431',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95432',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95433',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95435',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95436',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95437',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95439',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95441',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95442',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95443',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95444',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95445',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95446',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95448',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95449',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95450',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95451',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95452',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95453',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95454',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95456',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95457',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95458',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95459',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95460',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95461',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95462',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95463',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95464',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95465',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95466',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95467',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95468',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95469',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95470',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95471',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95472',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95473',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95476',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95480',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95481',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95482',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95485',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95486',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95487',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95488',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95490',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95492',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95493',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95494',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95497',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95501',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95502',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95503',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95511',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95514',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95518',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95519',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95521',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95524',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95525',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95526',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95527',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95528',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95531',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95532',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95534',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95536',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95537',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95538',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95540',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95542',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95543',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95545',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95546',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95547',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95548',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95549',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95550',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95551',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95552',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95553',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95554',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95555',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95556',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95558',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95559',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95560',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95562',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95563',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95564',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95565',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95567',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95568',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '95569',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95570',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95571',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95573',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95585',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95587',
    dma_code: '807',
    dma_description: 'SAN FRANCISCO - OAK - SAN JOSE',
  },
  {
    zip_code: '95589',
    dma_code: '802',
    dma_description: 'EUREKA',
  },
  {
    zip_code: '95595',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95601',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95602',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95603',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95604',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95605',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95606',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95607',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95608',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95609',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95610',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95611',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95612',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95613',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95614',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95615',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95616',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95617',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95618',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95619',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95620',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95621',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95623',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95624',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95625',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95626',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95627',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95628',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95629',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95630',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95631',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95632',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95633',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95634',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95635',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95636',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95637',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95638',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95639',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95640',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95641',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95642',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95644',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95645',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95646',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '95648',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95650',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95651',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95652',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95653',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95654',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95655',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95656',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95658',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95659',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95660',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95661',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95662',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95663',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95664',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95665',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95666',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95667',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95668',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95669',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95670',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95671',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95672',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95673',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95674',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95675',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95676',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95677',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95678',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95679',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95680',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95681',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95682',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95683',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95684',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95685',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95686',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95687',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95688',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95689',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95690',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95691',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95692',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95693',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95694',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95695',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95696',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95697',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95698',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95699',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95701',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95703',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95709',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95712',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95713',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95714',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95715',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95717',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95720',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95721',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95722',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95724',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95726',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95728',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95735',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95736',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95741',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95742',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95746',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95747',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95757',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95758',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95759',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95762',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95763',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95765',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95776',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95798',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95811',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95812',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95813',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95814',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95815',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95816',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95817',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95818',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95819',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95820',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95821',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95822',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95823',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95824',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95825',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95826',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95827',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95828',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95829',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95830',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95831',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95832',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95833',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95834',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95835',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95836',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95837',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95838',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95840',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95841',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95842',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95843',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95851',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95852',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95853',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95860',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95864',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95865',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95866',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95867',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95887',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95899',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95901',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95903',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95910',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95912',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95913',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95914',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95915',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95916',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95917',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95918',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95919',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95920',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95922',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95923',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95924',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95925',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95926',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95927',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95928',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95929',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95930',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95932',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95934',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95935',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95936',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95937',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95938',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95939',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95940',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95941',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95942',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95943',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95944',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95945',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95946',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95947',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95948',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95949',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95950',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95951',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95953',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95954',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95955',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95956',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95957',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95958',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95959',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95960',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95961',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95962',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95963',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95965',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95966',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95967',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95968',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95969',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95970',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95971',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95972',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95973',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95974',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95975',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95976',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95977',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95978',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95979',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95980',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95981',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95982',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95983',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95984',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95986',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95987',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95988',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '95991',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95992',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '95993',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96001',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96002',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96003',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96006',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96007',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96008',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96009',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96010',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96011',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96013',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96014',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96015',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96016',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96017',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96019',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96020',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96021',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96022',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96023',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96024',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96025',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96027',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96028',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96029',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96031',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96032',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96033',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96034',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96035',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96037',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96038',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96039',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96040',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96041',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96044',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96046',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96047',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96048',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96049',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96050',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96051',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96052',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96054',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96055',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96056',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96057',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96058',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96059',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96061',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96062',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96063',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96064',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96065',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96067',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96068',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96069',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96070',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96071',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96073',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96074',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96075',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96076',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96078',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96079',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96080',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96084',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96085',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96086',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96087',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96088',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96089',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96090',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96091',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96092',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96093',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96094',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96095',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96096',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96097',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96099',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96101',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96103',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96104',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96105',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96106',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96107',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96108',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96109',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96110',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96111',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96112',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96113',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96114',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96115',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96116',
    dma_code: '868',
    dma_description: 'CHICO - REDDING',
  },
  {
    zip_code: '96117',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96118',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96119',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96120',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96121',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96122',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96123',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96124',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96125',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96126',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96127',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96128',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96129',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96130',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96132',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96133',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96134',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '96135',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96136',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96137',
    dma_code: '811',
    dma_description: 'RENO',
  },
  {
    zip_code: '96140',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96141',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96142',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96143',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96145',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96146',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96148',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96150',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96151',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96152',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96154',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96155',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96156',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96157',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96158',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96160',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96161',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96162',
    dma_code: '862',
    dma_description: 'SACRAMNTO - STKTN - MODESTO',
  },
  {
    zip_code: '96701',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96703',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96704',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96705',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96706',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96707',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96708',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96709',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96710',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96712',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96713',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96714',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96715',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96716',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96717',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96718',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96719',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96720',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96721',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96722',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96725',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96726',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96727',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96728',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96729',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96730',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96731',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96732',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96733',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96734',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96737',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96738',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96739',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96740',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96741',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96742',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96743',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96744',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96745',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96746',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96747',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96748',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96749',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96750',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96751',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96752',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96753',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96754',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96755',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96756',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96757',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96759',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96760',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96761',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96762',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96763',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96764',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96765',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96766',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96767',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96768',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96769',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96770',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96771',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96772',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96773',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96774',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96776',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96777',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96778',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96779',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96780',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96781',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96782',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96783',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96784',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96785',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96786',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96788',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96789',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96790',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96791',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96792',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96793',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96795',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96796',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96797',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96801',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96802',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96803',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96804',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96805',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96806',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96807',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96808',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96809',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96810',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96811',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96812',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96813',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96814',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96815',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96816',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96817',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96818',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96819',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96820',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96821',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96822',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96823',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96824',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96825',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96826',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96827',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96828',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96830',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96835',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96836',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96837',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96839',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96840',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96843',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96844',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96846',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96847',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96848',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96849',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96850',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96853',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96854',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96857',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96858',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96859',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96860',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96861',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96863',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '96898',
    dma_code: '744',
    dma_description: 'HONOLULU',
  },
  {
    zip_code: '97001',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97002',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97004',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97005',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97006',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97007',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97008',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97009',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97010',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97011',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97013',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97014',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97015',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97016',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97017',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97018',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97019',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97020',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97021',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97022',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97023',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97024',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97026',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97027',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97028',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97029',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97030',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97031',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97032',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97033',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97034',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97035',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97036',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97037',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97038',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97039',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97040',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97041',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97042',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97044',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97045',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97048',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97049',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97050',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97051',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97053',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97054',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97055',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97056',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97057',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97058',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97060',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97062',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97063',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97064',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97065',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97067',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97068',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97070',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97071',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97075',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97076',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97077',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97078',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97080',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97086',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97089',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97101',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97102',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97103',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97106',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97107',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97108',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97109',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97110',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97111',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97112',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97113',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97114',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97115',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97116',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97117',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97118',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97119',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97121',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97122',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97123',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97124',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97125',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97127',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97128',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97130',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97131',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97132',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97133',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97134',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97135',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97136',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97137',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97138',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97140',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97141',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97143',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97144',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97145',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97146',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97147',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97148',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97149',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97201',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97202',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97203',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97204',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97205',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97206',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97207',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97208',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97209',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97210',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97211',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97212',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97213',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97214',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97215',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97216',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97217',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97218',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97219',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97220',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97221',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97222',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97223',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97224',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97225',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97227',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97228',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97229',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97230',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97231',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97232',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97233',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97236',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97238',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97239',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97240',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97242',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97251',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97253',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97254',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97255',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97256',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97258',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97259',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97266',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97267',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97268',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97269',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97271',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97272',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97280',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97281',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97282',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97283',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97286',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97290',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97291',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97292',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97293',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97294',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97296',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97298',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97301',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97302',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97303',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97304',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97305',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97306',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97307',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97308',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97309',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97310',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97311',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97312',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97313',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97314',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97317',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97321',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97322',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97324',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97325',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97326',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97327',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97329',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97330',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97331',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97333',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97335',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97336',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97338',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97339',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97341',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97342',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97343',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97344',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97345',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97346',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97347',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97348',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97350',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97351',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97352',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97355',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97357',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97358',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97360',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97361',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97362',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97364',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97365',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97366',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97367',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97368',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97369',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97370',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97371',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97372',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97373',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97374',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97375',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97376',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97377',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97378',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97380',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97381',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97383',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97384',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97385',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97386',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97388',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97389',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97390',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97391',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97392',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97394',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97396',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97401',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97402',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97403',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97404',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97405',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97406',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97407',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97408',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97409',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97410',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97411',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97412',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97413',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97414',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97415',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97416',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97417',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97419',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97420',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97423',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97424',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97425',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97426',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97427',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97428',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97429',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97430',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97431',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97432',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97434',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97435',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97436',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97437',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97438',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97439',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97440',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97441',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97442',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97443',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97444',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97446',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97447',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97448',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97449',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97450',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97451',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97452',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97453',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97454',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97455',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97456',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97457',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97458',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97459',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97461',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97462',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97463',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97464',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97465',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97466',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97467',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97469',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97470',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97471',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97472',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97473',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97476',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97477',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97478',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97479',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97480',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97481',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97482',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97484',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97486',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97487',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97488',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97489',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97490',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97491',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97492',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97493',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97494',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97495',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97496',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97497',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97498',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97499',
    dma_code: '801',
    dma_description: 'EUGENE',
  },
  {
    zip_code: '97501',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97502',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97503',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97504',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97520',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97522',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97523',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97524',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97525',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97526',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97527',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97528',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97530',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97531',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97532',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97533',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97534',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97535',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97536',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97537',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97538',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97539',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97540',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97541',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97543',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97544',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97601',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97602',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97603',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97604',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97620',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97621',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97622',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97623',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97624',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97625',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97626',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97627',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97630',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97632',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97633',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97634',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97635',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97636',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97637',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97638',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97639',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97640',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97641',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97701',
    dma_code: '821',
    dma_description: 'BEND, OR',
  },
  {
    zip_code: '97702',
    dma_code: '821',
    dma_description: 'BEND, OR',
  },
  {
    zip_code: '97707',
    dma_code: '821',
    dma_description: 'BEND, OR',
  },
  {
    zip_code: '97708',
    dma_code: '821',
    dma_description: 'BEND, OR',
  },
  {
    zip_code: '97709',
    dma_code: '821',
    dma_description: 'BEND, OR',
  },
  {
    zip_code: '97710',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97711',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97712',
    dma_code: '821',
    dma_description: 'BEND, OR',
  },
  {
    zip_code: '97720',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97721',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97722',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97730',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97731',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97732',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97733',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97734',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97735',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97736',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97737',
    dma_code: '813',
    dma_description: 'MEDFORD - KLAMATH FALLS',
  },
  {
    zip_code: '97738',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97739',
    dma_code: '821',
    dma_description: 'BEND, OR',
  },
  {
    zip_code: '97741',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97750',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97751',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97752',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97753',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97754',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97756',
    dma_code: '821',
    dma_description: 'BEND, OR',
  },
  {
    zip_code: '97758',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97759',
    dma_code: '821',
    dma_description: 'BEND, OR',
  },
  {
    zip_code: '97760',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97761',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97801',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '97810',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '97812',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97813',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '97814',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97817',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97818',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97819',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97820',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97823',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97824',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97825',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97826',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '97827',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97828',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '97830',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97833',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97834',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97835',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '97836',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97837',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97838',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '97839',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97840',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97841',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97842',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '97843',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97844',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97845',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97846',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '97848',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97850',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97856',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97857',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '97859',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '97861',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97862',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '97864',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97865',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97867',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97868',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '97869',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97870',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97873',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97874',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97875',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '97876',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97877',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97880',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '97882',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '97883',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97884',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97885',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '97886',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '97901',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '97902',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '97903',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '97904',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97905',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97906',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '97907',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '97908',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '97909',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '97910',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '97911',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '97913',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '97914',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '97917',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '97918',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '97920',
    dma_code: '757',
    dma_description: 'BOISE',
  },
  {
    zip_code: '98001',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98002',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98003',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98004',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98005',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98006',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98007',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98008',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98009',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98010',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98011',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98012',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98013',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98014',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98015',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98019',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98020',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98021',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98022',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98023',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98024',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98025',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98026',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98027',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98028',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98029',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98030',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98031',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98032',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98033',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98034',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98035',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98036',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98037',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98038',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98039',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98040',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98041',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98042',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98043',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98045',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98046',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98047',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98050',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98051',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98052',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98053',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98054',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98055',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98056',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98057',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98058',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98059',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98061',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98062',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98063',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98064',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98065',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98068',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98070',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98071',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98072',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98073',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98074',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98075',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98077',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98082',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98083',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98087',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98089',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98092',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98093',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98101',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98102',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98103',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98104',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98105',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98106',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98107',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98108',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98109',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98110',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98111',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98112',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98113',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98114',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98115',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98116',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98117',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98118',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98119',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98121',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98122',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98124',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98125',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98126',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98127',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98129',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98133',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98134',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98136',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98138',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98139',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98141',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98144',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98145',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98146',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98148',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98151',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98154',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98155',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98158',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98160',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98161',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98164',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98165',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98166',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98168',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98170',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98174',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98175',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98177',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98178',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98181',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98184',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98185',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98188',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98190',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98191',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98194',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98195',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98198',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98199',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98201',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98203',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98204',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98205',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98206',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98207',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98208',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98213',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98220',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98221',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98222',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98223',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98224',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98225',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98226',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98227',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98228',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98229',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98230',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98231',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98232',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98233',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98235',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98236',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98237',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98238',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98239',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98240',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98241',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98243',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98244',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98245',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98247',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98248',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98249',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98250',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98251',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98252',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98253',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98255',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98256',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98257',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98258',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98259',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98260',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98261',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98262',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98263',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98264',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98266',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98267',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98270',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98271',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98272',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98273',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98274',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98275',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98276',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98277',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98278',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98279',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98280',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98281',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98282',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98283',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98284',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98286',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98287',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98288',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98290',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98291',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98292',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98293',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98294',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98295',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98296',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98297',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98303',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98304',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98305',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98310',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98311',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98312',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98314',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98315',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98320',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98321',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98322',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98323',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98324',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98325',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98326',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98327',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98328',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98329',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98330',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98331',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98332',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98333',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98335',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98336',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98337',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98338',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98339',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98340',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98342',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98343',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98344',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98345',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98346',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98348',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98349',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98350',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98351',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98352',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98353',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98354',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98355',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98356',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98357',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98358',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98359',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98360',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98361',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98362',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98363',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98364',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98365',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98366',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98367',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98368',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98370',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98371',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98372',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98373',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98374',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98375',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98376',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98377',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98378',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98380',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98381',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98382',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98383',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98384',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98385',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98386',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98387',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98388',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98390',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98391',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98392',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98393',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98394',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98395',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98396',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98397',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98398',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98401',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98402',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98403',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98404',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98405',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98406',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98407',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98408',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98409',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98411',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98412',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98415',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98416',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98417',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98418',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98419',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98421',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98422',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98424',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98430',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98431',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98433',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98438',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98439',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98442',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98443',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98444',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98445',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98446',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98447',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98448',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98450',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98455',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98460',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98464',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98465',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98466',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98467',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98477',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98481',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98490',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98492',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98493',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98496',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98497',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98498',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98499',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98501',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98502',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98503',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98504',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98505',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98506',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98507',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98508',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98509',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98511',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98512',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98513',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98516',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98520',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98522',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98524',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98526',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98527',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98528',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98530',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98531',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98532',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98533',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98535',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98536',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98537',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98538',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98539',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98540',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98541',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98542',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98544',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98546',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98547',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98548',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98550',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98552',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98554',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98555',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98556',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98557',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98558',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98559',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98560',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98561',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98562',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98563',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98564',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98565',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98566',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98568',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98569',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98570',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98571',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98572',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98575',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98576',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98577',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98579',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98580',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98581',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98582',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98583',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98584',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98585',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98586',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98587',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98588',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98589',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98590',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98591',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98592',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98593',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98595',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98596',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98597',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98599',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98601',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98602',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98603',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98604',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98605',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98606',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98607',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98609',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98610',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98611',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98612',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98613',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98614',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98616',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98617',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98619',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98620',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98621',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98622',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98623',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98624',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98625',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98626',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98628',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98629',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98631',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98632',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98635',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98637',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98638',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98639',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98640',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98641',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98642',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98643',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98644',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98645',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98647',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98648',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98649',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98650',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98651',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98660',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98661',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98662',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98663',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98664',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98665',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98666',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98667',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98668',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98670',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98671',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98672',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98673',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98674',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98675',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98682',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98683',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98684',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98685',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98686',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98687',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '98801',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98802',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98807',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98811',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98812',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98813',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98814',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98815',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98816',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98817',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98819',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98821',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98822',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98823',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98824',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98826',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98827',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98828',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98829',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98830',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98831',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98832',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98833',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98834',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98836',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98837',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98840',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98841',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98843',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98844',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98845',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98846',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98847',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98848',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98849',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98850',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98851',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98852',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98853',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98855',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98856',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98857',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98858',
    dma_code: '819',
    dma_description: 'SEATTLE - TACOMA',
  },
  {
    zip_code: '98859',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98860',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98862',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '98901',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98902',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98903',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98904',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98907',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98908',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98909',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98920',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98921',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98922',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98923',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98925',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98926',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98929',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98930',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98932',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98933',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98934',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98935',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98936',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98937',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98938',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98939',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98940',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98941',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98942',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98943',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98944',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98946',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98947',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98948',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98950',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98951',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98952',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '98953',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99001',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99003',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99004',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99005',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99006',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99008',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99009',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99011',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99012',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99013',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99014',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99016',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99017',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99018',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99019',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99020',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99021',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99022',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99023',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99025',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99026',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99027',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99029',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99030',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99031',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99032',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99033',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99034',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99036',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99037',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99039',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99040',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99101',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99102',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99103',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99104',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99105',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99107',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99109',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99110',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99111',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99113',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99114',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99115',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99116',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99117',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99118',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99119',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99121',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99122',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99123',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99124',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99125',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99126',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99128',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99129',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99130',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99131',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99133',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99134',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99135',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99136',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99137',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99138',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99139',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99140',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99141',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99143',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99144',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99146',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99147',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99148',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99149',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99150',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99151',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99152',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99153',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99154',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99155',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99156',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99157',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99158',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99159',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99160',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99161',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99163',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99164',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99165',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99166',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99167',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99169',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99170',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99171',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99173',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99174',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99176',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99179',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99180',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99181',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99185',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99201',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99202',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99203',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99204',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99205',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99206',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99207',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99208',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99209',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99210',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99211',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99212',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99213',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99214',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99215',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99216',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99217',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99218',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99219',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99220',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99223',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99224',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99228',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99251',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99252',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99256',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99258',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99260',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99301',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99302',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99320',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99321',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99322',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '99323',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99324',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99326',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99328',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99329',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99330',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99333',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99335',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99336',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99337',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99338',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99341',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99343',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99344',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99345',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99346',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99347',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99348',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99349',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99350',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99352',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99353',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99354',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99356',
    dma_code: '820',
    dma_description: 'PORTLAND, OR',
  },
  {
    zip_code: '99357',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99359',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99360',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99361',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99362',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99363',
    dma_code: '810',
    dma_description: 'YAKIMA - PASCO - RCHLND - KNNWCK',
  },
  {
    zip_code: '99371',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99401',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99402',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99403',
    dma_code: '881',
    dma_description: 'SPOKANE',
  },
  {
    zip_code: '99501',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99502',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99503',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99504',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99505',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99506',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99507',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99508',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99509',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99510',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99511',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99513',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99514',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99515',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99516',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99517',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99518',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99519',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99520',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99521',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99522',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99523',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99524',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99529',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99540',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99556',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99567',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99568',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99572',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99577',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99587',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99599',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99603',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99605',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99610',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99611',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99629',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99631',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99635',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99639',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99645',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99652',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99654',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99663',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99664',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99667',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99669',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99672',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99674',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99676',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99682',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99683',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99687',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99688',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99694',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99695',
    dma_code: '743',
    dma_description: 'ANCHORAGE',
  },
  {
    zip_code: '99701',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99702',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99703',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99705',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99706',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99707',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99708',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99709',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99710',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99711',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99712',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99714',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99716',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99725',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99775',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99790',
    dma_code: '745',
    dma_description: 'FAIRBANKS',
  },
  {
    zip_code: '99801',
    dma_code: '747',
    dma_description: 'JUNEAU',
  },
  {
    zip_code: '99802',
    dma_code: '747',
    dma_description: 'JUNEAU',
  },
  {
    zip_code: '99803',
    dma_code: '747',
    dma_description: 'JUNEAU',
  },
  {
    zip_code: '99811',
    dma_code: '747',
    dma_description: 'JUNEAU',
  },
  {
    zip_code: '99821',
    dma_code: '747',
    dma_description: 'JUNEAU',
  },
  {
    zip_code: '99824',
    dma_code: '747',
    dma_description: 'JUNEAU',
  },
  {
    zip_code: '99850',
    dma_code: '747',
    dma_description: 'JUNEAU',
  },
]
